webpackJsonp([1,0,3],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(57);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(203);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(445);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _vueRouter = __webpack_require__(201);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vuejsPaginate = __webpack_require__(569);
	
	var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);
	
	var _veeValidate = __webpack_require__(5);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _vueScrollto = __webpack_require__(202);
	
	var _vueScrollto2 = _interopRequireDefault(_vueScrollto);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ravenJs = __webpack_require__(442);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _vue3 = __webpack_require__(438);
	
	var _vue4 = _interopRequireDefault(_vue3);
	
	var _App = __webpack_require__(446);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(227);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(226);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _en = __webpack_require__(221);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _th = __webpack_require__(222);
	
	var _th2 = _interopRequireDefault(_th);
	
	var _validator = __webpack_require__(230);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _AuthManager = __webpack_require__(18);
	
	var _AuthManager2 = _interopRequireDefault(_AuthManager);
	
	var _StorageManager = __webpack_require__(16);
	
	var _StorageManager2 = _interopRequireDefault(_StorageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (({"DSN":"https://625237ce09ef4e62b9cb115a7e9aa22a@sentry.io/169504"}) && ("https://625237ce09ef4e62b9cb115a7e9aa22a@sentry.io/169504")) {
	  _ravenJs2.default.config(("https://625237ce09ef4e62b9cb115a7e9aa22a@sentry.io/169504")).addPlugin(_vue4.default, _vue2.default).install();
	}
	
	window.moment = _moment2.default;
	
	_vue2.default.use(_vueI18n2.default);
	_vue2.default.use(_vuejsPaginate2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueScrollto2.default);
	_vue2.default.use(_veeValidate2.default, _validator2.default);
	
	var storageManager = new _StorageManager2.default();
	storageManager.initStorage();
	
	var i18n = new _vueI18n2.default({
	  locale: 'th',
	  messages: {
	    th: _th2.default,
	    en: _en2.default
	  } });
	
	_axios2.default.defaults.baseURL = ("https://accounts.arkcube.net");
	
	_axios2.default.interceptors.response.use(function (response) {
	  return response;
	}, function (error) {
	  var parser = document.createElement('a');
	  parser.href = error.config.url;
	
	  if (parser.pathname === '/oauth/token') {
	    return _promise2.default.reject(error);
	  }
	
	  if (error.response.status === 401 || error.response.status === 403) {
	    if (parser.pathname === '/api/user/logout') {
	      return _promise2.default.resolve();
	    }
	
	    var namespace = _router2.default.currentRoute.params.namespace;
	
	    if (namespace) {
	      var authManager = new _AuthManager2.default();
	      authManager.logout(namespace).then(function () {
	        _router2.default.push('/' + namespace + '/login');
	        return;
	      });
	      return _promise2.default.reject(error);
	    } else {
	      _router2.default.push('/login');
	      return _promise2.default.reject(error);
	    }
	  } else {
	    return _promise2.default.reject(error);
	  }
	});
	
	var eventHub = new _vue2.default();
	
	_vue2.default.mixin({
	  data: function data() {
	    return {
	      eventHub: eventHub
	    };
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default },
	  i18n: i18n,
	  store: _store2.default,
	  router: _router2.default,
	  storageManager: storageManager
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(421)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(235),
	  /* template */
	  __webpack_require__(559),
	  /* scopeId */
	  "data-v-cc502874",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 5 */,
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(398)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(284),
	  /* template */
	  __webpack_require__(536),
	  /* scopeId */
	  "data-v-5b2b5510",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 7 */,
/* 8 */,
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(367)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(232),
	  /* template */
	  __webpack_require__(504),
	  /* scopeId */
	  "data-v-0a400259",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(303);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _classCallCheck2 = __webpack_require__(58);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(59);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _localforage = __webpack_require__(431);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StorageManager = function () {
	  function StorageManager() {
	    (0, _classCallCheck3.default)(this, StorageManager);
	  }
	
	  (0, _createClass3.default)(StorageManager, [{
	    key: 'initStorage',
	    value: function initStorage() {
	      _localforage2.default.config({
	        name: 'ByteArk Account'
	      });
	
	      _localforage2.default.getItem('teams').then(function (value) {
	        if (!value) {
	          _localforage2.default.setItem('teams', {});
	        }
	      });
	    }
	  }, {
	    key: 'setCredential',
	    value: function setCredential(credential, namespace) {
	      var now = new Date();
	      credential.created_at = now.getTime();
	      credential.namespace = namespace;
	
	      namespace = namespace.trim();
	
	      return _localforage2.default.getItem('teams').then(function (teams) {
	        if (teams[namespace]) {
	          teams[namespace].credential = credential;
	        } else {
	          teams[namespace] = {
	            credential: credential,
	            lang: 'th',
	            team: {}
	          };
	        }
	
	        _localforage2.default.setItem('teams', teams);
	
	        return teams[namespace];
	      });
	    }
	  }, {
	    key: 'getCredential',
	    value: function getCredential(namespace) {
	      return _localforage2.default.getItem('teams').then(function (teams) {
	        if (teams && teams[namespace]) {
	          return teams[namespace].credential;
	        } else {
	          return null;
	        }
	      });
	    }
	  }, {
	    key: 'removeCredential',
	    value: function removeCredential(namespace) {
	      return _localforage2.default.getItem('teams').then(function (teams) {
	        if (teams && teams[namespace]) {
	          delete teams[namespace];
	          return _localforage2.default.setItem('teams', teams);
	        }
	
	        return;
	      });
	    }
	  }, {
	    key: 'setTeam',
	    value: function setTeam(team) {
	      return _localforage2.default.getItem('teams').then(function (teams) {
	        if (teams && teams[team.namespace]) {
	          teams[team.namespace].team = {
	            team_id: team.id,
	            name: team.name,
	            namespace: team.namespace
	          };
	
	          return _localforage2.default.setItem('teams', teams);
	        }
	      });
	    }
	  }, {
	    key: 'getTeam',
	    value: function getTeam(namespace) {
	      return _localforage2.default.getItem('teams').then(function (teams) {
	        return teams[namespace];
	      });
	    }
	  }, {
	    key: 'getTeams',
	    value: function getTeams() {
	      return _localforage2.default.getItem('teams').then(function (teams) {
	        if (teams) {
	          return (0, _values2.default)(teams).map(function (data) {
	            return data.team;
	          });
	        } else {
	          return [];
	        }
	      });
	    }
	  }, {
	    key: 'setLang',
	    value: function setLang(lang, namespace) {
	      return _localforage2.default.getItem('teams').then(function (teams) {
	        if (teams && teams[namespace]) {
	          teams[namespace].lang = lang;
	
	          return _localforage2.default.setItem('teams', teams);
	        }
	
	        return;
	      });
	    }
	  }, {
	    key: 'getLang',
	    value: function getLang(namespace) {
	      return _localforage2.default.getItem('teams').then(function (teams) {
	        if (teams && teams[namespace]) {
	          return teams[namespace].lang;
	        }
	
	        return 'th';
	      });
	    }
	  }]);
	  return StorageManager;
	}();
	
	exports.default = StorageManager;

/***/ },
/* 17 */,
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(58);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(59);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _qs = __webpack_require__(188);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _StorageManager = __webpack_require__(16);
	
	var _StorageManager2 = _interopRequireDefault(_StorageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthManager = function () {
	  function AuthManager() {
	    (0, _classCallCheck3.default)(this, AuthManager);
	
	    this.storage = new _StorageManager2.default();
	  }
	
	  (0, _createClass3.default)(AuthManager, [{
	    key: 'login',
	    value: function login(username, password, namespace) {
	      var _this = this;
	
	      return _axios2.default.post('/oauth/token', {
	        namespace: namespace,
	        username: username,
	        password: password,
	        client_id: (2),
	        grant_type: ("byteark_grant")
	      }).then(function (response) {
	        return _this.storage.setCredential(response.data, namespace);
	      }).then(function (data) {
	        return _axios2.default.get('/api/user', {
	          headers: {
	            Authorization: 'Bearer ' + data.credential.access_token
	          }
	        });
	      }).then(function (response) {
	        _this.storage.setLang(response.data.lang, namespace);
	
	        return _this.storage.setTeam(response.data.team);
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout(namespace) {
	      _axios2.default.post('/api/user/logout');
	
	      return this.storage.removeCredential(namespace);
	    }
	  }, {
	    key: 'checkAuth',
	    value: function checkAuth(namespace) {
	      var _this2 = this;
	
	      return this.storage.getCredential(namespace).then(function (credential) {
	        if (credential) {
	          if (_this2.isValidCredential(credential)) {
	            return credential;
	          } else {
	            return _this2.refreshAuth(credential);
	          }
	        } else {
	          throw new Error();
	        }
	      });
	    }
	  }, {
	    key: 'refreshAuth',
	    value: function refreshAuth(oldCredential) {
	      var _this3 = this;
	
	      return _axios2.default.post('/oauth/token', {
	        refresh_token: oldCredential.refresh_token,
	        client_id: '',
	        grant_type: 'refresh_token'
	      }).then(function (response) {
	        return _this3.storage.setCredential(response.data, oldCredential.namespace);
	      }).then(function () {
	        return _this3.getAccessToken(oldCredential.namespace);
	      });
	    }
	  }, {
	    key: 'isValidCredential',
	    value: function isValidCredential(credential) {
	      var now = new Date();
	      var expired = new Date(credential.created_at + credential.expires_in * 1000);
	
	      if (now.getTime() > expired.getTime()) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'getAccessToken',
	    value: function getAccessToken(namespace) {
	      return this.storage.getCredential(namespace);
	    }
	  }, {
	    key: 'getLoggedInTeams',
	    value: function getLoggedInTeams() {
	      return this.storage.getTeams();
	    }
	  }, {
	    key: 'getFormAuthorizeURL',
	    value: function getFormAuthorizeURL(queryStringObject) {
	      return ("https://accounts.arkcube.net") + '/api/oauth/authorize?' + _qs2.default.stringify(queryStringObject);
	    }
	  }, {
	    key: 'isOauthFromOtherService',
	    value: function isOauthFromOtherService(queryStringObject) {
	      return 'redirect_uri' in queryStringObject;
	    }
	  }]);
	  return AuthManager;
	}();
	
	exports.default = AuthManager;

/***/ },
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(385)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(236),
	  /* template */
	  __webpack_require__(523),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(395)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(272),
	  /* template */
	  __webpack_require__(534),
	  /* scopeId */
	  "data-v-5755c492",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function loadPriceList() {
	  var priceList = [{ value: 300, key: '300' }, { value: 500, key: '500' }, { value: 1000, key: '1,000' }, { value: 3000, key: '3,000' }, { value: 5000, key: '5,000' }, { value: 10000, key: '10,000' }, { value: 20000, key: '20,000' }, { value: 50000, key: '50,000' }, { value: 300, key: 'Custom' }];
	
	  return priceList;
	}
	
	function loadDefaultPrice() {}
	
	exports.loadPriceList = loadPriceList;
	exports.loadDefaultPrice = loadDefaultPrice;

/***/ },
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(423)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(234),
	  /* template */
	  __webpack_require__(561),
	  /* scopeId */
	  "data-v-d7661aea",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(368)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(251),
	  /* template */
	  __webpack_require__(505),
	  /* scopeId */
	  "data-v-12400989",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(364)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(256),
	  /* template */
	  __webpack_require__(500),
	  /* scopeId */
	  "data-v-04433f8b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(372)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(265),
	  /* template */
	  __webpack_require__(509),
	  /* scopeId */
	  "data-v-1bd9bda2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(407)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(273),
	  /* template */
	  __webpack_require__(545),
	  /* scopeId */
	  "data-v-73ebdfd2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(418)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(279),
	  /* template */
	  __webpack_require__(556),
	  /* scopeId */
	  "data-v-9ce49992",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(401)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(283),
	  /* template */
	  __webpack_require__(539),
	  /* scopeId */
	  "data-v-5cc3d7f0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(427)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(286),
	  /* template */
	  __webpack_require__(565),
	  /* scopeId */
	  "data-v-ed35eac6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(411)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(290),
	  /* template */
	  __webpack_require__(549),
	  /* scopeId */
	  "data-v-7fc3e9d8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(388)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(299),
	  /* template */
	  __webpack_require__(526),
	  /* scopeId */
	  "data-v-421cb8a8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  login: {
	    labels: {
	      prefixLogin: 'Login to',
	      subfixLogin: 'Team',
	      dontHaveAccount: 'Don\'t have an account?',
	      dontHaveAccountOnTeam: 'Don\'t have an account on this team yet?',
	      contactTeamAdmin: 'Contact the team administrator for an invitation'
	    },
	    action: {
	      enterTeamURL: 'Enter your Team URL',
	      registerNewAccount: 'Register new account',
	      chooseYourTeam: 'Choose your team',
	      loginOtherTeam: 'Login to other team'
	    },
	    response: {
	      failed: 'Sorry, you entered an incorrect email or password.'
	    }
	  },
	  register: {
	    labels: {
	      register: 'Register',
	      acceptTerm: 'I accept the ',
	      termOfService: 'Terms of Service'
	    },
	    action: {
	      registerSuccess: 'Register Successfully',
	      finish: 'Finish'
	    },
	    failed: 'Unable to register new account, please try again later.',
	    success: 'We just sent you a confirmation email to '
	  },
	  forgot: {
	    labels: {
	      forgotPassword: 'Forgot password',
	      prefixResetPassword: 'To reset your password, enter the email address you use to login to',
	      subfixResetPassword: 'Team'
	    },
	    action: {
	      forgotPassword: 'Forgot password ?',
	      sendRequest: 'Send Request'
	    },
	    response: {
	      success: 'We have just sent your password reset link',
	      failed: 'We can\'t find a user with that e-mail address. please retry or contact your team manager.',
	      defaultFailed: 'An unexpected error occured. Please try again later.'
	    }
	  },
	  recovery: {
	    labels: {
	      resetPassword: 'Reset Password',
	      enterNewPassword: 'Enter new password for login to'
	    },
	    action: {
	      resetPassword: 'Confirm New Password',
	      continueLogin: 'Continue to Login',
	      backToLogin: 'Back to Login',
	      resend: 'Resend'
	    },
	    verifyToken: {
	      response: {
	        linkInvalid: 'This password reset link is invalid.',
	        linkExpired: 'This password reset link is expired. please resend.',
	        defaultFailed: 'An unexpected error occured. Please try again later.'
	      }
	    },
	    resetPassword: {
	      response: {
	        success: 'Your password has been reset',
	        failed: 'Reset password failed with the following errors',
	        defaultFailed: 'An unexpected error occured. Please try again later.'
	      }
	    }
	  },
	  changePassword: {
	    response: {
	      failed: 'Sorry, you entered an incorrect Current Password.'
	    }
	  },
	  contact: {
	    response: {
	      success: 'Your information has been submitted.'
	    }
	  },
	  activate: {
	    verifyToken: {
	      response: {
	        success: 'Your account is  now activated.',
	        linkInvalid: 'This activate link is invalid.',
	        linkExpired: 'This activate reset link is expired. please re-register.',
	        defaultFailed: 'An unexpected error occured. Please try again later.'
	      }
	    }
	  },
	  menu: {
	    dashboard: 'Dashboard',
	    billing: 'Billing',
	    team: 'Team',
	    reseller: 'Reseller',
	    admin: 'Admin',
	    profile: 'Profile',
	    password: 'Change Password',
	    support: 'Support',
	    logout: 'Log out',
	    services: 'Services',
	    general: 'General',
	    clientUsageHistory: 'Client Usage History',
	    addons: 'Add-ons Cost',
	    creditTransaction: 'Credit Transaction'
	  },
	  title: {
	    currentState: 'Current State',
	    stateMent: 'Statement',
	    DataTransfer: 'Data Transfer',
	    cost: 'Cost',
	    FreeStorage: 'Free Storage',
	    AdditionalStorage: 'Additional Storage',
	    QoderVODEncoding: 'Qoder VOD Encoding',
	    pricePlanVat: '** This Price Not Include Vat.'
	  },
	  unit: {
	    month: 'Month',
	    minute: 'Minute',
	    date: 'Date'
	  },
	  currentCredit: {
	    lastedTransaction: 'Lastest added credit',
	    textGuide: 'We accept the most popular credit cards: Visa, Mastercard and JCB',
	    percentageBar: 'of your current credits.'
	  },
	  monthToDateCost: {
	    nextCreditCharge: 'Next credit charge',
	    textGuide: 'There is been no usage yet this month .'
	  },
	  pricingPlan: {
	    title: 'Monthly Pricing Plan'
	  },
	  action: {
	    manage: 'Manage',
	    manageClientTeam: 'Manage Client Team',
	    moreDetail: 'More Detail',
	    login: 'Log in',
	    continue: 'Continue',
	    register: 'Register',
	    create: 'Create',
	    role: 'Role',
	    submit: 'Submit',
	    cancel: 'Cancel',
	    search: 'Search',
	    backTo: 'Back to',
	    print: 'Print',
	    editInfo: 'Edit Info'
	  },
	  text: {
	    total: 'Total',
	    totalTeams: 'Total Teams',
	    free: 'Free',
	    additional: 'Additional',
	    on: 'on',
	    or: 'or',
	    to: 'to',
	    textGuideFilter: 'Filter by Team name or Team namspace'
	  },
	  serviceGroups: {
	    endUserServices: 'End User Services',
	    developerServices: 'Developer Services'
	  },
	  services: {
	    account: {
	      name: 'Account',
	      shortDescription: 'Manage your ByteArk Account'
	    },
	    analytics: {
	      name: 'Analytics',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    storage: {
	      name: 'Storage',
	      shortDescription: 'Upload and distributes files around the world, with Amazon S3-liked APIs.'
	    },
	    fleet: {
	      name: 'Fleet',
	      shortDescription: 'Simple but powerful CDN, to serve contents from your server to anyone.'
	    },
	    qoder: {
	      name: 'Qoder',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    player: {
	      name: 'Player',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    current: {
	      state: 'You are here',
	      use: 'You Currently use'
	    }
	  },
	  solutions: {
	    vod: {
	      name: 'Video On Demand Platform',
	      shortDescription: 'จัดเก็บวิดีโอของคุณด้วยกลุ่มเมฆ เพิ่มประสิทธิภาพการรับชมวิดีโอจากทุกที่'
	    },
	    liveStraming: {
	      name: 'Live Streaming Platform',
	      shortDescription: 'ถ่ายทอดสดวิดีโอไปยังผู้ชมนับแสนไม่ใช่สิ่งที่เพ้อฝันเกินไปแน่นอน'
	    },
	    webCDN: {
	      name: 'Web CDN',
	      shortDescription: 'เร่งความเร็วให้กับเว็บไซต์ของคุณ โดยการทำ Caching เนื้อหาบนเว็บไซต์'
	    },
	    fileDistributor: {
	      name: 'File Distributor',
	      shortDescription: 'ไม่ว่าจะเป็น ไฟล์เกมส์ แพทช์เกมส์ รูปภาพ ให้เราช่วยคุณส่งต่อไปยังผู้เล่นของคุณได้ง่ายๆ'
	    }
	  },
	  mainHeaderGroups: {
	    services: 'Services',
	    quickStart: 'Getting Started',
	    solutions: 'Solutions'
	  },
	  quickStart: {
	    howToLiveStream: {
	      name: 'วิธีการถ่ายทอดสดออนไลน์ (Live Streaming)',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    howToUploadVdo: {
	      name: 'วิธีการเผยแพร่คลิปวิดีโอ',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    howToUploadFileToCDN: {
	      name: 'วิธีการอัพโหลดไฟล์เพื่อแจกจ่ายให้ผู้ใช้จำนวนมาก',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    howToImplementCDN: {
	      name: 'วิธีเปิดใช้ CDN สำหรับเว็บไซต์ของท่าน',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    howToAddCredit: {
	      name: 'วิธีการชำระเงิน โดยการเติมเครดิตผ่านบัตรเครดิต',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    }
	  },
	  billing: {
	    currencies: {
	      thb: 'THB'
	    },
	    labels: {
	      billing: 'Billing',
	      remainingCredits: 'Current Credits',
	      currentMonthUsage: 'MONTH-TO-DATE COST',
	      billingInformation: 'Billing Information',
	      paymentInformation: 'Enter your payment information',
	      perfixDiscount: 'After Discount',
	      subfixDiscount: '',
	      noDiscount: 'No Discount'
	    },
	    action: {
	      addCredit: 'Add Credit',
	      pay: 'Pay'
	    },
	    information: {
	      labels: {
	        firstname: 'First Name',
	        lastname: 'Last Name',
	        companyName: 'Company Name',
	        taxID: 'Tax ID',
	        addressLine1: 'Address Line 1',
	        addressLine2: 'Address Line 2',
	        city: 'City / Town',
	        state: 'State / Province / Region',
	        zipCode: 'ZIP Code',
	        country: 'Country',
	        billingContactPhone: 'Billing Contact Phone',
	        billingEmail: 'Billing E-mail',
	        noBillingInformation: 'Your account does not have a billing information.',
	        enterBillingInformation: 'Enter your billing information'
	      },
	      action: {
	        saveDetails: 'Save Detail',
	        changeInformation: 'Change Information',
	        addBillingInformation: 'Add billing information'
	      },
	      response: {
	        success: 'Saved successfully',
	        failed: 'Save failed with the following errors',
	        defaultFailed: 'An unexpected error occured. Please try again later.'
	      }
	    },
	    addcredit: {
	      labels: {
	        textGuide: 'How much credit you would like to add?',
	        remark: 'Credit is non-refundable.'
	      },
	      paymentResult: {
	        success: {
	          title: 'Success',
	          text: 'Payment process have been complete.'
	        },
	        failed: {
	          title: 'Error',
	          text: 'Payment process was rejected. Please try again.'
	        }
	      }
	    },
	    payment: {
	      labels: {
	        creditCardNumber: 'Credit card number',
	        nameOnCard: 'Name on card',
	        expireMonth: 'Expire month',
	        expireYear: 'Expire year',
	        code: 'CVV code'
	      }
	    }
	  },
	  annoucement: {
	    labels: {
	      annoucements: 'Annoucements'
	    }
	  },
	  team: {
	    title: 'Team Info',
	    labels: {
	      setting: 'Setting',
	      rename: 'Rename',
	      createTeam: 'Create Team',
	      editTeam: 'Edit Team'
	    },
	    url: {
	      labels: 'Team URL',
	      textGuide: '(This URL will be use used as permanent)'
	    },
	    displayName: {
	      labels: 'Team Display name',
	      textGuide: 'A Friendly name will be display on Website.'
	    },
	    type: {
	      labels: 'Team Type'
	    },
	    action: {
	      submit: 'Submit'
	    },
	    response: {
	      success: 'Saved successfully',
	      failed: 'Save failed with the following errors',
	      defaultFailed: 'An unexpected error occured. Please try again later.'
	    }
	  },
	  depositcredit: {
	    response: {
	      success: 'Deposited credit was success.',
	      failed: 'Save failed with the following errors',
	      defaultFailed: 'An unexpected error occured. Please try again later.'
	    }
	  },
	  deductcredit: {
	    response: {
	      success: 'Deducted credit was success.',
	      failed: 'Save failed with the following errors',
	      defaultFailed: 'An unexpected error occured. Please try again later.'
	    }
	  },
	  admin: {
	    billing: {
	      discount: {
	        response: {
	          failed: 'An unexpected error occured. Please try again later.'
	        }
	      }
	    },
	    pricingplan: {
	      discount: {
	        response: {
	          failed: 'An unexpected error occured. Please try again later.'
	        }
	      }
	    }
	  },
	  account: {
	    labels: {
	      account: 'Account Info',
	      displayName: 'Display name',
	      email: 'Email',
	      password: 'Password',
	      existingAccount: 'Already have an account?',
	      editProfile: 'Edit Profile',
	      role: 'Role'
	    },
	    profile: {
	      labels: {
	        changeDisplayImage: 'Change your Display image on',
	        chooseLanguage: 'Choose Language'
	      }
	    },
	    password: {
	      labels: {
	        changePassword: 'Change Password',
	        currentPassword: 'Current Password',
	        newPassword: 'New Password',
	        confirmNewPassword: 'Confirm New Password'
	      }
	    },
	    activate: {
	      labels: {
	        activateYourAccount: 'Activate your account'
	      },
	      action: {
	        login: 'Login Here'
	      }
	    },
	    lang: {
	      th: 'TH',
	      en: 'EN'
	    },
	    action: {
	      submit: 'Submit'
	    }
	  },
	  member: {
	    labels: {
	      members: 'Members',
	      totalMembers: 'Total Members',
	      createMember: 'Create Member',
	      editMembers: 'Edit Member'
	    },
	    action: {
	      changePassword: 'Change Password',
	      hidePassword: 'Hide Password',
	      deactivateAccount: 'Deactivate Account',
	      enableAccount: 'Enable Account'
	    },
	    role: {
	      manager: 'Manager',
	      user: {
	        textGuide: '(Prohibited from User management , Team Setting and Billing System)'
	      }
	    }
	  },
	  support: {
	    labels: {
	      contactUS: 'Contact us',
	      subject: 'Subject',
	      message: 'Message',
	      textGuide: 'Please tell us how we can help you.'
	    }
	  },
	  monthlyUsageHistory: {
	    labels: {
	      monthlyUsageHistory: 'Monthly Usage History',
	      noUsageHistory: 'There is no usage history on this month.'
	    },
	    action: {
	      report: 'Download Report'
	    }
	  },
	  clientUsageHistory: {
	    labels: {
	      team: 'Team',
	      invoiceNumber: 'Invoice Number',
	      usage: 'Usage',
	      sellingPrice: 'Selling Price',
	      discount: 'Discount',
	      netPrice: 'Net Price',
	      noClientUsageHistory: 'There is no usage history',
	      dateIssued: 'Date issued'
	    },
	    action: {
	      usageReport: 'Usage Report',
	      create: 'Create'
	    }
	  },
	  manageClientTeam: {
	    labels: {
	      name: 'Name',
	      url: 'URL',
	      type: 'Type',
	      reseller: 'Reseller',
	      payPlan: 'Pay plan'
	    },
	    action: {
	      billing: 'สรุปการใช้งานรายเดือน',
	      create: 'สร้างลูกค้าใหม่'
	    }
	  },
	  payPlan: {
	    labels: {
	      postPaid: 'Post Paid',
	      prePaid: 'Pre Paid'
	    }
	  },
	  statement: {
	    labels: {
	      statement: 'Statement',
	      orderNumber: 'Order Number',
	      invoiceNumber: 'Invoice Number',
	      receiptNumber: 'Receipt Number',
	      description: 'Description',
	      amount: 'Amount',
	      noBillingHistory: 'There is no billing history on this year.',
	      credit: 'Credit',
	      charge: 'Charge',
	      remaining: 'Remaining'
	    },
	    action: {
	      download: 'Download',
	      usageReport: 'Usage Report',
	      stateMent: 'Statement'
	    }
	  },
	  suspend: {
	    labels: {
	      suspend: 'Your Account has been suspend.',
	      defaultMessage: 'Your credit is not enough. Please fill your credit now'
	    }
	  }
	};

/***/ },
/* 222 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  login: {
	    labels: {
	      prefixLogin: 'ล็อกอินภายใต้ทีม',
	      subfixLogin: '',
	      dontHaveAccount: 'หากคุณยังไม่มีบัญชีผู้ใช้ ?',
	      dontHaveAccountOnTeam: 'หากต้องการสมัครใช้งานภายใต้ทีมนี้',
	      contactTeamAdmin: 'กรุณาติดต่อแอดมินของทีมเพื่อสร้างบัญชีผู้ใช้ให้คุณ'
	    },
	    action: {
	      enterTeamURL: 'กรุณากรอก Team URL ของคุณ',
	      registerNewAccount: 'สมัครใช้งาน',
	      chooseYourTeam: 'เลือกทีมที่ต้องการเข้าใช้งาน',
	      loginOtherTeam: 'ล็อคอินภายใต้ทีมอื่น'
	    },
	    response: {
	      failed: 'ขออภัย คุณกรอกอีเมลหรือรหัสผ่านผิด กรุณาลองใหม่อีกครั้ง'
	    }
	  },
	  register: {
	    labels: {
	      register: 'สมัครใช้งาน',
	      acceptTerm: 'คุณอ่านและยอมรับใน',
	      termOfService: 'ข้อกำหนดการใช้งาน'
	    },
	    action: {
	      registerSuccess: 'สมัครใช้งานเรียบร้อย',
	      finish: 'สำเร็จ'
	    },
	    failed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
	    success: 'กรุณากดยืนยันตัวตนจากอีเมลที่เพิ่งถูกส่งไปยัง '
	  },
	  forgot: {
	    labels: {
	      forgotPassword: 'หากคุณลืมรหัสผ่าน',
	      prefixResetPassword: 'กรุณากรอกอีเมลที่คุณเคยสมัครใช้งานภายใต้ทีม',
	      subfixResetPassword: ''
	    },
	    action: {
	      forgotPassword: 'ลืมรหัสผ่าน ?',
	      sendRequest: 'ส่งลิงก์สำหรับรีเซ็ตรหัสผ่าน'
	    },
	    response: {
	      success: 'ลิงก์สำหรับรีเซ็ตรหัสผ่านถูกส่งไปยังอีเมลเรียบร้อยแล้ว',
	      failed: 'ไม่พบัญชีผู้ใช้จากอีเมล์ที่คุณระบุ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลทีมของคุณ',
	      defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง'
	    }
	  },
	  recovery: {
	    labels: {
	      resetPassword: 'รีเซ็ตรหัสผ่าน',
	      enterNewPassword: 'กรอกรหัสผ่านใหม่สำหรับใช้ล็อคอินภายใต้ทีม'
	    },
	    action: {
	      resetPassword: 'ยืนยันรหัสผ่านใหม่',
	      continueLogin: 'ไปยังหน้าล็อคอิน',
	      backToLogin: 'กลับไปยังหน้าล็อคอิน',
	      resend: 'ส่งใหม่อีกครั้ง'
	    },
	    verifyToken: {
	      response: {
	        linkInvalid: 'ลิงก์รีเซ็ตรหัสผ่านไม่ถูกต้อง',
	        linkExpired: 'ลิงก์รีเซ็ตรหัสผ่านนี้หมดอายุลงแล้ว กรุณากดลืมรหัสผ่านใหม่อีกครั้ง',
	        defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง'
	      }
	    },
	    resetPassword: {
	      response: {
	        success: 'รหัสผ่านของคุณถูกรีเซ็ตแล้ว',
	        failed: 'รหัสผ่านของคุณไม่สำเร็จ กรุณาตรวจสอบข้อผิดพลาดดังต่อไปนี้',
	        defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง'
	      }
	    }
	  },
	  changePassword: {
	    response: {
	      failed: 'ขออภัย คุณกรอกรหัสผ่านปัจจุบันผิด'
	    }
	  },
	  contact: {
	    response: {
	      success: 'ข้อมูลของคุณถูกส่งเรียบร้อยแล้ว'
	    }
	  },
	  activate: {
	    verifyToken: {
	      response: {
	        success: 'บัญชีผู้ใช้ของคุณได้รับการยืนยันแล้ว',
	        linkInvalid: 'ลิงก์ที่ใช้ในการยืนยันอีเมลไม่ถูกต้อง',
	        linkExpired: 'ลิงก์ที่ใช้ในการยืนยันอีเมลนี้หมดอายุลงแล้ว กรุณาสมัครใช้งานใหม่อีกครั้ง',
	        defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง'
	      }
	    }
	  },
	  menu: {
	    dashboard: 'หน้าหลัก',
	    billing: 'บัญชี',
	    team: 'ทีม',
	    reseller: 'Reseller',
	    admin: 'Admin',
	    profile: 'บัญชีผู้ใช้',
	    password: 'เปลี่ยนรหัสผ่าน',
	    support: 'ช่วยเหลือ',
	    logout: 'ออกจากระบบ',
	    services: 'Services',
	    general: 'ข้อมูลทั่วไป',
	    clientUsageHistory: 'ประวัติการใช้งานลูกค้า',
	    addons: 'Add-ons Cost',
	    creditTransaction: 'Credit Transaction'
	  },
	  title: {
	    currentState: 'สถานะการใช้งาน',
	    statement: 'รายการเคลื่อนไหวของบัญชี',
	    DataTransfer: 'Data Transfer',
	    cost: 'ค่าบริการ',
	    FreeStorage: 'Free Storage',
	    AdditionalStorage: 'Additional Storage',
	    QoderVODEncoding: 'Qoder VOD Encoding',
	    pricePlanVat: '** ราคานี้ยังไม่รวมภาษีมูลค่าเพิ่ม'
	  },
	  unit: {
	    month: 'เดือน',
	    minute: 'นาที',
	    date: 'วันที่'
	  },
	  currentCredit: {
	    lastedTransaction: 'เติมเครดิตล่าสุด',
	    textGuide: 'ท่านสามารถใช้บริการของเราและชำระเงินด้วยบัตรเครดิตของ Visa, Mastercard และ JCB',
	    percentageBar: 'ของเครดิตปัจจุบัน'
	  },
	  monthToDateCost: {
	    creditNotEnough: 'ยอดการใช้งานเกินเครดิตคงเหลือ',
	    nextCreditCharge: 'กำหนดชำระ',
	    textGuide: 'ยังไม่มียอดการใช้งาน'
	  },
	  pricingPlan: {
	    title: 'แพลนค่าบริการ'
	  },
	  action: {
	    manage: 'แก้ไข',
	    manageClientTeam: 'จัดการลูกค้า',
	    moreDetail: 'ดูเพิ่มเติม',
	    login: 'ล็อกอิน',
	    continue: 'ขั้นตอนต่อไป',
	    register: 'ยืนยันการสมัครใช้งาน',
	    create: 'สร้าง',
	    role: 'ตำแหน่ง',
	    submit: 'ส่ง',
	    cancel: 'ยกเลิก',
	    search: 'ค้นหา',
	    backTo: 'กลับสู่หน้า',
	    print: 'พิมพ์',
	    editInfo: 'แก้ไขข้อมูลทีม'
	  },
	  text: {
	    total: 'รวมทั้งหมด',
	    totalTeams: 'ทีมทั้งหมด',
	    free: 'ฟรี',
	    additional: 'ค่าส่วนเกิน',
	    on: 'ในวันที่',
	    or: 'หรือ',
	    to: 'ถึง',
	    textGuideFilter: 'ค้นหาด้วย Team name หรือ Team URL'
	  },
	  serviceGroups: {
	    endUserServices: 'End User Services',
	    developerServices: 'Developer Services'
	  },
	  services: {
	    account: {
	      name: 'Account',
	      shortDescription: 'Manage your ByteArk Account'
	    },
	    analytics: {
	      name: 'Analytics',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    storage: {
	      name: 'Storage',
	      shortDescription: 'Upload and distributes files around the world, with Amazon S3-liked APIs.'
	    },
	    fleet: {
	      name: 'Fleet',
	      shortDescription: 'Simple but powerful CDN, to serve contents from your server to anyone.'
	    },
	    qoder: {
	      name: 'Qoder',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    player: {
	      name: 'Player',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    current: {
	      state: 'กำลังใช้งาน',
	      use: 'คุณกำลังใช้งาน'
	    }
	  },
	  solutions: {
	    vod: {
	      name: 'Video On Demand Platform',
	      shortDescription: 'จัดเก็บวิดีโอของคุณด้วยกลุ่มเมฆ เพิ่มประสิทธิภาพการรับชมวิดีโอจากทุกที่'
	    },
	    liveStraming: {
	      name: 'Live Streaming Platform',
	      shortDescription: 'ถ่ายทอดสดวิดีโอไปยังผู้ชมนับแสนไม่ใช่สิ่งที่เพ้อฝันเกินไปแน่นอน'
	    },
	    webCDN: {
	      name: 'Web CDN',
	      shortDescription: 'เร่งความเร็วให้กับเว็บไซต์ของคุณ โดยการทำ Caching เนื้อหาบนเว็บไซต์'
	    },
	    fileDistributor: {
	      name: 'File Distributor',
	      shortDescription: 'ไม่ว่าจะเป็น ไฟล์เกมส์ แพทช์เกมส์ รูปภาพ ให้เราช่วยคุณส่งต่อไปยังผู้เล่นของคุณได้ง่ายๆ'
	    }
	  },
	  mainHeaderGroups: {
	    services: 'Services',
	    quickStart: 'เริ่มต้นใช้งาน',
	    solutions: 'Solutions'
	  },
	  quickStart: {
	    howToLiveStream: {
	      name: 'วิธีการถ่ายทอดสดออนไลน์ (Live Streaming)',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    howToUploadVdo: {
	      name: 'วิธีการเผยแพร่คลิปวิดีโอ',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    howToUploadFileToCDN: {
	      name: 'วิธีการอัพโหลดไฟล์เพื่อแจกจ่ายให้ผู้ใช้จำนวนมาก',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    howToImplementCDN: {
	      name: 'วิธีเปิดใช้ CDN สำหรับเว็บไซต์ของท่าน',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    },
	    howToAddCredit: {
	      name: 'วิธีการชำระเงิน โดยการเติมเครดิตผ่านบัตรเครดิต',
	      shortDescription: 'Video transcoding without any setup, just upload and go!'
	    }
	  },
	  billing: {
	    currencies: {
	      thb: 'บาท'
	    },
	    labels: {
	      billing: 'บัญชี',
	      remainingCredits: 'เครดิตปัจจุบัน',
	      currentMonthUsage: 'ค่าใช้บริการระหว่างรอบบิล',
	      billingInformation: 'ที่อยู่สำหรับใบเสร็จ / ใบกำกับภาษี',
	      paymentInformation: 'กรุณากรอกข้อมูลการชำระเงิน',
	      perfixDiscount: 'หลังหักส่วนลด',
	      subfixDiscount: 'เรียบร้อยแล้ว',
	      noDiscount: 'ไม่มีส่วนลด ณ ขณะนี้'
	    },
	    action: {
	      addCredit: 'เติมเครดิต',
	      pay: 'เติม'
	    },
	    information: {
	      labels: {
	        firstname: 'ชื่อ',
	        lastname: 'นามสกุล',
	        companyName: 'ชื่อบริษัท',
	        taxID: 'หมายเลขประจำตัวผู้เสียภาษี',
	        addressLine1: 'ที่อยู่',
	        addressLine2: 'ที่อยู่ (ต่อ)',
	        city: 'เขต / อำเภอ',
	        state: 'แขวง / จังหวัด',
	        zipCode: 'รหัสไปรษณีย์',
	        country: 'ประเทศ',
	        billingContactPhone: 'เบอร์โทรศัพท์ที่ใช้ติดต่อ',
	        billingEmail: 'อีเมลที่ใช้ติดต่อ',
	        noBillingInformation: 'บัญชีนี้ยังไม่ระบุข้อมูล',
	        enterBillingInformation: 'กรุณากรอกที่อยู่สำหรับใบเสร็จ / ใบกำกับภาษี'
	      },
	      action: {
	        saveDetails: 'บันทึกข้อมูล',
	        changeInformation: 'เปลี่ยนแปลงข้อมูล',
	        enterBillingInformation: 'กรุณากรอกข้อมูลเพื่อใช้ในการเรียกเก็บค่าบริการ',
	        addBillingInformation: 'กรอกข้อมูล'
	      },
	      response: {
	        success: 'บันทึกข้อมูลสำเร็จแล้ว',
	        failed: 'บันทึกข้อมูลไม่สำเร็จ กรุณาตรวจสอบข้อผิดพลาดดังต่อไปนี้',
	        defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง'
	      }
	    },
	    addcredit: {
	      labels: {
	        textGuide: 'กรุณาระบุจำนวนเครดิตที่คุณต้องการเติม',
	        remark: 'หลังจากเติมเครดิตเสร็จสิ้นแล้ว คุณไม่สามารถขอคืนเครดิตได้'
	      },
	      paymentResult: {
	        success: {
	          title: 'สำเร็จ',
	          text: 'เติมเครดิตเรียบร้อยแล้ว'
	        },
	        failed: {
	          title: 'มีความผิดพลาดเกิดขึ้น',
	          text: 'เติมเครดิตไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'
	        }
	      }
	    },
	    payment: {
	      labels: {
	        creditCardNumber: 'Credit card number',
	        nameOnCard: 'Name on card',
	        expireMonth: 'Expire month',
	        expireYear: 'Expire year',
	        code: 'CVV code'
	      }
	    }
	  },
	  annoucement: {
	    labels: {
	      annoucements: 'Annoucements'
	    }
	  },
	  team: {
	    title: 'ข้อมูลทีม',
	    labels: {
	      setting: 'ตั้งค่า',
	      rename: 'แก้ไขชื่อทีม',
	      createTeam: 'สร้างทีม',
	      editTeam: 'แก้ไขทีม'
	    },
	    url: {
	      labels: 'Team URL',
	      textGuide: '(URL นี้จะถูกใช้ถาวร)'
	    },
	    displayName: {
	      labels: 'ชื่อทีม',
	      textGuide: 'ชื่อนี้จะถูกใช้แสดงผลบนเว็บไซต์'
	    },
	    type: {
	      labels: 'ประเภททีม'
	    },
	    action: {
	      submit: 'แก้ไขการตั้งค่าทีม'
	    },
	    response: {
	      success: 'บันทึกข้อมูลสำเร็จแล้ว',
	      failed: 'บันทึกข้อมูลไม่สำเร็จ กรุณาตรวจสอบข้อผิดพลาดดังต่อไปนี้',
	      defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง'
	    }
	  },
	  depositcredit: {
	    response: {
	      success: 'เติมเครดิตเรียบร้อยแล้ว',
	      failed: 'เติมเครดิตไม่สำเร็จ กรุณาตรวจสอบข้อผิดพลาดดังต่อไปนี้',
	      defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง'
	    }
	  },
	  deductcredit: {
	    response: {
	      success: 'หักเครดิตออกเรียบร้อยแล้ว',
	      failed: 'หักเครดิตไม่สำเร็จ กรุณาตรวจสอบข้อผิดพลาดดังต่อไปนี้',
	      defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง'
	    }
	  },
	  admin: {
	    billing: {
	      discount: {
	        response: {
	          failed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง'
	        }
	      }
	    },
	    pricingplan: {
	      discount: {
	        response: {
	          failed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง'
	        }
	      }
	    }
	  },
	  account: {
	    labels: {
	      account: 'ข้อมูลผู้ใช้',
	      displayName: 'ชื่อที่ใช้แสดงผล',
	      email: 'อีเมล',
	      password: 'รหัสผ่าน',
	      existingAccount: 'หากคุณมีบัญชีผู้ใช้อยู่แล้ว กรุณา',
	      role: 'ดำแหน่งของสมาชิก',
	      editProfile: 'แก้ไขข้อมูลบัญชีผู้ใช้'
	    },
	    profile: {
	      labels: {
	        changeDisplayImage: 'หากคุณต้องการเปลี่ยนภาพประจำตัว สามารถเปลี่ยนได้ที่เว็บไซต์',
	        chooseLanguage: 'ตั้งค่าภาษาที่ใช้แสดงผล'
	      }
	    },
	    password: {
	      labels: {
	        changePassword: 'เปลี่ยนรหัสผ่าน',
	        currentPassword: 'รหัสผ่านปัจจุบัน',
	        newPassword: 'รหัสผ่านใหม่',
	        confirmNewPassword: 'ยืนยันรหัสผ่านใหม่'
	      }
	    },
	    activate: {
	      labels: {
	        activateYourAccount: 'ยืนยันบัญชีผู้ใช้ของคุณ'
	      },
	      action: {
	        login: 'ล็อคอินที่นี่'
	      }
	    },
	    lang: {
	      th: 'ไทย',
	      en: 'อังกฤษ'
	    },
	    action: {
	      submit: 'บันทึกข้อมูล'
	    }
	  },
	  member: {
	    labels: {
	      members: 'สมาชิกในทีม',
	      totalMembers: 'สมาชิกทั้งหมด',
	      createMember: 'สร้างสมาชิกใหม่',
	      editMembers: 'แก้ไขข้อมูลสมาชิก'
	    },
	    action: {
	      changePassword: 'แก้ไขรหัสผ่าน',
	      hidePassword: 'ซ่อน',
	      deactivateAccount: 'ระงับการใช้งานของบัญชีนี้',
	      enableAccount: 'เปิดใช้งานบัญชีนี้'
	    },
	    role: {
	      manager: 'Manager',
	      user: {
	        textGuide: '(สิทธิ์ของผู้ใช้งานประเภทนี้ จะไม่สามารถจัดการสมาชิกในทีม ตั้งค่าทีม และจัดการบัญชีได้)'
	      }
	    }
	  },
	  support: {
	    labels: {
	      contactUS: 'ติดต่อ ByteArk',
	      subject: 'หัวข้อ',
	      message: 'รายละเอียด',
	      textGuide: 'หากคุณมีข้อสงสัย กรุณาส่งข้อความหาเราผ่านแบบฟอร์มด้านล่างนี้'
	    }
	  },
	  monthlyUsageHistory: {
	    labels: {
	      monthlyUsageHistory: 'ค่าใช้บริการระหว่างรอบบิล',
	      noUsageHistory: 'ไม่มีการใช้บริการในเดือนนี้'
	    },
	    action: {
	      report: 'ดาวน์โหลดรายงาน'
	    }
	  },
	  clientUsageHistory: {
	    labels: {
	      team: 'ชื่อทีม',
	      invoiceNumber: 'หมายเลขใบแจ้งหนี้',
	      usage: 'ปริมาณการใช้งาน',
	      sellingPrice: 'ราคาขาย',
	      discount: 'ส่วนลด',
	      retailPrice: 'ราคา',
	      netPrice: 'ราคาสุทธิหลังหักส่วนลด',
	      noClientUsageHistory: 'ไม่มีการใช้งานในเดือนนี้',
	      dateIssued: 'วันที่ออกเอกสาร'
	    },
	    action: {
	      usageReport: 'สรุปการใช้งานรายเดือน',
	      create: 'สร้าง'
	    }
	  },
	  manageClientTeam: {
	    labels: {
	      name: 'ชื่อ',
	      url: 'URL',
	      type: 'ประเภท',
	      reseller: 'Reseller',
	      payPlan: 'การชำระเงิน'
	    },
	    action: {
	      usageReport: 'สรุปการใช้งานรายเดือน',
	      create: 'สร้างลูกค้าใหม่'
	    }
	  },
	  payPlan: {
	    labels: {
	      postPaid: 'Post Paid',
	      prePaid: 'Pre Paid'
	    }
	  },
	  statement: {
	    labels: {
	      statement: 'รายการเคลื่อนไหวของบัญชี',
	      orderNumber: 'หมายเลขใบรับเงิน',
	      invoiceNumber: 'หมายเลขใบแจ้งหนี้',
	      receiptNumber: 'หมายเลขใบเสร็จรับเงิน',
	      description: 'รายละเอียด',
	      amount: 'ยอดเงิน',
	      noBillingHistory: 'ไม่มีความเคลื่อนไหวของบัญชีในปีนี้',
	      credit: 'เครดิตที่มีอยู่',
	      charge: 'หักออก',
	      remaining: 'คงเหลือ'
	    },
	    action: {
	      download: 'ดาวน์โหลดใบแจ้งหนี้',
	      usageReport: 'สรุปการใช้งานรายเดือน',
	      statement: 'ดูรายการเคลื่อนไหวของบัญชี'
	    }
	  },
	  suspend: {
	    labels: {
	      suspend: 'บัญชีของทีมคุณถูกระงับการใช้งาน',
	      defaultMessage: 'เครดิตปัจจุบันของคุณไม่พอต่อการใช้งาน กรุณาเติมเครดิตเพิ่ม'
	    }
	  }
	};

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(37);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = {
	  namespace: function namespace(field) {
	    return 'The ' + field + ' must contain 3-32 characters, can be lowercase, dash and numbers';
	  },
	  custom_price_between: function custom_price_between(field, _ref, value) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        min = _ref2[0],
	        max = _ref2[1];
	
	    if (Number(value) < Number(min)) {
	      return 'Please refill at least ' + Number(min).toLocaleString() + ' THB.';
	    } else if (Number(value) > Number(max)) {
	      return 'Please contact ByteArk if you want to refill more than ' + Number(max).toLocaleString() + ' THB';
	    }
	    return 'The ' + field + ' field must be between ' + Number(min).toLocaleString() + ' and ' + Number(max).toLocaleString() + '.';
	  }
	};
	
	var locale = {
	  name: 'en',
	  messages: messages,
	  attributes: {
	    email: 'Email',
	    password: 'Password',
	    new_password: 'New Password',
	    confirm_new_password: 'Confirm New Password',
	    team: 'Team Display name',
	    displayname: 'Display Name',
	    role: 'Role',
	    first_name: 'First Name',
	    last_name: 'Last Name',
	    address1: 'Address Line 1',
	    city: 'City / Town',
	    state: 'State / Province / Region',
	    zipcode: 'ZIP Code',
	    country: 'Country',
	    contact_phone: 'Billing Contact Phone',
	    contact_email: 'Billing E-mail'
	  }
	};
	
	exports.default = locale;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(37);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = {
	  _default: function _default(field) {
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07';
	  },
	  after: function after(field, _ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
	        target = _ref2[0];
	
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01 ' + target + '.';
	  },
	  alpha_dash: function alpha_dash(field) {
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E20\u0E32\u0E29\u0E32\u0E2D\u0E31\u0E07\u0E01\u0E24\u0E29 \u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 \u0E41\u0E25\u0E30 _ \u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19';
	  },
	  alpha_num: function alpha_num(field) {
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E20\u0E32\u0E29\u0E32\u0E2D\u0E31\u0E07\u0E01\u0E24\u0E29 \u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 \u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19';
	  },
	  alpha_spaces: function alpha_spaces(field) {
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E20\u0E32\u0E29\u0E32\u0E2D\u0E31\u0E07\u0E01\u0E24\u0E29 \u0E0A\u0E48\u0E2D\u0E07\u0E27\u0E48\u0E32\u0E07 \u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19';
	  },
	  alpha: function alpha(field) {
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E20\u0E32\u0E29\u0E32\u0E2D\u0E31\u0E07\u0E01\u0E24\u0E29\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19';
	  },
	  before: function before(field, _ref3) {
	    var _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
	        target = _ref4[0];
	
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32 ' + target + '.';
	  },
	  between: function between(field, _ref5) {
	    var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
	        min = _ref6[0],
	        max = _ref6[1];
	
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E0A\u0E48\u0E27\u0E07\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 ' + min + ' - ' + max + '.';
	  },
	  confirmed: function confirmed(field) {
	    return 'The ' + field + ' confirmation does not match.';
	  },
	  credit_card: function credit_card(field) {
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07';
	  },
	  date_between: function date_between(field, _ref7) {
	    var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
	        min = _ref8[0],
	        max = _ref8[1];
	
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 ' + min + ' - ' + max + '.';
	  },
	  date_format: function date_format(field, _ref9) {
	    var _ref10 = (0, _slicedToArray3.default)(_ref9, 1),
	        format = _ref10[0];
	
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19 ' + format + '.';
	  },
	  decimal: function decimal(field) {
	    var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['*'],
	        _ref12 = (0, _slicedToArray3.default)(_ref11, 1),
	        decimals = _ref12[0];
	
	    return 'The ' + field + ' must be numeric and may contain ' + (decimals === '*' ? '' : decimals) + ' decimal points.';
	  },
	  digits: function digits(field, _ref13) {
	    var _ref14 = (0, _slicedToArray3.default)(_ref13, 1),
	        length = _ref14[0];
	
	    return 'The ' + field + ' must be numeric and exactly contain ' + length + ' digits.';
	  },
	  dimensions: function dimensions(field, _ref15) {
	    var _ref16 = (0, _slicedToArray3.default)(_ref15, 2),
	        width = _ref16[0],
	        height = _ref16[1];
	
	    return 'The ' + field + ' must be ' + width + ' pixels by ' + height + ' pixels.';
	  },
	  email: function email(field) {
	    return 'The ' + field + ' must be a valid email.';
	  },
	  ext: function ext(field) {
	    return 'The ' + field + ' must be a valid file.';
	  },
	  image: function image(field) {
	    return 'The ' + field + ' must be an image.';
	  },
	  in: function _in(field) {
	    return 'The ' + field + ' must be a valid value.';
	  },
	  ip: function ip(field) {
	    return 'The ' + field + ' must be a valid ip address.';
	  },
	  max: function max(field, _ref17) {
	    var _ref18 = (0, _slicedToArray3.default)(_ref17, 1),
	        length = _ref18[0];
	
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19 ' + length + ' \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23';
	  },
	  max_value: function max_value(field, _ref19) {
	    var _ref20 = (0, _slicedToArray3.default)(_ref19, 1),
	        max = _ref20[0];
	
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E08\u0E33\u0E19\u0E27\u0E19\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19 ' + max + ' \u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32';
	  },
	  mimes: function mimes(field) {
	    return 'The ' + field + ' must have a valid file type.';
	  },
	  min: function min(field, _ref21) {
	    var _ref22 = (0, _slicedToArray3.default)(_ref21, 1),
	        length = _ref22[0];
	
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E44\u0E21\u0E48\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 ' + length + ' \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23';
	  },
	  min_value: function min_value(field, _ref23) {
	    var _ref24 = (0, _slicedToArray3.default)(_ref23, 1),
	        min = _ref24[0];
	
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 ' + min;
	  },
	  not_in: function not_in(field) {
	    return 'The ' + field + ' must be a valid value.';
	  },
	  numeric: function numeric(field) {
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02';
	  },
	  regex: function regex(field) {
	    return 'The ' + field + ' format is invalid.';
	  },
	  required: function required(field) {
	    return '\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 ' + field + ' \u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E23\u0E2D\u0E01';
	  },
	  size: function size(field, _ref25) {
	    var _ref26 = (0, _slicedToArray3.default)(_ref25, 1),
	        _size = _ref26[0];
	
	    return 'The ' + field + ' must be less than ' + _size + ' KB.';
	  },
	  url: function url(field) {
	    return 'The ' + field + ' is not a valid URL.';
	  },
	  namespace: function namespace(field) {
	    return field + ' \u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22 3-32 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23 \u0E41\u0E25\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E31\u0E27\u0E20\u0E32\u0E29\u0E32\u0E2D\u0E31\u0E07\u0E01\u0E24\u0E29\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E40\u0E25\u0E47\u0E01 \u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 \u0E41\u0E25\u0E30 _ \u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19';
	  },
	  custom_price_between: function custom_price_between(field, _ref27, value) {
	    var _ref28 = (0, _slicedToArray3.default)(_ref27, 2),
	        min = _ref28[0],
	        max = _ref28[1];
	
	    if (Number(value) < Number(min)) {
	      return '\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E15\u0E34\u0E21\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E49\u0E19\u0E2D\u0E22 ' + Number(min).toLocaleString() + ' \u0E1A\u0E32\u0E17';
	    } else if (Number(value) > Number(max)) {
	      return '\u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E17\u0E35\u0E21\u0E07\u0E32\u0E19 ByteArk \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E15\u0E34\u0E21\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 ' + Number(max).toLocaleString() + ' \u0E1A\u0E32\u0E17';
	    }
	    return field + ' \u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 ' + Number(min).toLocaleString() + ' - ' + Number(max).toLocaleString() + '.';
	  }
	};
	
	var locale = {
	  name: 'th',
	  messages: messages,
	  attributes: {
	    email: 'อีเมล',
	    password: 'รหัสผ่าน',
	    new_password: 'รหัสผ่านใหม่',
	    confirm_new_password: 'ยืนยันรหัสผ่านใหม่',
	    team: 'ชื่อทีม',
	    displayname: 'ชื่อที่ใช้แสดงผล',
	    role: 'สิทธิ์ของสมาชิก',
	    first_name: 'ชื่อ',
	    last_name: 'นามสกุล',
	    address1: 'ที่อยู่',
	    city: 'เขต / อำเภอ',
	    state: 'แขวง / จังหวัด',
	    zipcode: 'รหัสไปรษณีย์',
	    country: 'ประเทศ',
	    contact_phone: 'เบอร์โทรศัพท์ที่ใช้ติดต่อ',
	    contact_email: 'อีเมลที่ใช้ติดต่อ'
	  }
	};
	
	exports.default = locale;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _AuthManager = __webpack_require__(18);
	
	var _AuthManager2 = _interopRequireDefault(_AuthManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authManager = new _AuthManager2.default();
	
	var matchLoginLogoutPath = function matchLoginLogoutPath(record) {
	  return record.path === '/:namespace/login' || record.path === '/:namespace/forgot';
	};
	
	var currentNamespace = null;
	
	var guard = function guard(to, from, next) {
	  if (currentNamespace && currentNamespace !== to.params.namespace) {
	    window.location.reload(to, true);
	    return;
	  }
	  currentNamespace = to.params.namespace;
	
	  if (to.matched.some(function (record) {
	    return record.meta.requiresAuth;
	  })) {
	    authManager.checkAuth(to.params.namespace).then(function (credential) {
	      _axios2.default.defaults.headers.common.Authorization = 'Bearer ' + credential.access_token;
	      return next();
	    }).catch(function () {
	      return next('/' + to.params.namespace + '/login');
	    });
	  } else if (to.matched.some(matchLoginLogoutPath)) {
	    authManager.checkAuth(to.params.namespace).then(function (credential) {
	      _axios2.default.defaults.headers.common.Authorization = 'Bearer ' + credential.access_token;
	
	      if ((0, _keys2.default)(to.query).length <= 0) {
	        return next('/' + to.params.namespace + '/');
	      } else {
	        return next();
	      }
	    }).catch(function () {
	      return next();
	    });
	  } else {
	    next();
	  }
	};
	
	exports.default = guard;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueRouter = __webpack_require__(201);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _AuthManager = __webpack_require__(18);
	
	var _AuthManager2 = _interopRequireDefault(_AuthManager);
	
	var _AppChrome = __webpack_require__(481);
	
	var _AppChrome2 = _interopRequireDefault(_AppChrome);
	
	var _TeamChrome = __webpack_require__(484);
	
	var _TeamChrome2 = _interopRequireDefault(_TeamChrome);
	
	var _AdminChrome = __webpack_require__(480);
	
	var _AdminChrome2 = _interopRequireDefault(_AdminChrome);
	
	var _Home = __webpack_require__(447);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Login = __webpack_require__(489);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _ForgotPassword = __webpack_require__(486);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _RecoveryPassword = __webpack_require__(487);
	
	var _RecoveryPassword2 = _interopRequireDefault(_RecoveryPassword);
	
	var _Register = __webpack_require__(494);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _ActivateAccount = __webpack_require__(493);
	
	var _ActivateAccount2 = _interopRequireDefault(_ActivateAccount);
	
	var _BillingChrome = __webpack_require__(482);
	
	var _BillingChrome2 = _interopRequireDefault(_BillingChrome);
	
	var _BillingSummary = __webpack_require__(461);
	
	var _BillingSummary2 = _interopRequireDefault(_BillingSummary);
	
	var _TeamMemberBrowser = __webpack_require__(496);
	
	var _TeamMemberBrowser2 = _interopRequireDefault(_TeamMemberBrowser);
	
	var _TeamDeactivate = __webpack_require__(495);
	
	var _TeamDeactivate2 = _interopRequireDefault(_TeamDeactivate);
	
	var _TeamSetting = __webpack_require__(499);
	
	var _TeamSetting2 = _interopRequireDefault(_TeamSetting);
	
	var _TeamMemberCreator = __webpack_require__(497);
	
	var _TeamMemberCreator2 = _interopRequireDefault(_TeamMemberCreator);
	
	var _TeamMemberEditor = __webpack_require__(498);
	
	var _TeamMemberEditor2 = _interopRequireDefault(_TeamMemberEditor);
	
	var _TeamBrowser = __webpack_require__(456);
	
	var _TeamBrowser2 = _interopRequireDefault(_TeamBrowser);
	
	var _AddonCostBrowser = __webpack_require__(451);
	
	var _AddonCostBrowser2 = _interopRequireDefault(_AddonCostBrowser);
	
	var _AddonCostCreator = __webpack_require__(452);
	
	var _AddonCostCreator2 = _interopRequireDefault(_AddonCostCreator);
	
	var _TeamCreator = __webpack_require__(457);
	
	var _TeamCreator2 = _interopRequireDefault(_TeamCreator);
	
	var _TeamEditor = __webpack_require__(458);
	
	var _TeamEditor2 = _interopRequireDefault(_TeamEditor);
	
	var _TeamBillingSummary = __webpack_require__(455);
	
	var _TeamBillingSummary2 = _interopRequireDefault(_TeamBillingSummary);
	
	var _CreditTransactionBrowser = __webpack_require__(460);
	
	var _CreditTransactionBrowser2 = _interopRequireDefault(_CreditTransactionBrowser);
	
	var _Page = __webpack_require__(196);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Page3 = __webpack_require__(485);
	
	var _Page4 = _interopRequireDefault(_Page3);
	
	var _PageUsageReport = __webpack_require__(470);
	
	var _PageUsageReport2 = _interopRequireDefault(_PageUsageReport);
	
	var _PageOrderNumberReport = __webpack_require__(469);
	
	var _PageOrderNumberReport2 = _interopRequireDefault(_PageOrderNumberReport);
	
	var _PaymentResponse = __webpack_require__(474);
	
	var _PaymentResponse2 = _interopRequireDefault(_PaymentResponse);
	
	var _Profile = __webpack_require__(492);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _EditPassword = __webpack_require__(491);
	
	var _EditPassword2 = _interopRequireDefault(_EditPassword);
	
	var _ManageClientUsageHistory = __webpack_require__(453);
	
	var _ManageClientUsageHistory2 = _interopRequireDefault(_ManageClientUsageHistory);
	
	var _Support = __webpack_require__(450);
	
	var _Support2 = _interopRequireDefault(_Support);
	
	var _guard = __webpack_require__(225);
	
	var _guard2 = _interopRequireDefault(_guard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authManager = new _AuthManager2.default();
	
	var routes = [{
	  path: '/',
	  redirect: '/login'
	}, {
	  path: '/login',
	  component: _Login2.default
	}, {
	  path: '/register',
	  component: _Register2.default
	}, {
	  path: '/:namespace/login',
	  component: _Login2.default
	}, {
	  path: '/:namespace/forgot',
	  component: _ForgotPassword2.default
	}, {
	  path: '/:namespace/activate/:token',
	  component: _ActivateAccount2.default
	}, {
	  path: '/:namespace/recovery/:token',
	  component: _RecoveryPassword2.default
	}, {
	  path: '/:namespace/403',
	  component: _Page2.default
	}, {
	  path: '/:namespace/404',
	  component: _Page4.default
	}, {
	  path: '/:namespace/usage-report',
	  component: _PageUsageReport2.default,
	  meta: { requiresAuth: true }
	}, {
	  path: '/:namespace/transactions',
	  component: _PageOrderNumberReport2.default,
	  meta: { requiresAuth: true }
	}, {
	  path: '/:namespace/billing/payment/:id',
	  component: _PaymentResponse2.default,
	  meta: { requiresAuth: true }
	}, {
	  path: '/:namespace/admin/teams/:subnamespace/usage-report',
	  component: _PageUsageReport2.default,
	  meta: { requiresAuth: true } }, {
	  path: '/:namespace/admin/teams/:subnamespace/transactions',
	  component: _PageOrderNumberReport2.default,
	  meta: { requiresAuth: true } }, {
	  path: '/:namespace/reseller/teams/:subnamespace/usage-report',
	  component: _PageUsageReport2.default,
	  meta: { requiresAuth: true } }, {
	  path: '/:namespace',
	  component: _AppChrome2.default,
	  redirect: '/:namespace/dashboard',
	  meta: { requiresAuth: true },
	  children: [{
	    path: 'dashboard',
	    component: _Home2.default
	  }, {
	    path: 'billing',
	    redirect: '',
	    component: _BillingChrome2.default,
	    children: [{
	      path: '',
	      component: _BillingSummary2.default
	    }]
	  }, {
	    path: 'team',
	    component: _TeamChrome2.default,
	    redirect: 'team/members',
	    meta: { requiresManager: true },
	    children: [{
	      path: 'members',
	      component: _TeamMemberBrowser2.default
	    }, {
	      path: 'members/create',
	      component: _TeamMemberCreator2.default
	    }, {
	      path: 'members/:memberId/edit',
	      component: _TeamMemberEditor2.default
	    }, {
	      path: 'deactivate',
	      component: _TeamDeactivate2.default
	    }, {
	      path: 'setting',
	      component: _TeamSetting2.default
	    }]
	  }, {
	    path: 'self/profile',
	    component: _Profile2.default
	  }, {
	    path: 'self/password',
	    component: _EditPassword2.default
	  }, {
	    path: 'support',
	    component: _Support2.default
	  }, {
	    path: 'logout',
	    beforeEnter: function beforeEnter(to, from, next) {
	      authManager.logout(to.params.namespace).then(function () {
	        next('/' + to.params.namespace + '/login');
	      });
	    }
	  }, {
	    path: 'admin',
	    component: _AdminChrome2.default,
	    redirect: 'admin/teams',
	    meta: { requiresManager: true },
	    children: [{
	      path: 'teams',
	      component: _TeamBrowser2.default
	    }, {
	      path: 'teams/create',
	      component: _TeamCreator2.default
	    }, {
	      path: 'teams/:subnamespace/edit',
	      component: _TeamEditor2.default
	    }, {
	      path: 'teams/:subnamespace/members/create',
	      component: _TeamMemberCreator2.default
	    }, {
	      path: 'teams/:subnamespace/members/:memberId/edit',
	      component: _TeamMemberEditor2.default
	    }, {
	      path: 'teams/:subnamespace/billings',
	      component: _TeamBillingSummary2.default
	    }, {
	      path: 'client-usage-history',
	      component: _ManageClientUsageHistory2.default
	    }, {
	      path: 'addon-cost',
	      component: _AddonCostBrowser2.default
	    }, {
	      path: 'addon-cost/create',
	      component: _AddonCostCreator2.default
	    }, {
	      path: 'transactions',
	      component: _CreditTransactionBrowser2.default
	    }]
	  }, {
	    path: 'reseller',
	    component: _AdminChrome2.default,
	    redirect: 'reseller/teams',
	    meta: { requiresSuperAdmin: false },
	    children: [{
	      path: 'teams',
	      component: _TeamBrowser2.default
	    }, {
	      path: 'teams/create',
	      component: _TeamCreator2.default
	    }, {
	      path: 'teams/:subnamespace/edit',
	      component: _TeamEditor2.default
	    }, {
	      path: 'teams/:subnamespace/members/create',
	      component: _TeamMemberCreator2.default
	    }, {
	      path: 'teams/:subnamespace/members/:memberId/edit',
	      component: _TeamMemberEditor2.default
	    }, {
	      path: 'teams/:subnamespace/billings',
	      component: _TeamBillingSummary2.default
	    }]
	  }]
	}];
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: routes,
	  scrollBehavior: function scrollBehavior() {
	    return { x: 0, y: 0 };
	  }
	});
	
	router.beforeEach(_guard2.default);
	
	exports.default = router;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(203);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(7);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _currentUser = __webpack_require__(228);
	
	var _currentUser2 = _interopRequireDefault(_currentUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    currentUser: _currentUser2.default
	  },
	  strict: debug
	});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(304);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _StorageManager = __webpack_require__(16);
	
	var _StorageManager2 = _interopRequireDefault(_StorageManager);
	
	var _mutationTypes = __webpack_require__(229);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  data: {
	    display_image: {
	      sizes: {
	        default: {},
	        large: {},
	        medium: {},
	        small: {}
	      }
	    },
	    email: null,
	    id: null,
	    lang: 'th',
	    name: null,
	    role: null,
	    team: {},
	    team_id: null
	  },
	  error: null,
	  isLoading: false
	};
	
	var getters = {
	  currentUser: function currentUser(state) {
	    return state.data;
	  },
	
	  getCurrentUserError: function getCurrentUserError(state) {
	    return state.error;
	  },
	
	  isLoadingCurrentUser: function isLoadingCurrentUser(state) {
	    return state.isLoading;
	  }
	};
	
	var actions = {
	  getCurrentUser: function getCurrentUser(_ref) {
	    var commit = _ref.commit;
	
	    commit(types.FETCH_CURRENT_USER_REQUEST);
	
	    _axios2.default.get('/api/user').then(function (response) {
	      commit(types.FETCH_CURRENT_USER_SUCCESS, response.data);
	
	      commit(types.SAVE_CURRENT_TEAM, response.data.team);
	    }).catch(function (error) {
	      commit(types.FETCH_CURRENT_USER_FAILURE, error);
	    });
	  },
	  updateCurrentUserTeam: function updateCurrentUserTeam(_ref2, team) {
	    var commit = _ref2.commit;
	
	    commit(types.UPDATE_CURRENT_USER_TEAM, team);
	
	    commit(types.SAVE_CURRENT_TEAM, team);
	  },
	  updateCurrentUserLang: function updateCurrentUserLang(_ref3, lang) {
	    var commit = _ref3.commit;
	
	    commit(types.UPDATE_CURRENT_USER_LANG, lang);
	  },
	  clearCurrentUser: function clearCurrentUser(_ref4) {
	    var commit = _ref4.commit;
	
	    commit(types.CLEAR_CURRENT_USER);
	  }
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.FETCH_CURRENT_USER_REQUEST, function (state) {
	  state.isLoading = true;
	}), (0, _defineProperty3.default)(_mutations, types.FETCH_CURRENT_USER_SUCCESS, function (state, user) {
	  state.isLoading = false;
	  state.data = user;
	}), (0, _defineProperty3.default)(_mutations, types.FETCH_CURRENT_USER_FAILURE, function (state, error) {
	  state.isLoading = false;
	  state.error = error;
	}), (0, _defineProperty3.default)(_mutations, types.UPDATE_CURRENT_USER_TEAM, function (state, team) {
	  state.data.team = team;
	}), (0, _defineProperty3.default)(_mutations, types.SAVE_CURRENT_TEAM, function (state, team) {
	  var storageManager = new _StorageManager2.default();
	  storageManager.setTeam(team);
	}), (0, _defineProperty3.default)(_mutations, types.UPDATE_CURRENT_USER_LANG, function (state, lang) {
	  state.data.lang = lang;
	}), (0, _defineProperty3.default)(_mutations, types.CLEAR_CURRENT_USER, function (state) {
	  state.data = null;
	  state.error = null;
	  state.isLoading = false;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 229 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FETCH_CURRENT_USER_REQUEST = exports.FETCH_CURRENT_USER_REQUEST = 'FETCH_CURRENT_USER_REQUEST';
	var FETCH_CURRENT_USER_SUCCESS = exports.FETCH_CURRENT_USER_SUCCESS = 'FETCH_CURRENT_USER_SUCCESS';
	var FETCH_CURRENT_USER_FAILURE = exports.FETCH_CURRENT_USER_FAILURE = 'FETCH_CURRENT_USER_FAILURE';
	
	var UPDATE_CURRENT_USER_TEAM = exports.UPDATE_CURRENT_USER_TEAM = 'UPDATE_CURRENT_USER_TEAM';
	
	var SAVE_CURRENT_TEAM = exports.SAVE_CURRENT_TEAM = 'SAVE_CURRENT_TEAM';
	
	var UPDATE_CURRENT_USER_LANG = exports.UPDATE_CURRENT_USER_LANG = 'UPDATE_CURRENT_USER_LANG';
	
	var CLEAR_CURRENT_USER = exports.CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER';

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _promise = __webpack_require__(57);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _slicedToArray2 = __webpack_require__(37);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _veeValidate = __webpack_require__(5);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _th = __webpack_require__(224);
	
	var _th2 = _interopRequireDefault(_th);
	
	var _en = __webpack_require__(223);
	
	var _en2 = _interopRequireDefault(_en);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_veeValidate2.default.Validator.extend('namespace', {
	  getMessage: function getMessage(field) {
	    return 'The ' + field + ' must contain 3-32 characters, can be lowercase, dash and numbers';
	  },
	  validate: function validate(value) {
	    return value !== null && value.match('^[a-z0-9][a-z0-9\\-]+[a-z0-9]$') !== null;
	  }
	});
	
	_veeValidate2.default.Validator.extend('custom_price_between', {
	  getMessage: function getMessage(field, _ref, value) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        min = _ref2[0],
	        max = _ref2[1];
	
	    if (Number(value) < Number(min)) {
	      return 'Please refill at least ' + Number(min).toLocaleString() + ' THB.';
	    } else if (Number(value) > Number(max)) {
	      return 'Please contact ByteArk if you want to refill more than ' + Number(max).toLocaleString() + ' THB';
	    }
	    return 'The ' + field + ' field must be between ' + Number(min).toLocaleString() + ' and ' + Number(max).toLocaleString() + '.';
	  },
	  validate: function validate(value, _ref3) {
	    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	        min = _ref4[0],
	        max = _ref4[1];
	
	    return new _promise2.default(function (resolve) {
	      resolve({
	        valid: Number(min) <= value && Number(max) >= value,
	        data: value
	      });
	    });
	  }
	});
	
	_veeValidate2.default.ErrorBag.prototype.addAll = function (errors) {
	  var _this = this;
	
	  (0, _keys2.default)(errors).forEach(function (key) {
	    var messages = errors[key];
	    if (messages.length > 0) {
	      _this.add.call(_this, key, messages[0], '');
	    }
	  });
	};
	
	_veeValidate2.default.Validator.addLocale(_th2.default);
	_veeValidate2.default.Validator.addLocale(_en2.default);
	
	var VeeValidateConfig = {
	  locale: 'th'
	};
	
	exports.default = VeeValidateConfig;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Chrome = __webpack_require__(483);
	
	var _Chrome2 = _interopRequireDefault(_Chrome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Chrome: _Chrome2.default
	  }
	};

/***/ },
/* 232 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  props: {
	    alertClass: {
	      type: String,
	      default: ''
	    },
	    iconClass: {
	      type: String,
	      default: null
	    },
	    type: {
	      type: String,
	      required: true
	    }
	  }
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	var _MainCurrentState = __webpack_require__(462);
	
	var _MainCurrentState2 = _interopRequireDefault(_MainCurrentState);
	
	var _Year2015PricingPlan = __webpack_require__(478);
	
	var _Year2015PricingPlan2 = _interopRequireDefault(_Year2015PricingPlan);
	
	var _Year2017PricingPlan = __webpack_require__(479);
	
	var _Year2017PricingPlan2 = _interopRequireDefault(_Year2017PricingPlan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    MainCurrentState: _MainCurrentState2.default,
	    Year2015PricingPlan: _Year2015PricingPlan2.default,
	    Year2017PricingPlan: _Year2017PricingPlan2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    isLoading: function isLoading() {
	      return this.isCurrentStatLoading;
	    },
	    showMainCurrentState: function showMainCurrentState() {
	      if (this.team) {
	        if (this.team.is_superadmin || this.team.has_reseller) {
	          return false;
	        }
	      }
	
	      if (this.currentUser.role === 'user') {
	        return false;
	      }
	
	      return true;
	    },
	    showMonthlyPricingPlan: function showMonthlyPricingPlan() {
	      if (this.team) {
	        if (this.team.is_superadmin || this.team.has_reseller) {
	          return false;
	        }
	      }
	
	      if (this.currentUser.role === 'user') {
	        return false;
	      }
	
	      return true;
	    },
	    team: function team() {
	      if (this.currentUser) {
	        return this.currentUser.team;
	      }
	      return null;
	    },
	    serviceS3URL: function serviceS3URL() {
	      if (this.currentUser) {
	        var namespace = this.currentUser.team.namespace;
	        return '' + ("http://console.arkcube.net/switch.php?team=") + namespace;
	      }
	      return null;
	    },
	    serviceQoderURL: function serviceQoderURL() {
	      if (this.currentUser) {
	        var namespace = this.currentUser.team.namespace;
	        return ("https://qoder.arkcube.net/switch") + '/' + namespace;
	      }
	      return null;
	    },
	    serviceFleetURL: function serviceFleetURL() {
	      if (this.currentUser) {
	        var namespace = this.currentUser.team.namespace;
	        return ("https://fleet.arkcube.net/switch") + '/' + namespace;
	      }
	      return null;
	    }
	  }),
	  data: function data() {
	    return {
	      showCurrentStat: false,
	      isCurrentStatLoading: false,
	      showPricingPlan2015: false
	    };
	  },
	  created: function created() {
	    if (this.team) {
	      this.showPricingPlan2015 = this.team.pricing_plan === 'year_2015' ? 1 : 0;
	    }
	  },
	  mounted: function mounted() {
	    this.checkVisibleComponents();
	  },
	  methods: {
	    checkVisibleComponents: function checkVisibleComponents() {
	      if (!this.team.is_reseller && !this.team.has_reseller) {
	        var isTeamManager = this.currentUser.role === 'manager';
	
	        if (isTeamManager) {
	          this.showCurrentStat = true;
	        }
	      } else if (this.team.is_reseller) {
	        this.showCurrentStat = true;
	      } else if (this.team.has_reseller) {}
	    },
	    currentStatLoadChanged: function currentStatLoadChanged(value) {
	      this.isCurrentStatLoading = value;
	    }
	  }
	};

/***/ },
/* 234 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    isSubmiting: {
	      type: Boolean,
	      default: false
	    },
	    loaderIconClass: {
	      type: String,
	      default: 'loader-circle'
	    }
	  }
	};

/***/ },
/* 235 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 236 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Modal',
	  props: {
	    blocking: {
	      type: Boolean,
	      default: false
	    }
	  },
	  watch: {
	    is_open: function is_open(value) {
	      document.body.classList.toggle('modal-open', value);
	    }
	  },
	  data: function data() {
	    return {
	      is_open: false
	    };
	  },
	  methods: {
	    open: function open() {
	      this.is_open = true;
	
	      this.$emit('open');
	    },
	    close: function close() {
	      this.is_open = false;
	
	      this.$emit('close');
	    },
	    onOverlayClick: function onOverlayClick(event) {
	      if (!event.target.classList || event.target.classList.contains('modal')) {
	        if (!this.blocking) {
	          this.close();
	        }
	      }
	    }
	  }
	};

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    teamData: {
	      type: Object
	    },
	    currentMonth: {
	      type: String
	    }
	  },
	  computed: {
	    monthList: function monthList() {
	      var list = [];
	
	      if (this.teamData) {
	        var now = (0, _moment2.default)().startOf('months');
	        var start = (0, _moment2.default)(this.teamData.created_at).startOf('months');
	        var months = now.diff(start, 'months');
	        list.push(now.format('MMMM YYYY'));
	
	        for (var i = 0; i < months; i += 1) {
	          list.push(now.subtract(1, 'months').format('MMMM YYYY'));
	        }
	      }
	
	      return list;
	    }
	  },
	  data: function data() {
	    return {
	      value: (0, _moment2.default)().startOf('month').format('MMMM YYYY')
	    };
	  },
	  methods: {
	    onChange: function onChange() {
	      this.$emit('input', this.value);
	    }
	  }
	};

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser', 'getCurrentUserError']), {
	    showBillingMenu: function showBillingMenu() {
	      var userOfReseller = this.currentUser.team.is_reseller && this.currentUser.role === 'user';
	      return !this.currentUser.team.is_superadmin || userOfReseller;
	    },
	    showTeamMenu: function showTeamMenu() {
	      return this.currentUser.role === 'manager';
	    },
	    showDeactivateTeamMenu: function showDeactivateTeamMenu() {
	      if (this.currentUser.team.is_reseller || this.currentUser.team.has_reseller || this.currentUser.team.is_superadmin) {
	        return false;
	      }
	
	      return true;
	    },
	    showAdminMenu: function showAdminMenu() {
	      return this.currentUser.role === 'manager' && this.currentUser.team.is_superadmin;
	    },
	    showResellerMenu: function showResellerMenu() {
	      return this.currentUser.role === 'manager' && this.currentUser.team.is_reseller;
	    },
	    serviceS3URL: function serviceS3URL() {
	      if (this.currentUser) {
	        var namespace = this.currentUser.team.namespace;
	        return '' + ("http://console.arkcube.net/switch.php?team=") + namespace;
	      }
	      return null;
	    },
	    serviceQoderURL: function serviceQoderURL() {
	      if (this.currentUser) {
	        var namespace = this.currentUser.team.namespace;
	        return ("https://qoder.arkcube.net/switch") + '/' + namespace;
	      }
	      return null;
	    },
	    serviceFleetURL: function serviceFleetURL() {
	      if (this.currentUser) {
	        var namespace = this.currentUser.team.namespace;
	        return ("https://fleet.arkcube.net/switch") + '/' + namespace;
	      }
	      return null;
	    }
	  }),
	  data: function data() {
	    return {
	      isNavbarShow: false,
	      isShowSiteMenu: false,
	      isShowSubMenuTeam: false,
	      isShowSubMenuAdmin: false,
	      isShowSubMenuReseller: false
	    };
	  },
	  methods: {
	    showNavbar: function showNavbar(value) {
	      this.isNavbarShow = value;
	    },
	    showSiteMenu: function showSiteMenu() {
	      this.isShowSiteMenu = !this.isShowSiteMenu;
	    },
	    showSubMenuTeam: function showSubMenuTeam() {
	      this.isShowSubMenuTeam = !this.isShowSubMenuTeam;
	      if (this.isShowSubMenuTeam) {
	        this.isShowSubMenuAdmin = false;
	        this.isShowSubMenuReseller = false;
	      }
	    },
	    showSubMenuAdmin: function showSubMenuAdmin() {
	      this.isShowSubMenuAdmin = !this.isShowSubMenuAdmin;
	      if (this.isShowSubMenuAdmin) {
	        this.isShowSubMenuTeam = false;
	        this.isShowSubMenuReseller = false;
	      }
	    },
	    showSubMenuReseller: function showSubMenuReseller() {
	      this.isShowSubMenuReseller = !this.isShowSubMenuReseller;
	      if (this.isShowSubMenuReseller) {
	        this.isShowSubMenuTeam = false;
	        this.isShowSubMenuAdmin = false;
	      }
	    }
	  }
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _vuex = __webpack_require__(7);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    Alert: _Alert2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    'support.subject': function supportSubject() {
	      if (this.formErrors.has('subject')) {
	        this.formErrors.remove('subject');
	      }
	    },
	    'support.content': function supportContent() {
	      if (this.formErrors.has('content')) {
	        this.formErrors.remove('content');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser'])),
	  data: function data() {
	    return {
	      isSubmiting: false,
	      isLoading: false,
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      support: []
	    };
	  },
	  created: function created() {
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('subject', 'required', { prettyName: 'Subject' });
	    this.validator.attach('content', 'required', { prettyName: 'Content' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.showAlert = false;
	      this.validator.validateAll({
	        subject: this.support.subject,
	        content: this.support.content
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        _this.isSubmiting = true;
	        _axios2.default.post('/api/support/messages', {
	          subject: _this.support.subject,
	          content: _this.support.content
	        }).then(function () {
	          _this.isSubmiting = false;
	          _this.support = [];
	          _this.successResponse = _this.$t('contact.response.success');
	          _this.errorResponse = null;
	          _this.showAlert = true;
	        }).catch(function (error) {
	          _this.isSubmiting = false;
	
	          if (error.response.status === 422) {
	            _this.errorResponse = _this.$t('team.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else if (error.response.status === 400) {
	            _this.errorResponse = _this.$t('changePassword.response.failed');
	          } else {
	            _this.errorResponse = _this.$t('team.response.defaultFailed');
	          }
	
	          _this.showAlert = true;
	        });
	      }).catch(function () {});
	    }
	  }
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _sweetalert = __webpack_require__(23);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _vueSelect = __webpack_require__(35);
	
	var _vueSelect2 = _interopRequireDefault(_vueSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    vSelect: _vueSelect2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      isError: false,
	      total_addon: 0,
	      teams: [],
	      currentTeam: null,
	      addons: [],
	      pagination: {
	        total: 0,
	        per_page: 20,
	        current_page: 1,
	        last_page: 0,
	        from: 1,
	        to: 1,
	        next_page_url: null,
	        prev_page_url: null,
	        total_page: 0
	      }
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	  },
	  watch: {
	    currentTeam: function currentTeam(value) {
	      if (value) {
	        this.fetchAddons(value.value);
	      }
	    }
	  },
	  computed: {
	    filterItems: function filterItems() {
	      var temp = [];
	      this.teams.forEach(function (item) {
	        temp.push({ label: item.namespace, value: item.namespace });
	      });
	      return temp;
	    }
	  },
	  mounted: function mounted() {
	    this.fetchTeams();
	    this.fetchAddons();
	  },
	  methods: {
	    fetchTeams: function fetchTeams() {
	      var _this = this;
	
	      var url = '/api/teams?except=reseller';
	
	      _axios2.default.get(url).then(function (response) {
	        _this.teams = response.data.data;
	        _this.isLoading = false;
	        _this.isError = false;
	      }).catch(function () {
	        _this.isLoading = false;
	        _this.isError = true;
	      });
	    },
	    fetchAddons: function fetchAddons() {
	      var _this2 = this;
	
	      var url = '/api/admin/billaddons';
	      _axios2.default.get(url).then(function (response) {
	        _this2.total_addon = response.data.total;
	        _this2.makePagination(response.data);
	        _this2.addons = response.data.data;
	        _this2.isLoading = false;
	        _this2.isError = false;
	      }).catch(function () {
	        _this2.isLoading = false;
	        _this2.isError = true;
	      });
	    },
	    makePagination: function makePagination(data) {
	      this.pagination.total = data.total;
	      this.pagination.per_page = data.per_page;
	      this.pagination.current_page = data.current_page;
	      this.pagination.last_page = data.last_page;
	      this.pagination.from = data.from;
	      this.pagination.to = data.to;
	      this.pagination.next_page_url = data.next_page_url;
	      this.pagination.prev_page_url = data.prev_page_url;
	      this.pagination.total_page = Math.ceil(data.total / data.per_page);
	    },
	    getDate: function getDate(date) {
	      return (0, _moment2.default)(date, ['YYYY-MM', _moment2.default.ISO_8601]).format('MMM YYYY');
	    },
	    changePage: function changePage(page) {
	      this.fetchTeams(page);
	    },
	    changeItem: function changeItem(item, index) {
	      var _this3 = this;
	
	      var text = 'Are you sure to deactivate Add-on ' + item.description;
	      (0, _sweetalert2.default)({
	        title: 'Are you sure to deactivate?',
	        text: text,
	        showCancelButton: true,
	        confirmButtonColor: '#00A6ED',
	        cancelButtonColor: '#c6d3d7',
	        confirmButtonText: 'Yes, deactivate it',
	        closeOnConfirm: true
	      }).then(function () {
	        var url = 'api/admin/billaddons/' + item.id + '/deactivate';
	        _axios2.default.post(url).then(function (response) {
	          _this3.addons.splice(index, 1, response.data);
	          (0, _sweetalert2.default)('Success', 'Add-on have been deactive', 'success');
	        }).catch(function () {});
	      });
	    }
	  }
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _vueSelect = __webpack_require__(35);
	
	var _vueSelect2 = _interopRequireDefault(_vueSelect);
	
	var _veeValidate = __webpack_require__(5);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    Alert: _Alert2.default,
	    vSelect: _vueSelect2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  data: function data() {
	    return {
	      isSubmiting: false,
	      isLoading: false,
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      terminateMonthList: [],
	      currentStartMonth: (0, _moment2.default)().startOf('months').format('MMMM'),
	      currentStartYear: (0, _moment2.default)().startOf('months').format('YYYY'),
	      currentTerminateMonth: (0, _moment2.default)().startOf('months').add(6, 'months').format('MMMM'),
	      currentTerminateYear: (0, _moment2.default)().startOf('months').format('YYYY'),
	      description: '',
	      bill_description: '',
	      cost: 500,
	      type: 'one-time',
	      started_at: '2017-03',
	      terminate_at: '2017-03',
	      currentTeam: null,
	      teams: [],
	      CurrentItemCategory: 'LiveTranscodeVM',
	      itemCategory: ['LiveTranscodeVM', 'DataTransfer', 'Shipping', 'Custom']
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('team', 'required', { prettyName: 'Team' });
	    this.validator.attach('description', 'required', { prettyName: 'Description' });
	    this.validator.attach('bill_description', 'required', { prettyName: 'Billing Description' });
	    this.validator.attach('team_id', 'required', { prettyName: 'Team' });
	    this.validator.attach('cost', 'required', { prettyName: 'Cost' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounted: function mounted() {
	    this.fetchTeams();
	  },
	  computed: {
	    filterItems: function filterItems() {
	      var temp = [];
	      this.teams.forEach(function (item) {
	        temp.push({ label: item.namespace, value: item.id });
	      });
	      return temp;
	    },
	    monthList: function monthList() {
	      var list = [];
	
	      var now = (0, _moment2.default)().startOf('years');
	      list.push(now.format('MMMM'));
	
	      for (var i = 0; i < 11; i += 1) {
	        list.push(now.add(1, 'months').format('MMMM'));
	      }
	
	      return list;
	    },
	    yearList: function yearList() {
	      var list = [];
	
	      var now = (0, _moment2.default)().startOf('years');
	      list.push(now.format('YYYY'));
	
	      for (var i = 0; i < 12; i += 1) {
	        list.push(now.add(1, 'years').format('YYYY'));
	      }
	
	      return list;
	    },
	    currentStart: function currentStart() {
	      var start = (0, _moment2.default)().year(this.currentStartYear).month(this.currentStartMonth).format('YYYY-MM');
	      return start;
	    },
	    currentTerminate: function currentTerminate() {
	      var terminate = (0, _moment2.default)().year(this.currentTerminateYear).month(this.currentTerminateMonth).format('YYYY-MM');
	      return terminate;
	    }
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.showAlert = false;
	
	      this.validator.validateAll({
	        description: this.description,
	        bill_description: this.bill_description,
	        cost: this.cost,
	        team: this.currentTeam
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        _this.isSubmiting = true;
	
	        _axios2.default.post('api/admin/billaddons', {
	          description: _this.description,
	          bill_description: _this.bill_description,
	          team_id: _this.currentTeam.value,
	          type: _this.type,
	          cost: _this.cost,
	          item_category: _this.CurrentItemCategory,
	          started_at: _this.currentStart,
	          terminated_at: _this.type === 'recurring' ? _this.currentTerminate : null
	        }).then(function (response) {
	          _this.isSubmiting = false;
	          _this.addon = response.data;
	          _this.successResponse = _this.$t('team.response.success');
	          _this.errorResponse = null;
	          _this.showAlert = true;
	
	          setTimeout(function () {
	            _this.$router.push('/' + _this.$route.params.namespace + '/admin/addon-cost');
	          }, 2000);
	        }).catch(function (error) {
	          if (error.response.status === 422) {
	            _this.errorResponse = _this.$t('team.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorResponse = _this.$t('team.response.defaultFailed');
	          }
	          _this.showAlert = true;
	        });
	      }).catch(function () {});
	    },
	    fetchTeams: function fetchTeams() {
	      var _this2 = this;
	
	      var url = '/api/teams?except=reseller&nopage=true';
	
	      _axios2.default.get(url).then(function (response) {
	        _this2.teams = response.data;
	        _this2.isLoading = false;
	      }).catch(function () {});
	    },
	    checkTerminateDate: function checkTerminateDate() {
	      var diffTime = (0, _moment2.default)(this.currentTerminate).isBefore(this.currentStart);
	      var sameTime = (0, _moment2.default)(this.currentTerminate).isSame(this.currentStart);
	      if (diffTime || sameTime) {
	        var terminate = (0, _moment2.default)(this.currentStart).add(6, 'months');
	        this.currentTerminateMonth = (0, _moment2.default)(terminate, ['YYYY-MM', _moment2.default.ISO_8601]).format('MMMM');
	        this.currentTerminateYear = (0, _moment2.default)(terminate, ['YYYY-MM', _moment2.default.ISO_8601]).format('YYYY');
	      }
	    }
	  }
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	var _ClientUsageHistory = __webpack_require__(49);
	
	var _ClientUsageHistory2 = _interopRequireDefault(_ClientUsageHistory);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ClientUsageHistory: _ClientUsageHistory2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    isLoading: function isLoading() {
	      return this.isClientUsageHistoryLoading;
	    }
	  }),
	  data: function data() {
	    return {
	      team: null,
	      isClientUsageHistoryLoading: false
	    };
	  },
	  created: function created() {
	    this.team = this.currentUser.team;
	  },
	  methods: {
	    clientUsageHistoryLoadChanged: function clientUsageHistoryLoadChanged(value) {
	      this.isClientUsageHistoryLoading = value;
	    }
	  }
	};

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(7);
	
	var _veeValidate = __webpack_require__(5);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    team: function team(value) {
	      if (value) {}
	    },
	    amount: function amount() {
	      if (this.formErrors.has('amount')) {
	        this.formErrors.remove('amount');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser'])),
	  data: function data() {
	    return {
	      isSubmiting: false,
	      isLoading: false,
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      transactionType: 'deposit',
	      description: '',
	      amount: 0,
	      note: null
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	
	    this.$emit('loadChanged', false);
	
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('amount', 'required|min_value:1', { prettyName: 'Amount' });
	    this.validator.attach('description', 'required', { prettyName: 'Description' });
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  methods: {
	    onSubmitManualCredit: function onSubmitManualCredit() {
	      var _this = this;
	
	      this.showAlert = false;
	
	      this.validator.validateAll({
	        amount: this.amount,
	        description: this.description
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        _this.isSubmiting = true;
	
	        if (_this.transactionType === 'deposit') {
	          return _axios2.default.post('/api/admin/deposit', {
	            namespace: _this.team.namespace,
	            credit: _this.amount,
	            description: _this.description,
	            note: _this.note
	          });
	        } else if (_this.transactionType === 'deduct') {
	          return _axios2.default.post('/api/admin/deduct', {
	            namespace: _this.team.namespace,
	            credit: _this.amount,
	            description: _this.description,
	            note: _this.note
	          });
	        }
	      }).then(function () {
	        _this.isSubmiting = false;
	
	        if (_this.transactionType === 'deposit') {
	          _this.successResponse = _this.$t('depositcredit.response.success');
	        } else {
	          _this.successResponse = _this.$t('deductcredit.response.success');
	        }
	
	        _this.errorResponse = null;
	        _this.showAlert = true;
	        _this.amount = 0;
	        _this.description = '';
	        _this.note = '';
	
	        _this.eventHub.$emit('manualAddCreditSuccess');
	      }).catch(function (error) {
	        _this.isSubmiting = false;
	        if (error.response) {
	          if (error.response.status === 422) {
	            _this.errorResponse = error.response.data.credit;
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorResponse = _this.$t('team.response.defaultFailed');
	          }
	
	          _this.showAlert = true;
	        }
	      });
	    }
	  }
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _TeamInfo = __webpack_require__(466);
	
	var _TeamInfo2 = _interopRequireDefault(_TeamInfo);
	
	var _CurrentStat = __webpack_require__(192);
	
	var _CurrentStat2 = _interopRequireDefault(_CurrentStat);
	
	var _CurrentPackage = __webpack_require__(467);
	
	var _CurrentPackage2 = _interopRequireDefault(_CurrentPackage);
	
	var _ManualCredit = __webpack_require__(454);
	
	var _ManualCredit2 = _interopRequireDefault(_ManualCredit);
	
	var _BillingInformation = __webpack_require__(194);
	
	var _BillingInformation2 = _interopRequireDefault(_BillingInformation);
	
	var _Statement = __webpack_require__(193);
	
	var _Statement2 = _interopRequireDefault(_Statement);
	
	var _MonthlyUsageHistory = __webpack_require__(195);
	
	var _MonthlyUsageHistory2 = _interopRequireDefault(_MonthlyUsageHistory);
	
	var _ClientUsageHistory = __webpack_require__(49);
	
	var _ClientUsageHistory2 = _interopRequireDefault(_ClientUsageHistory);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TeamInfo: _TeamInfo2.default,
	    CurrentStat: _CurrentStat2.default,
	    CurrentPackage: _CurrentPackage2.default,
	    ManualCredit: _ManualCredit2.default,
	    BillingInformation: _BillingInformation2.default,
	    Statement: _Statement2.default,
	    MonthlyUsageHistory: _MonthlyUsageHistory2.default,
	    ClientUsageHistory: _ClientUsageHistory2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    isLoading: function isLoading() {
	      return this.isTeamInfoLoading || this.isCurrentStatLoading || this.isManualCreditLoading || this.isBillingInformationLoading || this.isMonthlyUsageHistoryLoading || this.isClientUsageHistoryLoading;
	    }
	  }),
	  watch: {
	    $route: function $route() {
	      this.fetchTeam();
	    }
	  },
	  data: function data() {
	    return {
	      showCurrentTeamInfo: true,
	      showCurrentStat: false,
	      showCurrentPackage: false,
	      showManualCredit: false,
	      showBillingInformation: false,
	      showMonthlyUsageHistory: false,
	      showStatement: false,
	      showClientUsageHistory: false,
	      team: null,
	      isTeamInfoLoading: false,
	      isCurrentStatLoading: false,
	      iscurrentPackageLoading: false,
	      isManualCreditLoading: false,
	      isBillingInformationLoading: false,
	      isMonthlyUsageHistoryLoading: false,
	      isStatementLoading: false,
	      isClientUsageHistoryLoading: false
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	  },
	  mounted: function mounted() {
	    this.fetchTeam();
	  },
	  methods: {
	    fetchTeam: function fetchTeam() {
	      var _this = this;
	
	      var subnamespace = this.$route.params.subnamespace;
	      _axios2.default.get('/api/teams/' + subnamespace).then(function (response) {
	        _this.team = response.data;
	
	        _this.checkVisibleComponents();
	      }).catch(function () {});
	    },
	    resetVisibleComponents: function resetVisibleComponents() {
	      this.showCurrentTeamInfo = true;
	      this.showCurrentStat = false;
	      this.showCurrentPackage = false;
	      this.showManualCredit = false;
	      this.showBillingInformation = false;
	      this.showMonthlyUsageHistory = false;
	      this.showStatement = false;
	      this.showClientUsageHistory = false;
	    },
	    checkVisibleComponents: function checkVisibleComponents() {
	      if (this.currentUser.team.is_superadmin) {
	        if (!this.team.is_reseller && !this.team.has_reseller) {
	          this.resetVisibleComponents();
	
	          var isPrePaidTeam = this.team.pay_plan === 'prepaid';
	          this.showCurrentStat = true;
	          this.showCurrentPackage = true;
	          this.showManualCredit = isPrePaidTeam;
	          this.showBillingInformation = true;
	          this.showMonthlyUsageHistory = true;
	          this.showStatement = true;
	        } else if (this.team.is_reseller) {
	          this.resetVisibleComponents();
	
	          this.showCurrentStat = true;
	          this.showCurrentPackage = true;
	          this.showBillingInformation = true;
	          this.showClientUsageHistory = true;
	        } else if (this.team.has_reseller) {
	          this.resetVisibleComponents();
	
	          this.showCurrentTeamInfo = true;
	          this.showCurrentStat = false;
	          this.showCurrentPackage = true;
	          this.showMonthlyUsageHistory = true;
	        }
	      } else if (this.currentUser.team.is_reseller) {
	        this.resetVisibleComponents();
	
	        this.showCurrentStat = true;
	        this.showMonthlyUsageHistory = true;
	      }
	    },
	    teamInfoLoadChanged: function teamInfoLoadChanged(value) {
	      this.isTeamInfoLoading = value;
	    },
	    currentStatLoadChanged: function currentStatLoadChanged(value) {
	      this.isCurrentStatLoading = value;
	    },
	    currentPackageLoadChanged: function currentPackageLoadChanged(value) {
	      this.iscurrentPackageLoading = value;
	    },
	    manualCreditLoadChanged: function manualCreditLoadChanged(value) {
	      this.isManualCreditLoading = value;
	    },
	    billingInformationLoadChanged: function billingInformationLoadChanged(value) {
	      this.isBillingInformationLoading = value;
	    },
	    monthlyUsageHistoryLoadChanged: function monthlyUsageHistoryLoadChanged(value) {
	      this.isMonthlyUsageHistoryLoading = value;
	    },
	    statementLoadChanged: function statementLoadChanged(value) {
	      this.isStatementLoading = value;
	    },
	    clientUsageHistoryLoadChanged: function clientUsageHistoryLoadChanged(value) {
	      this.isClientUsageHistoryLoading = value;
	    }
	  }
	};

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(7);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  data: function data() {
	    return {
	      isSubmiting: false,
	      isLoading: false,
	      isError: false,
	      total_team: 0,
	      showFilterItems: false,
	      teams: [],
	      pricingplanList: [],
	      currentPayPlanType: '',
	      currentPricingPlanType: '',
	      currentSuspendType: '',
	      currentName: '',
	      pagination: {
	        total: 0,
	        per_page: 20,
	        current_page: 1,
	        last_page: 0,
	        from: 1,
	        to: 1,
	        next_page_url: null,
	        prev_page_url: null,
	        total_page: 0
	      }
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	  },
	  mounted: function mounted() {
	    this.fetchTeams();
	    this.fetchPricingPlanList();
	
	    if (this.currentUser.is_superadmin) {
	      this.showFilterItems = true;
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    showUserRole: function showUserRole() {
	      if (!this.$route.params.subnamespace && (this.currentUser.team.is_superadmin || this.currentUser.team.is_reseller)) {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    currentPage: function currentPage() {
	      if (this.currentUser.team.is_superadmin) {
	        return 'admin';
	      } else if (this.currentUser.team.is_reseller) {
	        return 'reseller';
	      }
	    }
	  }),
	  methods: {
	    fetchPricingPlanList: function fetchPricingPlanList() {
	      var _this = this;
	
	      _axios2.default.get('/api/pricingplans').then(function (response) {
	        _this.pricingplanList = response.data.plans;
	        _this.currentPricingPlanType.alias = _this.team.pricing_plan;
	
	        _this.isLoading = false;
	      }).catch(function () {
	        _this.isLoading = false;
	      });
	    },
	    fetchTeams: function fetchTeams(page) {
	      var _this2 = this;
	
	      var url = '/api/teams';
	
	      var hasFirstFiler = false;
	
	      if (this.currentPayPlanType) {
	        if (hasFirstFiler) {
	          url = url + '&pay_plan=' + this.currentPayPlanType;
	        } else {
	          hasFirstFiler = true;
	          url = url + '?pay_plan=' + this.currentPayPlanType;
	        }
	      }
	
	      if (this.currentPricingPlanType) {
	        if (hasFirstFiler) {
	          url = url + '&pricing_plan=' + this.currentPricingPlanType;
	        } else {
	          hasFirstFiler = true;
	          url = url + '?pricing_plan=' + this.currentPricingPlanType;
	        }
	      }
	
	      if (this.currentSuspendType) {
	        if (hasFirstFiler) {
	          url = url + '&is_suspend=' + this.currentSuspendType;
	        } else {
	          hasFirstFiler = true;
	          url = url + '?is_suspend=' + this.currentSuspendType;
	        }
	      }
	
	      if (this.currentName) {
	        if (hasFirstFiler) {
	          url = url + '&name=' + this.currentName;
	        } else {
	          hasFirstFiler = true;
	          url = url + '?name=' + this.currentName;
	        }
	      }
	
	      if (page) {
	        if (hasFirstFiler) {
	          url = url + '&page=' + page;
	        } else {
	          hasFirstFiler = true;
	          url = url + '?page=' + page;
	        }
	      }
	
	      _axios2.default.get(url).then(function (response) {
	        _this2.isSubmiting = false;
	        _this2.total_team = response.data.total;
	        _this2.makePagination(response.data);
	        _this2.teams = response.data.data;
	        _this2.isLoading = false;
	        _this2.isError = false;
	      }).catch(function () {
	        _this2.isSubmiting = false;
	        _this2.isLoading = false;
	        _this2.isError = true;
	      });
	    },
	    makePagination: function makePagination(data) {
	      this.pagination.total = data.total;
	      this.pagination.per_page = data.per_page;
	      this.pagination.current_page = data.current_page;
	      this.pagination.last_page = data.last_page;
	      this.pagination.from = data.from;
	      this.pagination.to = data.to;
	      this.pagination.next_page_url = data.next_page_url;
	      this.pagination.prev_page_url = data.prev_page_url;
	      this.pagination.total_page = Math.ceil(data.total / data.per_page);
	    },
	    changePage: function changePage(page) {
	      this.fetchTeams(page);
	    },
	    filterItems: function filterItems() {
	      this.fetchTeams();
	    }
	  }
	};

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _vuex = __webpack_require__(7);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _vueSelect = __webpack_require__(35);
	
	var _vueSelect2 = _interopRequireDefault(_vueSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    vSelect: _vueSelect2.default,
	    Alert: _Alert2.default
	  },
	  watch: {
	    'user.team': function userTeam() {
	      if (this.formErrors.has('team')) {
	        this.formErrors.remove('team');
	      }
	    },
	    'user.namespace': function userNamespace() {
	      if (this.formErrors.has('namespace')) {
	        this.formErrors.remove('namespace');
	      }
	    },
	    'user.email': function userEmail() {
	      if (this.formErrors.has('email')) {
	        this.formErrors.remove('email');
	      }
	    },
	    'user.displayname': function userDisplayname() {
	      if (this.formErrors.has('displayname')) {
	        this.formErrors.remove('displayname');
	      }
	    },
	    'user.password': function userPassword() {
	      if (this.formErrors.has('password')) {
	        this.formErrors.remove('password');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    },
	    filterItems: function filterItems() {
	      var temp = [];
	      this.teams.forEach(function (item) {
	        temp.push({ label: item.namespace, value: item.id });
	      });
	      return temp;
	    },
	    showTeamType: function showTeamType() {
	      if (this.currentUser.team.is_superadmin) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    currentPage: function currentPage() {
	      if (this.currentUser.team.is_superadmin) {
	        return 'admin';
	      } else if (this.currentUser.team.is_reseller) {
	        return 'reseller';
	      }
	    }
	  }),
	  data: function data() {
	    return {
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      teams: [],
	      currentResellerTeam: '',
	      isSubmiting: false,
	      user: {
	        team: null,
	        namespace: null,
	        email: null,
	        displayName: null,
	        password: null,
	        type: 'normal-team'
	      }
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('team', 'required|max:72', { prettyName: 'Team Display name' });
	    this.validator.attach('namespace', 'required|namespace|min:3|max:32', { prettyName: 'Team URL' });
	    this.validator.attach('email', 'required|email');
	    this.validator.attach('displayname', 'required', { prettyName: 'display name' });
	    this.validator.attach('password', 'required|min:6');
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounted: function mounted() {
	    if (this.currentPage === 'admin') {
	      this.fetchTeams();
	    }
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.submitForm = false;
	      this.validator.validateAll({
	        team: this.user.team,
	        namespace: this.user.namespace,
	        email: this.user.email,
	        displayname: this.user.displayname,
	        password: this.user.password
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        _this.isSubmiting = true;
	
	        _axios2.default.post('/api/teams', {
	          name: _this.user.team,
	          namespace: _this.user.namespace,
	          email: _this.user.email,
	          display_name: _this.user.displayname,
	          password: _this.user.password,
	          is_reseller: _this.user.type === 'reseller' ? 1 : 0,
	          reseller_id: _this.user.type === 'sub-team' ? _this.currentResellerTeam.value : 0
	        }).then(function () {
	          _this.successResponse = _this.$t('team.response.success');
	          _this.errorResponse = null;
	          _this.showAlert = true;
	          _this.isSubmiting = false;
	          var redirectUrl = '/' + _this.$route.params.namespace + '/' + _this.currentPage + '/teams/';
	
	          setTimeout(function () {
	            _this.$router.push(redirectUrl);
	          }, 2000);
	        }).catch(function (error) {
	          if (error.response.status === 422) {
	            _this.errorResponse = _this.$t('team.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorResponse = _this.$t('team.response.defaultFailed');
	          }
	          _this.showAlert = true;
	          _this.isSubmiting = false;
	        });
	      }).catch(function () {});
	    },
	    fetchTeams: function fetchTeams() {
	      var _this2 = this;
	
	      var url = '/api/teams?accept=reseller';
	
	      _axios2.default.get(url).then(function (response) {
	        _this2.teams = response.data.data;
	        _this2.isLoading = false;
	      }).catch(function () {});
	    }
	  }
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _TeamTransfer = __webpack_require__(459);
	
	var _TeamTransfer2 = _interopRequireDefault(_TeamTransfer);
	
	var _TeamTerminate = __webpack_require__(200);
	
	var _TeamTerminate2 = _interopRequireDefault(_TeamTerminate);
	
	var _MembersBrowser = __webpack_require__(199);
	
	var _MembersBrowser2 = _interopRequireDefault(_MembersBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    Alert: _Alert2.default,
	    LoadingIndicator: _LoadingIndicator2.default,
	    MembersBrowser: _MembersBrowser2.default,
	    TeamTerminate: _TeamTerminate2.default,
	    TeamTransfer: _TeamTransfer2.default
	  },
	  watch: {
	    'team.name': function teamName() {
	      if (this.formErrors.has('name')) {
	        this.formErrors.remove('name');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    },
	    isLoading: function isLoading() {
	      return this.isMembersBrowserLoading;
	    },
	    currentPage: function currentPage() {
	      if (this.currentUser.team.is_superadmin) {
	        return 'admin';
	      } else if (this.currentUser.team.is_reseller) {
	        return 'reseller';
	      }
	    }
	  }),
	  created: function created() {
	    this.isLoading = true;
	    this.isMembersBrowserLoading = false;
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('name', 'required|max:72', { prettyName: 'Team Display name' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounted: function mounted() {
	    this.fetchTeam();
	  },
	  data: function data() {
	    return {
	      showGeneralAlert: false,
	      errorGeneralResponse: null,
	      successGeneralResponse: null,
	      showSuspendAlert: false,
	      errorSuspendResponse: null,
	      successSuspendResponse: null,
	      validator: null,
	      formErrors: null,
	      team: null,
	      teamSuspend: null,
	      currentSuspendMode: '',
	      isMembersBrowserLoading: false
	    };
	  },
	  methods: {
	    onSubmitGeneral: function onSubmitGeneral() {
	      var _this = this;
	
	      this.showGeneralAlert = false;
	
	      this.validator.validateAll({
	        name: this.team.name
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        var namespace = _this.team.namespace;
	
	        _this.isSubmiting = true;
	        _axios2.default.put('/api/teams/' + namespace, {
	          name: _this.team.name
	        }).then(function (response) {
	          _this.isSubmiting = false;
	          _this.successGeneralResponse = _this.$t('team.response.success');
	          _this.errorGeneralResponse = null;
	          _this.team = response.data;
	          _this.showGeneralAlert = true;
	
	          _this.$store.dispatch('updateCurrentUserTeam', _this.team);
	        }).catch(function (error) {
	          _this.isSubmiting = false;
	
	          if (error.response.status === 422) {
	            _this.errorGeneralResponse = _this.$t('team.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorGeneralResponse = _this.$t('team.response.defaultFailed');
	          }
	          _this.showGeneralAlert = true;
	        });
	      }).catch(function () {
	        _this.isSubmiting = false;
	      });
	    },
	    onSubmitSuspendStatus: function onSubmitSuspendStatus() {
	      var _this2 = this;
	
	      this.showSuspendAlert = false;
	
	      _axios2.default.post('api/admin/setsuspend', {
	        namespace: this.team.namespace,
	        mode: this.currentSuspendMode,
	        suspend_reason: this.teamSuspend.suspend_reason
	      }).then(function (response) {
	        _this2.successSuspendResponse = _this2.$t('team.response.success');
	        _this2.teamSuspend = response.data;
	        _this2.updateSupsendMode();
	
	        _this2.errorSuspendResponse = null;
	        _this2.showSuspendAlert = true;
	      }).catch(function (error) {
	        if (error.response.status === 422) {
	          _this2.errorSuspendResponse = _this2.$t('team.response.failed');
	          _this2.formErrors.addAll(error.response.data);
	        } else {
	          _this2.errorSuspendResponse = _this2.$t('team.response.defaultFailed');
	        }
	        _this2.showSuspendAlert = true;
	      });
	    },
	    onSubmitDeactivateStatus: function onSubmitDeactivateStatus() {
	      var _this3 = this;
	
	      this.showSuspendAlert = false;
	
	      _axios2.default.post('api/admin/setdeactivate', {
	        namespace: this.team.namespace,
	        mode: this.currentDeactivateMode
	      }).then(function (response) {
	        _this3.successSuspendResponse = _this3.$t('team.response.success');
	        _this3.teamSuspend = response.data;
	        _this3.updateSupsendMode();
	
	        _this3.errorSuspendResponse = null;
	        _this3.showSuspendAlert = true;
	      }).catch(function (error) {
	        if (error.response.status === 422) {
	          _this3.errorSuspendResponse = _this3.$t('team.response.failed');
	          _this3.formErrors.addAll(error.response.data);
	        } else {
	          _this3.errorSuspendResponse = _this3.$t('team.response.defaultFailed');
	        }
	        _this3.showSuspendAlert = true;
	      });
	    },
	    fetchTeam: function fetchTeam() {
	      var _this4 = this;
	
	      var namespace = this.$route.params.subnamespace;
	
	      _axios2.default.get('/api/teams/' + namespace).then(function (response) {
	        _this4.team = response.data;
	        _this4.teamSuspend = response.data.suspend ? response.data.suspend : [];
	        _this4.updateSupsendMode();
	
	        _this4.isLoading = false;
	      }).catch(function () {
	        _this4.isLoading = false;
	      });
	    },
	    changePayPlan: function changePayPlan(value) {
	      this.team.pay_plan = value;
	    },
	    updateSupsendMode: function updateSupsendMode() {
	      if (this.teamSuspend) {
	        if (this.teamSuspend.is_manual_locked && !this.teamSuspend.is_suspend) {
	          this.currentSuspendMode = 'active';
	        } else if (this.teamSuspend.is_manual_locked && this.teamSuspend.is_suspend) {
	          this.currentSuspendMode = 'suspend';
	        } else {
	          this.currentSuspendMode = 'auto';
	        }
	      }
	    },
	    membersBrowserLoadChanged: function membersBrowserLoadChanged(value) {
	      this.isMembersBrowserLoading = value;
	    }
	  }
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueSelect = __webpack_require__(35);
	
	var _vueSelect2 = _interopRequireDefault(_vueSelect);
	
	var _veeValidate = __webpack_require__(5);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _TeamTerminate = __webpack_require__(200);
	
	var _TeamTerminate2 = _interopRequireDefault(_TeamTerminate);
	
	var _MembersBrowser = __webpack_require__(199);
	
	var _MembersBrowser2 = _interopRequireDefault(_MembersBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    Alert: _Alert2.default,
	    LoadingIndicator: _LoadingIndicator2.default,
	    MembersBrowser: _MembersBrowser2.default,
	    TeamTerminate: _TeamTerminate2.default,
	    vSelect: _vueSelect2.default
	  },
	  props: ['team'],
	  watch: {
	    'team.name': function teamName() {
	      if (this.formErrors.has('name')) {
	        this.formErrors.remove('name');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    },
	    isLoading: function isLoading() {
	      return this.isMembersBrowserLoading;
	    },
	    currentPage: function currentPage() {
	      if (this.currentUser.team.is_superadmin) {
	        return 'admin';
	      } else if (this.currentUser.team.is_reseller) {
	        return 'reseller';
	      }
	    },
	    filterItems: function filterItems() {
	      var temp = [];
	      this.teams.forEach(function (item) {
	        temp.push({ label: item.namespace, value: item.id });
	      });
	      return temp;
	    }
	  }),
	  created: function created() {
	    this.isLoading = true;
	    this.isMembersBrowserLoading = false;
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('name', 'required|max:72', { prettyName: 'Team Display name' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounted: function mounted() {
	    this.fetchTeams();
	  },
	  data: function data() {
	    return {
	      showGeneralAlert: false,
	      errorGeneralResponse: null,
	      successGeneralResponse: null,
	      showSuspendAlert: false,
	      errorSuspendResponse: null,
	      successSuspendResponse: null,
	      validator: null,
	      formErrors: null,
	      currentSuspendMode: '',
	      isMembersBrowserLoading: false,
	      teams: [],
	      newReseller: null
	    };
	  },
	  methods: {
	    onSubmitGeneral: function onSubmitGeneral() {
	      var _this = this;
	
	      this.showGeneralAlert = false;
	
	      this.validator.validateAll({
	        name: this.team.name
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        var namespace = _this.team.namespace;
	
	        _this.isSubmiting = true;
	        _axios2.default.put('/api/teams/' + namespace, {
	          name: _this.team.name
	        }).then(function (response) {
	          _this.isSubmiting = false;
	          _this.successGeneralResponse = _this.$t('team.response.success');
	          _this.errorGeneralResponse = null;
	          _this.team = response.data;
	          _this.showGeneralAlert = true;
	
	          _this.$store.dispatch('updateCurrentUserTeam', _this.team);
	        }).catch(function (error) {
	          _this.isSubmiting = false;
	
	          if (error.response.status === 422) {
	            _this.errorGeneralResponse = _this.$t('team.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorGeneralResponse = _this.$t('team.response.defaultFailed');
	          }
	          _this.showGeneralAlert = true;
	        });
	      }).catch(function () {
	        _this.isSubmiting = false;
	      });
	    },
	    onSubmitSuspendStatus: function onSubmitSuspendStatus() {
	      var _this2 = this;
	
	      this.showSuspendAlert = false;
	
	      _axios2.default.post('api/admin/setsuspend', {
	        namespace: this.team.namespace,
	        mode: this.currentSuspendMode,
	        suspend_reason: this.teamSuspend.suspend_reason
	      }).then(function (response) {
	        _this2.successSuspendResponse = _this2.$t('team.response.success');
	        _this2.teamSuspend = response.data;
	        _this2.updateSupsendMode();
	
	        _this2.errorSuspendResponse = null;
	        _this2.showSuspendAlert = true;
	      }).catch(function (error) {
	        if (error.response.status === 422) {
	          _this2.errorSuspendResponse = _this2.$t('team.response.failed');
	          _this2.formErrors.addAll(error.response.data);
	        } else {
	          _this2.errorSuspendResponse = _this2.$t('team.response.defaultFailed');
	        }
	        _this2.showSuspendAlert = true;
	      });
	    },
	    onSubmitDeactivateStatus: function onSubmitDeactivateStatus() {
	      var _this3 = this;
	
	      this.showSuspendAlert = false;
	
	      _axios2.default.post('api/admin/setdeactivate', {
	        namespace: this.team.namespace,
	        mode: this.currentDeactivateMode
	      }).then(function (response) {
	        _this3.successSuspendResponse = _this3.$t('team.response.success');
	        _this3.teamSuspend = response.data;
	        _this3.updateSupsendMode();
	
	        _this3.errorSuspendResponse = null;
	        _this3.showSuspendAlert = true;
	      }).catch(function (error) {
	        if (error.response.status === 422) {
	          _this3.errorSuspendResponse = _this3.$t('team.response.failed');
	          _this3.formErrors.addAll(error.response.data);
	        } else {
	          _this3.errorSuspendResponse = _this3.$t('team.response.defaultFailed');
	        }
	        _this3.showSuspendAlert = true;
	      });
	    },
	    fetchTeams: function fetchTeams() {
	      var _this4 = this;
	
	      _axios2.default.get('/api/teams').then(function (response) {
	        _this4.teams = response.data.data;
	        _this4.isLoading = false;
	      }).catch(function () {
	        _this4.isLoading = false;
	      });
	    },
	    changePayPlan: function changePayPlan(value) {
	      this.team.pay_plan = value;
	    },
	    membersBrowserLoadChanged: function membersBrowserLoadChanged(value) {
	      this.isMembersBrowserLoading = value;
	    }
	  }
	};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(7);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  data: function data() {
	    return {
	      isSubmiting: false,
	      isLoading: false,
	      isError: false,
	      currentMonth: '',
	      currentSourceType: '',
	      currentCreditType: '',
	      total_transaction: 0,
	      transactions: [],
	      sourceTypeList: [],
	      pagination: {
	        total: 0,
	        per_page: 20,
	        current_page: 1,
	        last_page: 0,
	        from: 1,
	        to: 1,
	        next_page_url: null,
	        prev_page_url: null,
	        total_page: 0
	      }
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    team: function team() {
	      return this.currentUser.team;
	    },
	    monthList: function monthList() {
	      var list = [];
	      var team = this.team;
	      if (team.created_at) {
	        var now = (0, _moment2.default)().startOf('months');
	        var start = (0, _moment2.default)(team.created_at).startOf('months');
	        var months = now.diff(start, 'months');
	        list.push(now.format('MMMM YYYY'));
	
	        for (var i = 0; i < months; i += 1) {
	          list.push(now.subtract(1, 'months').format('MMMM YYYY'));
	        }
	      }
	
	      return list;
	    }
	  }),
	  created: function created() {
	    this.isLoading = true;
	  },
	  mounted: function mounted() {
	    this.fetchTransactions();
	    this.fetchSourceTypes();
	  },
	  methods: {
	    fetchTransactions: function fetchTransactions(page) {
	      var _this = this;
	
	      var url = '/api/admin/transactions';
	      var hasFirstFiler = false;
	
	      if (this.currentSourceType) {
	        if (hasFirstFiler) {
	          url = url + '&source_type=' + this.currentSourceType;
	        } else {
	          hasFirstFiler = true;
	          url = url + '?source_type=' + this.currentSourceType;
	        }
	      }
	
	      if (this.currentMonth) {
	        var month = (0, _moment2.default)(this.currentMonth, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	        if (hasFirstFiler) {
	          url = url + '&month=' + month;
	        } else {
	          hasFirstFiler = true;
	          url = url + '?month=' + month;
	        }
	      }
	
	      if (this.currentCreditType) {
	        if (hasFirstFiler) {
	          url = url + '&credit_type=' + this.currentCreditType;
	        } else {
	          hasFirstFiler = true;
	          url = url + '?credit_type=' + this.currentCreditType;
	        }
	      }
	
	      if (page) {
	        if (hasFirstFiler) {
	          url = url + '&page=' + page;
	        } else {
	          hasFirstFiler = true;
	          url = url + '?page=' + page;
	        }
	      }
	
	      _axios2.default.get(url).then(function (response) {
	        _this.total_transaction = response.data.total;
	        _this.makePagination(response.data);
	        _this.transactions = response.data.data;
	        _this.isLoading = false;
	        _this.isError = false;
	        _this.isSubmiting = false;
	      }).catch(function () {
	        _this.isLoading = false;
	        _this.isError = true;
	        _this.isSubmiting = false;
	      });
	    },
	    fetchSourceTypes: function fetchSourceTypes() {
	      var _this2 = this;
	
	      var url = '/api/sourcetypes';
	
	      _axios2.default.get(url).then(function (response) {
	        _this2.sourceTypeList = response.data;
	        _this2.isLoading = false;
	        _this2.isError = false;
	      }).catch(function () {
	        _this2.isLoading = false;
	        _this2.isError = true;
	      });
	    },
	    makePagination: function makePagination(data) {
	      this.pagination.total = data.total;
	      this.pagination.per_page = data.per_page;
	      this.pagination.current_page = data.current_page;
	      this.pagination.last_page = data.last_page;
	      this.pagination.from = data.from;
	      this.pagination.to = data.to;
	      this.pagination.next_page_url = data.next_page_url;
	      this.pagination.prev_page_url = data.prev_page_url;
	      this.pagination.total_page = Math.ceil(data.total / data.per_page);
	    },
	    changePage: function changePage(page) {
	      this.fetchTransactions(page);
	    },
	    getHistoryDate: function getHistoryDate(date) {
	      return (0, _moment2.default)(date, ['YYYY-MM-DD', _moment2.default.ISO_8601]).format('D MMM YYYY');
	    },
	    getFullHistoryDate: function getFullHistoryDate(date) {
	      return (0, _moment2.default)(date, ['YYYY-MM-DD HH:mm', _moment2.default.ISO_8601]).format('D MMM YYYY HH:mm');
	    },
	    filterItems: function filterItems() {
	      this.fetchTransactions();
	    },
	    showUsageReport: function showUsageReport(statement) {
	      if (!statement) {
	        return false;
	      }
	
	      if (statement.source_type === 'System') {
	        return true;
	      }
	
	      return false;
	    },
	    urlUsageReport: function urlUsageReport(item) {
	      if (item.statement && item.statement.month) {
	        var month = (0, _moment2.default)(item.statement.month, ['YYYY-MM-DD HH:mm', _moment2.default.ISO_8601]).format('YYYY-MM');
	
	        var parentUrl = this.$route.params.namespace;
	        var namespace = item.team.namespace;
	
	        var url = '/' + parentUrl + '/admin/teams/' + namespace + '/usage-report';
	
	        return url + '?month=' + month;
	      }
	
	      return '';
	    },
	    urlOrderNumberReport: function urlOrderNumberReport(item) {
	      if (item.statement && item.statement.order_number) {
	        var parentUrl = this.$route.params.namespace;
	        var namespace = item.team.namespace;
	
	        var url = '/' + parentUrl + '/admin/teams/' + namespace + '/transactions';
	
	        return url + '?number=' + item.statement.order_number;
	      }
	      return '';
	    }
	  }
	};

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	var _vueScrollto = __webpack_require__(202);
	
	var _vueScrollto2 = _interopRequireDefault(_vueScrollto);
	
	var _CurrentStat = __webpack_require__(192);
	
	var _CurrentStat2 = _interopRequireDefault(_CurrentStat);
	
	var _PaymentSection = __webpack_require__(475);
	
	var _PaymentSection2 = _interopRequireDefault(_PaymentSection);
	
	var _RedeemVoucher = __webpack_require__(464);
	
	var _RedeemVoucher2 = _interopRequireDefault(_RedeemVoucher);
	
	var _Statement = __webpack_require__(193);
	
	var _Statement2 = _interopRequireDefault(_Statement);
	
	var _MonthlyUsageHistory = __webpack_require__(195);
	
	var _MonthlyUsageHistory2 = _interopRequireDefault(_MonthlyUsageHistory);
	
	var _ClientUsageHistory = __webpack_require__(49);
	
	var _ClientUsageHistory2 = _interopRequireDefault(_ClientUsageHistory);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    CurrentStat: _CurrentStat2.default,
	    PaymentSection: _PaymentSection2.default,
	    RedeemVoucher: _RedeemVoucher2.default,
	    Statement: _Statement2.default,
	    MonthlyUsageHistory: _MonthlyUsageHistory2.default,
	    ClientUsageHistory: _ClientUsageHistory2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    isLoading: function isLoading(value) {
	      if (!value) {
	        if (this.$route.hash === '#addcreditSection') {
	          this.$nextTick(function () {
	            _vueScrollto2.default.scrollTo('#addcreditSection');
	          });
	        } else if (this.$route.hash === '#statementSection') {
	          this.$nextTick(function () {
	            _vueScrollto2.default.scrollTo('#statementSection');
	          });
	        }
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    isLoading: function isLoading() {
	      return this.isCurrentStatLoading || this.isPaymentSectionLoading || this.isRedeemVoucherLoading || this.isMonthlyUsageHistoryLoading || this.isStatementLoading || this.isClientUsageHistoryLoading;
	    }
	  }),
	  data: function data() {
	    return {
	      showCurrentStat: false,
	      showPaymentSection: false,
	      showBillingCredit: false,
	      showBillingInformation: false,
	      showRedeemVoucher: false,
	      showMonthlyUsageHistory: false,
	      showStatement: false,
	      showClientUsageHistory: false,
	      team: null,
	      isCurrentStatLoading: false,
	      isBillingCreditLoading: false,
	      isBillingInformationLoading: false,
	      isRedeemVoucherLoading: false,
	      isMonthlyUsageHistoryLoading: false,
	      isStatementLoading: false,
	      isClientUsageHistoryLoading: false
	    };
	  },
	  mounted: function mounted() {
	    this.team = this.currentUser.team;
	
	    this.checkVisibleComponents();
	  },
	  methods: {
	    resetVisibleComponents: function resetVisibleComponents() {
	      this.showCurrentStat = false;
	      this.showPaymentSection = false;
	      this.showBillingCredit = false;
	      this.showBillingInformation = false;
	      this.showRedeemVoucher = false;
	      this.showMonthlyUsageHistory = false;
	      this.showStatement = false;
	      this.showClientUsageHistory = false;
	    },
	    checkVisibleComponents: function checkVisibleComponents() {
	      var isTeamManager = this.currentUser.role === 'manager';
	
	      if (!this.team.is_reseller && !this.team.has_reseller) {
	        this.resetVisibleComponents();
	
	        var isPrePaidTeam = this.team.pay_plan === 'prepaid';
	
	        if (isTeamManager) {
	          this.showCurrentStat = true;
	          this.showPaymentSection = isPrePaidTeam;
	          this.showBillingCredit = Boolean(isPrePaidTeam);
	          this.showRedeemVoucher = isPrePaidTeam;
	          this.showBillingInformation = true;
	          this.showStatement = true;
	        }
	
	        this.showMonthlyUsageHistory = true;
	      } else if (this.team.is_reseller) {
	        this.resetVisibleComponents();
	
	        if (isTeamManager) {
	          this.showBillingInformation = true;
	        }
	
	        this.showClientUsageHistory = true;
	      } else if (this.team.has_reseller) {
	        this.resetVisibleComponents();
	
	        this.showMonthlyUsageHistory = true;
	      }
	    },
	    currentStatLoadChanged: function currentStatLoadChanged(value) {
	      this.isCurrentStatLoading = value;
	    },
	    paymentSectionLoadChanged: function paymentSectionLoadChanged(value) {
	      this.isPaymentSectionLoading = value;
	    },
	    redeemVoucherLoadChanged: function redeemVoucherLoadChanged(value) {
	      this.isRedeemVoucherLoading = value;
	    },
	    monthlyUsageHistoryLoadChanged: function monthlyUsageHistoryLoadChanged(value) {
	      this.isMonthlyUsageHistoryLoading = value;
	    },
	    statementLoadChanged: function statementLoadChanged(value) {
	      this.isStatementLoading = value;
	    },
	    clientUsageHistoryLoadChanged: function clientUsageHistoryLoadChanged(value) {
	      this.isClientUsageHistoryLoading = value;
	    }
	  }
	};

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    team: function team(value) {
	      if (value) {
	        this.fetchBalances();
	      }
	    }
	  },
	  computed: {
	    isPrePaidTeam: function isPrePaidTeam() {
	      return this.team.pay_plan === 'prepaid';
	    },
	    showCurrentCredit: function showCurrentCredit() {
	      if (this.team.is_reseller || this.team.has_reseller) {
	        return false;
	      }
	
	      if (!this.isPrePaidTeam) {
	        return false;
	      }
	
	      return true;
	    },
	    showLastAddedCredit: function showLastAddedCredit() {
	      return this.balances.latest_refill_transaction && this.balances.latest_refill_transaction.created_at;
	    },
	    usagePercentage: function usagePercentage() {
	      if (!this.balances.upcoming_bill) {
	        return 0;
	      }
	      if (this.balances.credit <= 0 && this.balances.upcoming_bill.total_cost > 0) {
	        return 100;
	      }
	
	      var percentage = this.balances.upcoming_bill.total_cost / this.balances.credit * 100;
	
	      if (isNaN(percentage) || !isFinite(percentage)) {
	        return 0;
	      }
	      return parseFloat(Math.round(percentage * 100) / 100).toFixed(2);
	    },
	    showUsagePercentage: function showUsagePercentage() {
	      if (!this.balances.upcoming_bill) {
	        return false;
	      }
	
	      var percentage = this.balances.upcoming_bill.total_cost / this.balances.credit * 100;
	
	      if (!isFinite(percentage)) {
	        return false;
	      }
	
	      return this.balances.upcoming_bill.total_cost > 0;
	    },
	    showDiscount: function showDiscount() {
	      if (this.team && !this.team.has_reseller) {
	        if (this.team.discount > 0) {
	          return true;
	        }
	      }
	      return false;
	    },
	    upcomingBillDate: function upcomingBillDate() {
	      if (this.balances.upcoming_bill) {
	        return (0, _moment2.default)(this.balances.upcoming_bill.will_charge_at).format('D MMM YYYY');
	      } else {
	        return '';
	      }
	    },
	    humanTotalCost: function humanTotalCost() {
	      if (this.balances.upcoming_bill) {
	        return this.balances.upcoming_bill.human_total_cost;
	      }
	
	      return 0.0;
	    },
	    latestRefillDate: function latestRefillDate() {
	      if (this.balances.latest_refill_transaction) {
	        return (0, _moment2.default)(this.balances.latest_refill_transaction.created_at).format('D MMM YYYY');
	      } else {
	        return '';
	      }
	    },
	    isTeamSuspend: function isTeamSuspend() {
	      if (this.team) {
	        if (this.team.suspend) {
	          return this.team.suspend.is_suspend;
	        }
	      }
	      return false;
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    this.isLoading = true;
	
	    this.$emit('loadChanged', true);
	
	    this.eventHub.$on('manualAddCreditSuccess', function () {
	      _this.fetchBalances();
	    });
	  },
	  mounted: function mounted() {
	    if (this.team) {
	      this.fetchBalances();
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      balances: null
	    };
	  },
	  methods: {
	    fetchBalances: function fetchBalances() {
	      var _this2 = this;
	
	      var namespace = this.team.namespace;
	
	      var url = '/api/teams/' + namespace + '/balances';
	
	      _axios2.default.get(url).then(function (response) {
	        _this2.balances = response.data;
	        _this2.isLoading = false;
	
	        _this2.$emit('loadChanged', false);
	      }).catch(function () {
	        _this2.isLoading = false;
	
	        _this2.$emit('loadChanged', false);
	      });
	    }
	  }
	};

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    forceFullWidthBoxes: {
	      type: Boolean
	    },
	    team: {
	      type: Object
	    }
	  },
	  computed: {
	    isPrePaidTeam: function isPrePaidTeam() {
	      return this.team.pay_plan === 'prepaid';
	    },
	    showCurrentCredit: function showCurrentCredit() {
	      if (this.team.is_reseller || this.team.has_reseller) {
	        return false;
	      }
	
	      if (!this.isPrePaidTeam) {
	        return false;
	      }
	
	      return true;
	    },
	    showLastAddedCredit: function showLastAddedCredit() {
	      return this.balances.latest_refill_transaction && this.balances.latest_refill_transaction.created_at;
	    },
	    usagePercentage: function usagePercentage() {
	      if (!this.balances.upcoming_bill) {
	        return 0;
	      }
	      if (this.balances.credit <= 0 && this.balances.upcoming_bill.total_cost > 0) {
	        return 100;
	      }
	
	      var percentage = this.balances.upcoming_bill.total_cost / this.balances.credit * 100;
	      if (isNaN(percentage)) {
	        return 0;
	      }
	      return parseFloat(Math.round(percentage * 100) / 100).toFixed(2);
	    },
	    showUsagePercentage: function showUsagePercentage() {
	      if (!this.balances.upcoming_bill) {
	        return false;
	      }
	
	      return this.balances.upcoming_bill.total_cost > 0;
	    },
	    upcomingBillDate: function upcomingBillDate() {
	      if (this.balances.upcoming_bill) {
	        return (0, _moment2.default)(this.balances.upcoming_bill.will_charge_at).format('D MMM YYYY');
	      } else {
	        return '';
	      }
	    },
	    latestRefillDate: function latestRefillDate() {
	      if (this.balances.latest_refill_transaction) {
	        return (0, _moment2.default)(this.balances.latest_refill_transaction.created_at).format('D MMM YYYY');
	      } else {
	        return '';
	      }
	    },
	    humanTotalCost: function humanTotalCost() {
	      if (this.balances.upcoming_bill) {
	        return this.balances.upcoming_bill.human_total_cost;
	      }
	
	      return 0.0;
	    },
	    isTeamSuspend: function isTeamSuspend() {
	      if (this.team) {
	        if (this.team.suspend && !this.$route.params.subnamespace) {
	          return this.team.suspend.is_suspend;
	        }
	      }
	      return false;
	    },
	    showDiscount: function showDiscount() {
	      if (this.team) {
	        if (this.team.has_reseller) {
	          return false;
	        }
	        return true;
	      }
	      return false;
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    this.isLoading = true;
	
	    this.$emit('loadChanged', true);
	
	    this.eventHub.$on('manualAddCreditSuccess', function () {
	      _this.fetchBalances();
	    });
	  },
	  mounted: function mounted() {
	    if (this.team) {
	      this.fetchBalances();
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      balances: {
	        team_id: 0,
	        credit: 0,
	        human_credit: '0.00',
	        human_usage: '0.00',
	        latest_refill_transaction: {
	          source_type: null,
	          description: null,
	          note: null,
	          credit: 0,
	          balance: 0,
	          human_credit: '0.00',
	          human_balance: '0.00',
	          source: null
	        },
	        upcoming_bill: {
	          month: null,
	          pricing_plan: null,
	          total_cost: 0,
	          charged_balance_transaction_id: null,
	          charged_invoice_id: null,
	          will_charge_at: null,
	          charged_at: null,
	          created_at: null,
	          updated_at: null,
	          human_total_cost: '0.00',
	          invoice_url: null
	        },
	        latest_bill_id: null
	      }
	    };
	  },
	  methods: {
	    fetchBalances: function fetchBalances() {
	      var _this2 = this;
	
	      var namespace = this.team.namespace;
	
	      var url = '/api/teams/' + namespace + '/balances';
	
	      _axios2.default.get(url).then(function (response) {
	        _this2.balances = response.data;
	        _this2.isLoading = false;
	
	        _this2.$emit('loadChanged', false);
	      }).catch(function () {
	        _this2.isLoading = false;
	
	        _this2.$emit('loadChanged', false);
	      });
	    }
	  }
	};

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  computed: {
	    currentSupsend: function currentSupsend() {
	      if (this.team && this.team.suspend) {
	        if (this.team.suspend.is_manual_locked) {
	          if (this.team.suspend.is_suspend) {
	            return 'Suspend';
	          } else {
	            return 'Active';
	          }
	        } else {
	          return 'Auto';
	        }
	      }
	    }
	  },
	  created: function created() {
	    this.isLoading = true;
	
	    this.$emit('loadChanged', true);
	
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('payPlan', 'required', { prettyName: 'pricing plan' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  data: function data() {
	    return {
	      showPayPlanAlert: false,
	      errorPayPlanResponse: null,
	      successPayPlanResponse: null,
	      validator: null,
	      formErrors: null,
	      showPayPlanForm: false
	    };
	  },
	  methods: {
	    onSubmitPayplan: function onSubmitPayplan() {
	      var _this = this;
	
	      this.showPayPlanAlert = false;
	
	      _axios2.default.post('api/admin/setpayplan', {
	        namespace: this.team.namespace,
	        pay_plan: this.team.pay_plan
	      }).then(function (response) {
	        _this.successPayPlanResponse = _this.$t('team.response.success');
	        _this.cancelPayPlanForm();
	        _this.team.pay_plan = response.data.pay_plan;
	        _this.errorPayPlanResponse = null;
	      }).catch(function (error) {
	        if (error.response.status === 422) {
	          _this.errorPayPlanResponse = _this.$t('team.response.failed');
	        } else {
	          _this.errorPayPlanResponse = _this.$t('team.response.defaultFailed');
	        }
	        _this.showPayPlanAlert = true;
	      });
	    },
	    togglePayPlanForm: function togglePayPlanForm() {
	      this.showPayPlanForm = true;
	    },
	    cancelPayPlanForm: function cancelPayPlanForm() {
	      this.showPayPlanForm = false;
	    }
	  }
	};

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	var _veeValidate = __webpack_require__(5);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    voucherCode: function voucherCode() {
	      if (this.formErrors.has('voucherCode')) {
	        this.formErrors.remove('voucherCode');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser'])),
	  data: function data() {
	    return {
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      voucherCode: null
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	
	    this.$emit('loadChanged', false);
	
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('voucherCode', 'required', { prettyName: 'Voucher Code' });
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  methods: {
	    onSubmitRedeemVoucher: function onSubmitRedeemVoucher() {}
	  }
	};

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  computed: {
	    teamSuspend: function teamSuspend() {
	      return this.team && this.team.suspend ? this.team.suspend : [];
	    }
	  },
	  created: function created() {
	    this.isLoading = true;
	
	    this.$emit('loadChanged', true);
	
	    this.validator = new _veeValidate.Validator();
	
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounth: function mounth() {
	    this.updateSupsendMode();
	  },
	  data: function data() {
	    return {
	      showSuspendAlert: false,
	      errorSuspendResponse: null,
	      successSuspendResponse: null,
	      validator: null,
	      formErrors: null,
	      currentSuspendMode: 'suspend',
	      showSettingSuspendForm: false
	    };
	  },
	  methods: {
	    onSubmitSuspendStatus: function onSubmitSuspendStatus() {
	      var _this = this;
	
	      this.showSuspendAlert = false;
	
	      _axios2.default.post('api/admin/setsuspend', {
	        namespace: this.team.namespace,
	        mode: this.currentSuspendMode,
	        suspend_reason: this.teamSuspend.suspend_reason
	      }).then(function (response) {
	        _this.successSuspendResponse = _this.$t('team.response.success');
	        _this.teamSuspend = response.data;
	        _this.updateSupsendMode();
	
	        _this.errorSuspendResponse = null;
	        _this.showSuspendAlert = true;
	      }).catch(function (error) {
	        if (error.response.status === 422) {
	          _this.errorSuspendResponse = _this.$t('team.response.failed');
	          _this.formErrors.addAll(error.response.data);
	        } else {
	          _this.errorSuspendResponse = _this.$t('team.response.defaultFailed');
	        }
	        _this.showSuspendAlert = true;
	      });
	    },
	    updateSupsendMode: function updateSupsendMode() {
	      if (this.teamSuspend) {
	        if (this.teamSuspend.is_manual_locked && !this.teamSuspend.is_suspend) {
	          this.currentSuspendMode = 'active';
	        } else if (this.teamSuspend.is_manual_locked && this.teamSuspend.is_suspend) {
	          this.currentSuspendMode = 'suspend';
	        } else {
	          this.currentSuspendMode = 'auto';
	        }
	      }
	    },
	    toggleSettingSuspendForm: function toggleSettingSuspendForm() {
	      this.showSettingSuspendForm = true;
	    },
	    cancelSettingSuspendForm: function cancelSettingSuspendForm() {
	      this.updateSupsendMode();
	      this.showSettingSuspendForm = false;
	    }
	  }
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(7);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    team: function team(value) {
	      if (value) {
	        this.fetchTransaction(this.currentYear);
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    },
	    yearList: function yearList() {
	      var list = [];
	
	      var now = (0, _moment2.default)().startOf('years');
	      var start = (0, _moment2.default)(this.team.created_at).startOf('years');
	      var years = now.diff(start, 'years');
	      list.push(now.format('YYYY'));
	
	      for (var i = 0; i < years; i += 1) {
	        list.push(now.subtract(1, 'years').format('YYYY'));
	      }
	
	      return list;
	    },
	    havaTransactions: function havaTransactions() {
	      return this.transactions.data && this.transactions.data.length > 0;
	    },
	    downLoadUrl: function downLoadUrl() {
	      if (this.team && this.currentUser) {
	        if (this.$route.params.subnamespace) {
	          var parentUrl = this.$route.params.namespace;
	          var namespace = this.$route.params.subnamespace;
	
	          var role = void 0;
	
	          if (this.currentUser.team.is_superadmin) {
	            role = 'admin';
	          } else if (this.currentUser.team.is_reseller) {
	            role = 'reseller';
	          }
	
	          return '/' + parentUrl + '/' + role + '/teams/' + namespace;
	        } else {
	          var _namespace = this.$route.params.namespace;
	          return '/' + _namespace;
	        }
	      }
	    }
	  }),
	  data: function data() {
	    return {
	      isLoading: false,
	      transactions: null,
	      currentYear: (0, _moment2.default)().format('YYYY')
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.isLoading = true;
	
	    this.$emit('loadChanged', true);
	
	    this.eventHub.$on('manualAddCreditSuccess', function () {
	      _this.fetchTransaction(_this.currentYear);
	    });
	  },
	  mounted: function mounted() {
	    if (this.team) {
	      this.fetchTransaction(this.currentYear);
	    }
	  },
	  methods: {
	    fetchTransaction: function fetchTransaction(year) {
	      var _this2 = this;
	
	      var namespace = this.team.namespace;
	
	      if (!year) {
	        year = (0, _moment2.default)(this.currentMonth, ['YYYY', _moment2.default.ISO_8601]).format('YYYY');
	      } else {
	        year = (0, _moment2.default)(year, ['YYYY', _moment2.default.ISO_8601]).format('YYYY');
	      }
	
	      _axios2.default.get('/api/teams/' + namespace + '/balances/transaction?year=' + year).then(function (response) {
	        _this2.transactions = response.data;
	        _this2.isLoading = false;
	
	        _this2.$emit('loadChanged', false);
	      }).catch(function () {
	        _this2.isLoading = false;
	
	        _this2.$emit('loadChanged', false);
	      });
	    },
	    getHistoryDate: function getHistoryDate(date) {
	      return (0, _moment2.default)(date, ['YYYY-MM-DD', _moment2.default.ISO_8601]).format('D MMM YYYY');
	    },
	    getFullHistoryDate: function getFullHistoryDate(date) {
	      return (0, _moment2.default)(date, ['YYYY-MM-DD HH:mm', _moment2.default.ISO_8601]).format('D MMM YYYY HH:mm');
	    },
	    urlUsageReport: function urlUsageReport(month) {
	      if (!month) {
	        month = (0, _moment2.default)(this.currentMonth, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	      } else {
	        month = (0, _moment2.default)(month, ['YYYY-MM-DD HH:mm', _moment2.default.ISO_8601]).format('YYYY-MM');
	      }
	
	      return this.downLoadUrl + '/usage-report?month=' + month;
	    },
	    urlOrderNumberReport: function urlOrderNumberReport(number) {
	      if (number) {
	        return this.downLoadUrl + '/transactions?number=' + number;
	      }
	      return '';
	    },
	    onChange: function onChange() {
	      this.fetchTransaction(this.currentYear);
	    }
	  }
	};

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  props: {
	    team: {
	      type: Object
	    },
	    currentUser: {
	      type: Object
	    }
	  },
	  watch: {
	    team: function team(value) {
	      if (value) {
	        this.isLoading = false;
	        this.$emit('loadChanged', false);
	      }
	    }
	  },
	  computed: {
	    currentPage: function currentPage() {
	      if (this.$route.params.subnamespace && this.currentUser.team.is_superadmin) {
	        return 'admin';
	      } else if (this.$route.params.subnamespace && this.currentUser.team.is_reseller) {
	        return 'reseller';
	      } else {
	        return 'self';
	      }
	    }
	  },
	  created: function created() {
	    this.isLoading = true;
	    this.$emit('loadChanged', true);
	  },
	  data: function data() {
	    return {
	      isLoading: false
	    };
	  }
	};

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _DiscountPackage = __webpack_require__(468);
	
	var _DiscountPackage2 = _interopRequireDefault(_DiscountPackage);
	
	var _PricingPlan = __webpack_require__(477);
	
	var _PricingPlan2 = _interopRequireDefault(_PricingPlan);
	
	var _PayPlan = __webpack_require__(463);
	
	var _PayPlan2 = _interopRequireDefault(_PayPlan);
	
	var _SettingSuspend = __webpack_require__(465);
	
	var _SettingSuspend2 = _interopRequireDefault(_SettingSuspend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DiscountPackage: _DiscountPackage2.default,
	    PricingPlan: _PricingPlan2.default,
	    PayPlan: _PayPlan2.default,
	    SettingSuspend: _SettingSuspend2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {},
	  computed: {},
	  created: function created() {
	    this.isLoading = true;
	
	    this.$emit('loadChanged', true);
	  },
	  mounted: function mounted() {},
	  data: function data() {
	    return {
	      isLoading: false
	    };
	  },
	  methods: {
	    pricingPlanLoadChanged: function pricingPlanLoadChanged(value) {
	      this.isLoading = value;
	      this.$emit('loadChanged', value);
	    }
	  }
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    'currentDiscount.percent': function currentDiscountPercent() {
	      if (this.formErrors.has('percent')) {
	        this.formErrors.remove('percent');
	      }
	    },
	    'currentDiscount.description': function currentDiscountDescription() {
	      if (this.formErrors.has('description')) {
	        this.formErrors.remove('description');
	      }
	    }
	  },
	  computed: {
	    hasDiscount: function hasDiscount() {
	      return this.team.discount > 0;
	    }
	  },
	  created: function created() {
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('percent', 'required|between:0,100', { prettyName: 'discount percent' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounted: function mounted() {
	    if (this.team && this.team.discount) {
	      this.currentDiscount.percent = this.team.discount;
	    }
	  },
	  data: function data() {
	    return {
	      validator: null,
	      formErrors: null,
	      showAlert: false,
	      errorResponse: null,
	      showDiscountForm: false,
	      currentDiscount: {
	        percent: 0,
	        description: null
	      }
	    };
	  },
	  methods: {
	    onSubmitDiscountForm: function onSubmitDiscountForm() {
	      var _this = this;
	
	      this.showAlert = false;
	
	      this.validator.validateAll({
	        percent: this.currentDiscount.percent
	      }).then(function () {
	        return _this.updateDiscount(_this.currentDiscount.percent);
	      }).then(function () {
	        _this.showAlert = false;
	
	        _this.toggleDiscountForm();
	
	        _this.team.discount = _this.currentDiscount.percent;
	      }).catch(function (error) {
	        if (error.response) {
	          _this.showAlert = true;
	          _this.errorResponse = _this.$t('admin.billing.discount.response.failed');
	        }
	      });
	    },
	    toggleDiscountForm: function toggleDiscountForm() {
	      this.showDiscountForm = !this.showDiscountForm;
	    },
	    cancleDiscountForm: function cancleDiscountForm() {
	      this.currentDiscount.percent = this.team.discount;
	      this.toggleDiscountForm();
	    },
	    updateDiscount: function updateDiscount(percent) {
	      return _axios2.default.post('/api/teams/' + this.team.namespace + '/discount', {
	        discount: percent
	      });
	    },
	    removeDiscount: function removeDiscount() {
	      var _this2 = this;
	
	      this.updateDiscount(0).then(function () {
	        _this2.currentDiscount.percent = 0;
	        _this2.team.discount = 0;
	      }).catch(function () {});
	    }
	  }
	};

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _veeValidate = __webpack_require__(5);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _StorageManager = __webpack_require__(16);
	
	var _StorageManager2 = _interopRequireDefault(_StorageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['data'],
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    isLoadingCurrentUser: function isLoadingCurrentUser() {
	      this.checkAuthorize();
	    },
	    $route: function $route() {
	      this.checkAuthorize();
	    },
	
	    currentUser: function currentUser() {
	      var _this = this;
	
	      if (this.currentUser) {
	        var namespace = this.currentUser.team.namespace;
	
	        this.$i18n.locale = this.currentUser.lang;
	
	        _veeValidate.Validator.setLocale(this.currentUser.lang);
	
	        _moment2.default.locale(this.currentUser.lang);
	
	        this.storage.getLang(namespace).then(function (lang) {
	          if (lang !== _this.currentUser.lang) {
	            _this.storage.setLang(_this.currentUser.lang, namespace);
	          }
	        });
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isLoadingCurrentUser', 'getCurrentUserError', 'currentUser']), {
	    dateIssued: function dateIssued() {
	      if (this.statement && this.statement.created_at) {
	        return (0, _moment2.default)(this.statement.created_at).format('D MMMM YYYY');
	      }
	      return '';
	    }
	  }),
	  data: function data() {
	    return {
	      isUnauthorize: false,
	      isPrinting: false,
	      statement: {},
	      billingInformation: {
	        first_name: null,
	        last_name: null,
	        company_name: null,
	        tax_id: null,
	        address1: null,
	        address2: null,
	        city: null,
	        state: null,
	        zipcode: null,
	        country: null,
	        contact_phone: null,
	        contact_email: null
	      },
	      team: null,
	      reseller: null,
	      storage: null
	    };
	  },
	  mounted: function mounted() {
	    this.fetchOrderNumberReport(this.$route.query.number);
	  },
	  created: function created() {
	    this.storage = new _StorageManager2.default();
	
	    this.$store.dispatch('getCurrentUser');
	  },
	  methods: {
	    checkAuthorize: function checkAuthorize() {
	      if (this.currentUser) {
	        if (this.$route.matched.some(function (record) {
	          return record.meta.requiresManager;
	        })) {
	          if (this.currentUser.role !== 'manager' && !this.currentUser.team.is_superadmin) {
	            this.isUnauthorize = true;
	            return;
	          }
	        } else if (this.$route.matched.some(function (record) {
	          return record.meta.requiresSuperAdmin;
	        })) {
	          if (!this.currentUser.team.is_superadmin) {
	            this.isUnauthorize = true;
	            return;
	          }
	        }
	      }
	      this.isUnauthorize = false;
	    },
	    fetchOrderNumberReport: function fetchOrderNumberReport(number) {
	      var _this2 = this;
	
	      var namespace = '';
	
	      if (this.$route.params.subnamespace) {
	        namespace = this.$route.params.subnamespace;
	      } else {
	        namespace = this.$route.params.namespace;
	      }
	
	      var url = '/api/teams/' + namespace + '/balances/transaction/' + number;
	
	      _axios2.default.get(url).then(function (response) {
	        _this2.statement = response.data;
	        _this2.team = _this2.statement ? _this2.statement.team : '';
	        _this2.billingInformation = _this2.team ? _this2.team.active_billing_address : '';
	      }).catch(function () {});
	    }
	  }
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _veeValidate = __webpack_require__(5);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _StorageManager = __webpack_require__(16);
	
	var _StorageManager2 = _interopRequireDefault(_StorageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['data'],
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    isLoadingCurrentUser: function isLoadingCurrentUser() {
	      this.checkAuthorize();
	    },
	    $route: function $route() {
	      this.checkAuthorize();
	    },
	
	    currentUser: function currentUser() {
	      var _this = this;
	
	      if (this.currentUser) {
	        var namespace = this.currentUser.team.namespace;
	
	        this.$i18n.locale = this.currentUser.lang;
	
	        _veeValidate.Validator.setLocale(this.currentUser.lang);
	
	        _moment2.default.locale(this.currentUser.lang);
	
	        this.storage.getLang(namespace).then(function (lang) {
	          if (lang !== _this.currentUser.lang) {
	            _this.storage.setLang(_this.currentUser.lang, namespace);
	          }
	        });
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isLoadingCurrentUser', 'getCurrentUserError', 'currentUser']), {
	    dateIssued: function dateIssued() {
	      if (this.usageReportMonth) {
	        return (0, _moment2.default)(this.usageReportMonth).add(1, 'months').startOf('month').format('D MMMM YYYY');
	      }
	      return '';
	    },
	    currentMonth: function currentMonth() {
	      if (this.usageReportMonth) {
	        return (0, _moment2.default)(this.usageReportMonth, ['YYYY-MM', _moment2.default.ISO_8601]).format('MMMM YYYY');
	      }
	      return '';
	    }
	  }),
	  data: function data() {
	    return {
	      isUnauthorize: false,
	      isPrinting: false,
	      usages: {},
	      team: null,
	      reseller: null,
	      usageReportMonth: null,
	      billingInformation: {
	        first_name: null,
	        last_name: null,
	        company_name: null,
	        tax_id: null,
	        address1: null,
	        address2: null,
	        city: null,
	        state: null,
	        zipcode: null,
	        country: null,
	        contact_phone: null,
	        contact_email: null
	      },
	      storage: null
	    };
	  },
	  mounted: function mounted() {
	    this.fetchUsages(this.$route.query.month);
	  },
	  created: function created() {
	    this.storage = new _StorageManager2.default();
	
	    this.$store.dispatch('getCurrentUser');
	  },
	  methods: {
	    checkAuthorize: function checkAuthorize() {
	      if (this.currentUser) {
	        if (this.$route.matched.some(function (record) {
	          return record.meta.requiresManager;
	        })) {
	          if (this.currentUser.role !== 'manager' && !this.currentUser.team.is_superadmin) {
	            this.isUnauthorize = true;
	            return;
	          }
	        } else if (this.$route.matched.some(function (record) {
	          return record.meta.requiresSuperAdmin;
	        })) {
	          if (!this.currentUser.team.is_superadmin) {
	            this.isUnauthorize = true;
	            return;
	          }
	        }
	      }
	      this.isUnauthorize = false;
	    },
	    fetchUsages: function fetchUsages(month) {
	      var _this2 = this;
	
	      var namespace = '';
	
	      if (this.$route.params.subnamespace) {
	        namespace = this.$route.params.subnamespace;
	      } else {
	        namespace = this.$route.params.namespace;
	      }
	
	      if (!month) {
	        month = (0, _moment2.default)().format('YYYY-MM');
	      } else {
	        month = (0, _moment2.default)(month, ['D MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	      }
	
	      this.usageReportMonth = month;
	
	      var url = '/api/teams/' + namespace + '/usage?month=' + month;
	
	      _axios2.default.get(url).then(function (response) {
	        _this2.usages = response.data;
	        _this2.team = _this2.usages.client_team;
	      }).catch(function () {});
	    }
	  }
	};

/***/ },
/* 262 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _veeValidate = __webpack_require__(5);
	
	var _sweetalert = __webpack_require__(23);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Modal = __webpack_require__(48);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _PaymentInformationForm = __webpack_require__(198);
	
	var _PaymentInformationForm2 = _interopRequireDefault(_PaymentInformationForm);
	
	var _credit = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    Modal: _Modal2.default,
	    FormGroup: _FormGroup2.default,
	    PaymentInformationForm: _PaymentInformationForm2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    'currentPrice.value': function currentPriceValue(value) {
	      var _this = this;
	
	      if (this.currentPrice.key === 'Custom') {
	        this.validator.validateAll({
	          customPrice: value
	        }).then(function (success) {
	          if (!success) {
	            return;
	          }
	
	          _this.selectedCredit = value;
	        }).catch(function () {});
	      } else {
	        this.selectedCredit = value;
	      }
	    }
	  },
	  computed: {},
	  data: function data() {
	    return {
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      currentPrice: { value: 300, key: '300' },
	      priceList: null,
	      selectedCredit: 300
	    };
	  },
	  created: function created() {
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('customPrice', 'required|numeric|custom_price_between:300,100000', { prettyName: 'Custom Credit' });
	
	    this.validator.errorBag.errors = [];
	    this.$set(this, 'formErrors', this.validator.errorBag);
	    this.loadPriceList();
	  },
	  mounted: function mounted() {
	    if (this.$route.query.result) {
	      this.resultPayment(this.$route.query.result);
	    }
	  },
	  methods: {
	    loadPriceList: function loadPriceList() {
	      this.priceList = (0, _credit.loadPriceList)();
	    },
	
	    onPayButtonClick: function onPayButtonClick() {
	      this.$refs.paymentInformationForm.clearForm();
	      this.$refs.paymentInformationFormModal.open();
	    },
	    onPaymentInformationFormComplete: function onPaymentInformationFormComplete() {},
	    onPaymentInformationFormCancel: function onPaymentInformationFormCancel() {
	      this.$refs.paymentInformationFormModal.close();
	    },
	    resultPayment: function resultPayment(action) {
	      var _this2 = this;
	
	      if (action === 'success') {
	        (0, _sweetalert2.default)(this.$t('billing.addcredit.paymentResult.success.title'), this.$t('billing.addcredit.paymentResult.success.text'), 'success').then(function () {
	          _this2.$router.replace(_this2.$route.path);
	        });
	      } else {
	        (0, _sweetalert2.default)(this.$t('billing.addcredit.paymentResult.failed.title'), this.$t('billing.addcredit.paymentResult.failed.text'), 'error').then(function () {
	          _this2.$router.replace(_this2.$route.path);
	        });
	      }
	    }
	  }
	};

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _veeValidate = __webpack_require__(5);
	
	var _sweetalert = __webpack_require__(23);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Modal = __webpack_require__(48);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _PaymentInformationForm = __webpack_require__(198);
	
	var _PaymentInformationForm2 = _interopRequireDefault(_PaymentInformationForm);
	
	var _PaypalCheckout = __webpack_require__(476);
	
	var _PaypalCheckout2 = _interopRequireDefault(_PaypalCheckout);
	
	var _credit = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    Modal: _Modal2.default,
	    FormGroup: _FormGroup2.default,
	    PaymentInformationForm: _PaymentInformationForm2.default,
	    PaypalCheckout: _PaypalCheckout2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    'currentPrice.value': function currentPriceValue(value) {
	      var _this = this;
	
	      if (this.currentPrice.key === 'Custom') {
	        this.validator.validateAll({
	          customPrice: value
	        }).then(function (success) {
	          if (!success) {
	            return;
	          }
	
	          _this.selectedCredit = value;
	        }).catch(function () {});
	      } else {
	        this.selectedCredit = value;
	      }
	    }
	  },
	  computed: {},
	  data: function data() {
	    return {
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      currentPrice: { value: 300, key: '300' },
	      priceList: null,
	      selectedCredit: 300,
	      buttonStyle: {
	        label: 'pay',
	        size: 'responsive',
	        color: 'blue',
	        shape: 'rect',
	        tagline: false
	      }
	    };
	  },
	  created: function created() {
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('customPrice', 'required|numeric|custom_price_between:300,100000', { prettyName: 'Custom Credit' });
	
	    this.validator.errorBag.errors = [];
	    this.$set(this, 'formErrors', this.validator.errorBag);
	    this.loadPriceList();
	    this.paypalDevEnv = (false);
	  },
	  mounted: function mounted() {
	    if (this.$route.query.result) {
	      this.resultPayment(this.$route.query.result);
	    }
	  },
	  methods: {
	    loadPriceList: function loadPriceList() {
	      this.priceList = (0, _credit.loadPriceList)();
	    },
	
	    onPayButtonClick: function onPayButtonClick() {
	      this.$refs.paymentInformationForm.clearForm();
	      this.$refs.paymentInformationFormModal.open();
	    },
	    validatePayButton: function validatePayButton(actions) {
	      return this.formErrors.first('customPrice') ? actions.disable() : actions.enable();
	    },
	    onPaymentInformationFormComplete: function onPaymentInformationFormComplete() {},
	    onPaymentInformationFormCancel: function onPaymentInformationFormCancel() {
	      this.$refs.paymentInformationFormModal.close();
	    },
	    resultPayment: function resultPayment(action) {
	      var _this2 = this;
	
	      if (action === 'success') {
	        (0, _sweetalert2.default)(this.$t('billing.addcredit.paymentResult.success.title'), this.$t('billing.addcredit.paymentResult.success.text'), 'success').then(function () {
	          _this2.$router.replace(_this2.$route.path);
	        });
	      } else {
	        (0, _sweetalert2.default)(this.$t('billing.addcredit.paymentResult.failed.title'), this.$t('billing.addcredit.paymentResult.failed.text'), 'error').then(function () {
	          _this2.$router.replace(_this2.$route.path);
	        });
	      }
	    }
	  }
	};

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _sweetalert = __webpack_require__(23);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Modal = __webpack_require__(48);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _BillingInformationForm = __webpack_require__(197);
	
	var _BillingInformationForm2 = _interopRequireDefault(_BillingInformationForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    Modal: _Modal2.default,
	    FormGroup: _FormGroup2.default,
	    LoadingIndicator: _LoadingIndicator2.default,
	    BillingInformationForm: _BillingInformationForm2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    team: function team(value) {
	      if (value) {
	        this.fetchBillingInformation();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hasBillingInformation: false,
	      isLoading: false,
	      billingInformation: {
	        first_name: null,
	        last_name: null,
	        company_name: null,
	        tax_id: null,
	        address1: null,
	        address2: null,
	        city: null,
	        state: null,
	        zipcode: null,
	        country: 'TH',
	        contact_phone: null,
	        contact_email: null
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.isLoading = true;
	
	    this.$emit('loadChanged', true);
	
	    this.eventHub.$on('billingInformationUpdated', function (newBillingInformation) {
	      _this.billingInformation = (0, _assign2.default)({}, newBillingInformation);
	
	      _this.hasBillingInformation = true;
	
	      _this.eventHub.$emit('hasBillingInformationUpdated', _this.hasBillingInformation);
	    });
	  },
	  mounted: function mounted() {
	    if (this.team) {
	      this.fetchBillingInformation();
	    }
	  },
	  methods: {
	    fetchBillingInformation: function fetchBillingInformation() {
	      var _this2 = this;
	
	      _axios2.default.get('/api/teams/' + this.team.namespace + '/billing/info').then(function (response) {
	        _this2.isLoading = false;
	
	        if (Array.isArray(response.data)) {
	          _this2.hasBillingInformation = false;
	        } else {
	          _this2.hasBillingInformation = true;
	
	          _this2.$nextTick(function () {
	            _this2.billingInformation = response.data;
	          });
	        }
	
	        _this2.$emit('loadChanged', false);
	
	        _this2.eventHub.$emit('hasBillingInformationUpdated', _this2.hasBillingInformation);
	      }).catch(function () {
	        _this2.isLoading = false;
	
	        _this2.$emit('loadChanged', false);
	      });
	    },
	    onChangeInformationButtonClick: function onChangeInformationButtonClick() {
	      this.$refs.billingInformationForm.refreshBillingInformation();
	      this.$refs.billingInformationFormModal.open();
	    },
	    onBillingInformationFormSaved: function onBillingInformationFormSaved(newBillingInformation) {
	      this.billingInformation = (0, _assign2.default)({}, newBillingInformation);
	      this.$refs.billingInformationFormModal.close();
	
	      this.hasBillingInformation = true;
	
	      (0, _sweetalert2.default)('Success', 'Billing Information have been updated.', 'success');
	
	      this.eventHub.$emit('hasBillingInformationUpdated', this.hasBillingInformation);
	    },
	    onBillingInformationFormCancel: function onBillingInformationFormCancel() {
	      this.$refs.billingInformationFormModal.close();
	    }
	  }
	};

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(7);
	
	var _veeValidate = __webpack_require__(5);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _StorageManager = __webpack_require__(16);
	
	var _StorageManager2 = _interopRequireDefault(_StorageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    isLoadingCurrentUser: function isLoadingCurrentUser() {
	      this.checkAuthorize();
	    },
	    currentUser: function currentUser(value) {
	      var _this = this;
	
	      if (value) {
	        var namespace = this.currentUser.team.namespace;
	
	        this.$i18n.locale = this.currentUser.lang;
	        _veeValidate.Validator.setLocale(this.currentUser.lang);
	
	        this.storage.getLang(namespace).then(function (lang) {
	          if (lang !== _this.currentUser.lang) {
	            _this.storage.setLang(_this.currentUser.lang, namespace);
	          }
	        });
	
	        this.requestPaymentCallback();
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isLoadingCurrentUser', 'currentUser'])),
	  data: function data() {
	    return {
	      isLoading: false,
	      isUnauthorize: false,
	      storage: null
	    };
	  },
	  created: function created() {
	    this.storage = new _StorageManager2.default();
	
	    this.$store.dispatch('getCurrentUser');
	  },
	  mounted: function mounted() {},
	  methods: {
	    checkAuthorize: function checkAuthorize() {
	      if (this.currentUser) {
	        if (this.$route.matched.some(function (record) {
	          return record.meta.requiresManager;
	        })) {
	          if (this.currentUser.role !== 'manager') {
	            this.isUnauthorize = true;
	            return;
	          }
	        } else if (this.$route.matched.some(function (record) {
	          return record.meta.requiresSuperAdmin;
	        })) {
	          if (!this.currentUser.team.is_superadmin) {
	            this.isUnauthorize = true;
	            return;
	          }
	        }
	      }
	      this.isUnauthorize = false;
	    },
	    requestPaymentCallback: function requestPaymentCallback() {
	      var _this2 = this;
	
	      var paymentId = this.$route.params.id;
	      var queryParams = this.$route.query;
	
	      this.isLoading = true;
	      _axios2.default.get('/api/payment/return/' + paymentId, {
	        params: queryParams
	      }).then(function () {
	        _this2.isLoading = false;
	        var namespace = _this2.$route.params.namespace;
	        _this2.$router.push({ path: '/' + namespace + '/billing', query: { result: 'success' } });
	      }).catch(function () {
	        _this2.isLoading = false;
	        var namespace = _this2.$route.params.namespace;
	        _this2.$router.push({ path: '/' + namespace + '/billing', query: { result: 'fail' } });
	      });
	    }
	  }
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BillingCreditDirect = __webpack_require__(471);
	
	var _BillingCreditDirect2 = _interopRequireDefault(_BillingCreditDirect);
	
	var _BillingCreditOmise = __webpack_require__(472);
	
	var _BillingCreditOmise2 = _interopRequireDefault(_BillingCreditOmise);
	
	var _BillingCreditPayPal = __webpack_require__(473);
	
	var _BillingCreditPayPal2 = _interopRequireDefault(_BillingCreditPayPal);
	
	var _BillingInformation = __webpack_require__(194);
	
	var _BillingInformation2 = _interopRequireDefault(_BillingInformation);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BillingCreditDirect: _BillingCreditDirect2.default,
	    BillingCreditOmise: _BillingCreditOmise2.default,
	    BillingCreditPayPal: _BillingCreditPayPal2.default,
	    BillingInformation: _BillingInformation2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  props: {
	    team: {
	      type: Object
	    },
	    showBillingCredit: {
	      type: Boolean
	    },
	    showBillingInformation: {
	      type: Boolean
	    }
	  },
	  data: function data() {
	    return {
	      currentPaymentMethod: null
	    };
	  },
	
	  computed: {
	    isLoading: function isLoading() {
	      var loading = this.isBillingCreditLoading || this.isBillingInformationLoading;
	
	      this.$emit('loadChanged', loading);
	
	      return loading;
	    },
	    showOmisePayment: function showOmisePayment() {
	      var paymentMethod = 'omise';
	      return this.isPaymentAvailable(paymentMethod);
	    },
	    showPayPalPayment: function showPayPalPayment() {
	      var paymentMethod = 'paypal';
	      return this.isPaymentAvailable(paymentMethod);
	    }
	  },
	  created: function created() {
	    if (this.team.available_payment_methods) {
	      this.currentPaymentMethod = this.team.available_payment_methods[0];
	    }
	  },
	  mounted: function mounted() {},
	  methods: {
	    isPaymentAvailable: function isPaymentAvailable(paymentMethod) {
	      if (this.team.available_payment_methods) {
	        var isAvailable = false;
	        isAvailable = this.team.available_payment_methods.find(function (item) {
	          if (item === paymentMethod) {
	            return true;
	          }
	        });
	        return isAvailable;
	      }
	      return false;
	    },
	
	    billingCreditLoadChanged: function billingCreditLoadChanged(value) {
	      this.isBillingCreditLoading = value;
	    },
	    billingInformationLoadChanged: function billingInformationLoadChanged(value) {
	      this.isBillingInformationLoading = value;
	    }
	  }
	};

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _paypalCheckout = __webpack_require__(434);
	
	var _paypalCheckout2 = _interopRequireDefault(_paypalCheckout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    credit: {
	      type: Number,
	      required: true
	    },
	    commit: {
	      type: Boolean,
	      required: false,
	      default: true
	    },
	    dev: {
	      type: Boolean,
	      required: false
	    },
	    buttonStyle: {
	      type: Object,
	      required: false,
	      validator: function validator(value) {
	        var isValid = function isValid(item, options) {
	          return options.some(function (v) {
	            return v === item;
	          });
	        };
	        var copy = (0, _assign2.default)({}, value);
	        var options = {
	          size: ['tiny', 'small', 'medium', 'responsive'],
	          color: ['gold', 'blue', 'silver'],
	          shape: ['pill', 'rect']
	        };
	
	        (0, _keys2.default)(options).forEach(function (key) {
	          var item = copy[key];
	          var valid = isValid(item, options[key]);
	
	          if (!valid) {
	            console.warn('style.' + key + ' = \'' + item + '\' isn\'t a valid option', options[key]);
	            return false;
	          }
	
	          return true;
	        });
	
	        return true;
	      }
	    },
	    validate: {
	      type: Function,
	      required: false
	    }
	  },
	  computed: {
	    env: function env() {
	      return this.dev ? 'sandbox' : 'production';
	    }
	  },
	  methods: {
	    PayPalPayment: function PayPalPayment() {
	      return _axios2.default.post('/api/payment/paypal', { credit: this.credit }).then(function (response) {
	        var data = response.data;
	        console.log(data);
	        return data.paymentID;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    onAuthorize: function onAuthorize(data, actions) {
	      return actions.redirect();
	    },
	    onCancel: function onCancel(data, actions) {
	      return actions.redirect();
	    }
	  },
	  mounted: function mounted() {
	    var vue = this;
	
	    var buttonObject = {
	      env: vue.env,
	
	      validate: vue.validate,
	
	      payment: vue.PayPalPayment,
	
	      commit: vue.commit,
	
	      onAuthorize: vue.onAuthorize,
	
	      onCancel: vue.onCancel
	    };
	
	    if (vue.buttonStyle !== undefined) {
	      buttonObject.style = vue.buttonStyle;
	    }
	
	    _paypalCheckout2.default.Button.render(buttonObject, '#paypal-button');
	  }
	};

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    team: function team(value) {
	      if (value) {
	        this.fetchPricingPlanList();
	      }
	    },
	    'currentPricingPlan.alias': function currentPricingPlanAlias(value) {
	      var pricingPlan = this.pricingPlanList.find(function (item) {
	        if (item.alias === value) {
	          return item;
	        }
	      });
	
	      if (pricingPlan) {
	        this.currentPricingPlan.name = pricingPlan.name;
	      }
	    }
	  },
	  created: function created() {
	    this.isLoading = true;
	
	    this.$emit('loadChanged', true);
	
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('pricingPlan', 'required', { prettyName: 'pricing plan' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounted: function mounted() {
	    if (this.team) {
	      this.fetchPricingPlanList();
	    }
	  },
	  computed: {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      validator: null,
	      formErrors: null,
	      showAlert: false,
	      errorResponse: null,
	      showPricingPlanForm: false,
	      currentPricingPlan: {
	        name: null,
	        alias: null
	      },
	      pricingPlanList: null
	    };
	  },
	  methods: {
	    fetchPricingPlanList: function fetchPricingPlanList() {
	      var _this = this;
	
	      _axios2.default.get('/api/pricingplans').then(function (response) {
	        _this.pricingPlanList = response.data.plans;
	        _this.currentPricingPlan.alias = _this.team.pricing_plan;
	
	        _this.isLoading = false;
	
	        _this.$emit('loadChanged', false);
	      }).catch(function () {
	        _this.isLoading = false;
	
	        _this.$emit('loadChanged', false);
	      });
	    },
	    onSubmitPricingPlanForm: function onSubmitPricingPlanForm() {
	      var _this2 = this;
	
	      this.showAlert = false;
	
	      this.validator.validateAll({
	        pricingPlan: this.currentPricingPlan.alias
	      }).then(function () {
	        return _this2.updatePricingPlan(_this2.currentPricingPlan.alias);
	      }).then(function () {
	        _this2.showAlert = false;
	
	        _this2.team.pricing_plan = _this2.currentPricingPlan.alias;
	
	        _this2.togglePricingPlanForm();
	      }).catch(function () {
	        _this2.showAlert = true;
	        _this2.errorResponse = _this2.$t('admin.billing.pricingplan.response.failed');
	      });
	    },
	    togglePricingPlanForm: function togglePricingPlanForm() {
	      this.showPricingPlanForm = !this.showPricingPlanForm;
	    },
	    cancelPricingPlanForm: function cancelPricingPlanForm() {
	      this.currentPricingPlan.alias = this.team.pricing_plan;
	      this.togglePricingPlanForm();
	    },
	    updatePricingPlan: function updatePricingPlan(pricingPlan) {
	      return _axios2.default.post('/api/teams/' + this.team.namespace + '/pricingplan', {
	        pricing_plan: pricingPlan
	      });
	    }
	  }
	};

/***/ },
/* 270 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 271 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(7);
	
	var _MonthList = __webpack_require__(448);
	
	var _MonthList2 = _interopRequireDefault(_MonthList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    team: {
	      type: Object
	    },
	    showTitle: {
	      type: Boolean
	    }
	  },
	  components: {
	    MonthList: _MonthList2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    },
	    shortCurrentMonth: function shortCurrentMonth() {
	      return (0, _moment2.default)(this.currentMonth, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	    },
	    downLoadUrl: function downLoadUrl() {
	      if (this.team && this.currentUser) {
	        if (this.$route.params.subnamespace) {
	          var parentUrl = this.$route.params.namespace;
	          var namespace = this.$route.params.subnamespace;
	
	          var role = void 0;
	
	          if (this.currentUser.team.is_superadmin) {
	            role = 'admin';
	          } else if (this.currentUser.team.is_reseller) {
	            role = 'reseller';
	          }
	
	          return '/' + parentUrl + '/' + role + '/teams/' + namespace + '/usage-report';
	        } else {
	          var _namespace = this.$route.params.namespace;
	          return '/' + _namespace + '/usage-report';
	        }
	      }
	    }
	  }),
	  created: function created() {
	    this.isLoading = true;
	
	    this.$emit('loadChanged', true);
	  },
	  mounted: function mounted() {
	    if (this.team) {
	      this.fetchUsages(this.currentMonth);
	    }
	  },
	  data: function data() {
	    return {
	      currentMonth: (0, _moment2.default)().startOf('months').format('MMMM YYYY'),
	      teams: [],
	      step: -1
	    };
	  },
	  methods: {
	    fetchUsages: function fetchUsages(month) {
	      var _this = this;
	
	      this.isLoading = true;
	
	      var namespace = this.team.namespace;
	
	      if (!month) {
	        month = (0, _moment2.default)(this.currentMonth, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	      } else {
	        month = (0, _moment2.default)(month, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	      }
	
	      var url = void 0;
	
	      if (this.currentUser.team.is_superadmin && !this.$route.params.subnamespace) {
	        url = '/api/admin/bills?month=' + month + '&namespace=' + namespace + '&sort=cost';
	      } else {
	        url = '/api/teams/' + namespace + '/bills?month=' + month + '&sort=cost';
	      }
	
	      _axios2.default.get(url).then(function (response) {
	        _this.teams = response.data;
	        _this.isLoading = false;
	
	        _this.$emit('loadChanged', false);
	      }).catch(function () {
	        _this.isLoading = false;
	
	        _this.$emit('loadChanged', false);
	      });
	    },
	    showChild: function showChild(value) {
	      if (this.step !== value) {
	        this.step = value;
	      } else {
	        this.step = -1;
	      }
	    },
	    showReportDownload: function showReportDownload(month) {
	      if (this.isLoading) {
	        return false;
	      }
	
	      var now = (0, _moment2.default)().startOf('months');
	      var start = (0, _moment2.default)(month, ['MMMM YYYY', _moment2.default.ISO_8601]).startOf('months');
	      var months = now.diff(start, 'months');
	
	      if (months > 0) {
	        return true;
	      }
	
	      return false;
	    },
	    urlUsageReport: function urlUsageReport(month) {
	      if (!month) {
	        month = (0, _moment2.default)(this.currentMonth, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	      } else {
	        month = (0, _moment2.default)(month, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	      }
	
	      return this.downLoadUrl + '?month=' + month;
	    }
	  }
	};

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(7);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    team: function team(value) {
	      if (value) {
	        this.fetchUsages(this.currentMonth);
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    },
	    monthList: function monthList() {
	      var list = [];
	
	      var now = (0, _moment2.default)().startOf('months');
	      var start = (0, _moment2.default)(this.team.created_at).startOf('months');
	      var months = now.diff(start, 'months');
	      list.push(now.format('MMMM YYYY'));
	
	      for (var i = 0; i < months; i += 1) {
	        list.push(now.subtract(1, 'months').format('MMMM YYYY'));
	      }
	
	      return list;
	    },
	    showReportDownload: function showReportDownload() {
	      if (this.isLoading) {
	        return false;
	      }
	
	      if (this.usages && this.usages.items <= 0) {
	        return false;
	      }
	
	      var now = (0, _moment2.default)().startOf('months');
	      var start = (0, _moment2.default)(this.currentMonth, ['MMMM YYYY', _moment2.default.ISO_8601]).startOf('months');
	      var months = now.diff(start, 'months');
	
	      if (months > 0) {
	        return true;
	      }
	
	      return false;
	    },
	    downLoadUrl: function downLoadUrl() {
	      if (this.team && this.currentUser) {
	        if (this.$route.params.subnamespace) {
	          var parentUrl = this.$route.params.namespace;
	          var namespace = this.$route.params.subnamespace;
	
	          var role = void 0;
	
	          if (this.currentUser.team.is_superadmin) {
	            role = 'admin';
	          } else if (this.currentUser.team.is_reseller) {
	            role = 'reseller';
	          }
	
	          return '/' + parentUrl + '/' + role + '/teams/' + namespace + '/usage-report';
	        } else {
	          var _namespace = this.$route.params.namespace;
	          return '/' + _namespace + '/usage-report';
	        }
	      }
	    },
	    showCost: function showCost() {
	      if (this.currentUser) {
	        return this.currentUser.role === 'manager';
	      }
	      return false;
	    },
	    haveUsageItems: function haveUsageItems() {
	      return this.usages && this.usages.items && this.usages.items.length > 0;
	    }
	  }),
	  data: function data() {
	    return {
	      isLoading: false,
	      usages: null,
	      currentMonth: (0, _moment2.default)().startOf('month').format('MMMM YYYY')
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	    this.$emit('loadChanged', true);
	  },
	  mounted: function mounted() {
	    if (this.team) {
	      this.fetchUsages(this.currentMonth);
	    }
	  },
	  methods: {
	    fetchUsages: function fetchUsages(month) {
	      var _this = this;
	
	      this.isLoading = true;
	
	      var namespace = this.team.namespace;
	
	      if (!month) {
	        month = (0, _moment2.default)(this.currentMonth, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	      } else {
	        month = (0, _moment2.default)(month, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	      }
	
	      _axios2.default.get('/api/teams/' + namespace + '/usage?month=' + month).then(function (response) {
	        _this.usages = response.data;
	        _this.isLoading = false;
	
	        _this.$emit('loadChanged', false);
	      }).catch(function () {
	        _this.isLoading = false;
	
	        _this.$emit('loadChanged', false);
	      });
	    },
	    onChange: function onChange() {
	      this.fetchUsages(this.currentMonth);
	    },
	    urlUsageReport: function urlUsageReport() {
	      var month = this.currentMonth;
	
	      if (!month) {
	        month = (0, _moment2.default)(this.currentMonth, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	      } else {
	        month = (0, _moment2.default)(month, ['MMMM YYYY', _moment2.default.ISO_8601]).format('YYYY-MM');
	      }
	
	      return this.downLoadUrl + '?month=' + month;
	    }
	  }
	};

/***/ },
/* 274 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _veeValidate = __webpack_require__(5);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(7);
	
	var _NavBar = __webpack_require__(449);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Page = __webpack_require__(196);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _StorageManager = __webpack_require__(16);
	
	var _StorageManager2 = _interopRequireDefault(_StorageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    NavBar: _NavBar2.default,
	    Page403: _Page2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    isLoadingCurrentUser: function isLoadingCurrentUser() {
	      this.checkAuthorize();
	    },
	    $route: function $route() {
	      this.checkAuthorize();
	    },
	
	    currentUser: function currentUser() {
	      var _this = this;
	
	      if (this.currentUser) {
	        var namespace = this.currentUser.team.namespace;
	
	        this.$i18n.locale = this.currentUser.lang;
	
	        _veeValidate.Validator.setLocale(this.currentUser.lang);
	
	        _moment2.default.locale(this.currentUser.lang);
	
	        this.storage.getLang(namespace).then(function (lang) {
	          if (lang !== _this.currentUser.lang) {
	            _this.storage.setLang(_this.currentUser.lang, namespace);
	          }
	        });
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isLoadingCurrentUser', 'getCurrentUserError', 'currentUser']), {
	    isTeamSuspend: function isTeamSuspend() {
	      if (this.currentUser) {
	        if (this.currentUser.team.suspend) {
	          return this.currentUser.team.suspend.is_suspend;
	        }
	      }
	      return false;
	    },
	    isLangTH: function isLangTH() {
	      if (this.currentUser) {
	        if (this.currentUser.lang === 'th') {
	          return true;
	        }
	      }
	      return false;
	    }
	  }),
	  data: function data() {
	    return {
	      isUnauthorize: false,
	      storage: null
	    };
	  },
	  created: function created() {
	    this.storage = new _StorageManager2.default();
	
	    this.$store.dispatch('getCurrentUser');
	  },
	  methods: {
	    checkAuthorize: function checkAuthorize() {
	      if (this.currentUser) {
	        if (this.$route.matched.some(function (record) {
	          return record.meta.requiresManager;
	        })) {
	          if (this.currentUser.role !== 'manager' && !this.currentUser.team.is_superadmin) {
	            this.isUnauthorize = true;
	            return;
	          }
	        } else if (this.$route.matched.some(function (record) {
	          return record.meta.requiresSuperAdmin;
	        })) {
	          if (!this.currentUser.team.is_superadmin) {
	            this.isUnauthorize = true;
	            return;
	          }
	        } else if (this.$route.matched.some(function (record) {
	          return record.meta.requiresReseller;
	        })) {
	          if (!(this.currentUser.team.is_reseller && this.currentUser.role === 'manager')) {
	            this.isUnauthorize = true;
	            return;
	          }
	        }
	      }
	      this.isUnauthorize = false;
	    }
	  }
	};

/***/ },
/* 276 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 277 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 278 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 279 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 280 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    Alert: _Alert2.default
	  },
	  watch: {
	    'user.email': function userEmail() {
	      if (this.formErrors.has('email')) {
	        this.formErrors.remove('email');
	      }
	    }
	  },
	  data: function data() {
	    return {
	      validator: null,
	      formErrors: null,
	      showAlert: false,
	      errorResponse: null,
	      successResponse: null,
	      user: {
	        email: null
	      }
	    };
	  },
	  created: function created() {
	    this.validator = new _veeValidate.Validator({
	      email: 'required|email'
	    });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.validator.validateAll({
	        email: this.user.email
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        var namespace = _this.$route.params.namespace;
	
	        _axios2.default.post('/api/password/forgot', {
	          namespace: namespace,
	          email: _this.user.email
	        }).then(function () {
	          _this.successResponse = _this.$t('forgot.response.success') + ' to ' + _this.user.email;
	          _this.errorResponse = null;
	          _this.showAlert = true;
	        }).catch(function (error) {
	          if (error.response.status === 422) {
	            _this.errorResponse = _this.$t('forgot.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorResponse = _this.$t('forgot.response.defaultFailed');
	          }
	          _this.showAlert = true;
	        });
	      }).catch(function () {});
	    },
	    clearFormErrors: function clearFormErrors() {
	      this.formErrors.clear();
	    }
	  }
	};

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    'user.password': function userPassword() {
	      if (this.formErrors.has('password')) {
	        this.formErrors.remove('password');
	      }
	    },
	    'user.confirmpassword': function userConfirmpassword() {
	      if (this.formErrors.has('confirmpassword')) {
	        this.formErrors.remove('confirmpassword');
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      status: null,
	      resetPasswordSuccess: false,
	      errorResponse: null,
	      user: {
	        password: null,
	        confirmpassword: null
	      }
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('password', 'required|min:6', { prettyName: 'new password' });
	    this.validator.attach('confirmpassword', 'required|min:6|confirmed:password', { prettyName: 'confirm new password' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounted: function mounted() {
	    this.validateToken();
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.showAlert = false;
	
	      this.validator.validateAll({
	        password: this.user.password,
	        confirmpassword: this.user.confirmpassword
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        var token = _this.$route.params.token;
	
	        _axios2.default.post('/api/password/reset', {
	          token: token,
	          password: _this.user.password,
	          password_confirmation: _this.user.confirmpassword
	        }).then(function () {
	          _this.resetPasswordSuccess = true;
	        }).catch(function (error) {
	          if (error.response.status === 422) {
	            if (error.response.data.token && error.response.data.token === 'expired') {
	              _this.errorResponse = _this.$t('recovery.verifyToken.response.linkExpired');
	            } else {
	              _this.errorResponse = _this.$t('recovery.resetPassword.response.failed');
	              _this.formErrors.addAll(error.response.data);
	            }
	          } else {
	            _this.errorResponse = _this.$t('recovery.resetPassword.response.defaultFailed');
	          }
	          _this.showAlert = true;
	          _this.resetPasswordSuccess = false;
	        });
	      }).catch(function () {});
	    },
	    validateToken: function validateToken() {
	      var _this2 = this;
	
	      var token = this.$route.params.token;
	
	      _axios2.default.get('/api/password/reset/' + token).then(function (response) {
	        _this2.status = response.data.status;
	        _this2.isLoading = false;
	      }).catch(function (error) {
	        if (error.response.status === 422) {
	          _this2.status = error.response.data.status;
	        } else {
	          _this2.errorResponse = _this2.$t('recovery.verifyToken.response.defaultFailed');
	        }
	        _this2.isLoading = false;
	      });
	    }
	  }
	};

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(25);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _LoadingButton = __webpack_require__(191);
	
	var _LoadingButton2 = _interopRequireDefault(_LoadingButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default,
	    LoadingButton: _LoadingButton2.default
	  },
	  props: {
	    team: {
	      type: Object
	    },
	    billingInformation: {
	      type: Object
	    }
	  },
	  watch: {
	    billingInformation: function billingInformation(value) {
	      this.newBillingInformation = (0, _assign2.default)({}, value);
	    },
	    'newBillingInformation.company_name': function newBillingInformationCompany_name(value) {
	      if (value) {
	        this.isRequiredTaxIDField = true;
	      } else {
	        this.isRequiredTaxIDField = false;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isSubmiting: false,
	      isRequiredTaxIDField: false,
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      newBillingInformation: {
	        first_name: null,
	        last_name: null,
	        company_name: null,
	        tax_id: null,
	        address1: null,
	        address2: null,
	        city: null,
	        state: null,
	        zipcode: null,
	        country: 'TH',
	        contact_phone: null,
	        contact_email: null
	      }
	    };
	  },
	  created: function created() {
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('first_name', 'required', { prettyName: 'First Name' });
	    this.validator.attach('last_name', 'required', { prettyName: 'Last Name' });
	    this.validator.attach('address1', 'required', { prettyName: 'Address Line 1' });
	    this.validator.attach('city', 'required', { prettyName: 'City / Town' });
	    this.validator.attach('state', 'required', { prettyName: 'State / Province / Region' });
	    this.validator.attach('zipcode', 'required', { prettyName: 'ZIP Code' });
	    this.validator.attach('country', 'required', { prettyName: 'Country' });
	    this.validator.attach('contact_phone', 'required|max:32', { prettyName: 'Billing Contact Phone' });
	    this.validator.attach('contact_email', 'required|email', { prettyName: 'Billing E-mail' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.showAlert = false;
	
	      var validateFields = {
	        first_name: this.newBillingInformation.first_name,
	        last_name: this.newBillingInformation.last_name,
	        address1: this.newBillingInformation.address1,
	        city: this.newBillingInformation.city,
	        state: this.newBillingInformation.state,
	        zipcode: this.newBillingInformation.zipcode,
	        country: this.newBillingInformation.country,
	        contact_phone: this.newBillingInformation.contact_phone,
	        contact_email: this.newBillingInformation.contact_email
	      };
	
	      if (this.isRequiredTaxIDField) {
	        this.validator.attach('tax_id', 'required|digits:13', { prettyName: 'Tax ID' });
	        validateFields.tax_id = this.newBillingInformation.tax_id;
	      } else {
	        this.validator.detach('tax_id');
	      }
	
	      this.validator.validateAll(validateFields).then(function (success) {
	        if (!success) {
	          return;
	        }
	        _this.isSubmiting = true;
	
	        return _axios2.default.post('/api/teams/' + _this.team.namespace + '/billing/info', _this.newBillingInformation);
	      }).then(function (response) {
	        _this.isSubmiting = false;
	        _this.errorResponse = null;
	
	        _this.newBillingInformation = response.data;
	
	        _this.$emit('save', _this.newBillingInformation);
	      }).catch(function (error) {
	        if (error.response) {
	          if (error.response.status === 422) {
	            _this.errorResponse = _this.$t('billing.information.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorResponse = _this.$t('billing.information.response.defaultFailed');
	          }
	
	          _this.showAlert = true;
	        }
	        _this.isSubmiting = false;
	      });
	    },
	    refreshBillingInformation: function refreshBillingInformation() {
	      this.clearFormErrors();
	
	      this.newBillingInformation = (0, _assign2.default)({}, this.billingInformation);
	    },
	    onCancelButtonClick: function onCancelButtonClick() {
	      this.$emit('cancel');
	    },
	    clearForm: function clearForm() {
	      this.newBillingInformation.first_name = null;
	      this.newBillingInformation.last_name = null;
	      this.newBillingInformation.company_name = null;
	      this.newBillingInformation.tax_id = null;
	      this.newBillingInformation.address1 = null;
	      this.newBillingInformation.address2 = null;
	      this.newBillingInformation.city = null;
	      this.newBillingInformation.state = null;
	      this.newBillingInformation.zipcode = null;
	      this.newBillingInformation.country = 'TH';
	      this.newBillingInformation.contact_phone = null;
	      this.newBillingInformation.contact_email = null;
	
	      this.clearFormErrors();
	    },
	    clearFormErrors: function clearFormErrors() {
	      this.formErrors.clear();
	    }
	  }
	};

/***/ },
/* 284 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    error: {
	      type: String,
	      default: null
	    },
	    formGroupClass: {
	      type: String,
	      default: ''
	    },
	    errorTextClass: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _LoadingButton = __webpack_require__(191);
	
	var _LoadingButton2 = _interopRequireDefault(_LoadingButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default,
	    LoadingButton: _LoadingButton2.default
	  },
	  props: {
	    credit: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      isSubmiting: false,
	      card: {
	        name: null,
	        number: null,
	        expiration_month: null,
	        expiration_year: null,
	        security_code: null
	      }
	    };
	  },
	  created: function created() {
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('name', 'required', { prettyName: 'Name on card' });
	    this.validator.attach('number', 'required|credit_card', { prettyName: 'Card number' });
	    this.validator.attach('expiration_month', 'required|digits:2|date_format:MM', { prettyName: 'Expire month' });
	    this.validator.attach('expiration_year', 'required|digits:4|date_format:YYYY', { prettyName: 'Expire year' });
	    this.validator.attach('security_code', 'required|numeric', { prettyName: 'CVV code' });
	
	    this.validator.errorBag.errors = [];
	    this.$set(this, 'formErrors', this.validator.errorBag);
	
	    Omise.setPublicKey(("pkey_test_578480yp9qz62011ou1"));
	  },
	  methods: {
	    onSubmit: function onSubmit() {},
	    onClickPayButton: function onClickPayButton() {
	      var _this = this;
	
	      this.validator.validateAll({
	        name: this.card.name,
	        number: this.card.number,
	        expiration_month: this.card.expiration_month,
	        expiration_year: this.card.expiration_year,
	        security_code: this.card.security_code
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        _this.isSubmiting = true;
	
	        Omise.createToken('card', _this.card, function (statusCode, response) {
	          if (statusCode === 200) {
	            _this.showAlert = false;
	
	            _this.sendPaymentRequest(response.id, _this.credit);
	          } else {
	            _this.isSubmiting = false;
	            _this.showAlert = true;
	
	            _this.errorResponse = response.message;
	          }
	        });
	      }).catch(function () {});
	    },
	    sendPaymentRequest: function sendPaymentRequest(omiseToken, credit) {
	      var _this2 = this;
	
	      _axios2.default.post('/api/payment/omise', {
	        token: omiseToken,
	        credit: credit
	      }).then(function (response) {
	        _this2.isSubmiting = false;
	
	        window.location = response.data.authorize_uri;
	      }).catch(function (error) {
	        _this2.isSubmiting = false;
	        _this2.showAlert = true;
	
	        _this2.errorResponse = error.response.data.failure_message;
	      });
	    },
	    clearForm: function clearForm() {
	      this.card.name = null;
	      this.card.number = null;
	      this.card.expiration_month = null;
	      this.card.expiration_year = null;
	      this.card.security_code = null;
	
	      this.clearFormErrors();
	    },
	    clearFormErrors: function clearFormErrors() {
	      this.formErrors.clear();
	    }
	  }
	};

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _OmiseForm = __webpack_require__(488);
	
	var _OmiseForm2 = _interopRequireDefault(_OmiseForm);
	
	var _BillingInformationForm = __webpack_require__(197);
	
	var _BillingInformationForm2 = _interopRequireDefault(_BillingInformationForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    OmiseForm: _OmiseForm2.default,
	    BillingInformationForm: _BillingInformationForm2.default
	  },
	  props: {
	    team: {
	      type: Object
	    },
	    credit: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      step: 0,
	      hasBillingInformation: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.fetchBillingInformation();
	    this.eventHub.$on('hasBillingInformationUpdated', function (hasBillingInformation) {
	      _this.hasBillingInformation = hasBillingInformation;
	    });
	  },
	  methods: {
	    fetchBillingInformation: function fetchBillingInformation() {
	      var _this2 = this;
	
	      _axios2.default.get('/api/teams/' + this.team.namespace + '/billing/info').then(function (response) {
	        _this2.isLoading = false;
	
	        if (Array.isArray(response.data)) {
	          _this2.hasBillingInformation = false;
	        } else {
	          _this2.hasBillingInformation = true;
	
	          _this2.$nextTick(function () {
	            _this2.billingInformation = response.data;
	          });
	        }
	
	        _this2.$emit('loadChanged', false);
	
	        _this2.eventHub.$emit('hasBillingInformationUpdated', _this2.hasBillingInformation);
	      }).catch(function () {
	        _this2.isLoading = false;
	
	        _this2.$emit('loadChanged', false);
	      });
	    },
	    onBillingInformationFormSaved: function onBillingInformationFormSaved(newBillingInformation) {
	      this.step = 1;
	
	      this.eventHub.$emit('billingInformationUpdated', newBillingInformation);
	    },
	    onBillingInformationFormCancel: function onBillingInformationFormCancel() {
	      this.$emit('cancel');
	    },
	    clearForm: function clearForm() {
	      this.step = 0;
	
	      if (this.$refs.billingInformationForm) {
	        this.$refs.billingInformationForm.clearForm();
	      }
	
	      if (this.$refs.omiseForm) {
	        this.$refs.omiseForm.clearForm();
	      }
	    }
	  }
	};

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _qs = __webpack_require__(188);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _veeValidate = __webpack_require__(5);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _TeamListForm = __webpack_require__(490);
	
	var _TeamListForm2 = _interopRequireDefault(_TeamListForm);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _AuthManager = __webpack_require__(18);
	
	var _AuthManager2 = _interopRequireDefault(_AuthManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default,
	    TeamListForm: _TeamListForm2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    'user.namespace': function userNamespace() {
	      if (this.user.namespace) {
	        this.user.namespace = this.user.namespace.toLowerCase();
	      }
	
	      if (this.formErrors.has('namespace')) {
	        this.formErrors.remove('namespace');
	      }
	    },
	    'user.email': function userEmail() {
	      if (this.formErrors.has('email')) {
	        this.formErrors.remove('email');
	      }
	    },
	    'user.password': function userPassword() {
	      if (this.formErrors.has('password')) {
	        this.formErrors.remove('password');
	      }
	    }
	  },
	  computed: {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    },
	    oauthFormURL: function oauthFormURL() {
	      return this.authManager.getFormAuthorizeURL(this.$route.query);
	    },
	    getLoginPath: function getLoginPath() {
	      if ((0, _keys2.default)(this.$route.query).length > 0) {
	        return '/' + this.user.namespace + '/login?' + _qs2.default.stringify(this.$route.query);
	      } else {
	        return '/' + this.user.namespace + '/login';
	      }
	    }
	  },
	  data: function data() {
	    return {
	      stepEnum: {
	        teamList: 0,
	        namespaceForm: 1,
	        loginForm: 2
	      },
	      step: 0,
	      authManager: null,
	      validator: null,
	      formErrors: null,
	      isLoading: false,
	      isLoggingIn: false,
	      isLoginFailed: false,
	      loginFailedText: this.$i18n.t('login.response.failed'),
	      teams: null,
	      user: {
	        namespace: null,
	        email: null,
	        password: null
	      },
	      accessToken: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.authManager = new _AuthManager2.default();
	
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('namespace', 'required|namespace|min:3|max:32', { prettyName: 'Team URL' });
	    this.validator.attach('email', 'required|email');
	    this.validator.attach('password', 'required');
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	
	    this.isLoginFailed = false;
	    this.step = this.stepEnum.namespaceForm;
	
	    if (this.$route.params.namespace) {
	      this.user.namespace = this.$route.params.namespace;
	      this.step = this.stepEnum.loginForm;
	
	      if (this.authManager.isOauthFromOtherService(this.$route.query)) {
	        this.authManager.getAccessToken(this.$route.params.namespace).then(function (credential) {
	          if (!credential || !credential.access_token) {
	            return;
	          }
	
	          _this.isLoading = true;
	          _this.accessToken = credential.access_token;
	          _this.$nextTick(function () {
	            _this.$refs.oauthForm.submit();
	          });
	        });
	      }
	    } else {
	      this.isLoading = true;
	
	      this.authManager.getLoggedInTeams().then(function (teams) {
	        if (teams.length > 0) {
	          _this.teams = teams;
	          _this.step = _this.stepEnum.teamList;
	        } else {
	          _this.step = _this.stepEnum.namespaceForm;
	        }
	
	        _this.isLoading = false;
	      });
	    }
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this2 = this;
	
	      if (this.step === this.stepEnum.namespaceForm) {
	        this.validator.validateAll({
	          namespace: this.user.namespace
	        }).then(function (success) {
	          if (!success) {
	            return;
	          }
	
	          _this2.step = _this2.stepEnum.loginForm;
	          _this2.$router.push(_this2.getLoginPath());
	        }).catch(function () {});
	      } else if (this.step === this.stepEnum.loginForm) {
	        this.validator.validateAll({
	          namespace: this.user.namespace,
	          email: this.user.email,
	          password: this.user.password
	        }).then(function (success) {
	          if (!success) {
	            return;
	          }
	
	          _this2.isLoggingIn = true;
	
	          return _this2.authManager.login(_this2.user.email, _this2.user.password, _this2.user.namespace);
	        }).then(function () {
	          _this2.isLoginFailed = false;
	          _this2.isLoggingIn = false;
	
	          if (_this2.authManager.isOauthFromOtherService(_this2.$route.query)) {
	            _this2.authManager.getAccessToken(_this2.user.namespace).then(_this2.submitOauthForm);
	          } else {
	            _this2.$router.push('/' + _this2.user.namespace);
	          }
	        }).catch(function (error) {
	          if (error.response) {
	            if (error.response.status === 403) {
	              _this2.loginFailedText = error.response.data.message;
	            } else {
	              _this2.loginFailedText = _this2.$i18n.t('login.response.failed');
	            }
	
	            _this2.isLoginFailed = true;
	            _this2.user.password = null;
	            _this2.isLoggingIn = false;
	          }
	        });
	      }
	    },
	    onLoginOtherTeam: function onLoginOtherTeam() {
	      this.step = this.stepEnum.namespaceForm;
	    },
	    submitOauthForm: function submitOauthForm(credential) {
	      var _this3 = this;
	
	      this.accessToken = credential.access_token;
	      this.$nextTick(function () {
	        _this3.$refs.oauthForm.submit();
	      });
	    },
	    clearFormErrors: function clearFormErrors() {
	      this.formErrors.clear();
	    }
	  }
	};

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthManager = __webpack_require__(18);
	
	var _AuthManager2 = _interopRequireDefault(_AuthManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    teams: {
	      type: Array
	    }
	  },
	  computed: {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    }
	  },
	  data: function data() {
	    return {
	      authManager: null
	    };
	  },
	  created: function created() {
	    this.authManager = new _AuthManager2.default();
	  },
	  methods: {
	    selectTeam: function selectTeam(namespace) {
	      var _this = this;
	
	      if (this.authManager.isOauthFromOtherService(this.$route.query)) {
	        this.authManager.getAccessToken(namespace).then(function (credential) {
	          _this.$emit('selectTeam', credential);
	        });
	      } else {
	        this.$router.push('/' + namespace);
	      }
	    },
	    loginOtherTeamClick: function loginOtherTeamClick() {
	      this.$emit('loginOtherTeam');
	    }
	  }
	};

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _vuex = __webpack_require__(7);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    Alert: _Alert2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    'user.password': function userPassword() {
	      if (this.formErrors.has('password')) {
	        this.formErrors.remove('password');
	      }
	    },
	    'user.new_password': function userNew_password() {
	      if (this.formErrors.has('new_password')) {
	        this.formErrors.remove('new_password');
	      }
	    },
	    'user.confirm_new_password': function userConfirm_new_password() {
	      if (this.formErrors.has('confirm_new_password')) {
	        this.formErrors.remove('confirm_new_password');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    showEmail: function showEmail() {
	      if (this.currentUser.team.is_superadmin) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }),
	  data: function data() {
	    return {
	      isSubmiting: false,
	      isLoading: false,
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      user: []
	    };
	  },
	  created: function created() {
	    this.isUserLoading = true;
	
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('current_password', 'required|min:6', { prettyName: 'Current Password' });
	    this.validator.attach('new_password', 'required|min:6', { prettyName: 'New Password' });
	    this.validator.attach('confirm_new_password', 'required|min:6', { prettyName: 'Confirm New Password' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.showAlert = false;
	      this.validator.validateAll({
	        current_password: this.user.password,
	        new_password: this.user.new_password,
	        confirm_new_password: this.user.confirm_new_password
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        _this.isSubmiting = true;
	
	        _axios2.default.put('/api/password', {
	          current_password: _this.user.password,
	          new_password: _this.user.new_password,
	          confirm_new_password: _this.user.confirm_new_password
	        }).then(function () {
	          _this.isSubmiting = false;
	          _this.successResponse = _this.$t('team.response.success');
	          _this.errorResponse = null;
	          _this.showAlert = true;
	        }).catch(function (error) {
	          _this.isSubmiting = false;
	          if (error.response.status === 422) {
	            _this.errorResponse = _this.$t('team.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else if (error.response.status === 400) {
	            _this.errorResponse = _this.$t('changePassword.response.failed');
	          } else {
	            _this.errorResponse = _this.$t('team.response.defaultFailed');
	          }
	
	          _this.showAlert = true;
	        });
	      }).catch(function () {});
	    }
	  }
	};

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(7);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  watch: {
	    team: function team(value) {
	      if (value) {
	        this.fetchUsers();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      isError: false,
	      users: [],
	      pagination: {
	        total: 0,
	        per_page: 20,
	        current_page: 1,
	        last_page: 0,
	        from: 1,
	        to: 1,
	        next_page_url: null,
	        prev_page_url: null,
	        total_page: 0
	      }
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	  },
	  mounted: function mounted() {
	    if (this.team) {
	      this.fetchUsers();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    currentPage: function currentPage() {
	      if (this.currentUser.team.is_superadmin) {
	        return 'admin';
	      } else if (this.currentUser.team.is_reseller) {
	        return 'reseller';
	      }
	    }
	  }),
	  methods: {
	    fetchUsers: function fetchUsers(page) {
	      var _this = this;
	
	      var url = '/api/teams/' + this.team.namespace + '/users';
	
	      if (page) {
	        url = url + '?page=' + page;
	      }
	
	      _axios2.default.get(url).then(function (response) {
	        _this.makePagination(response.data);
	        _this.users = response.data.data;
	        _this.isLoading = false;
	        _this.isError = false;
	
	        _this.$emit('loadChanged', false);
	      }).catch(function () {
	        _this.isLoading = false;
	        _this.isError = true;
	      });
	    },
	    makePagination: function makePagination(data) {
	      this.pagination.total = data.total;
	      this.pagination.per_page = data.per_page;
	      this.pagination.current_page = data.current_page;
	      this.pagination.last_page = data.last_page;
	      this.pagination.from = data.from;
	      this.pagination.to = data.to;
	      this.pagination.next_page_url = data.next_page_url;
	      this.pagination.prev_page_url = data.prev_page_url;
	      this.pagination.total_page = Math.ceil(data.total / data.per_page);
	    },
	    changePage: function changePage(page) {
	      this.fetchUsers(page);
	    },
	    urlCreateMember: function urlCreateMember() {
	      var namespace = this.team.namespace;
	
	      var parentUrl = this.$route.params.namespace;
	      namespace = this.$route.params.subnamespace;
	      return '/' + parentUrl + '/' + this.currentPage + '/teams/' + namespace + '/members/create';
	    },
	    urlEditMember: function urlEditMember(memberId) {
	      var namespace = this.team.namespace;
	
	      if (this.$route.params.subnamespace) {
	        var parentUrl = this.$route.params.namespace;
	        namespace = this.$route.params.subnamespace;
	        return '/' + parentUrl + '/' + this.currentPage + '/teams/' + namespace + '/members/' + memberId + '/edit';
	      }
	
	      return '/' + namespace + '/team/members/' + memberId + '/edit';
	    }
	  }
	};

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(302);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _vuex = __webpack_require__(7);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _StorageManager = __webpack_require__(16);
	
	var _StorageManager2 = _interopRequireDefault(_StorageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    Alert: _Alert2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    'user.name': function userName() {
	      if (this.formErrors.has('name')) {
	        this.formErrors.remove('name');
	      }
	    },
	    'user.lang': function userLang() {
	      if (this.formErrors.has('lang')) {
	        this.formErrors.remove('lang');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    showEmail: function showEmail() {
	      if (this.currentUser.team.is_superadmin) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }),
	  data: function data() {
	    return {
	      isSubmiting: false,
	      isLoading: false,
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      user: null,
	      storage: null
	    };
	  },
	  created: function created() {
	    this.isUserLoading = true;
	    this.user = JSON.parse((0, _stringify2.default)(this.currentUser));
	
	    this.storage = new _StorageManager2.default();
	
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('name', 'required', { prettyName: 'display name' });
	    this.validator.attach('lang', 'required', { prettyName: 'language' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.showAlert = false;
	      this.validator.validateAll({
	        name: this.user.name,
	        lang: this.user.lang
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        _this.isSubmiting = true;
	
	        _axios2.default.put('/api/user', {
	          name: _this.user.name,
	          lang: _this.user.lang
	        }).then(function (response) {
	          var namespace = _this.currentUser.team.namespace;
	
	          _this.storage.getLang(namespace).then(function (lang) {
	            if (response.data.lang !== lang) {
	              _this.storage.setLang(response.data.lang, namespace);
	              _this.$i18n.locale = response.data.lang;
	              _veeValidate.Validator.setLocale(response.data.lang);
	              _moment2.default.locale(response.data.lang);
	
	              _this.$store.dispatch('updateCurrentUserLang', response.data.lang);
	            }
	          });
	
	          _this.isSubmiting = false;
	          _this.successResponse = _this.$t('team.response.success');
	          _this.errorResponse = null;
	          _this.showAlert = true;
	        }).catch(function (error) {
	          _this.isSubmiting = false;
	
	          if (error.response.status === 422) {
	            _this.errorResponse = _this.$t('team.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorResponse = _this.$t('team.response.defaultFailed');
	          }
	          _this.showAlert = true;
	        });
	      }).catch(function () {});
	    }
	  }
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  data: function data() {
	    return {
	      isLoading: true,
	      showAlert: false,
	      validator: null,
	      status: null,
	      resetPasswordSuccess: false,
	      errorResponse: null
	    };
	  },
	  mounted: function mounted() {
	    this.validateToken();
	  },
	  methods: {
	    validateToken: function validateToken() {
	      var _this = this;
	
	      var token = this.$route.params.token;
	      var namespace = this.$route.params.namespace;
	
	      _axios2.default.post('/api/activate-account', {
	        namespace: namespace,
	        token: token
	      }).then(function (response) {
	        _this.status = response.data.status;
	        _this.isLoading = false;
	        _this.showAlert = true;
	      }).catch(function (error) {
	        if (error.response.status === 422) {
	          _this.status = error.response.data.status;
	        } else {
	          _this.errorResponse = _this.$t('recovery.verifyToken.response.defaultFailed');
	        }
	        _this.isLoading = false;
	      });
	    }
	  }
	};

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _AuthManager = __webpack_require__(18);
	
	var _AuthManager2 = _interopRequireDefault(_AuthManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Alert: _Alert2.default,
	    FormGroup: _FormGroup2.default
	  },
	  watch: {
	    'user.team': function userTeam() {
	      if (this.formErrors.has('team')) {
	        this.formErrors.remove('team');
	      }
	    },
	    'user.namespace': function userNamespace() {
	      if (this.user.namespace) {
	        this.user.namespace = this.user.namespace.toLowerCase();
	      }
	      if (this.formErrors.has('namespace')) {
	        this.formErrors.remove('namespace');
	      }
	    },
	    'user.email': function userEmail() {
	      if (this.formErrors.has('email')) {
	        this.formErrors.remove('email');
	      }
	    },
	    'user.displayname': function userDisplayname() {
	      if (this.formErrors.has('displayname')) {
	        this.formErrors.remove('displayname');
	      }
	    },
	    'user.password': function userPassword() {
	      if (this.formErrors.has('password')) {
	        this.formErrors.remove('password');
	      }
	    },
	    'user.accept': function userAccept(value) {
	      if (this.formErrors.has('accept')) {
	        this.formErrors.remove('accept');
	      }
	
	      if (!value) {
	        this.user.accept = null;
	      }
	    }
	  },
	  computed: {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    }
	  },
	  data: function data() {
	    return {
	      step: 0,
	      authManager: null,
	      validator: null,
	      formErrors: null,
	      showAlert: false,
	      errorResponse: null,
	      isSubmiting: false,
	      user: {
	        team: null,
	        namespace: null,
	        email: null,
	        displayName: null,
	        password: null,
	        accept: null
	      }
	    };
	  },
	  created: function created() {
	    this.authManager = new _AuthManager2.default();
	
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('team', 'required|max:72', { prettyName: 'team name' });
	    this.validator.attach('namespace', 'required|namespace|min:3|max:32', { prettyName: 'Team URL' });
	    this.validator.attach('email', 'required|email');
	    this.validator.attach('displayname', 'required', { prettyName: 'display name' });
	    this.validator.attach('password', 'required|min:6');
	    this.validator.attach('accept', 'required', { prettyName: 'Accept Terms of Service' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	
	    this.isRegisterFailed = false;
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      if (this.step === 0) {
	        this.validator.validateAll({
	          displayname: this.user.displayname,
	          email: this.user.email,
	          password: this.user.password
	        }).then(function (success) {
	          if (!success) {
	            return;
	          }
	          _this.step = 1;
	
	          _this.user.team = _this.user.displayname;
	        }).catch(function () {});
	      } else {
	        this.clearErrors();
	
	        this.validator.validateAll({
	          team: this.user.team,
	          namespace: this.user.namespace,
	          displayname: this.user.displayname,
	          email: this.user.email,
	          password: this.user.password,
	          accept: this.user.accept
	        }).then(function (success) {
	          if (!success) {
	            return;
	          }
	
	          _this.isSubmiting = true;
	          _this.showAlert = false;
	          _this.errorResponse = null;
	
	          _axios2.default.post('/api/registrations', {
	            name: _this.user.team,
	            namespace: _this.user.namespace,
	            email: _this.user.email,
	            display_name: _this.user.displayname,
	            password: _this.user.password
	          }).then(function () {
	            _this.isSubmiting = false;
	            _this.clearErrors();
	
	            _this.step = 2;
	          }).catch(function (error) {
	            _this.isSubmiting = false;
	            if (error.response.status === 422) {
	              _this.formErrors.addAll(error.response.data);
	              _this.errorResponse = _this.$t('register.failed');
	            } else {
	              _this.errorResponse = _this.$t('register.failed');
	            }
	            _this.showAlert = true;
	          });
	        }).catch(function () {});
	      }
	    },
	    clearErrors: function clearErrors() {
	      this.showAlert = false;
	      this.formErrors.clear();
	      this.errorResponse = null;
	    }
	  }
	};

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default
	  },
	  watch: {
	    'team.name': function teamName(value) {
	      this.validator.validateAll({
	        name: value
	      }).catch(function () {});
	    }
	  },
	  data: function data() {
	    return {
	      isSubmiting: false,
	      hasUser: false,
	      validator: null,
	      formErrors: null,
	      step: 'information',
	      team: {
	        id: 1,
	        name: 'ByteArk',
	        namespace: 'https://accounts.byteark.com/byteark',
	        owner: { id: 90, username: 'bongbank', password: 'bongbank', team: 'inox' },
	        owner_id: 2,
	        reseller: 0,
	        reseller_id: 0
	      },
	      users: []
	    };
	  },
	  created: function created() {
	    this.validator = new _veeValidate.Validator({
	      name: 'required'
	    });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounted: function mounted() {
	    this.fetchUsers();
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.validator.validateAll({
	        team: this.team.name
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        _this.isSubmiting = true;
	        _axios2.default.put('/inox/admin/teams/' + _this.team.namespace + '/edit', {
	          team: _this.team.name
	        }).then(function (response) {
	          _this.isSubmiting = false;
	          _this.team = response.data;
	        }).catch(function () {
	          _this.isSubmiting = false;
	        });
	      }).catch(function () {
	        _this.isSubmiting = false;
	      });
	    },
	    fetchUsers: function fetchUsers() {
	      var _this2 = this;
	
	      _axios2.default.get('/api/teams/' + this.$route.params.namespace + '/users').then(function (response) {
	        _this2.users = response.data.data;
	      }).catch(function () {});
	    },
	    swapTab: function swapTab(value) {
	      this.step = value;
	    }
	  }
	};

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    $route: 'fetchUsers'
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      isError: false,
	      team: null,
	      users: [],
	      pagination: {
	        total: 0,
	        per_page: 20,
	        current_page: 1,
	        last_page: 0,
	        from: 1,
	        to: 1,
	        next_page_url: null,
	        prev_page_url: null,
	        total_page: 0
	      }
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	    this.fetchUsers();
	  },
	  methods: {
	    fetchUsers: function fetchUsers(page) {
	      var _this = this;
	
	      var url = '/api/teams/' + this.$route.params.namespace + '/users';
	      if (page) {
	        url = url + '?page=' + page;
	      }
	
	      _axios2.default.get(url).then(function (response) {
	        _this.makePagination(response.data);
	        _this.users = response.data.data;
	        _this.isLoading = false;
	        _this.isError = false;
	
	        window.scrollTo(0, 0);
	      }).catch(function () {
	        _this.isLoading = false;
	        _this.isError = true;
	      });
	    },
	    makePagination: function makePagination(data) {
	      this.pagination.total = data.total;
	      this.pagination.per_page = data.per_page;
	      this.pagination.current_page = data.current_page;
	      this.pagination.last_page = data.last_page;
	      this.pagination.from = data.from;
	      this.pagination.to = data.to;
	      this.pagination.next_page_url = data.next_page_url;
	      this.pagination.prev_page_url = data.prev_page_url;
	      this.pagination.total_page = Math.ceil(data.total / data.per_page);
	    },
	    changePage: function changePage(page) {
	      this.fetchUsers(page);
	    }
	  }
	};

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _vuex = __webpack_require__(7);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    Alert: _Alert2.default
	  },
	  watch: {
	    'user.email': function userEmail() {
	      if (this.formErrors.has('email')) {
	        this.formErrors.remove('email');
	      }
	    },
	    'user.name': function userName() {
	      if (this.formErrors.has('name')) {
	        this.formErrors.remove('name');
	      }
	    },
	    'user.password': function userPassword() {
	      if (this.formErrors.has('password')) {
	        this.formErrors.remove('password');
	      }
	    },
	    'user.role': function userRole() {
	      if (this.formErrors.has('role')) {
	        this.formErrors.remove('role');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    showUserRole: function showUserRole() {
	      if (!this.$route.params.subnamespace && (this.currentUser.team.is_superadmin || this.currentUser.team.is_reseller)) {
	        this.user.role = 'manager';
	        return false;
	      } else {
	        this.user.role = 'user';
	        return true;
	      }
	    },
	    currentPage: function currentPage() {
	      if (this.$route.params.subnamespace && this.currentUser.team.is_superadmin) {
	        this.redirectUrl = '/' + this.$route.params.namespace + '/admin/teams/' + this.$route.params.subnamespace + '/edit';
	        return 'admin';
	      } else if (this.$route.params.subnamespace && this.currentUser.team.is_reseller) {
	        this.redirectUrl = '/' + this.$route.params.namespace + '/reseller/teams/' + this.$route.params.subnamespace + '/edit';
	        return 'reseller';
	      } else {
	        this.redirectUrl = '/' + this.$route.params.namespace + '/team/members';
	        return 'self';
	      }
	    }
	  }),
	  data: function data() {
	    return {
	      isSubmiting: false,
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      redirectUrl: '',
	      user: {
	        email: null,
	        name: null,
	        password: null,
	        role: ''
	      }
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('email', 'required|email');
	    this.validator.attach('name', 'required', { prettyName: 'display name' });
	    this.validator.attach('password', 'required');
	    this.validator.attach('role', 'required');
	    this.validator.attach('password', 'required|min:6');
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounted: function mounted() {
	    if (this.showUserRole) {
	      this.user.role = 'user';
	    } else {
	      this.user.role = 'manager';
	    }
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.submitForm = false;
	
	      this.validator.validateAll({
	        name: this.user.name,
	        email: this.user.email,
	        password: this.user.password,
	        role: this.user.role
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        var namespace = _this.$route.params.namespace;
	
	        if (_this.$route.params.subnamespace) {
	          namespace = _this.$route.params.subnamespace;
	        }
	
	        _this.isSubmiting = true;
	
	        _axios2.default.post('/api/teams/' + namespace + '/users', {
	          email: _this.user.email,
	          name: _this.user.name,
	          password: _this.user.password,
	          role: _this.user.role,
	          team_id: _this.currentUser.team.id
	        }).then(function () {
	          _this.isSubmiting = false;
	          _this.successResponse = _this.$t('team.response.success');
	          _this.errorResponse = null;
	          _this.showAlert = true;
	
	          setTimeout(function () {
	            _this.$router.push(_this.redirectUrl);
	          }, 2000);
	        }).catch(function (error) {
	          _this.isSubmiting = false;
	          if (error.response.status === 422) {
	            _this.errorResponse = _this.$t('team.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorResponse = _this.$t('team.response.defaultFailed');
	          }
	          _this.showAlert = true;
	        });
	      }).catch(function () {});
	    }
	  }
	};

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _vuex = __webpack_require__(7);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _sweetalert = __webpack_require__(23);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    Alert: _Alert2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    'user.email': function userEmail() {
	      if (this.formErrors.has('email')) {
	        this.formErrors.remove('email');
	      }
	    },
	    'user.name': function userName() {
	      if (this.formErrors.has('name')) {
	        this.formErrors.remove('name');
	      }
	    },
	    'user.role': function userRole() {
	      if (this.formErrors.has('role')) {
	        this.formErrors.remove('role');
	      }
	    },
	    'user.password': function userPassword() {
	      if (this.formErrors.has('password')) {
	        this.formErrors.remove('password');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser']), {
	    isLoading: function isLoading() {
	      return this.isUserLoading || this.isTeamLoading;
	    },
	    showUserRole: function showUserRole() {
	      if (this.team.is_superadmin || this.team.is_reseller) {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    showEmail: function showEmail() {
	      if (this.currentUser.team.is_superadmin) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    currentPage: function currentPage() {
	      if (this.team) {
	        if (this.$route.params.subnamespace && this.currentUser.team.is_superadmin) {
	          this.redirectUrl = '/' + this.$route.params.namespace + '/admin/teams/' + this.$route.params.subnamespace + '/edit';
	          return 'admin';
	        } else if (this.$route.params.subnamespace && this.currentUser.team.is_reseller) {
	          this.redirectUrl = '/' + this.$route.params.namespace + '/reseller/teams/' + this.$route.params.subnamespace + '/edit';
	          return 'reseller';
	        } else {
	          this.redirectUrl = '/' + this.$route.params.namespace + '/team/members';
	          return 'self';
	        }
	      }
	      return 'self';
	    }
	  }),
	  data: function data() {
	    return {
	      isSubmiting: false,
	      isUserLoading: false,
	      isTeamLoading: false,
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      showPassword: false,
	      user: null,
	      team: null
	    };
	  },
	  created: function created() {
	    this.isUserLoading = true;
	    this.isTeamLoading = true;
	    this.fetchUser();
	    this.fetchTeam();
	
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('email', 'required|email');
	    this.validator.attach('name', 'required', { prettyName: 'display name' });
	    this.validator.attach('role', 'required');
	    this.validator.attach('password', 'min:6');
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  methods: {
	    changePassword: function changePassword() {
	      this.showPassword = !this.showPassword;
	    },
	    enableAccount: function enableAccount(value) {
	      var _this = this;
	
	      var isEnabled = value;
	
	      var text = 'Are you sure to Deactivate Account ' + this.user.name;
	      var title = 'Are you sure to Deactivate?';
	      var confirmButtonText = 'Yes, Deactivate Account';
	
	      if (isEnabled === true) {
	        text = 'Are you sure to Enable Account ' + this.user.name;
	        title = 'Are you sure to Enable?';
	        confirmButtonText = 'Yes, Enable Account';
	      }
	
	      (0, _sweetalert2.default)({
	        title: title,
	        text: text,
	        showCancelButton: true,
	        confirmButtonColor: '#00A6ED',
	        cancelButtonColor: '#c6d3d7',
	        confirmButtonText: confirmButtonText,
	        closeOnConfirm: true
	      }).then(function () {
	        var namespace = _this.$route.params.namespace;
	
	        if (_this.$route.params.subnamespace) {
	          namespace = _this.$route.params.subnamespace;
	        }
	
	        var memberId = _this.$route.params.memberId;
	
	        _axios2.default.post('/api/teams/' + namespace + '/users/' + memberId + '/set-enabled', {
	          is_enabled: isEnabled
	        }).then(function (response) {
	          _this.user = response.data;
	          _this.successResponse = _this.$t('team.response.success');
	          _this.errorResponse = null;
	          _this.showAlert = true;
	
	          setTimeout(function () {
	            _this.$router.push(_this.redirectUrl);
	          }, 2000);
	        }).catch(function (error) {
	          if (error.response.status === 422) {
	            _this.errorResponse = _this.$t('team.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorResponse = _this.$t('team.response.defaultFailed');
	          }
	          _this.showAlert = true;
	        });
	      });
	    },
	    fetchUser: function fetchUser() {
	      var _this2 = this;
	
	      var namespace = this.$route.params.namespace;
	
	      if (this.$route.params.subnamespace) {
	        namespace = this.$route.params.subnamespace;
	      }
	
	      var url = '/api/teams/' + namespace + '/users/' + this.$route.params.memberId;
	
	      _axios2.default.get(url).then(function (response) {
	        _this2.user = response.data;
	        _this2.isUserLoading = false;
	      }).catch(function () {
	        _this2.isUserLoading = false;
	      });
	    },
	    fetchTeam: function fetchTeam() {
	      var _this3 = this;
	
	      var namespace = this.$route.params.namespace;
	
	      if (this.$route.params.subnamespace) {
	        namespace = this.$route.params.subnamespace;
	      }
	
	      var url = '/api/teams/' + namespace;
	
	      _axios2.default.get(url).then(function (response) {
	        _this3.team = response.data;
	        _this3.isTeamLoading = false;
	      }).catch(function () {
	        _this3.isTeamLoading = false;
	      });
	    },
	    onSubmit: function onSubmit() {
	      var _this4 = this;
	
	      this.showAlert = false;
	      this.validator.validateAll({
	        name: this.user.name,
	        email: this.user.email,
	        role: this.user.role,
	        password: this.user.password
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        var namespace = _this4.$route.params.namespace;
	
	        if (_this4.$route.params.subnamespace) {
	          namespace = _this4.$route.params.subnamespace;
	        }
	
	        var memberId = _this4.$route.params.memberId;
	
	        _this4.isSubmiting = true;
	
	        _axios2.default.put('/api/teams/' + namespace + '/users/' + memberId, {
	          name: _this4.user.name,
	          email: _this4.user.email,
	          role: _this4.user.role,
	          password: _this4.user.password
	        }).then(function (response) {
	          _this4.user = response.data;
	          _this4.isSubmiting = false;
	          _this4.successResponse = _this4.$t('team.response.success');
	          _this4.errorResponse = null;
	          _this4.showAlert = true;
	
	          setTimeout(function () {
	            _this4.$router.push(_this4.redirectUrl);
	          }, 2000);
	        }).catch(function (error) {
	          _this4.isSubmiting = false;
	
	          if (error.response.status === 422) {
	            _this4.errorResponse = _this4.$t('team.response.failed');
	            _this4.formErrors.addAll(error.response.data);
	          } else {
	            _this4.errorResponse = _this4.$t('team.response.defaultFailed');
	          }
	          _this4.showAlert = true;
	        });
	      }).catch(function () {
	        _this4.showPassword = true;
	      });
	    }
	  }
	};

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _veeValidate = __webpack_require__(5);
	
	var _FormGroup = __webpack_require__(6);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FormGroup: _FormGroup2.default,
	    Alert: _Alert2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  watch: {
	    'team.name': function teamName() {
	      if (this.formErrors.has('name')) {
	        this.formErrors.remove('name');
	      }
	    }
	  },
	  computed: {
	    baseURL: function baseURL() {
	      return ("https://accounts.arkcube.net");
	    }
	  },
	  data: function data() {
	    return {
	      isSubmiting: false,
	      isLoading: false,
	      showAlert: false,
	      validator: null,
	      formErrors: null,
	      errorResponse: null,
	      successResponse: null,
	      team: null
	    };
	  },
	  created: function created() {
	    this.isLoading = true;
	    this.validator = new _veeValidate.Validator();
	    this.validator.attach('name', 'required|max:72', { prettyName: 'Team Display name' });
	
	    this.$set(this, 'formErrors', this.validator.errorBag);
	  },
	  mounted: function mounted() {
	    this.fetchTeam();
	  },
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this = this;
	
	      this.showAlert = false;
	
	      this.validator.validateAll({
	        name: this.team.name
	      }).then(function (success) {
	        if (!success) {
	          return;
	        }
	
	        var namespace = _this.$route.params.namespace;
	
	        _this.isSubmiting = true;
	        _axios2.default.put('/api/teams/' + namespace, {
	          name: _this.team.name
	        }).then(function (response) {
	          _this.isSubmiting = false;
	          _this.successResponse = _this.$t('team.response.success');
	          _this.errorResponse = null;
	          _this.team = response.data;
	          _this.showAlert = true;
	
	          _this.$store.dispatch('updateCurrentUserTeam', _this.team);
	        }).catch(function (error) {
	          _this.isSubmiting = false;
	
	          if (error.response.status === 422) {
	            _this.errorResponse = _this.$t('team.response.failed');
	            _this.formErrors.addAll(error.response.data);
	          } else {
	            _this.errorResponse = _this.$t('team.response.defaultFailed');
	          }
	          _this.showAlert = true;
	        });
	      }).catch(function () {
	        _this.isSubmiting = false;
	      });
	    },
	    fetchTeam: function fetchTeam() {
	      var _this2 = this;
	
	      var namespace = this.$route.params.namespace;
	
	      _axios2.default.get('/api/teams/' + namespace).then(function (response) {
	        _this2.team = response.data;
	        _this2.isLoading = false;
	      }).catch(function () {
	        _this2.isLoading = false;
	      });
	    }
	  }
	};

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _sweetalert = __webpack_require__(23);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _LoadingIndicator = __webpack_require__(4);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	  props: {
	    team: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      currentTerminateMode: false
	    };
	  },
	  created: function created() {
	    this.currentTerminateMode = this.team.is_terminated;
	
	    this.isLoading = true;
	  },
	  mounted: function mounted() {
	    if (this.team) {
	      this.currentTerminateMode = this.team.is_terminated;
	    }
	  },
	  methods: {
	    onSubmit: function onSubmit(value) {
	      var _this = this;
	
	      var title = '';
	      var text = '';
	      var btnConfirm = '';
	
	      if (value) {
	        title = 'Are you sure to Terminate this team?';
	        text = 'After Terminate, ' + this.team.name + ' Team will not be able to access ByteArk Account and use any service.';
	        btnConfirm = 'Yes, Terminate it';
	      } else {
	        title = 'Are you sure to Activate this team?';
	        text = 'After Activated, ' + this.team.name + ' Team will be able to access ByteArk Account and use any service.';
	        btnConfirm = 'Yes, Activate it';
	      }
	
	      (0, _sweetalert2.default)({
	        title: title,
	        text: text,
	        showCancelButton: true,
	        confirmButtonColor: '#00A6ED',
	        cancelButtonColor: '#c6d3d7',
	        confirmButtonText: btnConfirm,
	        closeOnConfirm: true
	      }).then(function () {
	        var url = 'api/admin/terminate-team';
	        _axios2.default.post(url, {
	          namespace: _this.team.namespace,
	          is_terminated: value
	        }).then(function (response) {
	          _this.currentTerminateMode = response.data.is_terminated;
	          var textSuccess = '';
	
	          if (_this.currentTerminateMode) {
	            textSuccess = _this.team.name + ' have been terminated';
	          } else {
	            textSuccess = _this.team.name + ' have been activated';
	          }
	
	          (0, _sweetalert2.default)('Success', textSuccess, 'success');
	        }).catch(function () {});
	      });
	    }
	  }
	};

/***/ },
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 365 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 366 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 367 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 368 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 369 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 370 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 371 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 372 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 373 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 374 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 375 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 376 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 377 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 378 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 379 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 380 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 381 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 382 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 383 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 384 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 385 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 386 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 387 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 388 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 389 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 390 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 391 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 392 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 393 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 394 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 395 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 396 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 397 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 398 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 399 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 400 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 401 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 402 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 403 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 404 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 405 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 406 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 407 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 408 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 409 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 410 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 411 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 412 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 413 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 414 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 415 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 416 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 417 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 418 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 419 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 420 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 421 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 422 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 423 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 424 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 425 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 426 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 427 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 428 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 429 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 430 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 431 */,
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 72,
		"./af.js": 72,
		"./ar": 79,
		"./ar-dz": 73,
		"./ar-dz.js": 73,
		"./ar-kw": 74,
		"./ar-kw.js": 74,
		"./ar-ly": 75,
		"./ar-ly.js": 75,
		"./ar-ma": 76,
		"./ar-ma.js": 76,
		"./ar-sa": 77,
		"./ar-sa.js": 77,
		"./ar-tn": 78,
		"./ar-tn.js": 78,
		"./ar.js": 79,
		"./az": 80,
		"./az.js": 80,
		"./be": 81,
		"./be.js": 81,
		"./bg": 82,
		"./bg.js": 82,
		"./bn": 83,
		"./bn.js": 83,
		"./bo": 84,
		"./bo.js": 84,
		"./br": 85,
		"./br.js": 85,
		"./bs": 86,
		"./bs.js": 86,
		"./ca": 87,
		"./ca.js": 87,
		"./cs": 88,
		"./cs.js": 88,
		"./cv": 89,
		"./cv.js": 89,
		"./cy": 90,
		"./cy.js": 90,
		"./da": 91,
		"./da.js": 91,
		"./de": 94,
		"./de-at": 92,
		"./de-at.js": 92,
		"./de-ch": 93,
		"./de-ch.js": 93,
		"./de.js": 94,
		"./dv": 95,
		"./dv.js": 95,
		"./el": 96,
		"./el.js": 96,
		"./en-au": 97,
		"./en-au.js": 97,
		"./en-ca": 98,
		"./en-ca.js": 98,
		"./en-gb": 99,
		"./en-gb.js": 99,
		"./en-ie": 100,
		"./en-ie.js": 100,
		"./en-nz": 101,
		"./en-nz.js": 101,
		"./eo": 102,
		"./eo.js": 102,
		"./es": 104,
		"./es-do": 103,
		"./es-do.js": 103,
		"./es.js": 104,
		"./et": 105,
		"./et.js": 105,
		"./eu": 106,
		"./eu.js": 106,
		"./fa": 107,
		"./fa.js": 107,
		"./fi": 108,
		"./fi.js": 108,
		"./fo": 109,
		"./fo.js": 109,
		"./fr": 112,
		"./fr-ca": 110,
		"./fr-ca.js": 110,
		"./fr-ch": 111,
		"./fr-ch.js": 111,
		"./fr.js": 112,
		"./fy": 113,
		"./fy.js": 113,
		"./gd": 114,
		"./gd.js": 114,
		"./gl": 115,
		"./gl.js": 115,
		"./gom-latn": 116,
		"./gom-latn.js": 116,
		"./he": 117,
		"./he.js": 117,
		"./hi": 118,
		"./hi.js": 118,
		"./hr": 119,
		"./hr.js": 119,
		"./hu": 120,
		"./hu.js": 120,
		"./hy-am": 121,
		"./hy-am.js": 121,
		"./id": 122,
		"./id.js": 122,
		"./is": 123,
		"./is.js": 123,
		"./it": 124,
		"./it.js": 124,
		"./ja": 125,
		"./ja.js": 125,
		"./jv": 126,
		"./jv.js": 126,
		"./ka": 127,
		"./ka.js": 127,
		"./kk": 128,
		"./kk.js": 128,
		"./km": 129,
		"./km.js": 129,
		"./kn": 130,
		"./kn.js": 130,
		"./ko": 131,
		"./ko.js": 131,
		"./ky": 132,
		"./ky.js": 132,
		"./lb": 133,
		"./lb.js": 133,
		"./lo": 134,
		"./lo.js": 134,
		"./lt": 135,
		"./lt.js": 135,
		"./lv": 136,
		"./lv.js": 136,
		"./me": 137,
		"./me.js": 137,
		"./mi": 138,
		"./mi.js": 138,
		"./mk": 139,
		"./mk.js": 139,
		"./ml": 140,
		"./ml.js": 140,
		"./mr": 141,
		"./mr.js": 141,
		"./ms": 143,
		"./ms-my": 142,
		"./ms-my.js": 142,
		"./ms.js": 143,
		"./my": 144,
		"./my.js": 144,
		"./nb": 145,
		"./nb.js": 145,
		"./ne": 146,
		"./ne.js": 146,
		"./nl": 148,
		"./nl-be": 147,
		"./nl-be.js": 147,
		"./nl.js": 148,
		"./nn": 149,
		"./nn.js": 149,
		"./pa-in": 150,
		"./pa-in.js": 150,
		"./pl": 151,
		"./pl.js": 151,
		"./pt": 153,
		"./pt-br": 152,
		"./pt-br.js": 152,
		"./pt.js": 153,
		"./ro": 154,
		"./ro.js": 154,
		"./ru": 155,
		"./ru.js": 155,
		"./sd": 156,
		"./sd.js": 156,
		"./se": 157,
		"./se.js": 157,
		"./si": 158,
		"./si.js": 158,
		"./sk": 159,
		"./sk.js": 159,
		"./sl": 160,
		"./sl.js": 160,
		"./sq": 161,
		"./sq.js": 161,
		"./sr": 163,
		"./sr-cyrl": 162,
		"./sr-cyrl.js": 162,
		"./sr.js": 163,
		"./ss": 164,
		"./ss.js": 164,
		"./sv": 165,
		"./sv.js": 165,
		"./sw": 166,
		"./sw.js": 166,
		"./ta": 167,
		"./ta.js": 167,
		"./te": 168,
		"./te.js": 168,
		"./tet": 169,
		"./tet.js": 169,
		"./th": 170,
		"./th.js": 170,
		"./tl-ph": 171,
		"./tl-ph.js": 171,
		"./tlh": 172,
		"./tlh.js": 172,
		"./tr": 173,
		"./tr.js": 173,
		"./tzl": 174,
		"./tzl.js": 174,
		"./tzm": 176,
		"./tzm-latn": 175,
		"./tzm-latn.js": 175,
		"./tzm.js": 176,
		"./uk": 177,
		"./uk.js": 177,
		"./ur": 178,
		"./ur.js": 178,
		"./uz": 180,
		"./uz-latn": 179,
		"./uz-latn.js": 179,
		"./uz.js": 180,
		"./vi": 181,
		"./vi.js": 181,
		"./x-pseudo": 182,
		"./x-pseudo.js": 182,
		"./yo": 183,
		"./yo.js": 183,
		"./zh-cn": 184,
		"./zh-cn.js": 184,
		"./zh-hk": 185,
		"./zh-hk.js": 185,
		"./zh-tw": 186,
		"./zh-tw.js": 186
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 432;


/***/ },
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(396)
	__webpack_require__(397)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(231),
	  /* template */
	  __webpack_require__(535),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(383)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(233),
	  /* template */
	  __webpack_require__(520),
	  /* scopeId */
	  "data-v-2829aaf2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(237),
	  /* template */
	  __webpack_require__(501),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(380)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(238),
	  /* template */
	  __webpack_require__(517),
	  /* scopeId */
	  "data-v-248496c3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(429)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(239),
	  /* template */
	  __webpack_require__(567),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(402)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(240),
	  /* template */
	  __webpack_require__(540),
	  /* scopeId */
	  "data-v-602e0294",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(430)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(241),
	  /* template */
	  __webpack_require__(568),
	  /* scopeId */
	  "data-v-f9f994d0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(370)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(242),
	  /* template */
	  __webpack_require__(507),
	  /* scopeId */
	  "data-v-18269877",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(406)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(243),
	  /* template */
	  __webpack_require__(544),
	  /* scopeId */
	  "data-v-70c55eeb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(376)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(244),
	  /* template */
	  __webpack_require__(513),
	  /* scopeId */
	  "data-v-20f86518",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(365)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(245),
	  /* template */
	  __webpack_require__(502),
	  /* scopeId */
	  "data-v-08df39a2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(375)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(246),
	  /* template */
	  __webpack_require__(512),
	  /* scopeId */
	  "data-v-1e659633",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(426)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(247),
	  /* template */
	  __webpack_require__(564),
	  /* scopeId */
	  "data-v-e884db94",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(424)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(248),
	  /* template */
	  __webpack_require__(562),
	  /* scopeId */
	  "data-v-de3b5d18",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(404)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(249),
	  /* template */
	  __webpack_require__(542),
	  /* scopeId */
	  "data-v-60c562fa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(425)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(250),
	  /* template */
	  __webpack_require__(563),
	  /* scopeId */
	  "data-v-e01d3d82",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(412)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(252),
	  /* template */
	  __webpack_require__(550),
	  /* scopeId */
	  "data-v-808accf6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(413)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(253),
	  /* template */
	  __webpack_require__(551),
	  /* scopeId */
	  "data-v-8ed9dbe6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(390)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(254),
	  /* template */
	  __webpack_require__(528),
	  /* scopeId */
	  "data-v-453ee00e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(415)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(255),
	  /* template */
	  __webpack_require__(553),
	  /* scopeId */
	  "data-v-99802840",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(378)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(257),
	  /* template */
	  __webpack_require__(515),
	  /* scopeId */
	  "data-v-22bae63f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(394)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(258),
	  /* template */
	  __webpack_require__(533),
	  /* scopeId */
	  "data-v-548ecd4b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(428)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(259),
	  /* template */
	  __webpack_require__(566),
	  /* scopeId */
	  "data-v-f6cf1812",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(374)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(260),
	  /* template */
	  __webpack_require__(511),
	  /* scopeId */
	  "data-v-1dae418d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(403)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(261),
	  /* template */
	  __webpack_require__(541),
	  /* scopeId */
	  "data-v-60324df7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(422)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(262),
	  /* template */
	  __webpack_require__(560),
	  /* scopeId */
	  "data-v-d516d862",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(392)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(263),
	  /* template */
	  __webpack_require__(531),
	  /* scopeId */
	  "data-v-4f94fe67",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(384)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(264),
	  /* template */
	  __webpack_require__(522),
	  /* scopeId */
	  "data-v-39a54c8e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(371)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(266),
	  /* template */
	  __webpack_require__(508),
	  /* scopeId */
	  "data-v-1a32d44e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(387)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(267),
	  /* template */
	  __webpack_require__(525),
	  /* scopeId */
	  "data-v-400a6f7d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(268),
	  /* template */
	  __webpack_require__(529),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(405)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(269),
	  /* template */
	  __webpack_require__(543),
	  /* scopeId */
	  "data-v-60f555aa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(377)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(270),
	  /* template */
	  __webpack_require__(514),
	  /* scopeId */
	  "data-v-21337ee8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(416)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(271),
	  /* template */
	  __webpack_require__(554),
	  /* scopeId */
	  "data-v-9aec076c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(373)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(274),
	  /* template */
	  __webpack_require__(510),
	  /* scopeId */
	  "data-v-1c024790",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(393)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(275),
	  /* template */
	  __webpack_require__(532),
	  /* scopeId */
	  "data-v-532e47a2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(400)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(276),
	  /* template */
	  __webpack_require__(538),
	  /* scopeId */
	  "data-v-5ca43008",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(386)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(277),
	  /* template */
	  __webpack_require__(524),
	  /* scopeId */
	  "data-v-3cfd2be3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(278),
	  /* template */
	  __webpack_require__(521),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(417)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(280),
	  /* template */
	  __webpack_require__(555),
	  /* scopeId */
	  "data-v-9cc86a90",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(391)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(281),
	  /* template */
	  __webpack_require__(530),
	  /* scopeId */
	  "data-v-4c0cf0f2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(369)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(282),
	  /* template */
	  __webpack_require__(506),
	  /* scopeId */
	  "data-v-130a08b9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(379)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(285),
	  /* template */
	  __webpack_require__(516),
	  /* scopeId */
	  "data-v-23591e9e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(414)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(287),
	  /* template */
	  __webpack_require__(552),
	  /* scopeId */
	  "data-v-90f2b200",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(410)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(288),
	  /* template */
	  __webpack_require__(548),
	  /* scopeId */
	  "data-v-7dfeee90",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(381)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(289),
	  /* template */
	  __webpack_require__(518),
	  /* scopeId */
	  "data-v-24a1a3e4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(419)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(291),
	  /* template */
	  __webpack_require__(557),
	  /* scopeId */
	  "data-v-9d687c20",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(399)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(292),
	  /* template */
	  __webpack_require__(537),
	  /* scopeId */
	  "data-v-5c4e7921",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(408)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(293),
	  /* template */
	  __webpack_require__(546),
	  /* scopeId */
	  "data-v-764264cc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(389)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(294),
	  /* template */
	  __webpack_require__(527),
	  /* scopeId */
	  "data-v-42d46286",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(409)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(295),
	  /* template */
	  __webpack_require__(547),
	  /* scopeId */
	  "data-v-78f01375",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(420)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(296),
	  /* template */
	  __webpack_require__(558),
	  /* scopeId */
	  "data-v-c875730e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(366)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(297),
	  /* template */
	  __webpack_require__(503),
	  /* scopeId */
	  "data-v-09b87da0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(382)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(298),
	  /* template */
	  __webpack_require__(519),
	  /* scopeId */
	  "data-v-27f1b8d7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 500 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-block",
	    attrs: {
	      "id": "statementSection"
	    }
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n    " + _vm._s(_vm.$t("statement.labels.statement")) + "\n  ")]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]) : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "p-t-15"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-2 col-md-3"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentYear),
	      expression: "currentYear"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "filteringStatus"
	    },
	    on: {
	      "change": [function($event) {
	        _vm.currentYear = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, function($event) {
	        _vm.onChange()
	      }]
	    }
	  }, _vm._l((_vm.yearList), function(year, index) {
	    return _c('option', {
	      domProps: {
	        "value": year
	      }
	    }, [_vm._v(_vm._s(year))])
	  }))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.havaTransactions) ? _c('div', {
	    staticClass: "table-striped table-hover table-responsive"
	  }, [_c('table', {
	    staticClass: "table is-indent"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cell-80"
	  }, [_vm._v(_vm._s(_vm.$t("unit.date")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-150",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.orderNumber")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-150",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.invoiceNumber")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-150",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.receiptNumber")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-200",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.description")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-100 text-xs-right",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.amount")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-150 text-xs-right"
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions.data), function(item, index) {
	    return _c('tr', [_c('td', {
	      staticClass: "cell-80"
	    }, [_c('span', {
	      attrs: {
	        "title": _vm.getFullHistoryDate(item.created_at)
	      }
	    }, [_vm._v(_vm._s(_vm.getHistoryDate(item.created_at)))])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-150"
	    }, [(item.order_number) ? _c('router-link', {
	      staticClass: "btn btn-link",
	      attrs: {
	        "to": _vm.urlOrderNumberReport(item.order_number)
	      }
	    }, [_vm._v(" " + _vm._s(item.order_number) + "\n                    ")]) : _c('span', {
	      staticClass: "text-xs-center"
	    }, [_vm._v("-")])], 1), _vm._v(" "), _c('td', {
	      staticClass: "cell-150"
	    }, [_vm._v("\n                    " + _vm._s(item.invoice_number ? item.invoice_number : '-') + "\n                  ")]), _vm._v(" "), _c('td', {
	      staticClass: "cell-150"
	    }, [_vm._v("\n                    " + _vm._s(item.receipt_number ? item.receipt_number : '-') + "\n                  ")]), _vm._v(" "), _c('td', {
	      staticClass: "cell-200"
	    }, [_c('p', {
	      staticClass: "m-b-0"
	    }, [_vm._v(_vm._s(item.source))]), _vm._v(" "), _c('p', {
	      staticClass: "m-b-0 font-size-12 grey-500"
	    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), (item.note) ? _c('p', {
	      staticClass: "m-b-0 font-size-12 grey-500"
	    }, [_vm._v("Admin note - " + _vm._s(item.note))]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "cell-100 text-xs-right"
	    }, [(item.amount > 0) ? _c('span', {
	      staticClass: "green-600"
	    }, [_vm._v(_vm._s(item.human_amount) + " " + _vm._s(_vm.$t("billing.currencies.thb")))]) : (item.amount < 0) ? _c('span', {
	      staticClass: "red-600"
	    }, [_vm._v("\n                      " + _vm._s(item.human_amount) + " " + _vm._s(_vm.$t("billing.currencies.thb")) + "\n                    ")]) : _c('span', [_vm._v(_vm._s(item.human_amount) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-150 text-xs-right"
	    }, [(false) ? _c('a', {
	      staticClass: "btn btn-sm btn-icon btn-default",
	      attrs: {
	        "href": ("" + (item.download_url)),
	        "download": ""
	      }
	    }, [_vm._v("\n                      " + _vm._s(_vm.$t("statement.action.download")) + "\n                    ")]) : _vm._e(), _vm._v(" "), (item.source_type === 'System' && _vm.month) ? _c('router-link', {
	      staticClass: "btn btn-sm btn-icon btn-default",
	      attrs: {
	        "to": _vm.urlUsageReport(item.month)
	      }
	    }, [_vm._v(" " + _vm._s(_vm.$t("statement.action.download")) + "\n                    ")]) : _vm._e()], 1)])
	  }))])]) : _c('div', {
	    staticClass: "alert alert-primary alert-dismissible"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t("statement.labels.noBillingHistory")) + "\n          ")])])])])])])
	},staticRenderFns: []}

/***/ },
/* 501 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.value),
	      expression: "value"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": [function($event) {
	        _vm.value = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, function($event) {
	        _vm.onChange()
	      }]
	    }
	  }, _vm._l((_vm.monthList), function(month, index) {
	    return _c('option', {
	      domProps: {
	        "value": month
	      }
	    }, [_vm._v(_vm._s(month))])
	  }))
	},staticRenderFns: []}

/***/ },
/* 502 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_vm._v(_vm._s(_vm.currentPage === 'admin' ? 'Admin' : 'Reseller'))])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("action.manageClientTeam")))]), _vm._v(" "), _c('div', {
	    staticClass: "page-header-actions"
	  }, [_c('div', {
	    staticClass: "row no-space w-120"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-md-12"
	  }, [_c('div', {
	    staticClass: "counter"
	  }, [_c('div', {
	    staticClass: "counter-label p-t-5"
	  }, [_vm._v(_vm._s(_vm.$t("text.totalTeams")))]), _vm._v(" "), _c('span', {
	    staticClass: "counter-number font-weight-medium"
	  }, [_vm._v(_vm._s(_vm.total_team))])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : (_vm.isError) ? _c('div') : _c('div', [_c('div', {
	    staticClass: "p-b-15"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6 col-md-6"
	  }, [_c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/create")
	    }
	  }, [_c('i', {
	    staticClass: "icon md-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "text hidden-sm-down"
	  }, [_vm._v(" " + _vm._s(_vm.$t("clientUsageHistory.action.create")) + " ")])])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "p-b-15"
	  }, [_c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.filterItems($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showFilterItems) ? _c('div', {
	    staticClass: "col-xs-4 col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Pay Plan")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentPayPlanType),
	      expression: "currentPayPlanType"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.currentPayPlanType = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Show all")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "prepaid"
	    }
	  }, [_vm._v("Pre paid")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "postpaid"
	    }
	  }, [_vm._v("Post paid")])])])]) : _vm._e(), _vm._v(" "), (_vm.showFilterItems) ? _c('div', {
	    staticClass: "col-xs-4 col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Pricing Plan")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentPricingPlanType),
	      expression: "currentPricingPlanType"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.currentPricingPlanType = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Show all")]), _vm._v(" "), _vm._l((_vm.pricingplanList), function(item, index) {
	    return _c('option', {
	      domProps: {
	        "value": item.alias
	      }
	    }, [_vm._v(_vm._s(item.name))])
	  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showFilterItems) ? _c('div', {
	    staticClass: "col-xs-4 col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Suspend")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentSuspendType),
	      expression: "currentSuspendType"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.currentSuspendType = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Show all")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Suspend")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Active")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-md-3"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("text.textGuideFilter")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentName),
	      expression: "currentName"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "team",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.currentName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentName = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-4 col-md-2"
	  }, [_c('button', {
	    staticClass: "btn btn-success m-t-35",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(_vm._s(_vm.$t("action.search")))])])])])]), _vm._v(" "), (_vm.total_team) ? _c('div', {
	    staticClass: "table-striped table-hover table-responsive"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cell-50"
	  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-300"
	  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.name")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-300"
	  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.url")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-100"
	  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.type")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-100 text-xs-center"
	  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.reseller")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-100"
	  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.payPlan")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-50"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "cell-50"
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.teams), function(team, index) {
	    return _c('tr', {
	      attrs: {
	        "id": team.id
	      }
	    }, [_c('td', {
	      staticClass: "cell-50"
	    }, [_vm._v(_vm._s(team.id))]), _vm._v(" "), _c('td', {
	      staticClass: "cell-300"
	    }, [_vm._v(_vm._s(team.name))]), _vm._v(" "), _c('td', {
	      staticClass: "cell-300"
	    }, [_vm._v(_vm._s(team.namespace))]), _vm._v(" "), _c('td', {
	      staticClass: "cell-100"
	    }, [(team.is_reseller) ? _c('span', {
	      staticClass: "tag tag-danger"
	    }, [_vm._v("Reseller")]) : (team.has_reseller) ? _c('span', {
	      staticClass: "tag tag-info"
	    }, [_vm._v("Sub Team")]) : _c('span', {
	      staticClass: "tag tag-default"
	    }, [_vm._v("Normal")])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-100 text-xs-center"
	    }, [(team.has_reseller) ? _c('router-link', {
	      staticClass: "btn btn-link",
	      attrs: {
	        "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (team.reseller.namespace) + "/billings"),
	        "alt": "Reseller"
	      }
	    }, [_vm._v(_vm._s(team.reseller.name) + "\n                    ")]) : _c('span', {
	      staticClass: "text-center"
	    }, [_vm._v("-")])], 1), _vm._v(" "), _c('td', {
	      staticClass: "cell-100"
	    }, [(team.pay_plan === 'postpaid') ? _c('span', {
	      staticClass: "red-600"
	    }, [_vm._v(_vm._s(_vm.$t("payPlan.labels.postPaid")))]) : _c('span', [_vm._v(_vm._s(_vm.$t("payPlan.labels.prePaid")))])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-50 text-nowrap"
	    }, [_c('router-link', {
	      staticClass: "btn btn-sm btn-default",
	      attrs: {
	        "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (team.namespace) + "/billings"),
	        "alt": "Billing"
	      }
	    }, [_vm._v(_vm._s(_vm.$t("menu.billing")) + "\n                    ")])], 1), _vm._v(" "), _c('td', {
	      staticClass: "cell-50 text-nowrap"
	    }, [_c('router-link', {
	      staticClass: "btn btn-sm btn-default",
	      attrs: {
	        "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (team.namespace) + "/edit"),
	        "alt": "Edit"
	      }
	    }, [_vm._v(_vm._s(_vm.$t("action.manage")) + "\n                    ")])], 1)])
	  }))])]) : _c('div', {
	    staticClass: "alert alert-primary alert-dismissible"
	  }, [_vm._v("\n            There is no team.\n          ")])]), _vm._v(" "), _c('paginate', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm.pagination.total_page > 1)),
	      expression: "(pagination.total_page > 1)"
	    }],
	    attrs: {
	      "pageCount": _vm.pagination.total_page,
	      "prevText": '«',
	      "nextText": '»',
	      "clickHandler": _vm.changePage,
	      "containerClass": 'pagination pull-right',
	      "pageClass": 'page-item',
	      "pageLinkClass": 'page-link',
	      "prevClass": 'page-item',
	      "prevLinkClass": 'page-link',
	      "nextClass": 'page-item',
	      "nextLinkClass": 'page-link'
	    }
	  })], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 503 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main"
	  }, [(_vm.currentPage === 'self') ? _c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_vm._v(_vm._s(this.$route.params.namespace))]), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_vm._v(_vm._s(_vm.$t("member.labels.members")))])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("member.labels.editMembers")))])]) : _c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_vm._v(_vm._s(_vm.currentPage === 'admin' ? 'Admin' : 'Reseller'))]), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams")
	    }
	  }, [_vm._v(_vm._s(_vm.$t("action.manageClientTeam")))])], 1), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (_vm.$route.params.subnamespace) + "/edit")
	    }
	  }, [_vm._v(_vm._s(_vm.$route.params.subnamespace))])], 1)]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("member.labels.editMembers")))])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-section"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('name'),
	      "autocomplete": "false"
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.displayName")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.name),
	      expression: "user.name"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('account.labels.displayName')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.email")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "email",
	      "placeholder": _vm.$t('account.labels.email'),
	      "autocomplete": "false",
	      "disabled": !_vm.showEmail
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.password")))]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showPassword),
	      expression: "!showPassword"
	    }],
	    staticClass: "btn btn-icon btn-block btn-primary btn-outline",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.changePassword(_vm.showPassword)
	      }
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.$t("member.action.changePassword")) + "\n                  ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }, {
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showPassword),
	      expression: "showPassword"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "password",
	      "placeholder": _vm.$t('account.labels.password')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showPassword),
	      expression: "showPassword"
	    }],
	    staticClass: "btn btn-icon btn-block btn-link",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.changePassword(_vm.showPassword)
	      }
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.$t("member.action.hidePassword")) + "\n                  ")])]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "role"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.role")))]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.role),
	      expression: "user.role"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "manager"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.user.role, "manager")
	    },
	    on: {
	      "click": function($event) {
	        _vm.user.role = "manager"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "user"
	    }
	  }, [_vm._v("Manager\n                    ")])]), _vm._v(" "), (_vm.showUserRole) ? _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.role),
	      expression: "user.role"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "user"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.user.role, "user")
	    },
	    on: {
	      "click": function($event) {
	        _vm.user.role = "user"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "user"
	    }
	  }, [_vm._v("User "), _c('span', {
	    staticClass: "grey-400"
	  }, [_vm._v(_vm._s(_vm.$t("member.role.user.textGuide")))])])]) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t("member.labels.editMembers")) + "\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [(_vm.user.is_enabled) ? _c('button', {
	    staticClass: "btn btn-link pull-xs-right",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.enableAccount(false)
	      }
	    }
	  }, [_vm._v(" " + _vm._s(_vm.$t("member.action.deactivateAccount")) + "\n              ")]) : _c('button', {
	    staticClass: "btn btn-link pull-xs-right",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.enableAccount(true)
	      }
	    }
	  }, [_vm._v(" " + _vm._s(_vm.$t("member.action.enableAccount")) + "\n              ")])])])])], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 504 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('transition', {
	    attrs: {
	      "name": "fade-in",
	      "mode": "out-in",
	      "appear": ""
	    }
	  }, [_c('div', {
	    key: "alert",
	    class: ("alert alert-" + _vm.type + " " + _vm.alertClass),
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.iconClass),
	      expression: "iconClass"
	    }],
	    class: ("icon " + _vm.iconClass),
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _vm._t("default")], 2)])], 1)
	},staticRenderFns: []}

/***/ },
/* 505 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-block"
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]) : _c('div', {
	    staticClass: "row"
	  }, [(_vm.isTeamSuspend) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "alert alert-icon alert-danger alert-dismissible p-30",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-11 clearfix"
	  }, [_c('div', {
	    staticClass: "pull-xs-left"
	  }, [_c('h3', {
	    staticClass: "red-600 m-0 p-0"
	  }, [_c('i', {
	    staticClass: "icon md-notifications"
	  }), _vm._v(_vm._s(_vm.$t("suspend.labels.suspend")))]), _vm._v(" "), (this.team.suspend.suspend_reason) ? _c('p', {
	    staticClass: "p-l-40 m-0"
	  }, [_vm._v(_vm._s(this.team.suspend.suspend_reason))]) : _c('p', {
	    staticClass: "p-l-40 m-0"
	  }, [_vm._v(_vm._s(_vm.$t("suspend.labels.defaultMessage")))])])]), _vm._v(" "), (!this.team.suspend.suspend_reason) ? _c('div', {
	    staticClass: "col-md-1"
	  }, [_c('a', {
	    staticClass: "btn btn-danger btn-lg pull-xs-right",
	    attrs: {
	      "href": "#addcreditSection"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("billing.action.addCredit")))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showCurrentCredit) ? _c('div', [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "pricing-list pricing-credit text-xs-left m-b-0 card-stat"
	  }, [_c('div', {
	    staticClass: "pricing-header",
	    class: (_vm.balances.credit >= 0) ? 'bg-blue-600' : 'bg-red-600'
	  }, [_c('div', {
	    staticClass: "pricing-title"
	  }, [_vm._v(_vm._s(_vm.$t("billing.labels.remainingCredits")))]), _vm._v(" "), _c('div', {
	    staticClass: "pricing-price"
	  }, [_c('span', {
	    staticClass: "pricing-amount"
	  }, [_vm._v(_vm._s(_vm.balances.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]), _vm._v(" "), (_vm.showLastAddedCredit) ? _c('p', {
	    staticClass: "p-x-30 p-b-25"
	  }, [_vm._v(_vm._s(_vm.$t("currentCredit.lastedTransaction")) + " : " + _vm._s(_vm.balances.latest_refill_transaction.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")) + " " + _vm._s(_vm.$t("text.on")) + " " + _vm._s(_vm.latestRefillDate) + " ")]) : _c('p', {
	    staticClass: "p-x-30 p-b-25"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t("currentCredit.textGuide")))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "bg-blue-grey-100 p-30 card-stat"
	  }, [_c('div', {
	    staticClass: "counter counter-md text-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-label text-uppercase m-b-5"
	  }, [_vm._v(_vm._s(_vm.$t("billing.labels.currentMonthUsage")) + "\n              "), (_vm.showDiscount && (_vm.team.discount > 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.$t("billing.labels.perfixDiscount")) + " " + _vm._s(_vm.team.discount) + "% " + _vm._s(_vm.$t("billing.labels.subfixDiscount")) + ")")]) : _vm._e(), _vm._v(" "), (_vm.showDiscount && (_vm.team.discount <= 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.$t("billing.labels.noDiscount")) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "counter-number-group m-b-10"
	  }, [_c('span', {
	    staticClass: "counter-number"
	  }, [_vm._v(_vm._s(_vm.humanTotalCost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label"
	  }, [_c('div', {
	    staticClass: "progress progress-xs m-b-10"
	  }, [_c('div', {
	    staticClass: "progress-ba r progress-bar-info",
	    class: (_vm.usagePercentage <= 80) ? 'bg-primary' : 'bg-danger',
	    style: ({
	      width: _vm.usagePercentage + '%'
	    }),
	    attrs: {
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_vm._v("\n                 \n                ")])]), _vm._v(" "), (_vm.showUsagePercentage) ? _c('div', {
	    staticClass: "counter counter-sm text-xs-left m-t-30"
	  }, [(_vm.usagePercentage < 100) ? _c('div', {
	    staticClass: "counter-number-group"
	  }, [_c('span', {
	    staticClass: "counter-number",
	    class: (_vm.usagePercentage <= 80) ? 'blue-600' : 'red-600'
	  }, [_vm._v(_vm._s(_vm.usagePercentage) + "%")]), _vm._v(" "), _c('span', {
	    staticClass: "counter-number-related"
	  }, [_vm._v(_vm._s(_vm.$t("currentCredit.percentageBar")))])]) : _vm._e(), _vm._v(" "), (_vm.usagePercentage >= 100) ? _c('div', {
	    staticClass: "counter-number-group"
	  }, [_c('span', {
	    staticClass: "counter-number red-600"
	  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.creditNotEnough")))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "counter-number-group m-t-10"
	  }, [_c('span', {
	    staticClass: "counter-number-related"
	  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.nextCreditCharge")) + " : " + _vm._s(_vm.upcomingBillDate) + " ("), _c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#statementSection'),
	      expression: "'#statementSection'"
	    }],
	    staticClass: "btn btn-link p-0",
	    attrs: {
	      "href": "javascript:void(0)"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("title.statement")))]), _vm._v(")")])])]) : _c('div', {
	    staticClass: "counter counter-sm text-xs-left m-t-30"
	  }, [_c('div', {
	    staticClass: "counter-number-group"
	  }, [_c('span', {
	    staticClass: "counter-number-related"
	  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.textGuide"))), (_vm.balances.latest_bill_id) ? _c('span', [_vm._v("("), _c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#statementSection'),
	      expression: "'#statementSection'"
	    }],
	    staticClass: "btn btn-link p-0",
	    attrs: {
	      "href": "javascript:void(0)"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("title.statement")))]), _vm._v(")")]) : _vm._e()])])])])])])])]) : _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "p-30 bg-primary"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "font-size-24 m-b-5"
	  }, [_vm._v(_vm._s(_vm.$t("billing.labels.currentMonthUsage")))]), _vm._v(" "), (_vm.balances.upcoming_bill ? _vm.balances.upcoming_bill.total_cost > 0 : false) ? _c('div', [_c('div', {
	    staticClass: "font-size-14"
	  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.nextCreditCharge")) + ": " + _vm._s(_vm.upcomingBillDate) + " ("), _c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#statementSection'),
	      expression: "'#statementSection'"
	    }],
	    staticClass: "btn btn-link p-0",
	    attrs: {
	      "href": "javascript:void(0)"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("statement.action.statement")))]), _vm._v(")")])]) : _c('div', [_c('div', {
	    staticClass: "font-size-14"
	  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.textGuide")) + " "), (_vm.balances.latest_bill_id) ? _c('span', [_vm._v("("), _c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#statementSection'),
	      expression: "'#statementSection'"
	    }],
	    staticClass: "btn btn-link p-0",
	    attrs: {
	      "href": "javascript:void(0)"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("statement.action.statement")))]), _vm._v(")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "counter counter-lg text-xs-right"
	  }, [_c('span', {
	    staticClass: "counter-number white"
	  }, [_vm._v(_vm._s(_vm.humanTotalCost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])])])])])])
	},staticRenderFns: []}

/***/ },
/* 506 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-login-v3 layout-full"
	  }, [_c('div', {
	    staticClass: "page vertical-align text-xs-center"
	  }, [_c('div', {
	    staticClass: "page-content vertical-align-middle"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('div', [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.$t('recovery.labels.resetPassword')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('recovery.labels.enterNewPassword')) + " "), _c('span', {
	    staticClass: "blue-600 text-uppercase"
	  }, [_vm._v(_vm._s(_vm.$route.params.namespace))]), _vm._v(" " + _vm._s(_vm.$t('login.labels.subfixLogin')))]), _vm._v(" "), (_vm.status == 'link-invalid') ? _c('div', {
	    staticClass: "token-invalid"
	  }, [_c('alert', {
	    attrs: {
	      "alertClass": "alert-dismissible",
	      "type": "danger"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('recovery.verifyToken.response.linkInvalid')))])]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-block btn-link btn-lg btn-submit",
	    attrs: {
	      "to": ("/" + (this.$route.params.namespace) + "/login")
	    }
	  }, [_vm._v(_vm._s(_vm.$t('recovery.action.backToLogin')))])], 1) : _vm._e(), _vm._v(" "), (_vm.status == 'link-expried') ? _c('div', {
	    staticClass: "token-expried"
	  }, [_c('alert', {
	    attrs: {
	      "alertClass": "alert-dismissible",
	      "type": "danger"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('recovery.verifyToken.response.linkExpired')))])]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-block btn-link btn-lg btn-submit",
	    attrs: {
	      "to": ("/" + (this.$route.params.namespace) + "/forgot")
	    }
	  }, [_vm._v(_vm._s(_vm.$t('recovery.action.resend')))])], 1) : _vm._e(), _vm._v(" "), (_vm.status == 'success') ? _c('div', [(!_vm.resetPasswordSuccess) ? _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "alert-dismissible",
	      "type": "danger"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.errorResponse))])]), _vm._v(" "), _c('div', {
	    staticClass: "user-form"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.errors.first('password')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "password",
	      "placeholder": _vm.$t('account.password.labels.newPassword'),
	      "name": "password"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.errors.first('confirmpassword')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.confirmpassword),
	      expression: "user.confirmpassword"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "confirmpassword",
	      "placeholder": _vm.$t('account.password.labels.confirmNewPassword'),
	      "name": "confirmpassword"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.confirmpassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.confirmpassword = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-primary btn-lg btn-submit",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('recovery.action.resetPassword')))])], 1)], 1) : _c('div', {
	    staticClass: "reset-success"
	  }, [_c('alert', {
	    attrs: {
	      "alertClass": "alert-dismissible",
	      "type": "success"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('recovery.resetPassword.response.success')))])]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-block btn-link btn-lg btn-submit",
	    attrs: {
	      "to": ("/" + (this.$route.params.namespace) + "/login")
	    }
	  }, [_vm._v(_vm._s(_vm.$t('recovery.action.continueLogin')))])], 1)]) : _vm._e()])], 1)]), _vm._v(" "), _vm._m(1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brand"
	  }, [_c('img', {
	    staticClass: "brand-img",
	    attrs: {
	      "src": "/static/images/byteark-loading-white.png",
	      "alt": "logo account",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "brand-text font-size-24 grey-100"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "page-copyright page-copyright-inverse"
	  }, [_c('p', [_vm._v("Service by ByteArk.com")])])
	}]}

/***/ },
/* 507 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main page-border"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLoading),
	      expression: "isLoading"
	    }],
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-block"
	  }, [_c('p', {
	    staticClass: "card-text"
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isLoading),
	      expression: "!isLoading"
	    }],
	    staticClass: "card"
	  }, [_c('Client-usage-history', {
	    attrs: {
	      "team": _vm.team,
	      "showTitle": false
	    },
	    on: {
	      "loadChanged": _vm.clientUsageHistoryLoadChanged
	    }
	  })], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_vm._v("Admin")])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Client Usage History")])])
	}]}

/***/ },
/* 508 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app-chrome"
	  }, [(_vm.isLoadingCurrentUser || _vm.isLoading) ? _c('loading-indicator') : _c('div', [(_vm.isUnauthorize) ? _c('page403') : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 509 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "billingInformationSection"
	    }
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n    " + _vm._s(_vm.$t("billing.labels.billingInformation")) + "\n  ")]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]) : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 col-xs-12"
	  }, [_c('div', {
	    staticClass: "bg-blue-grey-100 p-30"
	  }, [(_vm.hasBillingInformation) ? _c('div', {
	    staticClass: "counter counter-md text-xs-left"
	  }, [_c('span', {
	    staticClass: "counter-number grey-600"
	  }, [_vm._v(_vm._s(_vm.billingInformation.first_name) + " " + _vm._s(_vm.billingInformation.last_name))]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label m-b-5 m-t-10"
	  }, [(_vm.team.is_reseller) ? _c('p', [_c('span', {
	    staticClass: "p-r-10"
	  }, [_vm._v(_vm._s(_vm.billingInformation.company_name))]), _vm._v(" " + _vm._s(_vm.$t("billing.information.labels.taxID")) + " : " + _vm._s(_vm.billingInformation.tax_id))]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "address1"
	  }, [_vm._v(_vm._s(_vm.billingInformation.address1))]), _vm._v(" "), _c('span', {
	    staticClass: "address2"
	  }, [_vm._v(_vm._s(_vm.billingInformation.address2))]), _vm._v(" "), _c('span', {
	    staticClass: "city"
	  }, [_vm._v(_vm._s(_vm.billingInformation.city))]), _vm._v(" "), _c('span', {
	    staticClass: "state"
	  }, [_vm._v(_vm._s(_vm.billingInformation.state))]), _vm._v(" "), _c('span', {
	    staticClass: "postal-code"
	  }, [_vm._v(_vm._s(_vm.billingInformation.zipcode))]), _vm._v(" "), _c('span', {
	    staticClass: "country"
	  }, [_vm._v(_vm._s(_vm.billingInformation.country))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("billing.information.labels.billingContactPhone")) + " : " + _vm._s(_vm.billingInformation.contact_phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("billing.information.labels.billingEmail")) + " : " + _vm._s(_vm.billingInformation.contact_email))])]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label text-uppercase m-b-5 m-t-20"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onChangeInformationButtonClick
	    }
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.action.changeInformation")) + "\n            ")])])]) : _c('div', [_c('p', {
	    staticClass: "font-size-16"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.noBillingInformation")))]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label text-uppercase m-b-5 m-t-20"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onChangeInformationButtonClick
	    }
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.action.addBillingInformation")) + "\n            ")])])])]), _vm._v(" "), _c('modal', {
	    ref: "billingInformationFormModal",
	    staticClass: "modal-primary"
	  }, [_c('h4', {
	    staticClass: "modal-title",
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.enterBillingInformation")))]), _vm._v(" "), _c('billing-information-form', {
	    ref: "billingInformationForm",
	    attrs: {
	      "team": _vm.team,
	      "billingInformation": _vm.billingInformation
	    },
	    on: {
	      "save": _vm.onBillingInformationFormSaved,
	      "cancel": _vm.onBillingInformationFormCancel
	    },
	    slot: "body"
	  })], 1)], 1)])])
	},staticRenderFns: []}

/***/ },
/* 510 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 511 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app-chrome"
	  }, [(_vm.isLoadingCurrentUser) ? _c('loading-indicator') : _c('div', [(_vm.isUnauthorize) ? _c('page403') : _c('div', {
	    staticClass: "page-content container"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h4', [_c('img', {
	    staticClass: "margin-right-10",
	    attrs: {
	      "src": "/static/images/byteark-logo-blue.png",
	      "title": "ByteArk",
	      "height": "60"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "m-t-20"
	  }, [_c('p', {
	    staticClass: "font-size-12 m-b-5"
	  }, [_vm._v("บริษัท ไบต์อาร์ค จำกัด")]), _vm._v(" "), _c('p', {
	    staticClass: "font-size-12 m-b-5"
	  }, [_vm._v("เลขที่ 1 อาคารพร้อมพันธ์ 2 ชั้น 6 ห้อง 610")]), _vm._v(" "), _c('p', {
	    staticClass: "font-size-12 m-b-5"
	  }, [_vm._v("ซอยลาดพร้าว 3 ถนนลาดพร้าว แขวงจอมพล")]), _vm._v(" "), _c('p', {
	    staticClass: "font-size-12 m-b-5"
	  }, [_vm._v("เขตจตุจักร กรุงเทพมหานคร 10900")]), _vm._v(" "), _c('p', {
	    staticClass: "font-size-12 m-b-5"
	  }, [_vm._v("เบอร์โทรศัพท์ 02-512-2826 โทรสาร 02-512-2827")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-xs-right"
	  }, [_c('h3', {
	    staticClass: "m-t-20 m-b-0"
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.orderNumber")) + ": " + _vm._s(_vm.statement.order_number))]), _vm._v(" "), _c('p', {
	    staticClass: "font-size-18"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.dateIssued")) + " : " + _vm._s(_vm.dateIssued))]), _vm._v(" "), _c('p', {
	    staticClass: "font-size-16"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.team")) + ": " + _vm._s(_vm.team ? _vm.team.name : ''))]), _vm._v(" "), (_vm.team ? _vm.team.reseller_id != 0 : false) ? _c('p', {
	    staticClass: "font-size-16"
	  }, [_vm._v(" Reseller : " + _vm._s(_vm.team.reseller.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "page-invoice-table table-responsive m-t-60"
	  }, [_c('table', {
	    staticClass: "table table-hover text-right"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("statement.labels.description")))]), _vm._v(" "), _c('th', {
	    staticClass: "text-xs-right"
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.amount")))])])]), _vm._v(" "), _c('tbody', [(_vm.statement) ? _c('tr', [_c('td', {
	    staticClass: "text-xs-left"
	  }, [_vm._v(_vm._s(_vm.statement.description))]), _vm._v(" "), _c('td', {
	    staticClass: "text-xs-right"
	  }, [_vm._v(_vm._s(_vm.statement.human_amount) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "text-xs-right"
	  }, [(!_vm.isPrinting) ? _c('button', {
	    staticClass: "btn btn-animate btn-animate-side btn-default btn-outline",
	    attrs: {
	      "type": "button",
	      "onclick": "javascript:window.print(); "
	    }
	  }, [_c('span', [_c('i', {
	    staticClass: "icon md-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t("action.print")))])]) : _vm._e()]), _vm._v(" "), (_vm.billingInformation) ? _c('div', {
	    staticClass: "m-t-40"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.billingInformation.first_name) + " " + _vm._s(_vm.billingInformation.last_name))]), _vm._v(" "), _c('div', {
	    staticClass: "m-b-5 m-t-10"
	  }, [(_vm.team && _vm.team.is_reseller) ? _c('p', [_c('span', {
	    staticClass: "p-r-10"
	  }, [_vm._v(_vm._s(_vm.billingInformation.company_name))]), _vm._v(" " + _vm._s(_vm.$t("billing.information.labels.taxID")) + " : " + _vm._s(_vm.billingInformation.tax_id))]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "address1"
	  }, [_vm._v(_vm._s(_vm.billingInformation.address1))]), _vm._v(" "), _c('span', {
	    staticClass: "address2"
	  }, [_vm._v(_vm._s(_vm.billingInformation.address2))]), _vm._v(" "), _c('span', {
	    staticClass: "city"
	  }, [_vm._v(_vm._s(_vm.billingInformation.city))]), _vm._v(" "), _c('span', {
	    staticClass: "state"
	  }, [_vm._v(_vm._s(_vm.billingInformation.state))]), _vm._v(" "), _c('span', {
	    staticClass: "postal-code"
	  }, [_vm._v(_vm._s(_vm.billingInformation.zipcode))]), _vm._v(" "), _c('span', {
	    staticClass: "country"
	  }, [_vm._v(_vm._s(_vm.billingInformation.country))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("billing.information.labels.billingContactPhone")) + " : " + _vm._s(_vm.billingInformation.contact_phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("billing.information.labels.billingEmail")) + " : " + _vm._s(_vm.billingInformation.contact_email))])])]) : _vm._e()])])])], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 512 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item active text-capitalize"
	  }, [_vm._v(_vm._s(_vm.currentPage))])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t('team.labels.createTeam')))])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [_c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-section"
	  }, [_c('h4', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.$t("team.title")))]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('team')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "team"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('team.displayName.labels')))]), _vm._v(" "), _c('span', {
	    staticClass: "guideline-block"
	  }, [_vm._v(_vm._s(_vm.$t('team.displayName.textGuide')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.team),
	      expression: "user.team"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "team",
	      "placeholder": _vm.$t('team.displayName.labels')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.team)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.team = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('namespace')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "namespace"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('team.url.labels')))]), _vm._v(" "), _c('span', {
	    staticClass: "help-block m-t-0"
	  }, [_vm._v(_vm._s(_vm.$t('team.url.textGuide')))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "input-group-addon"
	  }, [_vm._v(_vm._s((_vm.baseURL + "/")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.namespace),
	      expression: "user.namespace"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "namespace",
	      "placeholder": _vm.$t('team.url.labels')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.namespace)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.namespace = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.showTeamType) ? _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('type')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "role"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('team.type.labels')))]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.type),
	      expression: "user.type"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "normal-team"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.user.type, "normal-team")
	    },
	    on: {
	      "click": function($event) {
	        _vm.user.type = "normal-team"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "inputRadiosUnchecked"
	    }
	  }, [_vm._v("Normal Team")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.type),
	      expression: "user.type"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "reseller"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.user.type, "reseller")
	    },
	    on: {
	      "click": function($event) {
	        _vm.user.type = "reseller"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "inputRadiosUnchecked"
	    }
	  }, [_vm._v("Reseller")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.type),
	      expression: "user.type"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "sub-team"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.user.type, "sub-team")
	    },
	    on: {
	      "click": function($event) {
	        _vm.user.type = "sub-team"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "inputRadiosUnchecked"
	    }
	  }, [_vm._v("Sub Team of Reseller")])])]) : _vm._e(), _vm._v(" "), (_vm.user.type === 'sub-team' && _vm.showTeamType) ? _c('form-group', [_c('label', {
	    attrs: {
	      "for": "team"
	    }
	  }, [_vm._v("Choose Reseller "), _c('span', {
	    staticClass: "red-600"
	  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentResellerTeam),
	      expression: "currentResellerTeam"
	    }],
	    attrs: {
	      "options": _vm.filterItems
	    },
	    domProps: {
	      "value": (_vm.currentResellerTeam)
	    },
	    on: {
	      "input": function($event) {
	        _vm.currentResellerTeam = $event
	      }
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-section"
	  }, [_c('h4', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.$t('account.labels.account')))]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('displayname'),
	      "autocomplete": "false"
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('account.labels.displayName')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.displayname),
	      expression: "user.displayname"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('account.labels.displayName')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.displayname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.displayname = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('account.labels.email')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "email",
	      "placeholder": _vm.$t('account.labels.email'),
	      "autocomplete": "false"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('password')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('account.labels.password')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "password",
	      "placeholder": _vm.$t('account.labels.password')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.password = $event.target.value
	      }
	    }
	  })])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" Submit\n              ")])])])])])])])])
	},staticRenderFns: []}

/***/ },
/* 513 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main page-border"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_vm._v("Admin")]), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/admin/teams")
	    }
	  }, [_vm._v("Manage Team")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_vm._v(_vm._s((_vm.team) ? _vm.team.name : ''))])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Manage Billing")])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLoading || !_vm.team),
	      expression: "isLoading || !team"
	    }],
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-block"
	  }, [_c('p', {
	    staticClass: "card-text"
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isLoading),
	      expression: "!isLoading"
	    }],
	    staticClass: "card"
	  }, [(_vm.showCurrentTeamInfo) ? _c('Team-info', {
	    attrs: {
	      "team": _vm.team,
	      "currentUser": _vm.currentUser
	    },
	    on: {
	      "loadChanged": _vm.teamInfoLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showCurrentStat) ? _c('Current-stat', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.currentStatLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showCurrentPackage) ? _c('Current-package', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.currentPackageLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showManualCredit) ? _c('Manual-credit', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.manualCreditLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showBillingInformation) ? _c('div', {
	    staticClass: "card-block"
	  }, [_c('Billing-information', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.billingInformationLoadChanged
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMonthlyUsageHistory) ? _c('Monthly-usage-history', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.monthlyUsageHistoryLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showStatement) ? _c('Statement', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.statementLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showClientUsageHistory) ? _c('Client-usage-history', {
	    attrs: {
	      "team": _vm.team,
	      "showTitle": true
	    },
	    on: {
	      "loadChanged": _vm.clientUsageHistoryLoadChanged
	    }
	  }) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ },
/* 514 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "widget widget-shadow widget-pricing-plan-table"
	  }, [_c('div', {
	    staticClass: "widget-content bg-blue-grey-600"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('table', {
	    staticClass: "table margin-bottom-0"
	  }, [_c('thead', {
	    staticClass: "bg-blue-grey-700"
	  }, [_c('tr', [_c('th', {
	    staticClass: "white"
	  }, [_vm._v(_vm._s(_vm.$t("title.DataTransfer")))]), _vm._v(" "), _c('th', {
	    staticClass: "white"
	  }, [_vm._v(_vm._s(_vm.$t("title.cost")))]), _vm._v(" "), _c('th', {
	    staticClass: "white"
	  }, [_vm._v(_vm._s(_vm.$t("title.FreeStorage")))])])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 bottom-pricing-block"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('div', {
	    staticClass: "counter counter-md text-left"
	  }, [_c('div', {
	    staticClass: "counter-label blue-grey-300"
	  }, [_vm._v(_vm._s(_vm.$t("text.additional")) + " Storage")]), _vm._v(" "), _c('div', {
	    staticClass: "counter-number font-size-14 white"
	  }, [_vm._v("6 THB / GB / " + _vm._s(_vm.$t("unit.month")))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('div', {
	    staticClass: "counter counter-md text-left"
	  }, [_c('div', {
	    staticClass: "counter-label blue-grey-300"
	  }, [_vm._v(_vm._s(_vm.$t("title.QoderVODEncoding")))]), _vm._v(" "), _c('div', {
	    staticClass: "counter-number font-size-14 white"
	  }, [_vm._v("0.50 THB / " + _vm._s(_vm.$t("unit.minute")))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "counter counter-md text-left bg-blue-grey-700"
	  }, [_c('div', {
	    staticClass: "white"
	  }, [_vm._v(_vm._s(_vm.$t("title.pricePlanVat")))])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tbody', {
	    staticClass: "bg-white"
	  }, [_c('tr', [_c('td', [_vm._v("0 - 500 GB")]), _vm._v(" "), _c('td', [_vm._v("1.50 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("5 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("500 GB - 1 TB")]), _vm._v(" "), _c('td', [_vm._v("1.20 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("10 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 - 3 TB")]), _vm._v(" "), _c('td', [_vm._v("1.33 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("20 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 - 5 TB")]), _vm._v(" "), _c('td', [_vm._v("1.30 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("40 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5 - 10 TB")]), _vm._v(" "), _c('td', [_vm._v("1.08 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("60 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10 - 20 TB")]), _vm._v(" "), _c('td', [_vm._v("1.00 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("100 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("20 - 40 TB")]), _vm._v(" "), _c('td', [_vm._v("0.80 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("200 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("40 - 50 TB")]), _vm._v(" "), _c('td', [_vm._v("0.70 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("300 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("50 - 60 TB")]), _vm._v(" "), _c('td', [_vm._v("0.60 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("500 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("60 - 70 TB")]), _vm._v(" "), _c('td', [_vm._v("0.50 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("1 TB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("70 - 100 TB")]), _vm._v(" "), _c('td', [_vm._v("0.30 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("1.5 TB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 100 GB")]), _vm._v(" "), _c('td', [_vm._v("0.30 THB/GB")]), _vm._v(" "), _c('td', {
	    staticClass: "green-600"
	  }, [_vm._v("2 TB")])])])
	}]}

/***/ },
/* 515 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-block"
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]) : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-xs-12"
	  }, [_c('div', {
	    staticClass: "font-size-24 blue-grey-700 m-b-5"
	  }, [_vm._v("Team name : " + _vm._s(_vm.team.name) + "\n              "), (_vm.team.is_reseller) ? _c('span', {
	    staticClass: "font-size-18 red-600"
	  }, [_vm._v("[ Reseller ]")]) : (_vm.team.has_reseller) ? _c('span', {
	    staticClass: "font-size-18 blue-600"
	  }, [_vm._v("[ Sub Team ]")]) : _c('span', {
	    staticClass: "font-size-18 grey-600"
	  }, [_vm._v("[ Normal ]")])]), _vm._v(" "), (_vm.team.has_reseller) ? _c('div', {
	    staticClass: "font-size-14"
	  }, [_vm._v("Reseller : " + _vm._s(_vm.team.reseller ? _vm.team.reseller.name : ''))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "font-size-14"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2 col-xs-12"
	  }, [_c('div', {
	    staticClass: "counter counter-lg text-xs-right"
	  }, [_c('router-link', {
	    staticClass: "btn btn-lg btn-default",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (_vm.team.namespace) + "/edit"),
	      "alt": "Edit Team"
	    }
	  }, [_c('i', {
	    staticClass: "icon md-edit",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])], 1)])])])])])])
	},staticRenderFns: []}

/***/ },
/* 516 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    staticClass: "text-md-left",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": "danger"
	    }
	  }, [_c('span', {
	    staticClass: "text-capitalize"
	  }, [_vm._v(_vm._s(_vm.errorResponse))])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-md-12",
	      "error": _vm.formErrors.first('number')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Credit card number")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.card.number),
	      expression: "card.number"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.card.number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.card.number = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-md-12",
	      "error": _vm.formErrors.first('name')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Name on card")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.card.name),
	      expression: "card.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.card.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.card.name = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-md-4",
	      "error": _vm.formErrors.first('expiration_month')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Expire month")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.card.expiration_month),
	      expression: "card.expiration_month"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "MM",
	      "maxlength": "2"
	    },
	    domProps: {
	      "value": _vm._s(_vm.card.expiration_month)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.card.expiration_month = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "formGroupClass": "col-md-4",
	      "error": _vm.formErrors.first('expiration_year')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Expire year")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.card.expiration_year),
	      expression: "card.expiration_year"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "YYYY",
	      "maxlength": "4"
	    },
	    domProps: {
	      "value": _vm._s(_vm.card.expiration_year)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.card.expiration_year = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "formGroupClass": "col-md-4",
	      "error": _vm.formErrors.first('security_code')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("CVV code")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.card.security_code),
	      expression: "card.security_code"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "CVV",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "spellcheck": "off",
	      "autocapitalize": "off",
	      "maxlength": "4"
	    },
	    domProps: {
	      "value": _vm._s(_vm.card.security_code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.card.security_code = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), _c('loading-button', {
	    staticClass: "text-uppercase btn-block btn-lg m-t-10",
	    attrs: {
	      "isSubmiting": _vm.isSubmiting
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.onClickPayButton($event)
	      }
	    }
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isSubmiting),
	      expression: "!isSubmiting"
	    }],
	    staticClass: "icon md-lock",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(("Pay " + (_vm.credit.toLocaleString()) + " THB")) + "\n  ")]), _vm._v(" "), _vm._m(0)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "payment-logos m-t-10"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/omise.png",
	      "alt": "Omise"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "pull-xs-right",
	    attrs: {
	      "src": "/static/images/creditcard.png",
	      "alt": "Mc visa acceptance"
	    }
	  })])
	}]}

/***/ },
/* 517 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "clearfix"
	  }, [_c('nav', {
	    staticClass: "site-navbar navbar navbar-default navbar-mega navbar-inverse",
	    attrs: {
	      "role": "navigation"
	    }
	  }, [_c('div', {
	    staticClass: "navbar-header"
	  }, [_c('button', {
	    staticClass: "navbar-toggler hamburger hamburger-close navbar-toggler-left",
	    class: {
	      'hided': !_vm.isShowSiteMenu
	    },
	    attrs: {
	      "type": "button",
	      "data-toggle": "menubar"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showSiteMenu()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
	    staticClass: "hamburger-bar"
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
	    staticClass: "navbar-brand navbar-brand-center",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/")
	    }
	  }, [_c('img', {
	    staticClass: "navbar-brand-logo navbar-brand-logo-normal",
	    attrs: {
	      "src": "/static/images/byteark-logo.png",
	      "title": "ByteArk"
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "navbar-container container-fluid"
	  }, [_c('div', {
	    staticClass: "collapse navbar-collapse navbar-collapse-toolbar",
	    attrs: {
	      "id": "site-navbar-collapse"
	    }
	  }, [_c('ul', {
	    staticClass: "nav navbar-toolbar navbar-right navbar-toolbar-right"
	  }, [_c('li', {
	    staticClass: "nav-item dropdown"
	  }, [_vm._m(1), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu dropdown-menu-right dropdown-menu-media switch-service",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', {
	    staticClass: "dropdown-menu-header",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('h5', [_vm._v(_vm._s(_vm.$t("menu.services")))])]), _vm._v(" "), _c('li', {
	    staticClass: "list-group",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('div', {
	    attrs: {
	      "data-role": "container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "data-role": "content"
	    }
	  }, [_c('router-link', {
	    staticClass: "non-link list-group-item bg-blue-grey-100",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/"),
	      "role": "menuitem",
	      "target": "_blank"
	    }
	  }, [_c('div', {
	    staticClass: "media"
	  }, [_c('div', {
	    staticClass: "media-left p-l-5 p-r-20"
	  }, [_c('i', {
	    staticClass: "icon md-account bg-red-600 white icon-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h6', {
	    staticClass: "media-heading"
	  }, [_vm._v(_vm._s(_vm.$t("services.account.name")) + " "), _c('span', {
	    staticClass: "tag tag-danger pull-xs-right"
	  }, [_vm._v(_vm._s(_vm.$t("services.current.state")))])]), _vm._v(" "), _c('p', {
	    staticClass: "media-meta"
	  }, [_vm._v(_vm._s(_vm.$t("services.account.shortDescription")))])])])]), _vm._v(" "), _c('a', {
	    staticClass: "non-link list-group-item",
	    attrs: {
	      "href": _vm.serviceS3URL,
	      "role": "menuitem",
	      "target": "_blank"
	    }
	  }, [_c('div', {
	    staticClass: "media"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h6', {
	    staticClass: "media-heading"
	  }, [_vm._v(_vm._s(_vm.$t("services.storage.name")))]), _vm._v(" "), _c('p', {
	    staticClass: "media-meta"
	  }, [_vm._v(_vm._s(_vm.$t("services.storage.shortDescription")))])])])]), _vm._v(" "), _c('a', {
	    staticClass: "non-link list-group-item",
	    attrs: {
	      "href": _vm.serviceQoderURL,
	      "role": "menuitem",
	      "target": "_blank"
	    }
	  }, [_c('div', {
	    staticClass: "media"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h6', {
	    staticClass: "media-heading"
	  }, [_vm._v(_vm._s(_vm.$t("services.qoder.name")))]), _vm._v(" "), _c('p', {
	    staticClass: "media-meta"
	  }, [_vm._v(_vm._s(_vm.$t("services.qoder.shortDescription")))])])])]), _vm._v(" "), _c('a', {
	    staticClass: "non-link list-group-item",
	    attrs: {
	      "href": _vm.serviceFleetURL,
	      "role": "menuitem",
	      "target": "_blank"
	    }
	  }, [_c('div', {
	    staticClass: "media"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h6', {
	    staticClass: "media-heading"
	  }, [_vm._v(_vm._s(_vm.$t("services.fleet.name")))]), _vm._v(" "), _c('p', {
	    staticClass: "media-meta"
	  }, [_vm._v(_vm._s(_vm.$t("services.fleet.shortDescription")))])])])])], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "dropdown-menu-footer",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('router-link', {
	    staticClass: "dropdown-item ",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/")
	    }
	  }, [_c('i', {
	    staticClass: "icon md-pin",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "text hidden-sm-down"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t("services.current.use")) + " " + _vm._s(_vm.$t("services.account.name")) + " ")])])], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "nav-item nav-user clearfix dropdown"
	  }, [_c('a', {
	    staticClass: "nav-link navbar-avatar",
	    attrs: {
	      "data-toggle": "dropdown",
	      "href": "#",
	      "aria-expanded": "false",
	      "data-animation": "scale-up",
	      "role": "button"
	    }
	  }, [_c('span', {
	    staticClass: "avatar avatar-online"
	  }, [(_vm.currentUser) ? _c('img', {
	    staticClass: "img-fluid",
	    attrs: {
	      "src": _vm.currentUser.display_image.sizes.default.url,
	      "alt": "image-profile"
	    }
	  }) : _c('img', {
	    staticClass: "img-fluid",
	    attrs: {
	      "src": "/static/images/user.png",
	      "alt": "image-profile"
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "username"
	  }, [_vm._v(_vm._s(this.currentUser.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('router-link', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/self/profile"),
	      "role": "menuitem"
	    }
	  }, [_c('i', {
	    staticClass: "icon md-account",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('menu.profile')) + "\n              ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/self/password"),
	      "role": "menuitem"
	    }
	  }, [_c('i', {
	    staticClass: "icon md-key",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('menu.password')) + "\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-divider"
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/logout"),
	      "role": "menuitem"
	    }
	  }, [_c('i', {
	    staticClass: "icon md-power",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('menu.logout')) + "\n              ")])], 1)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "site-menubar site-menubar-light",
	    class: {
	      'show-site-menu': _vm.isShowSiteMenu
	    }
	  }, [_c('div', {
	    staticClass: "site-menubar-body"
	  }, [_c('div', [_c('ul', {
	    staticClass: "site-menu",
	    attrs: {
	      "data-plugin": "menu"
	    }
	  }, [_c('li', {
	    staticClass: "site-menu-category"
	  }, [_vm._v(_vm._s(_vm.$t('menu.general')))]), _vm._v(" "), _c('li', {
	    staticClass: "site-menu-item"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/dashboard")
	    }
	  }, [_c('i', {
	    staticClass: "site-menu-icon md-cloud-box",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('menu.dashboard')))])])], 1), _vm._v(" "), (_vm.showBillingMenu) ? _c('li', {
	    staticClass: "site-menu-item"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/billing")
	    }
	  }, [_c('i', {
	    staticClass: "site-menu-icon md-money-box",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('menu.billing')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.showTeamMenu) ? _c('li', {
	    staticClass: "site-menu-item has-sub",
	    class: {
	      'open': _vm.isShowSubMenuTeam
	    }
	  }, [_c('a', {
	    attrs: {
	      "data-dropdown-toggle": "false"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showSubMenuTeam()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "site-menu-icon md-accounts-list"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('menu.team')))]), _vm._v(" "), _c('span', {
	    staticClass: "site-menu-arrow"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "site-menu-sub",
	    class: {
	      'is-shown': _vm.isShowSubMenuTeam
	    }
	  }, [_c('li', {
	    staticClass: "site-menu-item"
	  }, [_c('router-link', {
	    staticClass: "animsition-link",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/team/members")
	    }
	  }, [_c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('member.labels.members')))])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "site-menu-item"
	  }, [_c('router-link', {
	    staticClass: "animsition-link",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/team/setting")
	    }
	  }, [_c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('team.labels.setting')))])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showAdminMenu) ? _c('li', {
	    staticClass: "site-menu-item has-sub",
	    class: {
	      'open': _vm.isShowSubMenuAdmin
	    }
	  }, [_c('a', {
	    attrs: {
	      "data-dropdown-toggle": "false"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showSubMenuAdmin()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "site-menu-icon md-developer-board",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('menu.admin')))]), _vm._v(" "), _c('span', {
	    staticClass: "site-menu-arrow"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "site-menu-sub",
	    class: {
	      'is-shown': _vm.isShowSubMenuAdmin
	    }
	  }, [_c('li', {
	    staticClass: "site-menu-item"
	  }, [_c('router-link', {
	    staticClass: "animsition-link",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/admin/client-usage-history")
	    }
	  }, [_c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('menu.clientUsageHistory')))])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "site-menu-item"
	  }, [_c('router-link', {
	    staticClass: "animsition-link",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/admin/teams")
	    }
	  }, [_c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t("action.manageClientTeam")))])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "site-menu-item"
	  }, [_c('router-link', {
	    staticClass: "animsition-link",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/admin/addon-cost")
	    }
	  }, [_c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('menu.addons')))])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "site-menu-item"
	  }, [_c('router-link', {
	    staticClass: "animsition-link",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/admin/transactions")
	    }
	  }, [_c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('menu.creditTransaction')))])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showResellerMenu) ? _c('li', {
	    staticClass: "site-menu-item has-sub",
	    class: {
	      'open': _vm.isShowSubMenuReseller
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.showSubMenuAdmin()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "site-menu-icon md-group-work",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('menu.reseller')))])]), _vm._v(" "), _c('ul', {
	    staticClass: "site-menu-sub",
	    class: {
	      'is-shown': _vm.isShowSubMenuReseller
	    }
	  }, [_c('li', {
	    staticClass: "site-menu-item"
	  }, [_c('router-link', {
	    staticClass: "animsition-link",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/reseller/teams")
	    }
	  }, [_c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('action.manageClientTeam')))])])], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.showAdminMenu) ? _c('li', {
	    staticClass: "site-menu-item"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/support")
	    }
	  }, [_c('i', {
	    staticClass: "site-menu-icon md-email",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "site-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('menu.support')))])])], 1) : _vm._e()])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "navbar-toggler collapsed",
	    attrs: {
	      "type": "button",
	      "data-target": "#site-navbar-collapse",
	      "data-toggle": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "icon md-more",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-service",
	    attrs: {
	      "data-toggle": "dropdown",
	      "href": "javascript:void(0)",
	      "title": "Service"
	    }
	  }, [_c('i', {
	    staticClass: "icon md-apps",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "media-left p-l-5 p-r-20"
	  }, [_c('i', {
	    staticClass: "icon md-storage bg-blue-600 white icon-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "media-left p-l-5 p-r-20"
	  }, [_c('i', {
	    staticClass: "icon md-videocam bg-blue-600 white icon-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "media-left p-l-5 p-r-20"
	  }, [_c('i', {
	    staticClass: "icon md-swap-vertical bg-blue-600 white icon-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ },
/* 518 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_c('div', {
	    staticClass: "page-main"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/self/profile")
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.editProfile")))])], 1)]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("account.password.labels.changePassword")))])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-md-6"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-section"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('password')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.password.labels.currentPassword")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "password",
	      "placeholder": _vm.$t('account.password.labels.currentPassword'),
	      "autocomplete": "false"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('new_password')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.password.labels.newPassword")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.new_password),
	      expression: "user.new_password"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "password",
	      "placeholder": _vm.$t('account.password.labels.newPassword'),
	      "autocomplete": "false"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.new_password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.new_password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('confirm_new_password')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.confirm_new_password),
	      expression: "user.confirm_new_password"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "password",
	      "placeholder": _vm.$t('account.password.labels.confirmNewPassword'),
	      "autocomplete": "false"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.confirm_new_password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.confirm_new_password = $event.target.value
	      }
	    }
	  })])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t("account.action.submit")) + "\n                ")])])])])], 1)])])])])
	},staticRenderFns: []}

/***/ },
/* 519 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_vm._v(_vm._s(this.$route.params.namespace))])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t('team.labels.setting')))])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('team.labels.rename')) + "\n              ")]), _vm._v(" "), _c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-section"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "team"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('team.displayName.labels')))]), _vm._v(" "), _c('span', {
	    staticClass: "guideline-block"
	  }, [_vm._v(_vm._s(_vm.$t('team.displayName.textGuide')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.team.name),
	      expression: "team.name"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "name",
	      "placeholder": "Team Display name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.team.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.team.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('team.url.labels')))]), _vm._v(" "), _c('span', {
	    staticClass: "help-block m-t-0"
	  }, [_vm._v(_vm._s(_vm.$t('team.url.textGuide')))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "input-group-addon"
	  }, [_vm._v(_vm._s((_vm.baseURL + "/")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.team.namespace),
	      expression: "team.namespace"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "namespace",
	      "placeholder": "Team URL",
	      "disabled": "true"
	    },
	    domProps: {
	      "value": _vm._s(_vm.team.namespace)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.team.namespace = $event.target.value
	      }
	    }
	  })])])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('team.action.submit')) + "\n              ")])])])])], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 520 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_c('div', {
	    staticClass: "page-content container-fluid page-dashboard"
	  }, [(_vm.showMainCurrentState && _vm.showMonthlyPricingPlan) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-7 col-md-12 col-xs-12"
	  }, [(_vm.showMainCurrentState) ? _c('main-current-state', {
	    attrs: {
	      "team": _vm.team,
	      "forceFullWidthBoxes": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.showMonthlyPricingPlan) ? _c('div', {
	    staticClass: "col-lg-5 col-md-12 col-xs-12"
	  }, [_c('div', {
	    staticClass: "page-header p-r-0"
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("pricingPlan.title")) + "\n            "), (_vm.showPricingPlan2015) ? _c('a', {
	    staticClass: "btn btn-link p-r-0 pull-xs-right",
	    attrs: {
	      "href": "https://www.byteark.com/pricing-2015",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t("action.moreDetail"))), _c('i', {
	    staticClass: "icon md-chevron-right m-r-0",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _c('a', {
	    staticClass: "btn btn-link p-r-0 pull-xs-right",
	    attrs: {
	      "href": "https://www.byteark.com/pricing/",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n             " + _vm._s(_vm.$t("action.moreDetail"))), _c('i', {
	    staticClass: "icon md-chevron-right m-r-0",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), (_vm.showPricingPlan2015) ? _c('year-2015-pricing-plan') : _c('year-2017-pricing-plan')], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-7 col-md-12 col-xs-12"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("mainHeaderGroups.solutions")))])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 col-xs-12"
	  }, [_c('a', {
	    staticClass: "non-link",
	    attrs: {
	      "href": _vm.serviceS3URL,
	      "title": _vm.$t('solutions.fileDistributor.name'),
	      "target": "_blank"
	    }
	  }, [_c('div', {
	    staticClass: "bg-white p-35 clearfix m-b-30 service-box file-distributor-box"
	  }, [_c('div', {
	    staticClass: "counter counter-md counter detail text-xs-left pull-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-number-group"
	  }, [_c('span', {
	    staticClass: "counter-number text-primary"
	  }, [_vm._v(_vm._s(_vm.$t("solutions.fileDistributor.name")))])]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label font-size-14"
	  }, [_c('p', {
	    staticClass: "m-b-10 m-t-10"
	  }, [_vm._v(_vm._s(_vm.$t("solutions.fileDistributor.shortDescription")))]), _vm._v(" "), _c('span', {
	    staticClass: "blue-600"
	  }, [_vm._v("Start with " + _vm._s(_vm.$t("services.storage.name")) + "  "), _c('i', {
	    staticClass: "icon md-chevron-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 col-xs-12"
	  }, [_c('a', {
	    staticClass: "non-link",
	    attrs: {
	      "href": _vm.serviceQoderURL,
	      "title": _vm.$t('solutions.vod.name'),
	      "target": "_blank"
	    }
	  }, [_c('div', {
	    staticClass: "bg-white p-35 clearfix m-b-30 service-box vod-box"
	  }, [_c('div', {
	    staticClass: "counter counter-md counter detail text-xs-left pull-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-number-group"
	  }, [_c('span', {
	    staticClass: "counter-number text-primary"
	  }, [_vm._v(_vm._s(_vm.$t("solutions.vod.name")))])]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label font-size-14"
	  }, [_c('p', {
	    staticClass: "m-b-10 m-t-10"
	  }, [_vm._v(_vm._s(_vm.$t("solutions.vod.shortDescription")))]), _vm._v(" "), _c('span', {
	    staticClass: "blue-600"
	  }, [_vm._v("Start with " + _vm._s(_vm.$t("services.qoder.name")) + " "), _c('i', {
	    staticClass: "icon md-chevron-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 col-xs-12"
	  }, [_c('a', {
	    staticClass: "non-link",
	    attrs: {
	      "href": _vm.serviceFleetURL,
	      "title": _vm.$t('solutions.liveStraming.name'),
	      "target": "_blank"
	    }
	  }, [_c('div', {
	    staticClass: "bg-white p-35 clearfix m-b-30 service-box"
	  }, [_c('div', {
	    staticClass: "counter counter-md counter detail text-xs-left pull-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-number-group"
	  }, [_c('span', {
	    staticClass: "counter-number text-primary"
	  }, [_vm._v(_vm._s(_vm.$t("solutions.liveStraming.name")))])]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label font-size-14"
	  }, [_c('p', {
	    staticClass: "m-b-10 m-t-10"
	  }, [_vm._v(_vm._s(_vm.$t("solutions.liveStraming.shortDescription")))]), _vm._v(" "), _c('span', {
	    staticClass: "blue-600"
	  }, [_vm._v("Start with " + _vm._s(_vm.$t("services.fleet.name")) + " "), _c('i', {
	    staticClass: "icon md-chevron-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 col-xs-12"
	  }, [_c('a', {
	    staticClass: "non-link",
	    attrs: {
	      "href": _vm.serviceFleetURL,
	      "title": _vm.$t('solutions.webCDN.name'),
	      "target": "_blank"
	    }
	  }, [_c('div', {
	    staticClass: "bg-white p-35 clearfix m-b-30 service-box"
	  }, [_c('div', {
	    staticClass: "counter counter-md counter detail text-xs-left pull-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-number-group"
	  }, [_c('span', {
	    staticClass: "counter-number text-primary"
	  }, [_vm._v(_vm._s(_vm.$t("solutions.webCDN.name")))])]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label font-size-14"
	  }, [_c('p', {
	    staticClass: "m-b-10 m-t-10"
	  }, [_vm._v(_vm._s(_vm.$t("solutions.webCDN.shortDescription")))]), _vm._v(" "), _c('span', {
	    staticClass: "blue-600"
	  }, [_vm._v("Start with " + _vm._s(_vm.$t("services.fleet.name")) + " "), _c('i', {
	    staticClass: "icon md-chevron-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-5 col-md-12 col-xs-12"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("mainHeaderGroups.quickStart")))])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "list-group bg-white bg-inherit"
	  }, [_c('a', {
	    staticClass: "list-group-item text-primary",
	    attrs: {
	      "href": "http://docs.byteark.com/article/http-live-streaming/"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t("quickStart.howToLiveStream.name")) + "\n                "), _vm._m(4)]), _vm._v(" "), _c('a', {
	    staticClass: "list-group-item text-primary",
	    attrs: {
	      "href": "http://docs.byteark.com/article/getting-start/vod-streaming"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t("quickStart.howToUploadVdo.name")) + "\n                "), _vm._m(5)]), _vm._v(" "), _c('a', {
	    staticClass: "list-group-item text-primary",
	    attrs: {
	      "href": "http://docs.byteark.com/article/byteark-storage/"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t("quickStart.howToUploadFileToCDN.name")) + "\n                "), _vm._m(6)]), _vm._v(" "), _c('a', {
	    staticClass: "list-group-item text-primary",
	    attrs: {
	      "href": "http://docs.byteark.com/article/payment/"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t("quickStart.howToAddCredit.name")) + "\n                "), _vm._m(7)]), _vm._v(" "), _c('a', {
	    staticClass: "list-group-item text-primary",
	    attrs: {
	      "href": "http://docs.byteark.com/article/getting-start/web-cdn"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t("quickStart.howToImplementCDN.name")) + "\n                "), _vm._m(8)])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-xs-right white m-t-10"
	  }, [_c('i', {
	    staticClass: "icon icon-circle icon-2x md-storage bg-primary"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-xs-right white m-t-10"
	  }, [_c('i', {
	    staticClass: "icon icon-circle icon-2x md-videocam bg-primary"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-xs-right white m-t-10"
	  }, [_c('i', {
	    staticClass: "icon icon-circle icon-2x md-swap-vertical bg-primary"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-xs-right white m-t-10"
	  }, [_c('i', {
	    staticClass: "icon icon-circle icon-2x md-laptop bg-primary"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "pull-xs-right"
	  }, [_c('i', {
	    staticClass: "icon md-chevron-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "pull-xs-right"
	  }, [_c('i', {
	    staticClass: "icon md-chevron-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "pull-xs-right"
	  }, [_c('i', {
	    staticClass: "icon md-chevron-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "pull-xs-right"
	  }, [_c('i', {
	    staticClass: "icon md-chevron-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "pull-xs-right"
	  }, [_c('i', {
	    staticClass: "icon md-chevron-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ },
/* 521 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 522 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "addcreditSection"
	    }
	  }, [_c('div', {
	    staticClass: "content bg-blue-grey-100 p-30"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 col-xs-12 m-b-10"
	  }, [_c('p', {
	    staticClass: "font-size-16"
	  }, [_vm._v(_vm._s(_vm.$t("billing.addcredit.labels.textGuide")))])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-xs-12"
	  }, [_c('form-group', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentPrice),
	      expression: "currentPrice"
	    }],
	    staticClass: "form-control form-control-lg",
	    on: {
	      "change": function($event) {
	        _vm.currentPrice = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.priceList), function(item, index) {
	    return _c('option', {
	      domProps: {
	        "value": item
	      }
	    }, [_vm._v(_vm._s(item.key) + "\n            "), (item.key !== 'Custom') ? _c('span', [_vm._v(_vm._s(_vm.$t("billing.currencies.thb")))]) : _vm._e()])
	  }))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.currentPrice.key === 'Custom') ? _c('div', {
	    staticClass: "col-md-8 col-xs-12"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('customPrice')
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentPrice.value),
	      expression: "currentPrice.value"
	    }],
	    staticClass: "form-control form-control-lg",
	    attrs: {
	      "type": "number",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.currentPrice.value)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentPrice.value = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon"
	  }, [_vm._v(_vm._s(_vm.$t("billing.currencies.thb")))])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 col-xs-12"
	  }, [_c('div', {
	    staticClass: "help-guide grey-500"
	  }, [_c('span', {
	    staticClass: "red-600"
	  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t("billing.addcredit.labels.remark")) + "\n        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-xs-12 m-t-15"
	  }, [_c('Paypal-checkout', {
	    attrs: {
	      "buttonStyle": _vm.buttonStyle,
	      "validate": _vm.validatePayButton,
	      "credit": _vm.selectedCredit,
	      "dev": _vm.paypalDevEnv
	    }
	  })], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('modal', {
	    ref: "paymentInformationFormModal",
	    staticClass: "modal-primary"
	  }, [_c('h4', {
	    staticClass: "modal-title",
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t("billing.labels.paymentInformation")))]), _vm._v(" "), _c('payment-information-form', {
	    ref: "paymentInformationForm",
	    attrs: {
	      "team": _vm.team,
	      "credit": _vm.selectedCredit
	    },
	    on: {
	      "complete": _vm.onPaymentInformationFormComplete,
	      "cancel": _vm.onPaymentInformationFormCancel
	    },
	    slot: "body"
	  })], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-xs-12 m-t-20"
	  }, [_c('div', {
	    staticClass: "payment-logos"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.paypal.com/webapps/mpp/paypal-popup",
	      "title": "How PayPal Works",
	      "onclick": "javascript:window.open('https://www.paypal.com/webapps/mpp/paypal-popup','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/logo-center/9_bdg_secured_by_pp_2line.png",
	      "border": "0",
	      "alt": "Secured by PayPal"
	    }
	  })]), _vm._v(" "), _c('img', {
	    staticClass: "pull-xs-right",
	    attrs: {
	      "src": "/static/images/creditcard.png",
	      "alt": "Mc visa acceptance"
	    }
	  })])])])
	}]}

/***/ },
/* 523 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('transition', {
	    attrs: {
	      "name": "modal-slide"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.is_open),
	      expression: "is_open"
	    }],
	    staticClass: "modal",
	    on: {
	      "click": _vm.onOverlayClick
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _vm._t("title")], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body")], 2), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._t("footer")], 2) : _vm._e()])])])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "overlay-fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.is_open),
	      expression: "is_open"
	    }],
	    staticClass: "modal-overlay"
	  })])], 1)
	},staticRenderFns: []}

/***/ },
/* 524 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "chrome"
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 525 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-block"
	  }, [(_vm.isLoading && !_vm.team) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]) : _c('div', {
	    staticClass: "row"
	  }, [(_vm.showBillingCredit) ? _c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t("billing.action.addCredit")) + "\n      ")]), _vm._v(" "), (_vm.team.available_payment_methods.length > 1) ? _c('div', {
	    staticClass: "payment-method"
	  }, [_c('div', {
	    staticClass: "form-radio"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.team.available_payment_methods), function(item) {
	    return _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "form-check",
	      class: {
	        active: _vm.currentPaymentMethod === item
	      },
	      on: {
	        "click": function($event) {
	          _vm.currentPaymentMethod = item
	        }
	      }
	    }, [_c('label', {
	      staticClass: "form-check-label custom-control custom-radio"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.currentPaymentMethod),
	        expression: "currentPaymentMethod"
	      }],
	      staticClass: "form-check-input custom-control-input",
	      attrs: {
	        "id": "radio1",
	        "name": "radio",
	        "type": "radio"
	      },
	      domProps: {
	        "value": item,
	        "checked": _vm._q(_vm.currentPaymentMethod, item)
	      },
	      on: {
	        "click": function($event) {
	          _vm.currentPaymentMethod = item
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "custom-control-indicator"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "custom-control-description"
	    }, [(item === 'omise') ? _c('img', {
	      attrs: {
	        "src": "https://assets.omise.co/assets/omise-logo-a86debcb438f41aa395a868ff43fe67090e277d44dea080cd2d51baec405ea71.svg",
	        "height": "24",
	        "alt": "PayPal Logo"
	      }
	    }) : _vm._e(), _vm._v(" "), (item === 'paypal') ? _c('img', {
	      attrs: {
	        "src": "https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-150px.png",
	        "border": "0",
	        "alt": "PayPal Logo",
	        "height": "24"
	      }
	    }) : _vm._e()])])])])
	  }))])]) : _vm._e(), _vm._v(" "), (_vm.showOmisePayment && _vm.currentPaymentMethod === 'omise') ? _c('BillingCreditOmise', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.billingCreditLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showPayPalPayment && _vm.currentPaymentMethod === 'paypal') ? _c('BillingCreditPayPal', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.billingCreditLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.showOmisePayment && !_vm.showPayPalPayment) ? _c('BillingCreditDirect') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showBillingInformation) ? _c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('Billing-information', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.billingInformationLoadChanged
	    }
	  })], 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ },
/* 526 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.currentTerminateMode) ? _c('div', {
	    staticClass: "bg-blue-grey-100 p-30"
	  }, [_c('h5', {
	    staticClass: "title"
	  }, [_vm._v("Do you want to Terminate " + _vm._s(_vm.team.name) + " Team?")]), _vm._v(" "), _c('p', [_vm._v("After Terminated, " + _vm._s(_vm.team.name) + " Team will not be able to access ByteArk Account and use any service.")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger btn-outline",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.onSubmit(true)
	      }
	    }
	  }, [_vm._v("\n      Terminate team"), _c('span', {
	    staticClass: "glyphicon"
	  })])]) : _c('div', {
	    staticClass: "bg-red-600 p-30"
	  }, [_c('h5', {
	    staticClass: "title white"
	  }, [_vm._v(_vm._s(_vm.team.name) + " is currently Terminated , Do you want to Activate " + _vm._s(_vm.team.name) + " Team?")]), _vm._v(" "), _c('p', {
	    staticClass: "white"
	  }, [_vm._v("After Activated, " + _vm._s(_vm.team.name) + " Team will be able to access ByteArk Account and use any service.")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default white btn-outline",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.onSubmit(false)
	      }
	    }
	  }, [_vm._v("\n      Activate team"), _c('span', {
	    staticClass: "glyphicon"
	  })])])])
	},staticRenderFns: []}

/***/ },
/* 527 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_vm._v(_vm._s(_vm.team.name))]), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_vm._v("Settings")])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Rename")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-section"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "username"
	    }
	  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.team.name),
	      expression: "team.name"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "name",
	      "placeholder": "Name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.team.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.team.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('namespace')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v("Namespace")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.team.namespace),
	      expression: "team.namespace"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "namespace",
	      "placeholder": "Name space",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.team.namespace)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.team.namespace = $event.target.value
	      }
	    }
	  })])], 1)])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" Submit\n          ")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-header-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon md-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "text hidden-sm-down"
	  }, [_vm._v(" Add User")])])])
	}]}

/***/ },
/* 528 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-block"
	  }, [_c('h4', {
	    staticClass: "card-title"
	  }, [_vm._v("\n    Redeem Voucher\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "bg-blue-grey-100 p-30"
	  }, [_c('p', [_vm._v("If you have a redeem voucher code, please enter it below to receive your credit.")]), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmitRedeemVoucher($event)
	      }
	    }
	  }, [_c('form-group', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.voucherCode),
	      expression: "voucherCode"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off",
	      "placeholder": "Voucher Code"
	    },
	    domProps: {
	      "value": _vm._s(_vm.voucherCode)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.voucherCode = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Redeem")])], 1)])])])])
	},staticRenderFns: []}

/***/ },
/* 529 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "paypal-button"
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 530 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-login-v3 layout-full th"
	  }, [_c('div', {
	    staticClass: "page vertical-align text-xs-center"
	  }, [_c('div', {
	    staticClass: "page-content vertical-align-middle"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.$t('forgot.action.forgotPassword')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('forgot.labels.prefixResetPassword')) + " "), _c('span', {
	    staticClass: "blue-600 text-uppercase"
	  }, [_vm._v(_vm._s(_vm.$route.params.namespace))]), _vm._v(" " + _vm._s(_vm.$t('forgot.labels.subfixResetPassword')))]), _vm._v(" "), _c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "alert-dismissible",
	      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successResponse) ? 'wb-check' : 'wb-close'))
	    }
	  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), (!this.successResponse) ? _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "user-form"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('email')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "id": "email",
	      "placeholder": _vm.$t('account.labels.email')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-primary btn-lg btn-submit",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('forgot.action.sendRequest')))])], 1)]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.$t('action.backTo')) + " "), _c('u', [_c('router-link', {
	    staticClass: "btn btn-link btn-register",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/login")
	    }
	  }, [_vm._v(_vm._s(_vm.$t('action.login')))])], 1)])], 1)]), _vm._v(" "), _vm._m(1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brand"
	  }, [_c('img', {
	    staticClass: "brand-img",
	    attrs: {
	      "src": "/static/images/byteark-loading-white.png",
	      "alt": "logo account",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "brand-text font-size-24 grey-100"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "page-copyright page-copyright-inverse"
	  }, [_c('p', [_vm._v("Service by ByteArk.com")])])
	}]}

/***/ },
/* 531 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "addcreditSection"
	    }
	  }, [_c('div', {
	    staticClass: "content bg-blue-grey-100 p-30"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 col-xs-12 m-b-10"
	  }, [_c('p', {
	    staticClass: "font-size-16"
	  }, [_vm._v(_vm._s(_vm.$t("billing.addcredit.labels.textGuide")))])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-xs-12"
	  }, [_c('form-group', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentPrice),
	      expression: "currentPrice"
	    }],
	    staticClass: "form-control form-control-lg",
	    on: {
	      "change": function($event) {
	        _vm.currentPrice = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.priceList), function(item, index) {
	    return _c('option', {
	      domProps: {
	        "value": item
	      }
	    }, [_vm._v(_vm._s(item.key) + "\n            "), (item.key !== 'Custom') ? _c('span', [_vm._v(_vm._s(_vm.$t("billing.currencies.thb")))]) : _vm._e()])
	  }))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.currentPrice.key === 'Custom') ? _c('div', {
	    staticClass: "col-md-8 col-xs-12"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('customPrice')
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentPrice.value),
	      expression: "currentPrice.value"
	    }],
	    staticClass: "form-control form-control-lg",
	    attrs: {
	      "type": "number",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.currentPrice.value)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentPrice.value = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon"
	  }, [_vm._v(_vm._s(_vm.$t("billing.currencies.thb")))])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 col-xs-12"
	  }, [_c('div', {
	    staticClass: "help-guide grey-500"
	  }, [_c('span', {
	    staticClass: "red-600"
	  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t("billing.addcredit.labels.remark")) + "\n        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-xs-12 m-t-15"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-block btn-lg text-uppercase",
	    attrs: {
	      "disabled": _vm.formErrors.first('customPrice'),
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onPayButtonClick
	    }
	  }, [_c('i', {
	    staticClass: "icon md-lock",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t("billing.action.pay")) + "\n        ")])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('modal', {
	    ref: "paymentInformationFormModal",
	    staticClass: "modal-primary"
	  }, [_c('h4', {
	    staticClass: "modal-title",
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.$t("billing.labels.paymentInformation")))]), _vm._v(" "), _c('payment-information-form', {
	    ref: "paymentInformationForm",
	    attrs: {
	      "team": _vm.team,
	      "credit": _vm.selectedCredit
	    },
	    on: {
	      "complete": _vm.onPaymentInformationFormComplete,
	      "cancel": _vm.onPaymentInformationFormCancel
	    },
	    slot: "body"
	  })], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-xs-12 m-t-20"
	  }, [_c('div', {
	    staticClass: "payment-logos"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/omise.png",
	      "alt": "Omise"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "pull-xs-right",
	    attrs: {
	      "src": "/static/images/creditcard.png",
	      "alt": "Mc visa acceptance"
	    }
	  })])])])
	}]}

/***/ },
/* 532 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app-chrome",
	    class: {
	      'suspended': _vm.isTeamSuspend, 'th': _vm.isLangTH
	    }
	  }, [(_vm.isLoadingCurrentUser) ? _c('loading-indicator') : _c('div', [(_vm.isTeamSuspend) ? _c('div', {
	    staticClass: "alert alert-social alert-linkedin alert-suspend"
	  }, [_c('div', {
	    staticClass: "container-fulid"
	  }, [_c('h4', [_c('i', {
	    staticClass: "icon md-notifications",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Your Account has been suspend.\n        "), (_vm.currentUser.team.suspend.suspend_reason) ? _c('span', {
	    staticClass: "font-size-14 p-l-10"
	  }, [_vm._v(_vm._s(_vm.currentUser.team.suspend.suspend_reason))]) : _c('span', {
	    staticClass: "font-size-14 p-l-10"
	  }, [_vm._v("Your credit isn't enough. Please add your credit now")]), _vm._v(" "), (!_vm.currentUser.team.suspend.suspend_reason) ? _c('router-link', {
	    staticClass: "btn btn-sm btn-default",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/billing#addcreditSection"),
	      "alt": "Add credit"
	    }
	  }, [_vm._v(" Add credit\n         ")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('nav-bar'), _vm._v(" "), (_vm.isUnauthorize) ? _c('page403') : _c('router-view'), _vm._v(" "), _c('footer', {
	    staticClass: "site-footer"
	  }, [_c('div', {
	    staticClass: "site-footer-legal"
	  }, [_vm._v("© 2017 "), _c('a', {
	    attrs: {
	      "href": "http://byteark.com"
	    }
	  }, [_vm._v("ByteArk")]), _vm._v(" All Rights Reserved. ")])])], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 533 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-block bg-grey-800"
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }), _vm._v(" "), (_vm.isLoading && !_vm.team) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]) : _c('div', [_c('discount-package', {
	    attrs: {
	      "team": _vm.team
	    }
	  }), _vm._v(" "), _c('pricing-plan', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.pricingPlanLoadChanged
	    }
	  }), _vm._v(" "), _c('pay-plan', {
	    attrs: {
	      "team": _vm.team
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 534 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-block"
	  }, [(_vm.showTitle) ? _c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n    " + _vm._s(_vm.$t("menu.clientUsageHistory")) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "p-t-15"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-2 col-md-3"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('month-list', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentMonth),
	      expression: "currentMonth"
	    }],
	    attrs: {
	      "teamData": _vm.team
	    },
	    domProps: {
	      "value": (_vm.currentMonth)
	    },
	    on: {
	      "input": [function($event) {
	        _vm.currentMonth = $event
	      }, function($event) {
	        _vm.fetchUsages(_vm.currentMonth)
	      }]
	    }
	  })], 1)])])]), _vm._v(" "), (_vm.teams.length > 0) ? _c('div', {
	    staticClass: "table-hover table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-hover"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "w-50"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "w-200"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.team")))]), _vm._v(" "), _c('th', {
	    staticClass: "w-150"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.invoiceNumber")))]), _vm._v(" "), _c('th', {
	    staticClass: "w-100 usage-column"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.usage")))]), _vm._v(" "), _c('th', {
	    staticClass: "w-250"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.retailPrice")))]), _vm._v(" "), _c('th', {
	    staticClass: "w-250"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.netPrice")))]), _vm._v(" "), _c('th', {
	    staticClass: "w-100"
	  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.type")))]), _vm._v(" "), _c('th', {
	    staticClass: "w-100 text-xs-center"
	  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.reseller")))]), _vm._v(" "), _c('th', {
	    staticClass: "hidden-sm-down w-100"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "hidden-sm-down w-100"
	  })])]), _vm._v(" "), _vm._l((_vm.teams), function(bill, billIndex) {
	    return _c('tbody', {
	      staticClass: "table-section"
	    }, [_c('tr', {
	      staticClass: "parent",
	      class: {
	        active: _vm.step === billIndex, 'a-link': bill.items.length > 0
	      },
	      on: {
	        "click": function($event) {
	          _vm.showChild(billIndex)
	        }
	      }
	    }, [_c('td', {
	      staticClass: "w-50 text-xs-center"
	    }, [(bill.items.length) ? _c('span', [(_vm.step === billIndex) ? _c('i', {
	      staticClass: "icon md-chevron-up"
	    }) : _c('i', {
	      staticClass: "icon md-chevron-down"
	    })]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "w-200 font-weight-medium"
	    }, [_c('router-link', {
	      staticClass: "btn btn-link",
	      attrs: {
	        "to": ("/" + (_vm.$route.params.namespace) + "/admin/teams/" + (bill.client_team.namespace) + "/billings"),
	        "alt": "Manage billing"
	      }
	    }, [_vm._v(_vm._s(bill.client_team.name) + "\n                ")])], 1), _vm._v(" "), _c('td', {
	      staticClass: "w-100 font-weight-medium"
	    }, [_vm._v("\n                " + _vm._s(bill.invoice_number ? bill.invoice_number : '-') + "\n              ")]), _vm._v(" "), _c('td', {
	      staticClass: "w-150 usage-column"
	    }, [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bill.human_total_cost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))]), _vm._v(" "), _c('td', [(bill.client_team.pay_plan === 'postpaid') ? _c('span', {
	      staticClass: "red-600"
	    }, [_vm._v(_vm._s(_vm.$t("payPlan.labels.postPaid")))]) : _c('span', [_vm._v(_vm._s(_vm.$t("payPlan.labels.prePaid")))])]), _vm._v(" "), _c('td', {
	      staticClass: "text-xs-center"
	    }, [(bill.client_team.has_reseller) ? _c('router-link', {
	      staticClass: "btn btn-link",
	      attrs: {
	        "to": ("/" + (_vm.$route.params.namespace) + "/admin/teams/" + (bill.client_team.reseller.namespace) + "/billings"),
	        "alt": "Reseller"
	      }
	    }, [_vm._v(_vm._s(bill.client_team.reseller.name) + "\n                ")]) : _c('span', {
	      staticClass: "text-center"
	    }, [_vm._v("-")])], 1), _vm._v(" "), _c('td', {
	      staticClass: "w-150 hidden-sm-down"
	    }, [(bill.invoice_url) ? _c('a', {
	      staticClass: "btn btn-primary",
	      attrs: {
	        "href": ("" + (bill.invoice_url)),
	        "download": ""
	      }
	    }, [_vm._v("\n                  Invoice\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "w-100 hidden-sm-down"
	    }, [(_vm.showReportDownload(bill.month)) ? _c('router-link', {
	      staticClass: "btn btn-primary",
	      attrs: {
	        "to": _vm.urlUsageReport(bill.month),
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.action.usageReport")))]) : _vm._e()], 1)]), _vm._v(" "), _vm._l((bill.items), function(item, itemIndex) {
	      return _c('tr', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (_vm.step === billIndex),
	          expression: "step === billIndex"
	        }],
	        staticClass: "child bg-grey-100 grey-700"
	      }, [_c('td', {
	        staticClass: "w-50"
	      }), _vm._v(" "), _c('td', {
	        staticClass: "w-200"
	      }, [_vm._v("\n               " + _vm._s(item.description) + "\n              ")]), _vm._v(" "), _c('td', {
	        staticClass: "w-100"
	      }), _vm._v(" "), _c('td', {
	        staticClass: "w-100 hidden-sm-down"
	      }, [_vm._v("\n                " + _vm._s(item.human_data_usage) + "\n              ")]), _vm._v(" "), _c('td', {
	        staticClass: "w-150 hidden-sm-down"
	      }, [_vm._v("\n                " + _vm._s(item.human_retail_price) + " " + _vm._s(_vm.$t("billing.currencies.thb")) + "\n              ")]), _vm._v(" "), _c('td', {
	        staticClass: "w-150 hidden-sm-down"
	      }, [_vm._v("\n                " + _vm._s(item.human_cost) + " " + _vm._s(_vm.$t("billing.currencies.thb")) + "\n              ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
	    })], 2)
	  })], 2)]) : _c('div', {
	    staticClass: "alert alert-primary alert-dismissible"
	  }, [_vm._v("\n        There is no client usage history on this month.\n      ")])])])])
	},staticRenderFns: []}

/***/ },
/* 535 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('chrome')
	},staticRenderFns: []}

/***/ },
/* 536 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ("form-group " + _vm.formGroupClass + " " + ((_vm.error) ? 'has-danger' : ''))
	  }, [_vm._t("default"), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.error),
	      expression: "error"
	    }],
	    class: ("help-block red-600 " + _vm.errorTextClass)
	  }, [_vm._v(_vm._s(_vm.error))])], 2)
	},staticRenderFns: []}

/***/ },
/* 537 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-login-v3 layout-full"
	  }, [_c('div', {
	    staticClass: "page vertical-align text-xs-center"
	  }, [_c('div', {
	    staticClass: "page-content vertical-align-middle"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('div', [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.$t('account.activate.labels.activateYourAccount')))]), _vm._v(" "), (_vm.status == 'link-invalid') ? _c('div', {
	    staticClass: "token-invalid"
	  }, [_c('alert', {
	    attrs: {
	      "alertClass": "alert-dismissible",
	      "type": "danger"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('activate.verifyToken.response.linkInvalid')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.status == 'link-expried') ? _c('div', {
	    staticClass: "token-expried"
	  }, [_c('alert', {
	    attrs: {
	      "alertClass": "alert-dismissible",
	      "type": "danger"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('activate.verifyToken.response.linkExpired')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.status == 'success') ? _c('div', [_c('alert', {
	    attrs: {
	      "alertClass": "alert-dismissible",
	      "type": "success"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('activate.verifyToken.response.success')))])]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-block btn-link btn-lg btn-submit",
	    attrs: {
	      "to": ("/" + (this.$route.params.namespace) + "/login")
	    }
	  }, [_vm._v(_vm._s(_vm.$t('account.activate.action.login')))])], 1) : _vm._e()])], 1)]), _vm._v(" "), _vm._m(1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brand"
	  }, [_c('img', {
	    staticClass: "brand-img",
	    attrs: {
	      "src": "/static/images/byteark-loading-white.png",
	      "alt": "logo account",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "brand-text font-size-24 grey-100"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "page-copyright page-copyright-inverse"
	  }, [_c('p', [_vm._v("Service by ByteArk.com")])])
	}]}

/***/ },
/* 538 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 539 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": "danger",
	      "iconClass": "wb-close"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.errorResponse))])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-xs-12 col-md-6",
	      "error": _vm.formErrors.first('first_name')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.firstname")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.first_name),
	      expression: "newBillingInformation.first_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.first_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.first_name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "formGroupClass": "col-xs-12 col-md-6",
	      "error": _vm.formErrors.first('last_name')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.lastname")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.last_name),
	      expression: "newBillingInformation.last_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.last_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.last_name = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-md-12",
	      "error": _vm.formErrors.first('company_name')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.companyName")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.company_name),
	      expression: "newBillingInformation.company_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.company_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.company_name = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-md-12",
	      "error": _vm.formErrors.first('tax_id')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.taxID")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.tax_id),
	      expression: "newBillingInformation.tax_id"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off",
	      "maxlength": "13"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.tax_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.tax_id = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-md-12",
	      "error": _vm.formErrors.first('address1')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.addressLine1")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.address1),
	      expression: "newBillingInformation.address1"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.address1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.address1 = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-md-12",
	      "error": _vm.formErrors.first('address2')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.addressLine2"))), _c('small', {
	    staticClass: "required grey-500"
	  }, [_vm._v("( Optional )")])]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.address2),
	      expression: "newBillingInformation.address2"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.address2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.address2 = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-xs-12 col-md-6",
	      "error": _vm.formErrors.first('city')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.city")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.city),
	      expression: "newBillingInformation.city"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.city)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.city = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "formGroupClass": "col-xs-12 col-md-6",
	      "error": _vm.formErrors.first('state')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.state")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.state),
	      expression: "newBillingInformation.state"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.state)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.state = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-xs-12 col-md-6",
	      "error": _vm.formErrors.first('zipcode')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.zipCode")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.zipcode),
	      expression: "newBillingInformation.zipcode"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.zipcode)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.zipcode = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "formGroupClass": "col-xs-12 col-md-6",
	      "error": _vm.formErrors.first('country')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.country")))]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.country),
	      expression: "newBillingInformation.country"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.newBillingInformation.country = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "TH"
	    }
	  }, [_vm._v("Thailand")])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "col-xs-12 col-md-6",
	      "error": _vm.formErrors.first('contact_phone')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.billingContactPhone")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.contact_phone),
	      expression: "newBillingInformation.contact_phone"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "tel",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.contact_phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.contact_phone = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "formGroupClass": "col-xs-12 col-md-6",
	      "error": _vm.formErrors.first('contact_email')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.billingEmail")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBillingInformation.contact_email),
	      expression: "newBillingInformation.contact_email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newBillingInformation.contact_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newBillingInformation.contact_email = $event.target.value
	      }
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 col-xs-12",
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_c('loading-button', {
	    staticClass: "text-capitalize m-r-10",
	    attrs: {
	      "isSubmiting": _vm.isSubmiting
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t("billing.information.action.saveDetails")) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default text-capitalize",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onCancelButtonClick
	    }
	  }, [_vm._v("\n        Cancel\n      ")])], 1)])], 1)
	},staticRenderFns: []}

/***/ },
/* 540 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_vm._m(0), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Add-ons Cost")]), _vm._v(" "), _c('div', {
	    staticClass: "page-header-actions"
	  }, [_c('div', {
	    staticClass: "row no-space w-120"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "counter"
	  }, [_c('div', {
	    staticClass: "counter-label p-t-5"
	  }, [_vm._v("Total Add-ons")]), _vm._v(" "), _c('span', {
	    staticClass: "counter-number font-weight-medium"
	  }, [_vm._v(_vm._s(_vm.total_addon))])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : (_vm.isError) ? _c('div') : _c('div', [_c('div', {
	    staticClass: "p-b-15"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-2 col-md-6"
	  }, [_c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/admin/addon-cost/create")
	    }
	  }, [_c('i', {
	    staticClass: "icon md-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "text hidden-sm-down"
	  }, [_vm._v(" Create ")])])], 1)])]), _vm._v(" "), (_vm.addons.length > 0) ? _c('div', {
	    staticClass: "table-striped table-hover table-responsive"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cell-30"
	  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-300"
	  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-300"
	  }, [_vm._v("Team")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-100"
	  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-100"
	  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-200"
	  }, [_vm._v("Use on Billing Monthly")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-50"
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.addons), function(item, index) {
	    return _c('tr', [_c('td', {
	      staticClass: "cell-30"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
	      staticClass: "cell-300"
	    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', {
	      staticClass: "cell-300"
	    }, [_c('router-link', {
	      attrs: {
	        "to": ("/" + (_vm.$route.params.namespace) + "/admin/teams/" + (item.team.namespace) + "/billings")
	      }
	    }, [_vm._v("\n                      " + _vm._s(item.team.namespace) + "\n                    ")])], 1), _vm._v(" "), _c('td', {
	      staticClass: "cell-100 text-nowrap"
	    }, [(!item.is_deactivate) ? _c('span', {
	      staticClass: "tag tag-success"
	    }, [_vm._v("Available")]) : _c('span', {
	      staticClass: "tag tag-danger"
	    }, [_vm._v("Deactivate")])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-100"
	    }, [(item.type == 'recurring') ? _c('span', [_vm._v("Recurring")]) : _c('span', [_vm._v("One Time")])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-200"
	    }, [_c('span', [_vm._v(_vm._s(_vm.getDate(item.started_at)))]), _vm._v(" "), (item.terminated_at) ? _c('span', [_vm._v("- " + _vm._s(_vm.getDate(item.terminated_at)))]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "cell-50 text-nowrap"
	    }, [(!item.is_deactivate) ? _c('button', {
	      staticClass: "btn btn-sm btn-default",
	      attrs: {
	        "alt": "Deactivate"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          $event.preventDefault();
	          _vm.changeItem(item, index)
	        }
	      }
	    }, [_vm._v("Deactive\n                    ")]) : _vm._e()])])
	  }))])]) : _c('div', {
	    staticClass: "alert alert-primary alert-dismissible"
	  }, [_vm._v("\n            There is no Add-ons.\n          ")])]), _vm._v(" "), _c('paginate', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm.pagination.total_page > 1)),
	      expression: "(pagination.total_page > 1)"
	    }],
	    attrs: {
	      "pageCount": _vm.pagination.total_page,
	      "prevText": '«',
	      "nextText": '»',
	      "clickHandler": _vm.changePage,
	      "containerClass": 'pagination pull-right',
	      "pageClass": 'page-item',
	      "pageLinkClass": 'page-link',
	      "prevClass": 'page-item',
	      "prevLinkClass": 'page-link',
	      "nextClass": 'page-item',
	      "nextLinkClass": 'page-link'
	    }
	  })], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_vm._v("Admin")])])
	}]}

/***/ },
/* 541 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app-chrome"
	  }, [(_vm.isLoadingCurrentUser) ? _c('loading-indicator') : _c('div', [(_vm.isUnauthorize) ? _c('page403') : _c('div', {
	    staticClass: "page-content container"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h4', [_c('img', {
	    staticClass: "margin-right-10",
	    attrs: {
	      "src": "/static/images/byteark-logo-blue.png",
	      "title": "ByteArk",
	      "height": "60"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-xs-right"
	  }, [_c('h3', {
	    staticClass: "m-t-20 m-b-0"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.action.usageReport")) + " " + _vm._s(this.currentMonth))]), _vm._v(" "), _c('p', {
	    staticClass: "font-size-18"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.dateIssued")) + " : " + _vm._s(this.dateIssued))]), _vm._v(" "), _c('p', {
	    staticClass: "font-size-16"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.team")) + ": " + _vm._s(_vm.team ? _vm.team.name : ''))]), _vm._v(" "), (_vm.team ? _vm.team.reseller_id != 0 : false) ? _c('p', {
	    staticClass: "font-size-16"
	  }, [_vm._v(" Reseller : " + _vm._s(_vm.team.reseller.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "page-invoice-table table-responsive m-t-60"
	  }, [_c('table', {
	    staticClass: "table table-hover text-right"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("statement.labels.statement")))]), _vm._v(" "), _c('th', {
	    staticClass: "text-xs-right"
	  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.usage")))]), _vm._v(" "), (_vm.usages.human_total_cost) ? _c('th', {
	    staticClass: "text-xs-right"
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.amount")))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.usages.items), function(item, index) {
	    return _c('tr', [_c('td', {
	      staticClass: "text-xs-left"
	    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', {
	      staticClass: "text-xs-right"
	    }, [_vm._v(_vm._s(item.human_data_usage))]), _vm._v(" "), (item.human_cost) ? _c('td', {
	      staticClass: "text-xs-right"
	    }, [_vm._v(_vm._s(item.human_cost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))]) : _vm._e()])
	  }))])]), _vm._v(" "), (_vm.usages.human_total_cost) ? _c('div', {
	    staticClass: "text-xs-right clearfix"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('p', {
	    staticClass: "page-invoice-amount font-size-18"
	  }, [_vm._v(_vm._s(_vm.$t("text.total")) + " :\n                "), _c('span', [_vm._v(_vm._s(_vm.usages.human_total_cost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])]) : _vm._e(), _vm._v(" "), (_vm.usages.human_total_cost && _vm.usages.charged_balance_transaction) ? _c('div', {
	    staticClass: "row m-t-35"
	  }, [_c('div', {
	    staticClass: "col-md-4 offset-md-8"
	  }, [_c('div', {
	    staticClass: "text-xs-right clearfix"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('p', {
	    staticClass: "page-invoice-amount m-b-5"
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.credit")) + " (" + _vm._s(this.dateIssued) + "):\n                    "), _c('span', [_vm._v(_vm._s(_vm.usages.charged_balance_transaction ? _vm.usages.charged_balance_transaction.credit + _vm.usages.charged_balance_transaction.balance : '') + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "text-xs-right clearfix"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('p', {
	    staticClass: "page-invoice-amount m-b-5"
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.charge")) + ":\n                    "), _c('span', [_vm._v("-" + _vm._s(_vm.usages.charged_balance_transaction ? _vm.usages.charged_balance_transaction.credit : '') + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "text-xs-right clearfix"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('p', {
	    staticClass: "page-invoice-amount font-size-18"
	  }, [_vm._v(_vm._s(_vm.$t("statement.labels.remaining")) + " :\n                    "), _c('span', [_vm._v(_vm._s(_vm.usages.charged_balance_transaction ? _vm.usages.charged_balance_transaction.balance : '') + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "text-xs-right"
	  }, [(!_vm.isPrinting) ? _c('button', {
	    staticClass: "btn btn-animate btn-animate-side btn-default btn-outline",
	    attrs: {
	      "type": "button",
	      "onclick": "javascript:window.print(); "
	    }
	  }, [_c('span', [_c('i', {
	    staticClass: "icon md-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t("action.print")))])]) : _vm._e()])])])])], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 542 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : (_vm.isError) ? _c('div') : _c('div', [_c('div', {
	    staticClass: "p-b-15"
	  }, [_c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.filterItems($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-3 col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Month")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentMonth),
	      expression: "currentMonth"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.currentMonth = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Show all")]), _vm._v(" "), _vm._l((_vm.monthList), function(month, index) {
	    return _c('option', {
	      domProps: {
	        "value": month
	      }
	    }, [_vm._v(_vm._s(month))])
	  })], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-3 col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Source Type")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentSourceType),
	      expression: "currentSourceType"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.currentSourceType = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Show all")]), _vm._v(" "), _vm._l((_vm.sourceTypeList), function(value, key, index) {
	    return _c('option', {
	      domProps: {
	        "value": key
	      }
	    }, [_vm._v(_vm._s(value))])
	  })], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-3 col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Credit Type")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentCreditType),
	      expression: "currentCreditType"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.currentCreditType = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Show all")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "add"
	    }
	  }, [_vm._v("Add")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "deduct"
	    }
	  }, [_vm._v("Deduct")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-3 col-md-2"
	  }, [_c('button', {
	    staticClass: "btn btn-success m-t-35",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" Filter\n                  ")])])])])]), _vm._v(" "), (_vm.total_transaction) ? _c('div', {
	    staticClass: "table-striped table-hover table-responsive"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cell-120"
	  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-120",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v("Order Number")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-120",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v("Invoice Number")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-120",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v("Receipt Number")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-120",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v("Team")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-250",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-100",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
	    staticClass: "cell-100 text-xs-right",
	    attrs: {
	      "scope": "col"
	    }
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions), function(item, index) {
	    return _c('tr', {
	      attrs: {
	        "id": item.id
	      }
	    }, [_c('td', {
	      staticClass: "cell-120"
	    }, [_c('span', {
	      attrs: {
	        "title": _vm.getFullHistoryDate(item.created_at)
	      }
	    }, [_vm._v(_vm._s(_vm.getFullHistoryDate(item.created_at)))])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-120"
	    }, [(item.statement && item.statement.order_number) ? _c('router-link', {
	      staticClass: "btn btn-link",
	      attrs: {
	        "to": _vm.urlOrderNumberReport(item)
	      }
	    }, [_vm._v(" " + _vm._s(item.statement.order_number) + " ")]) : _c('span', {
	      staticClass: "text-xs-center"
	    }, [_vm._v("-")])], 1), _vm._v(" "), _c('td', {
	      staticClass: "cell-120"
	    }, [(item.statement && item.statement.invoice_number) ? _c('span', [_vm._v(_vm._s(item.statement.invoice_number))]) : _c('span', {
	      staticClass: "text-xs-center"
	    }, [_vm._v("-")])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-120"
	    }, [(item.statement && item.statement.receipt_number) ? _c('span', [_vm._v(_vm._s(item.statement.receipt_number))]) : _c('span', {
	      staticClass: "text-xs-center"
	    }, [_vm._v("-")])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-120"
	    }, [_c('router-link', {
	      staticClass: "btn btn-link",
	      attrs: {
	        "to": ("/" + (_vm.$route.params.namespace) + "/admin/teams/" + (item.team.namespace) + "/billings"),
	        "alt": "Manage billing"
	      }
	    }, [_vm._v(_vm._s(item.team.name) + "\n                    ")])], 1), _vm._v(" "), _c('td', {
	      staticClass: "cell-250"
	    }, [_c('p', {
	      staticClass: "m-b-0"
	    }, [_vm._v(_vm._s(item.source))]), _vm._v(" "), _c('p', {
	      staticClass: "m-b-0 font-size-12 grey-500"
	    }, [_vm._v(_vm._s(item.description) + " "), (item.note) ? _c('span', [_vm._v(_vm._s(item.note))]) : _vm._e()])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-100"
	    }, [(item.credit > 0) ? _c('span', {
	      staticClass: "green-600"
	    }, [_vm._v(_vm._s(item.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")))]) : (item.credit < 0) ? _c('span', {
	      staticClass: "red-600"
	    }, [_vm._v("\n                      " + _vm._s(item.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")) + "\n                    ")]) : _c('span', [_vm._v(_vm._s(item.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-100 text-xs-right"
	    }, [(item.statement && item.statement.download_url) ? _c('a', {
	      staticClass: "btn btn-sm btn-icon btn-default",
	      attrs: {
	        "href": ("" + (item.statement.download_url)),
	        "download": ""
	      }
	    }, [_vm._v("\n                      Download\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.showUsageReport(item.statement)) ? _c('router-link', {
	      staticClass: "btn btn-sm btn-icon btn-default",
	      attrs: {
	        "to": _vm.urlUsageReport(item)
	      }
	    }, [_vm._v(" Usage Report\n                    ")]) : _vm._e()], 1)])
	  }))])]) : _c('div', {
	    staticClass: "alert alert-primary alert-dismissible"
	  }, [_vm._v("\n            There is no transaction history.\n          ")])]), _vm._v(" "), _c('paginate', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm.pagination.total_page > 1)),
	      expression: "(pagination.total_page > 1)"
	    }],
	    attrs: {
	      "pageCount": _vm.pagination.total_page,
	      "prevText": '«',
	      "nextText": '»',
	      "clickHandler": _vm.changePage,
	      "containerClass": 'pagination pull-right',
	      "pageClass": 'page-item',
	      "pageLinkClass": 'page-link',
	      "prevClass": 'page-item',
	      "prevLinkClass": 'page-link',
	      "nextClass": 'page-item',
	      "nextLinkClass": 'page-link'
	    }
	  })], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_vm._v("Admin")])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Credit Transactions")])])
	}]}

/***/ },
/* 543 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [(_vm.showPricingPlanForm) ? _c('div', {
	    staticClass: "bg-blue-grey-100 admin-package-box p-30 font-size-14 clearfix"
	  }, [_c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmitPricingPlanForm($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('form-group', {
	    attrs: {
	      "formGroupClass": "form-group col-md-12",
	      "error": _vm.formErrors.first('pricingPlan')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label",
	    attrs: {
	      "for": "role"
	    }
	  }, [_vm._v("Change Pricing Plan")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentPricingPlan.alias),
	      expression: "currentPricingPlan.alias"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "pricingPlan"
	    },
	    on: {
	      "change": function($event) {
	        _vm.currentPricingPlan.alias = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.pricingPlanList), function(pricingPlan, index) {
	    return _c('option', {
	      domProps: {
	        "value": pricingPlan.alias
	      }
	    }, [_vm._v("\n              " + _vm._s(pricingPlan.name) + "\n            ")])
	  }))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "btn btn-link pull-xs-right",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.cancelPricingPlanForm
	    }
	  }, [_vm._v("\n            Cancel\n          ")])])])])]) : _c('div', {
	    staticClass: "bg-blue-grey-100 admin-package-box  p-30 font-size-14"
	  }, [_c('div', {
	    staticClass: "counter counter-md text-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-label text-ca m-b-5"
	  }, [_vm._v("Pricing Plan Setting")]), _vm._v(" "), _c('span', {
	    staticClass: "counter-number"
	  }, [_vm._v(_vm._s(_vm.currentPricingPlan.name) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label m-b-5 m-t-20"
	  }, [_vm._v("Click for more detail "), _c('router-link', {
	    attrs: {
	      "to": "/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Pricing")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "counter-label text-uppercase m-b-5 m-t-20"
	  }, [(!_vm.team.has_reseller) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.togglePricingPlanForm
	    }
	  }, [_vm._v("Change plan\n        ")]) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "btn btn-success pull-xs-left",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("\n            Update Plan\n          ")])])
	}]}

/***/ },
/* 544 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-block"
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n    Manual Credit\n  ")]), _vm._v(" "), _c('p', {
	    staticClass: "card-text"
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "bg-blue-grey-100 p-30"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmitManualCredit($event)
	      }
	    }
	  }, [_c('form-group', [_c('label', {
	    staticClass: "form-control-label form-radio"
	  }, [_vm._v("Choose Type")]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary radio-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.transactionType),
	      expression: "transactionType"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "deposit",
	      "value": "deposit"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.transactionType, "deposit")
	    },
	    on: {
	      "click": function($event) {
	        _vm.transactionType = "deposit"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "payplan"
	    }
	  }, [_vm._v("Add")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary radio-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.transactionType),
	      expression: "transactionType"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "deduct",
	      "value": "deduct"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.transactionType, "deduct")
	    },
	    on: {
	      "click": function($event) {
	        _vm.transactionType = "deduct"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "payplan"
	    }
	  }, [_vm._v("Deduct")])])]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('amount')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label",
	    attrs: {
	      "for": "amount"
	    }
	  }, [_vm._v("Amount (THB)")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.amount),
	      expression: "amount"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.amount = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('description')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label",
	    attrs: {
	      "for": "description"
	    }
	  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.description),
	      expression: "description"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.description = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', [_c('label', {
	    staticClass: "form-control-label",
	    attrs: {
	      "for": "amount"
	    }
	  }, [_vm._v("Note for admin (Not show to user)")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.note),
	      expression: "note"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.note)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.note = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" Submit\n            ")])], 1)], 1)])]), _vm._v(" "), _c('p')])
	},staticRenderFns: []}

/***/ },
/* 545 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-block"
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n    " + _vm._s(_vm.$t("monthlyUsageHistory.labels.monthlyUsageHistory")) + "\n  ")]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]) : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "p-t-15"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-2 col-md-3"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentMonth),
	      expression: "currentMonth"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": [function($event) {
	        _vm.currentMonth = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, function($event) {
	        _vm.onChange()
	      }]
	    }
	  }, _vm._l((_vm.monthList), function(month, index) {
	    return _c('option', {
	      domProps: {
	        "value": month
	      }
	    }, [_vm._v(_vm._s(month))])
	  }))])]), _vm._v(" "), (_vm.showReportDownload) ? _c('div', {
	    staticClass: "col-xs-2 col-md-3"
	  }, [_c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": _vm.urlUsageReport(),
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("monthlyUsageHistory.action.report")))])], 1) : _vm._e()])]), _vm._v(" "), (_vm.haveUsageItems) ? _c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.usages.items), function(item, index) {
	    return _c('div', {
	      staticClass: "col-md-4 col-xs-12"
	    }, [_c('div', {
	      staticClass: "bg-blue-grey-100 p-35 clearfix m-b-30"
	    }, [_c('div', {
	      staticClass: "pull-xs-left white m-t-20"
	    }, [(item.item_category == 'dataTransfer') ? _c('i', {
	      staticClass: "icon icon-circle icon-2x md-swap-vertical bg-primary"
	    }) : (item.item_category == 'storage') ? _c('i', {
	      staticClass: "icon icon-circle icon-2x md-view-list bg-primary"
	    }) : (item.item_category === 'VODUsage') ? _c('i', {
	      staticClass: "icon icon-circle icon-2x md-case-play bg-primary"
	    }) : (item.item_category === 'InterBandwidth') ? _c('i', {
	      staticClass: "icon icon-circle icon-2x md-swap-vertical bg-primary"
	    }) : (item.item_category === 'LiveTranscodeVM') ? _c('i', {
	      staticClass: "icon icon-circle icon-2x md-tv-list bg-red-600 white"
	    }) : (item.item_category === 'Shipping') ? _c('i', {
	      staticClass: "icon icon-circle icon-2x md-truck bg-primary"
	    }) : _c('i', {
	      staticClass: "icon icon-circle icon-2x md-loupe bg-primary"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "counter counter-md counter text-xs-right pull-xs-right"
	    }, [_c('div', {
	      staticClass: "counter-number-group"
	    }, [(item.is_addon) ? _c('span', {
	      staticClass: "counter-number font-size-18"
	    }, [_vm._v(_vm._s(item.description))]) : _c('span', {
	      staticClass: "counter-number"
	    }, [_vm._v(_vm._s(item.human_data_usage))])]), _vm._v(" "), (!item.is_addon) ? _c('div', {
	      staticClass: "counter-label text-capitalize font-size-16"
	    }, [_vm._v(_vm._s(item.description))]) : _c('div', {
	      staticClass: "counter-label text-capitalize font-size-16"
	    }, [_vm._v(_vm._s(item.billing_description))]), _vm._v(" "), (_vm.showCost) ? _c('div', {
	      staticClass: "counter-label text-capitalize font-size-16 grey-900"
	    }, [_vm._v(" " + _vm._s(item.human_cost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))]) : _vm._e()])])])
	  })) : _c('div', {
	    staticClass: "alert alert-primary alert-dismissible"
	  }, [_vm._v("\n        " + _vm._s(_vm.$t("monthlyUsageHistory.labels.noUsageHistory")) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ },
/* 546 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-login-v3 layout-full th"
	  }, [_c('div', {
	    staticClass: "page vertical-align text-xs-center"
	  }, [_c('div', {
	    staticClass: "page-content vertical-align-middle"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [((this.step < 2)) ? _c('h1', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.$t('register.labels.register')))]) : _c('h1', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.$t('register.action.registerSuccess')))]), _vm._v(" "), _c('div', {
	    staticClass: "pearls row"
	  }, [_c('div', {
	    staticClass: "pearl current col-xs-4",
	    class: {
	      'done': (this.step === 0)
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('span', {
	    staticClass: "pearl-title"
	  }, [_vm._v(_vm._s(_vm.$t('account.labels.account')))])]), _vm._v(" "), _c('div', {
	    staticClass: "pearl col-xs-4",
	    class: {
	      'current': (this.step > 0)
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('span', {
	    staticClass: "pearl-title"
	  }, [_vm._v(_vm._s(_vm.$t('team.title')))])]), _vm._v(" "), _c('div', {
	    staticClass: "pearl col-xs-4",
	    class: {
	      'current': (this.step > 1)
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('span', {
	    staticClass: "pearl-title"
	  }, [_vm._v(_vm._s(_vm.$t('register.action.finish')))])])]), _vm._v(" "), _c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "alert-dismissible",
	      "type": "danger"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.errorResponse))])]), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade-in",
	      "mode": "out-in",
	      "appear": ""
	    }
	  }, [(this.step === 0) ? _c('div', {
	    key: "user-register",
	    staticClass: "user-form"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('displayname')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "displayname font-size-24"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('account.labels.displayName')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.displayname),
	      expression: "user.displayname"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "displayname",
	      "placeholder": _vm.$t('account.labels.displayName')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.displayname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.displayname = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('account.labels.email')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "email",
	      "id": "email",
	      "placeholder": _vm.$t('account.labels.email')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('password')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('account.labels.password')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "password",
	      "id": "password",
	      "placeholder": _vm.$t('account.labels.password')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-primary btn-lg btn-submit",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t("action.continue")) + " "), _c('span', {
	    staticClass: "glyphicon glyphicon-chevron-right"
	  })])], 1) : _vm._e(), _vm._v(" "), (this.step === 1) ? _c('div', {
	    key: "team-register",
	    staticClass: "default-form"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('team')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "team"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('team.displayName.labels')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.team),
	      expression: "user.team"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "team",
	      "placeholder": "Team Display name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.team)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.team = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('namespace')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "namespace"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('team.url.labels')) + " "), _c('span', {
	    staticClass: "grey-400 font-size-12"
	  }, [_vm._v(_vm._s(_vm.$t('team.url.textGuide')))])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "input-group-addon"
	  }, [_vm._v(_vm._s((_vm.baseURL + "/")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.namespace),
	      expression: "user.namespace"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "namespace",
	      "placeholder": "Team URL"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.namespace)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.namespace = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('accept')
	    }
	  }, [_c('div', {
	    staticClass: "checkbox-custom checkbox-primary m-b-0 m-t-20 text-xs-left"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.accept),
	      expression: "user.accept"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.user.accept) ? _vm._i(_vm.user.accept, null) > -1 : (_vm.user.accept)
	    },
	    on: {
	      "click": function($event) {
	        var $$a = _vm.user.accept,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.user.accept = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.user.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.user.accept = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "term"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("register.labels.acceptTerm")) + " "), _c('a', {
	    staticClass: "p-0 m-0",
	    attrs: {
	      "href": "https://www.byteark.com/terms-of-service/",
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("register.labels.termOfService")))])])])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-primary btn-lg btn-submit",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('action.register')) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (this.step === 2) ? _c('div', {
	    key: "completed-register",
	    staticClass: "default-form"
	  }, [_c('div', {
	    staticClass: "alert alert-success",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('register.success')) + " " + _vm._s(_vm.user.email))])])]) : _vm._e()])], 1), _vm._v(" "), ((this.step < 2)) ? _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.existingAccount"))), _c('u', [_c('router-link', {
	    staticClass: "btn btn-link btn-register",
	    attrs: {
	      "to": "login"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("action.login")))])], 1)]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(4)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brand"
	  }, [_c('img', {
	    staticClass: "brand-img",
	    attrs: {
	      "src": "/static/images/byteark-loading-white.png",
	      "alt": "logo account",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "brand-text font-size-24 grey-100"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pearl-icon"
	  }, [_c('i', {
	    staticClass: "icon md-account",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pearl-icon"
	  }, [_c('i', {
	    staticClass: "icon md-accounts-list",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pearl-icon"
	  }, [_c('i', {
	    staticClass: "icon md-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "page-copyright page-copyright-inverse"
	  }, [_c('p', [_vm._v("Service by ByteArk")])])
	}]}

/***/ },
/* 547 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_vm._v(_vm._s(this.$route.params.namespace))])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("member.labels.members")))]), _vm._v(" "), _c('div', {
	    staticClass: "page-header-actions"
	  }, [_c('div', {
	    staticClass: "row no-space w-120"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-md-12"
	  }, [_c('div', {
	    staticClass: "counter"
	  }, [_c('div', {
	    staticClass: "counter-label p-t-5"
	  }, [_vm._v(_vm._s(_vm.$t("member.labels.totalMembers")))]), _vm._v(" "), _c('span', {
	    staticClass: "counter-number font-weight-medium"
	  }, [_vm._v(_vm._s(_vm.pagination.total))])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : (_vm.isError) ? _c('div') : _c('div', [_c('div', {
	    staticClass: "p-b-15"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-2 col-md-6"
	  }, [_c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/team/members/create")
	    }
	  }, [_c('i', {
	    staticClass: "icon md-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "text hidden-sm-down"
	  }, [_vm._v(" " + _vm._s(_vm.$t("action.create")) + " ")])])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "table-striped table-hover table-responsive"
	  }, [_c('table', {
	    staticClass: "table is-indent"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cell-50",
	    attrs: {
	      "scope": "col"
	    }
	  }), _vm._v(" "), _c('th', {
	    staticClass: "cell-500",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.displayName")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-500",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.email")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-150 hidden-sm",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.role")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-250"
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user, index) {
	    return _c('tr', [_c('td', {
	      staticClass: "cell-50"
	    }, [_c('a', {
	      staticClass: "avatar"
	    }, [(user.display_image.sizes.default.url) ? _c('img', {
	      staticClass: "img-fluid",
	      attrs: {
	        "src": user.display_image.sizes.default.url,
	        "alt": "image-profile"
	      }
	    }) : _c('img', {
	      staticClass: "img-fluid",
	      attrs: {
	        "src": "/static/images/user.png",
	        "alt": "image-profile"
	      }
	    })])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-550"
	    }, [_vm._v("\n                    " + _vm._s(user.name) + "\n                  ")]), _vm._v(" "), _c('td', {
	      staticClass: "cell-500"
	    }, [_vm._v("\n                    " + _vm._s(user.email) + "\n                  ")]), _vm._v(" "), _c('td', {
	      staticClass: "cell-150 hidden-sm"
	    }, [(user.role == 'manager') ? _c('span', {
	      staticClass: "tag tag-danger"
	    }, [_vm._v("Manager")]) : _c('span', {
	      staticClass: "tag tag-default"
	    }, [_vm._v("User")])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-250"
	    }, [_c('router-link', {
	      staticClass: "btn btn-sm btn-default",
	      attrs: {
	        "to": ("/" + (_vm.$route.params.namespace) + "/team/members/" + (user.id) + "/edit"),
	        "data-toggle": "tooltip",
	        "data-original-title": "Edit"
	      }
	    }, [_vm._v(_vm._s(_vm.$t("action.manage")) + "\n                    ")]), _vm._v(" "), (!user.is_enabled) ? _c('button', {
	      staticClass: "btn btn-sm btn-link",
	      attrs: {
	        "type": "button"
	      }
	    }, [_vm._v("\n                      บัญชีนี้ถูกระงับการใช้งาน\n                    ")]) : _vm._e()], 1)])
	  }))])])]), _vm._v(" "), _c('paginate', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm.pagination.total_page > 1)),
	      expression: "(pagination.total_page > 1)"
	    }],
	    attrs: {
	      "pageCount": _vm.pagination.total_page,
	      "prevText": '«',
	      "nextText": '»',
	      "clickHandler": _vm.changePage,
	      "containerClass": 'pagination pull-right',
	      "pageClass": 'page-item',
	      "pageLinkClass": 'page-link',
	      "prevClass": 'page-item',
	      "prevLinkClass": 'page-link',
	      "nextClass": 'page-item',
	      "nextLinkClass": 'page-link'
	    }
	  })], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 548 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "namespace-form"
	  }, [_c('h3', {
	    staticClass: "title title-login"
	  }, [_vm._v(_vm._s(_vm.$t('login.action.chooseYourTeam')))]), _vm._v(" "), _c('ul', {
	    staticClass: "list-group list-group-gap"
	  }, _vm._l((_vm.teams), function(team, index) {
	    return _c('li', {
	      staticClass: "list-group-item bg-blue-grey-100"
	    }, [_c('a', {
	      staticClass: "btn btn-block btn-team text-xs-left media",
	      attrs: {
	        "ng-if": "team"
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectTeam(team.namespace)
	        }
	      }
	    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
	      staticClass: "media-body"
	    }, [_c('h4', {
	      staticClass: "media-heading"
	    }, [_c('span', {
	      staticClass: "text-uppercase blue-600"
	    }, [_vm._v(_vm._s(team.name))]), _vm._v(" Team")]), _vm._v(" "), _c('p', [_vm._v(_vm._s((_vm.baseURL + "/" + (team.namespace))))])]), _vm._v(" "), _vm._m(1, true)])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "login-help"
	  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('text.or')))])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": _vm.loginOtherTeamClick
	    }
	  }, [_vm._v(_vm._s(_vm.$t('login.action.loginOtherTeam')))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "media-left"
	  }, [_c('span', {
	    staticClass: "avatar avatar-online"
	  }, [_c('img', {
	    staticClass: "img-fluid",
	    attrs: {
	      "src": "/static/images/user.png"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "media-right align-middle"
	  }, [_c('i', {
	    staticClass: "icon md-chevron-right",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ },
/* 549 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-block"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]) : _c('div', [_c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t("member.labels.createMember")) + "\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "card-text"
	  }), _c('div', {
	    staticClass: "p-b-15"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-2 col-md-6"
	  }, [_c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": _vm.urlCreateMember()
	    }
	  }, [_c('i', {
	    staticClass: "icon md-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', {
	    staticClass: "text hidden-sm-down"
	  }, [_vm._v(" " + _vm._s(_vm.$t("action.create")) + " ")])])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [(_vm.users.length > 0) ? _c('div', {
	    staticClass: "table-striped table-hover table-responsive"
	  }, [_c('table', {
	    staticClass: "table is-indent"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "cell-50",
	    attrs: {
	      "scope": "col"
	    }
	  }), _vm._v(" "), _c('th', {
	    staticClass: "cell-500",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.displayName")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-500",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.email")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-150 hidden-sm",
	    attrs: {
	      "scope": "col"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.role")))]), _vm._v(" "), _c('th', {
	    staticClass: "cell-150"
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user, index) {
	    return _c('tr', [_c('td', {
	      staticClass: "cell-50"
	    }, [_c('a', {
	      staticClass: "avatar"
	    }, [(user.display_image.sizes.default.url) ? _c('img', {
	      staticClass: "img-fluid",
	      attrs: {
	        "src": user.display_image.sizes.default.url,
	        "alt": "image-profile"
	      }
	    }) : _c('img', {
	      staticClass: "img-fluid",
	      attrs: {
	        "src": "/static/images/user.png",
	        "alt": "image-profile"
	      }
	    })])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-550"
	    }, [_vm._v("\n                    " + _vm._s(user.name) + "\n                  ")]), _vm._v(" "), _c('td', {
	      staticClass: "cell-500"
	    }, [_vm._v("\n                    " + _vm._s(user.email) + "\n                  ")]), _vm._v(" "), _c('td', {
	      staticClass: "cell-150 hidden-sm"
	    }, [(user.role == 'manager') ? _c('span', {
	      staticClass: "tag tag-danger"
	    }, [_vm._v("Manager")]) : _c('span', {
	      staticClass: "tag tag-default"
	    }, [_vm._v("User")])]), _vm._v(" "), _c('td', {
	      staticClass: "cell-150"
	    }, [_c('router-link', {
	      staticClass: "btn btn-sm btn-default",
	      attrs: {
	        "to": _vm.urlEditMember(user.id),
	        "data-original-title": "Edit"
	      }
	    }, [_vm._v(" " + _vm._s(_vm.$t("action.manage")) + "\n                    ")])], 1)])
	  }))]), _vm._v(" "), _c('paginate', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm.pagination.total_page > 1)),
	      expression: "(pagination.total_page > 1)"
	    }],
	    attrs: {
	      "pageCount": _vm.pagination.total_page,
	      "prevText": '«',
	      "nextText": '»',
	      "clickHandler": _vm.changePage,
	      "containerClass": 'pagination pull-right',
	      "pageClass": 'page-item',
	      "pageLinkClass": 'page-link',
	      "prevClass": 'page-item',
	      "prevLinkClass": 'page-link',
	      "nextClass": 'page-item',
	      "nextLinkClass": 'page-link'
	    }
	  })], 1) : _c('div', {
	    staticClass: "alert alert-primary alert-dismissible"
	  }, [_vm._v("\n            There is no members.\n          ")])])]), _vm._v(" "), _c('p')])])
	},staticRenderFns: []}

/***/ },
/* 550 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "page-header"
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("title.currentState")))])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.showCurrentCredit) ? _c('div', {
	    staticClass: "current-state-block",
	    class: {
	      'col-md-12': _vm.forceFullWidthBoxes, 'col-md-6': !_vm.forceFullWidthBoxes
	    }
	  }, [_c('div', {
	    staticClass: "pricing-list pricing-credit text-xs-left m-b-0 card-stat"
	  }, [_c('div', {
	    staticClass: "pricing-header",
	    class: (_vm.balances.credit >= 0) ? 'bg-blue-600' : 'bg-red-600'
	  }, [_c('div', {
	    staticClass: "pricing-title"
	  }, [_vm._v(_vm._s(_vm.$t("billing.labels.remainingCredits")))]), _vm._v(" "), _c('div', {
	    staticClass: "pricing-price"
	  }, [_c('span', {
	    staticClass: "pricing-amount"
	  }, [_vm._v(_vm._s(_vm.balances.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]), _vm._v(" "), (_vm.showLastAddedCredit) ? _c('p', {
	    staticClass: "p-x-30 p-b-25"
	  }, [_vm._v(_vm._s(_vm.$t("currentCredit.lastedTransaction")) + " : " + _vm._s(_vm.balances.latest_refill_transaction.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")) + " " + _vm._s(_vm.$t("text.on")) + " " + _vm._s(_vm.latestRefillDate) + " ")]) : _c('p', {
	    staticClass: "p-x-30 p-b-25"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t("currentCredit.textGuide")))])])])])]) : _vm._e(), _vm._v(" "), (_vm.showCurrentCredit && _vm.isPrePaidTeam) ? _c('div', {
	    staticClass: "current-state-block",
	    class: {
	      'col-md-12': _vm.forceFullWidthBoxes, 'col-md-6': !_vm.forceFullWidthBoxes
	    }
	  }, [_c('div', {
	    staticClass: "bg-white p-30 card-stat"
	  }, [_c('div', {
	    staticClass: "counter counter-md text-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-label text-uppercase m-b-5"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t("billing.labels.currentMonthUsage")) + "\n            "), (_vm.showDiscount && (_vm.team.discount > 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.$t("billing.labels.perfixDiscount")) + " " + _vm._s(_vm.team.discount) + "% " + _vm._s(_vm.$t("billing.labels.subfixDiscount")) + ")")]) : _vm._e(), _vm._v(" "), (_vm.showDiscount && (_vm.team.discount <= 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.$t("billing.labels.noDiscount")) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "counter-number-group m-b-10"
	  }, [_c('span', {
	    staticClass: "counter-number"
	  }, [_vm._v(_vm._s(_vm.humanTotalCost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label"
	  }, [_c('div', {
	    staticClass: "progress progress-xs m-b-10"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-info",
	    class: (_vm.usagePercentage <= 80) ? 'bg-primary' : 'bg-danger',
	    style: ({
	      width: _vm.usagePercentage + '%'
	    }),
	    attrs: {
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_vm._v("\n               \n              ")])]), _vm._v(" "), (_vm.showUsagePercentage) ? _c('div', {
	    staticClass: "counter counter-sm text-xs-left m-t-30"
	  }, [(_vm.usagePercentage < 100) ? _c('div', {
	    staticClass: "counter-number-group"
	  }, [_c('span', {
	    staticClass: "counter-number",
	    class: (_vm.usagePercentage <= 80) ? 'blue-600' : 'red-600'
	  }, [_vm._v(_vm._s(_vm.usagePercentage) + "%")]), _vm._v(" "), _c('span', {
	    staticClass: "counter-number-related"
	  }, [_vm._v(_vm._s(_vm.$t("currentCredit.percentageBar")))])]) : _vm._e(), _vm._v(" "), (_vm.usagePercentage >= 100) ? _c('div', {
	    staticClass: "counter-number-group"
	  }, [_c('span', {
	    staticClass: "counter-number red-600"
	  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.creditNotEnough")))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "counter-number-group m-t-10"
	  }, [_c('span', {
	    staticClass: "counter-number-related"
	  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.nextCreditCharge")) + " : " + _vm._s(_vm.upcomingBillDate) + " "), _c('a', {
	    staticClass: "btn btn-link p-0 grey-100 font-size-12",
	    attrs: {
	      "href": ("/" + (_vm.$route.params.namespace) + "/billing#statementSection")
	    }
	  }, [_vm._v("(" + _vm._s(_vm.$t("statement.action.statement")) + ")")])])])]) : _c('div', {
	    staticClass: "counter counter-sm text-xs-left m-t-30"
	  }, [_c('div', {
	    staticClass: "counter-number-group"
	  }, [_c('span', {
	    staticClass: "counter-number-related"
	  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.textGuide")) + " "), (_vm.balances.latest_bill_id) ? _c('span', [_c('a', {
	    staticClass: "btn btn-link p-0 grey-100 font-size-12",
	    attrs: {
	      "href": ("/" + (_vm.$route.params.namespace) + "/billing#statementSection")
	    }
	  }, [_vm._v("(" + _vm._s(_vm.$t("statement.action.statement")) + ")")])]) : _vm._e()])])])])])])]) : _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "p-30 bg-primary"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "font-size-24 m-b-5"
	  }, [_vm._v(_vm._s(_vm.$t("billing.labels.currentMonthUsage")))]), _vm._v(" "), (_vm.showUsagePercentage) ? _c('div', [_c('div', {
	    staticClass: "font-size-14"
	  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.nextCreditCharge")) + " : " + _vm._s(_vm.upcomingBillDate) + " "), _c('a', {
	    staticClass: "btn btn-link p-0 grey-100 font-size-12",
	    attrs: {
	      "href": ("/" + (_vm.$route.params.namespace) + "/billing#statementSection")
	    }
	  }, [_vm._v("(" + _vm._s(_vm.$t("statement.action.statement")) + ")")])])]) : _c('div', [_c('span', {
	    staticClass: "counter-number-related"
	  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.textGuide"))), (_vm.balances.latest_bill_id) ? _c('span', [_c('a', {
	    staticClass: "btn btn-link p-0 grey-100 font-size-12",
	    attrs: {
	      "href": ("/" + (_vm.$route.params.namespace) + "/billing#statementSection")
	    }
	  }, [_vm._v("(" + _vm._s(_vm.$t("statement.action.statement")) + ")")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "counter counter-lg text-xs-right"
	  }, [_c('span', {
	    staticClass: "counter-number white"
	  }, [_vm._v(_vm._s(_vm.humanTotalCost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])])])])])])
	},staticRenderFns: []}

/***/ },
/* 551 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [(_vm.showPayPlanForm) ? _c('div', {
	    staticClass: "bg-blue-grey-100 admin-package-box p-30 font-size-14 admin-package-box clearfix"
	  }, [(!_vm.team.has_reseller && !_vm.team.is_reseller) ? _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmitPayplan($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showPayPlanAlert),
	      expression: "showPayPlanAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successPayPlanResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successPayPlanResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successPayPlanResponse) ? _c('span', [_vm._v(_vm._s(_vm.successPayPlanResponse))]) : (_vm.errorPayPlanResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorPayPlanResponse))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "form-control-label",
	    attrs: {
	      "for": "role"
	    }
	  }, [_vm._v("Pay Plan")]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('payPlan')
	    }
	  }, [_c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.team.pay_plan),
	      expression: "team.pay_plan"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "prepaid",
	      "value": "prepaid"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.team.pay_plan, "prepaid")
	    },
	    on: {
	      "click": function($event) {
	        _vm.team.pay_plan = "prepaid"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "payplan"
	    }
	  }, [_vm._v("Pre paid")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.team.pay_plan),
	      expression: "team.pay_plan"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "postpaid",
	      "value": "postpaid"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.team.pay_plan, "postpaid")
	    },
	    on: {
	      "click": function($event) {
	        _vm.team.pay_plan = "postpaid"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "payplan"
	    }
	  }, [_vm._v("Post paid")])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "btn btn-link pull-xs-right",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.cancelPayPlanForm
	    }
	  }, [_vm._v("\n            Cancel\n          ")])])])]) : _vm._e()]) : _c('div', {
	    staticClass: "bg-blue-grey-100 admin-package-box p-30 font-size-14"
	  }, [_c('div', {
	    staticClass: "counter counter-md text-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-label text-uppercase m-b-5"
	  }, [_vm._v("Customer Type Setting")]), _vm._v(" "), _c('span', {
	    staticClass: "counter-number text-capitalize"
	  }, [_vm._v(" " + _vm._s(_vm.team.pay_plan) + " ")]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label m-b-5 m-t-20"
	  }, [_vm._v("Suspension policy : Auto ")]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label text-uppercase m-b-5 m-t-20"
	  }, [(!_vm.team.has_reseller) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.togglePayPlanForm
	    }
	  }, [_vm._v("Change plan\n        ")]) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "btn btn-success pull-xs-left",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("\n            Update Plan\n          ")])])
	}]}

/***/ },
/* 552 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-login-v3 layout-full th"
	  }, [_c('div', {
	    staticClass: "page vertical-align text-xs-center"
	  }, [_c('div', {
	    staticClass: "page-content vertical-align-middle"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [(_vm.isLoading) ? _c('div', {
	    staticClass: "card-stat"
	  }, [_c('loading-indicator')], 1) : _c('div', [(this.step === this.stepEnum.teamList) ? _c('team-list-form', {
	    key: "namespace-login",
	    attrs: {
	      "teams": _vm.teams
	    },
	    on: {
	      "selectTeam": _vm.submitOauthForm,
	      "loginOtherTeam": _vm.onLoginOtherTeam
	    }
	  }) : _c('div', [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade-in",
	      "mode": "out-in",
	      "appear": ""
	    }
	  }, [(this.step === this.stepEnum.namespaceForm) ? _c('div', {
	    key: "team-login",
	    staticClass: "team-form"
	  }, [_c('h3', {
	    staticClass: "title title-login"
	  }, [_vm._v(_vm._s(_vm.$t('login.action.enterTeamURL')))]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('namespace')
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "input-group-addon form-group-mobile"
	  }, [_vm._v(_vm._s((_vm.baseURL + "/")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.namespace),
	      expression: "user.namespace"
	    }],
	    staticClass: "form-control form-group-mobile",
	    attrs: {
	      "type": "text",
	      "id": "namespace",
	      "placeholder": "Team URL"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.namespace)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.namespace = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-block btn-lg m-t-40",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.$t('action.continue')) + " "), _c('span', {
	    staticClass: "glyphicon glyphicon-chevron-right"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "login-help"
	  }, [_c('p', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.$t('login.labels.dontHaveAccount')) + " "), _c('u', [_c('router-link', {
	    staticClass: "btn btn-link btn-register",
	    attrs: {
	      "to": "register"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('login.action.registerNewAccount')))])], 1)])])], 1) : (this.step === this.stepEnum.loginForm) ? _c('div', {
	    key: "user-login",
	    staticClass: "user-form"
	  }, [_c('h3', {
	    staticClass: "title title-login"
	  }, [_vm._v(_vm._s(_vm.$t('login.labels.prefixLogin')) + " "), _c('span', {
	    staticClass: "text-uppercase blue-600"
	  }, [_vm._v(_vm._s(_vm.user.namespace))]), _vm._v(" " + _vm._s(_vm.$t('login.labels.subfixLogin')))]), _vm._v(" "), _c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLoginFailed),
	      expression: "isLoginFailed"
	    }],
	    attrs: {
	      "alertClass": "alert-dismissible",
	      "type": "danger"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.loginFailedText))])]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('account.labels.email')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    ref: "emailInput",
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "id": "email",
	      "placeholder": _vm.$t('account.labels.email')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('password')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('account.labels.password')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "password",
	      "placeholder": _vm.$t('account.labels.password')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-primary btn-lg btn-submit",
	    class: {
	      'btn-default': _vm.isLoggingIn
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isLoggingIn
	    }
	  }, [(_vm.isLoggingIn) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('action.login')) + "\n                    ")]), _vm._v(" "), _c('div', {
	    staticClass: "login-help"
	  }, [_c('router-link', {
	    staticClass: "btn btn-link btn-block pull-right",
	    attrs: {
	      "to": ("/" + (this.user.namespace) + "/forgot")
	    }
	  }, [_vm._v(_vm._s(_vm.$t('forgot.action.forgotPassword')))]), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('login.labels.dontHaveAccountOnTeam')))]), _c('br'), _vm._v(_vm._s(_vm.$t('login.labels.contactTeamAdmin')))])], 1)], 1) : _vm._e()])], 1)])], 1), _vm._v(" "), _c('form', {
	    ref: "oauthForm",
	    attrs: {
	      "method": "POST",
	      "action": _vm.oauthFormURL
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.accessToken),
	      expression: "accessToken"
	    }],
	    attrs: {
	      "type": "hidden",
	      "name": "access_token"
	    },
	    domProps: {
	      "value": _vm._s(_vm.accessToken)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.accessToken = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _vm._m(1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "brand"
	  }, [_c('img', {
	    staticClass: "brand-img",
	    attrs: {
	      "src": "/static/images/byteark-loading-white.png",
	      "alt": "logo account",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "brand-text font-size-24 grey-100"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "page-copyright page-copyright-inverse"
	  }, [_c('p', [_vm._v("Service by ByteArk")])])
	}]}

/***/ },
/* 553 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.showSettingSuspendForm) ? _c('div', {
	    staticClass: "bg-blue-grey-100 p-30 font-size-14 clearfix"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmitSuspendStatus($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showSuspendAlert),
	      expression: "showSuspendAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successSuspendResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successSuspendResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.successSuspendResponse))]) : (_vm.errorSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorSuspendResponse))]) : _vm._e()]), _vm._v(" "), _c('h4', {
	    staticClass: "title"
	  }, [_vm._v("Setting Suspend")]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v("Mode")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentSuspendMode),
	      expression: "currentSuspendMode"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.currentSuspendMode = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "auto"
	    }
	  }, [_vm._v("Auto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "active"
	    }
	  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "suspend"
	    }
	  }, [_vm._v("Suspend")])])]), _vm._v(" "), (_vm.currentSuspendMode === 'suspend') ? _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('suspend_reason')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "reason"
	    }
	  }, [_vm._v("Reason to client"), _c('span', {
	    staticClass: "red-500"
	  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.teamSuspend.suspend_reason),
	      expression: "teamSuspend.suspend_reason"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.teamSuspend.suspend_reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.teamSuspend.suspend_reason = $event.target.value
	      }
	    }
	  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "btn btn-link pull-xs-right",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.cancelSettingSuspendForm
	    }
	  }, [_vm._v("\n            Cancel\n          ")])])])])]) : _c('div', {
	    staticClass: "bg-blue-grey-100 p-30 font-size-14"
	  }, [_c('div', {
	    staticClass: "counter counter-md text-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-label text-uppercase m-b-5"
	  }, [_vm._v("Setting Suspend")]), _vm._v(" "), _c('span', {
	    staticClass: "counter-number"
	  }, [_vm._v(" " + _vm._s(_vm.currentSuspendMode.toUpperCase()) + " ")]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label text-uppercase m-b-5 m-t-20"
	  }, [(!_vm.team.has_reseller) ? _c('button', {
	    staticClass: "btn btn-primary btn-outline",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.toggleSettingSuspendForm
	    }
	  }, [_vm._v("Change setting\n        ")]) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "btn btn-success pull-xs-left",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("\n            Update Plan\n          ")])])
	}]}

/***/ },
/* 554 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "widget widget-shadow widget-pricing-plan-table widget-pricing-plan-2017"
	  }, [_c('div', {
	    staticClass: "widget-content bg-blue-grey-600"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('table', {
	    staticClass: "table margin-bottom-0"
	  }, [_c('thead', {
	    staticClass: "bg-blue-grey-700"
	  }, [_c('tr', [_c('th', {
	    staticClass: "white"
	  }, [_vm._v("Data Transfer")]), _vm._v(" "), _c('th', {
	    staticClass: "white"
	  }, [_vm._v(_vm._s(_vm.$t("title.cost")))])])]), _vm._v(" "), _c('tbody', {
	    staticClass: "bg-white"
	  }, [_c('tr', [_c('td', [_vm._v("0 - 10,000 GB")]), _vm._v(" "), _c('td', [_vm._v("1.50 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 10,000 - 50,000 GB")]), _vm._v(" "), _c('td', [_vm._v("1.20 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 50,000 - 100,000 GB")]), _vm._v(" "), _c('td', [_vm._v("0.80 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 100,000 - 300,000 GB")]), _vm._v(" "), _c('td', [_vm._v("0.40 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 300,000 - 1,000,000 GB")]), _vm._v(" "), _c('td', [_vm._v("0.30 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 1,000,000 GB - 5,000,000 GB")]), _vm._v(" "), _c('td', [_vm._v("0.20 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('table', {
	    staticClass: "table margin-bottom-0"
	  }, [_c('thead', {
	    staticClass: "bg-blue-grey-700"
	  }, [_c('tr', [_c('th', {
	    staticClass: "white"
	  }, [_vm._v("Storage")]), _vm._v(" "), _c('th', {
	    staticClass: "white"
	  }, [_vm._v(_vm._s(_vm.$t("title.cost")))])])]), _vm._v(" "), _c('tbody', {
	    staticClass: "bg-white"
	  }, [_c('tr', [_c('td', [_vm._v("0 - 5,000 GB")]), _vm._v(" "), _c('td', [_vm._v("5.00 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 5,000 - 20,000 GB")]), _vm._v(" "), _c('td', [_vm._v("4.00 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 20,000 GB")]), _vm._v(" "), _c('td', [_vm._v("3.00 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/GB")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('table', {
	    staticClass: "table margin-bottom-0"
	  }, [_c('thead', {
	    staticClass: "bg-blue-grey-700"
	  }, [_c('tr', [_c('th', {
	    staticClass: "white"
	  }, [_vm._v("Video on Demand (VOD) Encoding")]), _vm._v(" "), _c('th', {
	    staticClass: "white"
	  }, [_vm._v(_vm._s(_vm.$t("title.cost")))])])]), _vm._v(" "), _c('tbody', {
	    staticClass: "bg-white"
	  }, [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v("0.50 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/Min")])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_vm._v("1.00 " + _vm._s(_vm.$t("billing.currencies.thb")) + "/Min")])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', [_vm._v("> 5,000,000 GB")]), _vm._v(" "), _c('td', [_vm._v("Contact Us")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_vm._v("SD "), _c('span', {
	    staticClass: "smaller"
	  }, [_vm._v("(144p/240p/270p/360p/480p/576p)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_vm._v("HD "), _c('span', {
	    staticClass: "smaller"
	  }, [_vm._v("(720p/1080p)")])])
	}]}

/***/ },
/* 555 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page vertical-align text-xs-center"
	  }, [_c('div', {
	    staticClass: "page-content vertical-align-middle"
	  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace))
	    }
	  }, [_vm._v("\n      GO TO DASHBOARD\n    ")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('h1', {
	    staticClass: "animation-slide-top"
	  }, [_vm._v("404")]), _vm._v(" "), _c('h4', {
	    staticClass: "blue-grey-400"
	  }, [_vm._v("Sorry , Page not found.")])])
	}]}

/***/ },
/* 556 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page vertical-align text-xs-center"
	  }, [_c('div', {
	    staticClass: "page-content vertical-align-middle"
	  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace))
	    }
	  }, [_vm._v("\n      GO TO DASHBOARD\n    ")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('h1', {
	    staticClass: "animation-slide-top"
	  }, [_vm._v("403")]), _vm._v(" "), _c('h4', {
	    staticClass: "blue-grey-400"
	  }, [_vm._v("Sorry , You don't have permission to access this page.")])])
	}]}

/***/ },
/* 557 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_c('div', {
	    staticClass: "page-main"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.editProfile")))])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-md-6"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-section"
	  }, [_c('div', {
	    staticClass: "form-group form-avatar"
	  }, [_c('span', {
	    staticClass: "avatar avatar-lg"
	  }, [(_vm.currentUser) ? _c('img', {
	    staticClass: "img-fluid",
	    attrs: {
	      "src": _vm.currentUser.display_image.sizes.default.url,
	      "alt": "image-profile"
	    }
	  }) : _c('img', {
	    staticClass: "img-fluid",
	    attrs: {
	      "src": "/static/images/user.png",
	      "alt": "image-profile"
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("account.profile.labels.changeDisplayImage")) + " "), _c('a', {
	    attrs: {
	      "href": "http://www.gravatar.com",
	      "target": "_blank"
	    }
	  }, [_vm._v("Gravatar.com")])])])]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.displayName")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.name),
	      expression: "user.name"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('account.labels.displayName')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.email")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "email",
	      "placeholder": _vm.$t(
	        'account.labels.displayName'),
	      "autocomplete": "false",
	      "disabled": true
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.password")))]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-icon btn-block btn-link text-xs-left p-l-0",
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/self/password")
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.$t("member.action.changePassword")) + "\n                    ")])], 1), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('lang')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.profile.labels.chooseLanguage")))]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.lang),
	      expression: "user.lang"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "th"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.user.lang, "th")
	    },
	    on: {
	      "click": function($event) {
	        _vm.user.lang = "th"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "inputRadiosChecked"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.lang.th")))])]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.lang),
	      expression: "user.lang"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "en"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.user.lang, "en")
	    },
	    on: {
	      "click": function($event) {
	        _vm.user.lang = "en"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "inputRadiosChecked"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.lang.en")))])])])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t("account.action.submit")) + "\n                ")])])])])], 1)])])])])
	},staticRenderFns: []}

/***/ },
/* 558 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main"
	  }, [(_vm.currentPage === 'self') ? _c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_vm._v(_vm._s(this.$route.params.namespace))]), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_vm._v(_vm._s(_vm.$t("member.labels.members")))])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("member.labels.createMember")))])]) : _c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_vm._v(_vm._s(_vm.currentPage === 'admin' ? 'Admin' : 'Reseller'))]), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams")
	    }
	  }, [_vm._v(_vm._s(_vm.$t("action.manageClientTeam")))])], 1), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (_vm.$route.params.subnamespace) + "/edit")
	    }
	  }, [_vm._v(_vm._s(_vm.$route.params.subnamespace) + " ")])], 1)]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("member.labels.createMember")))])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [_c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-section"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('name'),
	      "autocomplete": "false"
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.displayName")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.name),
	      expression: "user.name"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('account.labels.displayName')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.email")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "email",
	      "placeholder": _vm.$t('account.labels.email'),
	      "autocomplete": "false"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('password')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.password")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "password",
	      "placeholder": _vm.$t('account.labels.password')
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('role')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "role"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("account.labels.role")))]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.role),
	      expression: "user.role"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "manager"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.user.role, "manager")
	    },
	    on: {
	      "click": function($event) {
	        _vm.user.role = "manager"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "manager"
	    }
	  }, [_vm._v(" Manager")])]), _vm._v(" "), (_vm.showUserRole) ? _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.role),
	      expression: "user.role"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "user"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.user.role, "user")
	    },
	    on: {
	      "click": function($event) {
	        _vm.user.role = "user"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "user"
	    }
	  }, [_vm._v("User "), _c('span', {
	    staticClass: "grey-400"
	  }, [_vm._v(_vm._s(_vm.$t("member.role.user.textGuide")))])])]) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t("action.create")) + "\n              ")])])])])])])])])
	},staticRenderFns: []}

/***/ },
/* 559 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "fixed",
	      "left": "0",
	      "right": "0",
	      "top": "0",
	      "bottom": "0",
	      "width": "100%",
	      "height": "100%",
	      "position": "absolute",
	      "margin": "0"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%",
	      "display": "table"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "display": "table-cell",
	      "text-align": "center",
	      "vertical-align": "middle"
	    }
	  }, [_c('div', {
	    staticClass: "loader vertical-align-middle loader-cube-grid center-block"
	  })])])])
	}]}

/***/ },
/* 560 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "addcreditSection"
	    }
	  }, [_c('div', {
	    staticClass: "content bg-blue-grey-100 p-30"
	  }, [_c('div', {
	    staticClass: "alert alert-info"
	  }, [_vm._v("\n      กรุณาเติมเงินผ่านช่องทาง\n      "), _c('a', {
	    attrs: {
	      "href": "https://www.byteark.com/payment/"
	    }
	  }, [_vm._v("https://www.byteark.com/payment/")]), _vm._v("\n      โดยคุณสามารถโอนเงินชำระตามจำนวนที่ต้องการ และแจ้งโอนเงินพร้อมหลักฐานการโอนเงินมาที่ "), _c('a', {
	    attrs: {
	      "href": "mailto:support@byteark.com"
	    }
	  }, [_vm._v("support@byteark.com")])])])])
	}]}

/***/ },
/* 561 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-primary btn-submit",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('span', {
	    staticClass: "loader vertical-align-middle loader-form",
	    class: _vm.loaderIconClass
	  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 562 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.currentPage === 'admin') ? _c('div', {
	    staticClass: "card-block"
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n    Transfer\n  ")]), _vm._v(" "), _c('p', {
	    staticClass: "card-text"
	  }), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showSuspendAlert),
	      expression: "showSuspendAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successSuspendResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successSuspendResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.successSuspendResponse))]) : (_vm.errorSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorSuspendResponse))]) : _vm._e()]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "team"
	    }
	  }, [_vm._v("Choose Reseller "), _c('span', {
	    staticClass: "red-600"
	  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newReseller),
	      expression: "newReseller"
	    }],
	    attrs: {
	      "options": _vm.filterItems
	    },
	    domProps: {
	      "value": (_vm.newReseller)
	    },
	    on: {
	      "input": function($event) {
	        _vm.newReseller = $event
	      }
	    }
	  })], 1)], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p')]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("\n        Submit "), _c('span', {
	    staticClass: "glyphicon"
	  })])
	}]}

/***/ },
/* 563 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main page-border"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("billing.labels.billing")))])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLoading),
	      expression: "isLoading"
	    }],
	    staticClass: "card-block"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isLoading),
	      expression: "!isLoading"
	    }]
	  }, [(_vm.showCurrentStat) ? _c('Current-stat', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.currentStatLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showPaymentSection) ? _c('Payment-section', {
	    attrs: {
	      "team": _vm.team,
	      "showBillingCredit": _vm.showBillingCredit,
	      "showBillingInformation": _vm.showBillingInformation
	    },
	    on: {
	      "loadChanged": _vm.paymentSectionLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showMonthlyUsageHistory) ? _c('Monthly-usage-history', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.monthlyUsageHistoryLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showStatement) ? _c('Statement', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.statementLoadChanged
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showClientUsageHistory) ? _c('Client-usage-history', {
	    attrs: {
	      "team": _vm.team,
	      "showTitle": true
	    },
	    on: {
	      "loadChanged": _vm.clientUsageHistoryLoadChanged
	    }
	  }) : _vm._e()], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 564 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main page-border"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_vm._v(_vm._s(_vm.currentPage === 'admin' ? 'Admin' : 'Reseller'))]), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams")
	    }
	  }, [_vm._v("Manage Team")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_vm._v(" " + _vm._s((_vm.team) ? _vm.team.name : '') + " ")])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t('action.editInfo')))])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [(_vm.isLoading || !_vm.team) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-block"
	  }, [_c('p', {
	    staticClass: "card-text"
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 card-stat"
	  }, [_c('loading-indicator')], 1)]), _vm._v(" "), _c('p')])]) : _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-block"
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('menu.general')) + "\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "card-text"
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmitGeneral($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 col-xs-12"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showGeneralAlert),
	      expression: "showGeneralAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successGeneralResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successGeneralResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successGeneralResponse) ? _c('span', [_vm._v(_vm._s(_vm.successGeneralResponse))]) : (_vm.errorGeneralResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorGeneralResponse))]) : _vm._e()]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "team"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('team.displayName.labels')))]), _vm._v(" "), _c('span', {
	    staticClass: "guideline-block"
	  }, [_vm._v(_vm._s(_vm.$t('team.displayName.textGuide')))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.team.name),
	      expression: "team.name"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "name",
	      "placeholder": _vm.$t('team.displayName.labels')
	    },
	    domProps: {
	      "value": _vm._s(_vm.team.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.team.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('team.url.labels')))]), _vm._v(" "), _c('span', {
	    staticClass: "help-block m-t-0"
	  }, [_vm._v(_vm._s(_vm.$t('team.url.textGuide')))]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "input-group-addon"
	  }, [_vm._v(_vm._s((_vm.baseURL + "/")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.team.namespace),
	      expression: "team.namespace"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "id": "namespace",
	      "placeholder": _vm.$t('team.url.labels'),
	      "disabled": "true"
	    },
	    domProps: {
	      "value": _vm._s(_vm.team.namespace)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.team.namespace = $event.target.value
	      }
	    }
	  })])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('team.action.submit')))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [(_vm.currentPage === 'admin') ? _c('team-terminate', {
	    attrs: {
	      "team": _vm.team
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('p')]), _vm._v(" "), (_vm.currentPage === 'admin') ? _c('div', {
	    staticClass: "card-block"
	  }, [_c('h3', {
	    staticClass: "card-title"
	  }, [_vm._v("\n          Suspension policy\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "card-text"
	  }), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmitSuspendStatus($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showSuspendAlert),
	      expression: "showSuspendAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successSuspendResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successSuspendResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.successSuspendResponse))]) : (_vm.errorSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorSuspendResponse))]) : _vm._e()]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v("Mode")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentSuspendMode),
	      expression: "currentSuspendMode"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.currentSuspendMode = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "auto"
	    }
	  }, [_vm._v("Auto")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "active"
	    }
	  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "suspend"
	    }
	  }, [_vm._v("Suspend")])])]), _vm._v(" "), (_vm.currentSuspendMode === 'suspend') ? _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('suspend_reason')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "reason"
	    }
	  }, [_vm._v("Reason to client"), _c('span', {
	    staticClass: "red-500"
	  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.teamSuspend.suspend_reason),
	      expression: "teamSuspend.suspend_reason"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.teamSuspend.suspend_reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.teamSuspend.suspend_reason = $event.target.value
	      }
	    }
	  })]) : _vm._e()], 1)]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("\n              Submit "), _c('span', {
	    staticClass: "glyphicon"
	  })])]), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('team-transfer', {
	    attrs: {
	      "team": _vm.team
	    }
	  }), _vm._v(" "), _c('members-browser', {
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "loadChanged": _vm.membersBrowserLoadChanged
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ },
/* 565 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [((_vm.hasBillingInformation && (_vm.step === 0))) ? _c('div', [_c('omise-form', {
	    ref: "omiseForm",
	    attrs: {
	      "credit": _vm.credit
	    }
	  })], 1) : _c('div', [_c('div', {
	    staticClass: "row pearls m-t-10"
	  }, [_c('div', {
	    staticClass: "pearl current col-xs-6",
	    class: {
	      'current': (this.step === 0)
	    }
	  }, [_c('div', {
	    staticClass: "pearl-icon"
	  }, [_c('i', {
	    staticClass: "icon md-info",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "pearl-title"
	  }, [_vm._v("Billing Info")])]), _vm._v(" "), _c('div', {
	    staticClass: "pearl col-xs-6",
	    class: {
	      'current': (this.step === 1)
	    }
	  }, [_c('div', {
	    staticClass: "pearl-icon"
	  }, [_c('i', {
	    staticClass: "icon md-card",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "pearl-title"
	  }, [_vm._v("Credit Card")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [((this.step === 0)) ? _c('billing-information-form', {
	    ref: "billingInformationForm",
	    attrs: {
	      "team": _vm.team
	    },
	    on: {
	      "save": _vm.onBillingInformationFormSaved,
	      "cancel": _vm.onBillingInformationFormCancel
	    }
	  }) : _vm._e(), _vm._v(" "), ((this.step === 1)) ? _c('omise-form', {
	    ref: "omiseForm",
	    attrs: {
	      "credit": _vm.credit
	    }
	  }) : _vm._e()], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 566 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [(!_vm.hasDiscount && !_vm.showDiscountForm) ? _c('div', {
	    staticClass: "bg-blue-grey-100 p-30 font-size-14 admin-package-box clearfix"
	  }, [_c('div', {
	    staticClass: "counter counter-md text-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-label text-uppercase m-b-5"
	  }, [_vm._v("Discount")]), _vm._v(" "), _c('span', {
	    staticClass: "counter-number"
	  }, [_vm._v("There are no Discount")]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label text-uppercase m-b-5 m-t-20 clearfix"
	  }, [(!_vm.team.has_reseller) ? _c('button', {
	    staticClass: "btn btn-primary btn-outline",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.toggleDiscountForm
	    }
	  }, [_vm._v("Add Discount\n        ")]) : _vm._e()])])]) : (_vm.showDiscountForm) ? _c('div', {
	    staticClass: "bg-blue-grey-100 p-30 admin-package-box font-size-14 clearfix"
	  }, [_c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmitDiscountForm($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": "danger",
	      "iconClass": "md-close"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.errorResponse))])]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "formGroupClass": "form-group col-md-12",
	      "error": _vm.formErrors.first('percent')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label"
	  }, [_vm._v("Discount Percent")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentDiscount.percent),
	      expression: "currentDiscount.percent"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "id": "percent",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.currentDiscount.percent)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentDiscount.percent = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon"
	  }, [_vm._v("%")])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "btn btn-success pull-xs-left",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("\n            Update Discount\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "btn btn-link pull-xs-right",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.cancleDiscountForm
	    }
	  }, [_vm._v("\n            Cancel\n          ")])])])])]) : _c('div', {
	    staticClass: "bg-blue-grey-100 p-30 font-size-14 clearfix"
	  }, [_c('div', {
	    staticClass: "counter counter-md text-xs-left"
	  }, [_c('div', {
	    staticClass: "counter-label text-uppercase m-b-5"
	  }, [_vm._v("Discount")]), _vm._v(" "), _c('span', {
	    staticClass: "counter-number"
	  }, [_vm._v(_vm._s(_vm.currentDiscount.percent) + " %")]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label m-b-5 m-t-20"
	  }, [_vm._v("This team will be apply with this credit.")]), _vm._v(" "), _c('div', {
	    staticClass: "counter-label text-uppercase m-b-5 m-t-20 clearfix"
	  }, [(!_vm.team.has_reseller) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.toggleDiscountForm
	    }
	  }, [_vm._v("Change discount\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.team.has_reseller) ? _c('button', {
	    staticClass: "btn btn-link grey-100 pull-xs-right",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.removeDiscount
	    }
	  }, [_vm._v("Remove\n        ")]) : _vm._e()])])])])
	},staticRenderFns: []}

/***/ },
/* 567 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_c('div', {
	    staticClass: "page-main"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.$t("support.labels.contactUS")))])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t("support.labels.textGuide")))]), _vm._v(" "), _c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-section"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('subject')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "subject"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("support.labels.subject")) + " "), _c('span', {
	    staticClass: "red-600"
	  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.support.subject),
	      expression: "support.subject"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "autocomplete": "false"
	    },
	    domProps: {
	      "value": _vm._s(_vm.support.subject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.support.subject = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('content')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "content"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("support.labels.message")) + " "), _c('span', {
	    staticClass: "red-600"
	  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.support.content),
	      expression: "support.content"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "autocomplete": "false",
	      "rows": "12"
	    },
	    domProps: {
	      "value": _vm._s(_vm.support.content)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.support.content = $event.target.value
	      }
	    }
	  })])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t("action.submit")) + "\n                ")])])])])], 1)])])])])
	},staticRenderFns: []}

/***/ },
/* 568 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-main"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', {
	    staticClass: "breadcrumb-item"
	  }, [_vm._v(_vm._s(this.$route.params.namespace))]), _vm._v(" "), _c('li', {
	    staticClass: "breadcrumb-item active"
	  }, [_vm._v("Addon cost")])]), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Create Addon cost")])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body panel-form"
	  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showAlert),
	      expression: "showAlert"
	    }],
	    attrs: {
	      "alertClass": "m-b-25 alert-dismissible",
	      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
	      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
	    }
	  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-section"
	  }, [_c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('team')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "team"
	    }
	  }, [_vm._v("Team")]), _vm._v(" "), _c('v-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentTeam),
	      expression: "currentTeam"
	    }],
	    attrs: {
	      "options": _vm.filterItems
	    },
	    domProps: {
	      "value": (_vm.currentTeam)
	    },
	    on: {
	      "input": function($event) {
	        _vm.currentTeam = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('description'),
	      "autocomplete": "false"
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "description"
	    }
	  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.description),
	      expression: "description"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": "Description"
	    },
	    domProps: {
	      "value": _vm._s(_vm.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.description = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('bill_description')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "bill_description"
	    }
	  }, [_vm._v("Billing Description")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.bill_description),
	      expression: "bill_description"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": "Billing Description",
	      "autocomplete": "false"
	    },
	    domProps: {
	      "value": _vm._s(_vm.bill_description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.bill_description = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "period"
	    }
	  }, [_vm._v("Item Category")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.itemCategory), function(item, index) {
	    return _c('div', {
	      staticClass: "col-md-4 col-xs-12"
	    }, [_c('div', {
	      staticClass: "alert alert-primary text-xs-center bg-blue-grey-100",
	      attrs: {
	        "role": "alert"
	      }
	    }, [(item === 'DataTransfer') ? _c('i', {
	      staticClass: "icon icon-circle icon-2x md-swap-vertical bg-primary"
	    }) : (item === 'LiveTranscodeVM') ? _c('i', {
	      staticClass: "icon icon-circle icon-2x md-tv-list bg-red-600 white"
	    }) : (item === 'Shipping') ? _c('i', {
	      staticClass: "icon icon-circle icon-2x md-truck bg-primary"
	    }) : _c('i', {
	      staticClass: "icon icon-circle icon-2x md-loupe bg-primary"
	    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item))]), _vm._v(" "), _c('div', {
	      staticClass: "radio-custom radio-primary"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.CurrentItemCategory),
	        expression: "CurrentItemCategory"
	      }],
	      attrs: {
	        "type": "radio"
	      },
	      domProps: {
	        "value": item,
	        "checked": _vm._q(_vm.CurrentItemCategory, item)
	      },
	      on: {
	        "click": function($event) {
	          _vm.CurrentItemCategory = item
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": "itemCategory"
	      }
	    })])])])
	  }))]), _vm._v(" "), _c('form-group', {
	    attrs: {
	      "error": _vm.formErrors.first('cost')
	    }
	  }, [_c('label', {
	    staticClass: "form-control-label",
	    attrs: {
	      "for": "cost"
	    }
	  }, [_vm._v("Cost (THB)")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cost),
	      expression: "cost"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "step": "0.01",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.cost)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cost = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "role"
	    }
	  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "one-time"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "one-time")
	    },
	    on: {
	      "click": function($event) {
	        _vm.type = "one-time"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "type"
	    }
	  }, [_vm._v("One Time")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio-custom radio-primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "recurring"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "recurring")
	    },
	    on: {
	      "click": function($event) {
	        _vm.type = "recurring"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "type"
	    }
	  }, [_vm._v("Recurring")])])]), _vm._v(" "), _c('form-group', [_c('label', {
	    attrs: {
	      "for": "period"
	    }
	  }, [_vm._v("Start at Billing Monthly")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentStartMonth),
	      expression: "currentStartMonth"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": [function($event) {
	        _vm.currentStartMonth = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, function($event) {
	        _vm.checkTerminateDate()
	      }]
	    }
	  }, _vm._l((_vm.monthList), function(month, index) {
	    return _c('option', {
	      domProps: {
	        "value": month
	      }
	    }, [_vm._v(_vm._s(month))])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentStartYear),
	      expression: "currentStartYear"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": [function($event) {
	        _vm.currentStartYear = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, function($event) {
	        _vm.checkTerminateDate()
	      }]
	    }
	  }, _vm._l((_vm.yearList), function(year, index) {
	    return _c('option', {
	      domProps: {
	        "value": year
	      }
	    }, [_vm._v(_vm._s(year))])
	  }))])])]), _vm._v(" "), (_vm.type === 'recurring') ? _c('form-group', [_c('label', {
	    attrs: {
	      "for": "period"
	    }
	  }, [_vm._v("Terminate at Billing Monthly")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentTerminateMonth),
	      expression: "currentTerminateMonth"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": [function($event) {
	        _vm.currentTerminateMonth = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, function($event) {
	        _vm.checkTerminateDate()
	      }]
	    }
	  }, _vm._l((_vm.monthList), function(month, index) {
	    return _c('option', {
	      domProps: {
	        "value": month
	      }
	    }, [_vm._v(_vm._s(month))])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentTerminateYear),
	      expression: "currentTerminateYear"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": [function($event) {
	        _vm.currentTerminateYear = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, function($event) {
	        _vm.checkTerminateDate()
	      }]
	    }
	  }, _vm._l((_vm.yearList), function(year, index) {
	    return _c('option', {
	      domProps: {
	        "value": year
	      }
	    }, [_vm._v(_vm._s(year))])
	  }))])])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    class: {
	      'btn-default': _vm.isSubmiting
	    },
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.isSubmiting
	    }
	  }, [(_vm.isSubmiting) ? _c('div', {
	    staticClass: "loader vertical-align-middle loader-circle loader-form"
	  }) : _vm._e(), _vm._v(" Submit\n              ")])])])])], 1)])])])
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.bd02e78e062b7cb25cf3.js